import React, { useState, useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import ChatModal from '../components/ChatModal';
import { playNotifSound } from '../notifHelper';
import {
  Building2, Truck, Users, DollarSign, Package, AlertCircle, CheckCircle,
  Clock, Search, FileText, Eye, XCircle, TrendingUp, Award, X,
  MapPin, Star, Phone, Mail, Calendar, BarChart3, PieChart, Activity,
  Shield, Settings, LogOut, Bell, ChevronRight, Download, Filter, Smartphone,
  UserCheck, UserX, RefreshCw, Globe, CreditCard, Percent, Map, Edit,
  UserPlus, Key, Lock, Unlock, ShieldCheck, ShieldAlert, Plus, Trash2,
  Briefcase, MessageSquare, Image, StickyNote, AlertTriangle, Ban, Flag,
  ChevronDown, ChevronUp, RotateCcw, ArrowRightLeft, Wallet, Menu, ClipboardList, MessageSquarePlus, Send, Wifi
} from 'lucide-react';
import SimuladorRedMercadeo from '../components/SimuladorRedMercadeo';
import { useStore, getStore, cerrarConversacionAdmin, reabrirConversacionAdmin, ocultarOfertaPro, mostrarOfertaPro, aprobarEmpresa as storeAprobarEmpresa, rechazarEmpresa as storeRechazarEmpresa, toggleStatusEmpresa as storeToggleStatusEmpresa, actualizarComisionEmpresa as storeActualizarComision, actualizarInsigniasManuales as storeActualizarInsignias, validarDocumentosEmpresa as storeValidarDocumentos, actualizarStatusDocumento as storeActualizarStatusDocumento, crearAdministrador as storeCrearAdmin, actualizarAdministrador as storeActualizarAdmin, toggleStatusAdministrador as storeToggleAdmin, eliminarAdministrador as storeEliminarAdmin, actualizarInsigniasCliente as storeActualizarInsigniasCliente, CATALOGO_INSIGNIAS, CATALOGO_INSIGNIAS_CLIENTE, DOCUMENTOS_REQUERIDOS, getDocumentosRequeridos, getNotificacionesPendientes, marcarNotificacionesLeidas, limpiarNotificaciones, toggleDifusionGlobal as storeToggleDifusion, adminCancelarSolicitud, adminCancelarViaje, adminMarcarDisputa, adminAgregarNota, adminResolverDisputa, adminForzarCompletar, enviarMensaje as storeEnviarMensaje, asignarPlanEmpresa as storeAsignarPlan, actualizarConfigPlan as storeActualizarConfigPlan, actualizarConfigRedMercadeo, gestionarComisionRed, getArbolReferidos, limpiarComisionesExpiradas, gestionarRetiroFondos } from '../store';
import { useApiStore, invalidarCacheConfig } from '../hooks/useApiStore';
import { getToken } from '../api';
import { validarDigitoVerificadorRFC } from '../utils/rfc';
import { apiAprobarEmpresa, apiRechazarEmpresa, apiSuspenderEmpresa, apiGuardarConfig, apiMarcarLeidas, apiAsignarPlanEmpresa, apiAdminVerificarDocumento, apiGestionarRetiro, apiAdminActualizarInsigniasEmpresa, apiAdminActualizarInsigniasUsuario, apiAdminCrearAdmin, apiAdminActualizarAdmin, apiAdminEliminarAdmin, apiAdminToggleAdmin, apiGetFinanzasAdmin, apiGetRetiros, apiCambiarPassword, apiAdminLiberarEscrow, apiAdminConfirmarPago, apiAdminCancelarPago,apiGetArbolReferidosAdmin, apiAdminGestionarComision, apiAdminActualizarComisionEmpresa, apiEnviarMensaje, apiGenerarFactura, apiSubirFacturaManual, apiGetFacturasAdmin, apiCancelarFactura, apiFacturamaHealth, apiPagarTransportista, apiGetAudit, apiGetTendencias, apiGetFacturaArchivos, apiFacturaDiagnostico, apiRecuperarCfdiId, apiFacturamaDebugRespuesta, apiAdminToggleReferidor, apiAdminRepararMLM, apiGetDownloadUrl, apiRetiroCancelar, apiGetMetricasLive, apiGetActividad, apiGetRetencionesSat, apiAdminActualizarRfcEmpresa, apiAdminCancelarSolicitud, apiGetPromos, apiCrearPromo, apiEditarPromo, apiEliminarPromo, apiAsignarPromo, apiQuitarPromo, apiEnviarMensajeAdmin, apiGetMensajesAdmin, apiCancelarViaje, apiAdminCambiarStatusViaje, apiAdminAbrirDisputa, apiAdminResolverDisputa } from '../api';

// ========== PERMISOS POR ROL ==========
const SECCIONES_POR_ROL = {
  superadmin: ['dashboard', 'pendientes', 'empresas', 'mapa', 'choferes', 'clientes', 'operaciones', 'retornos', 'admins', 'reportes', 'actividad', 'finanzas', 'facturacion', 'mensajes', 'auditoria', 'configuracion', 'soporte_chat', 'simulador_red', 'red_mercadeo'],
  admin:      ['dashboard', 'pendientes', 'empresas', 'mapa', 'choferes', 'clientes', 'operaciones', 'retornos', 'reportes', 'actividad', 'mensajes', 'soporte_chat'],
  operador:   ['dashboard', 'empresas', 'mapa', 'choferes', 'clientes', 'operaciones', 'retornos'],
  soporte:    ['clientes', 'operaciones', 'soporte_chat'],
};
const ACCIONES_POR_ROL = {
  superadmin: ['aprobar', 'suspender', 'rechazar', 'gestionar_admins', 'configuracion', 'exportar', 'editar_comision', 'insignias'],
  admin:      ['aprobar', 'suspender', 'rechazar', 'exportar'],
  operador:   [],
  soporte:    [],
};
// Qué secciones y acciones habilita cada permiso individual
const PERMISO_A_SECCIONES = {
  ver_empresas:        ['empresas', 'mapa'],
  aprobar_empresas:    ['pendientes'],
  ver_clientes:        ['clientes'],
  ver_reportes:        ['reportes'],
  gestionar_admins:    ['admins'],
  configuracion:       ['configuracion'],
};
const PERMISO_A_ACCIONES = {
  aprobar_empresas:    ['aprobar', 'rechazar'],
  suspender_empresas:  ['suspender'],
  exportar_datos:      ['exportar'],
  editar_comisiones:   ['editar_comision'],
  gestionar_admins:    ['gestionar_admins'],
  configuracion:       ['configuracion'],
  insignias:           ['insignias'],
};

// ─── Árbol visual de referidos (admin) ───────────────────────────────────────
function NodoArbolAdmin({ nodo, depth = 0, isFirst, isLast, solo }) {
  const [open, setOpen] = React.useState(true);
  const hijos = nodo.referidos || [];
  const tieneHijos = hijos.length > 0;

  const colores = [
    { circle: '#3b82f6', light: '#eff6ff', border: '#93c5fd', tag: 'N1' },
    { circle: '#8b5cf6', light: '#f5f3ff', border: '#c4b5fd', tag: 'N2' },
    { circle: '#f97316', light: '#fff7ed', border: '#fdba74', tag: 'N3' },
  ];
  const col = colores[depth] || colores[2];
  const inicial = (nodo.nombre || '?')[0].toUpperCase();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 0 }}>
      {depth > 0 && (
        <div style={{ display: 'flex', width: '100%', height: 24, alignItems: 'flex-end' }}>
          <div style={{ flex: 1, borderTop: isFirst || solo ? 'none' : '2px solid #d1d5db', height: 1, alignSelf: 'center' }} />
          <div style={{ width: 2, height: 24, backgroundColor: '#d1d5db' }} />
          <div style={{ flex: 1, borderTop: isLast || solo ? 'none' : '2px solid #d1d5db', height: 1, alignSelf: 'center' }} />
        </div>
      )}
      <div
        onClick={tieneHijos ? (e) => { e.preventDefault(); setOpen(o => !o); } : undefined}
        onMouseDown={tieneHijos ? (e) => e.preventDefault() : undefined}
        style={{
          background: col.light, border: `2px solid ${col.border}`,
          borderRadius: 10, padding: '6px 8px', width: 90, textAlign: 'center',
          cursor: tieneHijos ? 'pointer' : 'default',
          boxShadow: '0 1px 3px rgba(0,0,0,0.07)', position: 'relative',
          userSelect: 'none', WebkitUserSelect: 'none',
        }}
      >
        <div style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: col.circle, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 13, margin: '0 auto 4px' }}>
          {inicial}
        </div>
        <span style={{ position: 'absolute', top: 4, right: 4, background: col.circle, color: '#fff', fontSize: 8, fontWeight: 700, padding: '1px 4px', borderRadius: 4 }}>{col.tag}</span>
        <p style={{ fontWeight: 700, fontSize: 11, color: '#1f2937', lineHeight: 1.2, marginBottom: 2, wordBreak: 'break-word' }}>{nodo.nombre}</p>
        <p style={{ fontSize: 9, color: nodo.activo ? '#16a34a' : '#9ca3af', marginBottom: 2 }}>
          {nodo.esEmpresa ? (nodo.rol === 'transportista' ? '🚛 Empresa' : '🏢 Empresa') : '👤 Cliente'}
          {' '}{nodo.activo ? '· Activo' : '· Inactivo'}
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 4, flexWrap: 'wrap' }}>
          {(nodo.viajesCompletados || 0) > 0 && <span style={{ fontSize: 9, color: '#6b7280' }}>{nodo.viajesCompletados}v</span>}
          {(nodo.totalReferidos || 0) > 0 && <span style={{ fontSize: 9, color: col.circle, fontWeight: 700 }}>{nodo.totalReferidos}r</span>}
        </div>
        {tieneHijos && <div style={{ marginTop: 2, color: '#9ca3af', fontSize: 9 }}>{open ? '▲' : '▼'}</div>}
      </div>
      {tieneHijos && open && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ width: 2, height: 20, backgroundColor: '#d1d5db' }} />
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
            {hijos.map((hijo, i) => (
              <NodoArbolAdmin key={hijo.id} nodo={hijo} depth={depth + 1} isFirst={i === 0} isLast={i === hijos.length - 1} solo={hijos.length === 1} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ========== COMPONENTE: FEEDBACK USUARIOS ==========
const BASE_URL_FB = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:4000/api');

const TIPO_COLORS = {
  sugerencia: 'bg-blue-100 text-blue-700',
  mejora:     'bg-yellow-100 text-yellow-700',
  bug:        'bg-red-100 text-red-700',
  otro:       'bg-gray-100 text-gray-600',
};
const TIPO_LABELS = { sugerencia: '💡 Sugerencia', mejora: '🔧 Mejora', bug: '🐛 Error', otro: '💬 Otro' };
const ROL_COLORS  = { cliente: 'bg-blue-50 text-blue-600', transportista: 'bg-orange-50 text-orange-600', chofer: 'bg-green-50 text-green-600' };

function SeccionPromos({ recargar }) {
  const [promos, setPromos] = React.useState([]);
  const [cargando, setCargando] = React.useState(true);
  const [guardando, setGuardando] = React.useState(false);
  const [formAbierto, setFormAbierto] = React.useState(false);
  const [form, setForm] = React.useState({ nombre: '', comisionPromo: 0, cuposTotal: 30, fletesGratis: 3, fechaInicioRegistro: '', fechaFinRegistro: '', codigoAcceso: '' });
  const [editandoId, setEditandoId] = React.useState(null);

  const cargar = React.useCallback(() => {
    setCargando(true);
    apiGetPromos().then(setPromos).catch(() => {}).finally(() => setCargando(false));
  }, []);

  React.useEffect(() => { cargar(); }, [cargar]);

  const guardarPromo = async () => {
    if (!form.nombre) return;
    setGuardando(true);
    try {
      if (editandoId) {
        await apiEditarPromo(editandoId, form);
      } else {
        await apiCrearPromo(form);
      }
      setFormAbierto(false);
      setEditandoId(null);
      setForm({ nombre: '', comisionPromo: 0, cuposTotal: 30, fletesGratis: 3, fechaInicioRegistro: '', fechaFinRegistro: '', codigoAcceso: '' });
      cargar();
    } catch (e) { alert(e.message || 'Error al guardar'); }
    finally { setGuardando(false); }
  };

  const toggleActiva = async (promo) => {
    await apiEditarPromo(promo.id, { activa: !promo.activa });
    cargar();
  };

  const eliminar = async (promo) => {
    if (!window.confirm(`¿Eliminar la promo "${promo.nombre}"?`)) return;
    await apiEliminarPromo(promo.id).catch(e => alert(e.message));
    cargar();
  };

  const abrirEditar = (promo) => {
    setForm({ nombre: promo.nombre, comisionPromo: promo.comisionPromo, cuposTotal: promo.cuposTotal, fletesGratis: promo.fletesGratis, fechaInicioRegistro: promo.fechaInicioRegistro?.slice(0,10) || '', fechaFinRegistro: promo.fechaFinRegistro?.slice(0,10) || '', codigoAcceso: promo.codigoAcceso || '' });
    setEditandoId(promo.id);
    setFormAbierto(true);
  };

  return (
    <div className="mt-8 bg-white rounded-2xl shadow-lg p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">🎁 Promociones</h3>
          <p className="text-sm text-gray-500 mt-0.5">Configura promos de comisión para nuevos transportistas. Se asignan automáticamente al aprobar empresas.</p>
        </div>
        <button onClick={() => { setFormAbierto(true); setEditandoId(null); setForm({ nombre: '', comisionPromo: 0, cuposTotal: 30, fletesGratis: 3, fechaInicioRegistro: '', fechaFinRegistro: '' }); }}
          className="px-4 py-2 bg-green-600 text-white rounded-xl text-sm font-semibold hover:bg-green-700 flex items-center gap-2">
          + Nueva promo
        </button>
      </div>

      {/* Formulario */}
      {formAbierto && (
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-5 mb-5 space-y-4">
          <h4 className="font-semibold text-gray-700">{editandoId ? 'Editar promo' : 'Nueva promoción'}</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">Nombre *</label>
              <input value={form.nombre} onChange={e => setForm(f => ({...f, nombre: e.target.value}))} placeholder="Ej: Lanzamiento BC Mayo 2026" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">% Comisión promo</label>
              <input type="number" min="0" max="100" value={form.comisionPromo} onChange={e => setForm(f => ({...f, comisionPromo: parseFloat(e.target.value) || 0}))} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">Cupos totales</label>
              <input type="number" min="1" value={form.cuposTotal} onChange={e => setForm(f => ({...f, cuposTotal: parseInt(e.target.value) || 1}))} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">Fletes con promo por empresa</label>
              <input type="number" min="1" value={form.fletesGratis} onChange={e => setForm(f => ({...f, fletesGratis: parseInt(e.target.value) || 1}))} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">Inicio registro (opcional)</label>
              <input type="date" value={form.fechaInicioRegistro} onChange={e => setForm(f => ({...f, fechaInicioRegistro: e.target.value}))} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1 block">Cierre registro (opcional)</label>
              <input type="date" value={form.fechaFinRegistro} onChange={e => setForm(f => ({...f, fechaFinRegistro: e.target.value}))} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
            </div>
            <div className="sm:col-span-2">
              <label className="text-xs font-semibold text-gray-600 mb-1 block">Código de acceso (opcional)</label>
              <input
                value={form.codigoAcceso}
                onChange={e => setForm(f => ({...f, codigoAcceso: e.target.value.toUpperCase().replace(/\s/g, '')}))}
                placeholder="Ej: LANZAMIENTO  —  déjalo vacío para que aplique sin código"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-mono"
                maxLength={30}
              />
              <p className="text-xs text-gray-400 mt-1">Si defines un código, solo aplica a empresas que lo ingresaron al registrarse. Sin código → cualquier empresa puede recibirla.</p>
            </div>
          </div>
          <div className="flex gap-2 justify-end">
            <button onClick={() => { setFormAbierto(false); setEditandoId(null); }} className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-100">Cancelar</button>
            <button onClick={guardarPromo} disabled={guardando || !form.nombre} className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 disabled:opacity-50">
              {guardando ? 'Guardando...' : editandoId ? 'Guardar cambios' : 'Crear promo'}
            </button>
          </div>
        </div>
      )}

      {/* Lista de promos */}
      {cargando ? <p className="text-gray-400 text-sm">Cargando...</p> : promos.length === 0 ? (
        <div className="text-center py-10 text-gray-400">
          <p className="text-4xl mb-2">🎁</p>
          <p className="text-sm">No hay promociones configuradas</p>
          <p className="text-xs mt-1">Crea una para empezar a asignarla automáticamente al aprobar empresas</p>
        </div>
      ) : (
        <div className="space-y-3">
          {promos.map(p => {
            const cuposRestantes = (p.cuposTotal || 0) - (p.cuposUsados || 0);
            const pct = p.cuposTotal > 0 ? Math.round((p.cuposUsados || 0) / p.cuposTotal * 100) : 0;
            return (
              <div key={p.id} className={`border rounded-xl p-4 ${p.activa ? 'border-green-200 bg-green-50' : 'border-gray-200 bg-white'}`}>
                <div className="flex flex-wrap items-start gap-3 justify-between">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <p className="font-bold text-gray-800 truncate">{p.nombre}</p>
                      <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${p.activa ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>{p.activa ? '● Activa' : '● Inactiva'}</span>
                    </div>
                    <div className="flex flex-wrap gap-4 text-xs text-gray-600">
                      <span>💸 {p.comisionPromo}% comisión</span>
                      <span>🎁 {p.fletesGratis} fletes por empresa</span>
                      <span>👥 {p.cuposUsados || 0}/{p.cuposTotal} cupos usados</span>
                      {p.fechaFinRegistro && <span>📅 Cierra: {new Date(p.fechaFinRegistro).toLocaleDateString('es-MX')}</span>}
                      {p.codigoAcceso && <span className="font-mono bg-yellow-100 text-yellow-800 px-1.5 py-0.5 rounded">🔑 {p.codigoAcceso}</span>}
                    </div>
                    {/* Barra de progreso cupos */}
                    <div className="mt-2 h-1.5 bg-gray-200 rounded-full w-full max-w-xs">
                      <div className="h-1.5 bg-green-500 rounded-full transition-all" style={{ width: `${pct}%` }} />
                    </div>
                    <p className="text-xs text-gray-400 mt-0.5">{cuposRestantes} cupos disponibles</p>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <button onClick={() => toggleActiva(p)} className={`px-3 py-1.5 text-xs rounded-lg font-semibold transition ${p.activa ? 'bg-gray-100 text-gray-600 hover:bg-gray-200' : 'bg-green-600 text-white hover:bg-green-700'}`}>
                      {p.activa ? 'Desactivar' : 'Activar'}
                    </button>
                    <button onClick={() => abrirEditar(p)} className="p-1.5 text-blue-600 hover:bg-blue-100 rounded-lg"><Edit size={15}/></button>
                    {(p.cuposUsados || 0) === 0 && <button onClick={() => eliminar(p)} className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg"><Trash2 size={15}/></button>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function SeccionFeedback() {
  const [items, setItems]   = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroRol, setFiltroRol]   = useState('');
  const [filtroLeido, setFiltroLeido] = useState('false');

  const cargar = async () => {
    setCargando(true);
    try {
      const params = new URLSearchParams();
      if (filtroTipo) params.set('tipo', filtroTipo);
      if (filtroRol)  params.set('rol', filtroRol);
      if (filtroLeido !== '') params.set('leido', filtroLeido);
      const r = await fetch(`${BASE_URL_FB}/feedback?${params}`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      const data = await r.json();
      setItems(Array.isArray(data) ? data : []);
    } catch { setItems([]); }
    finally { setCargando(false); }
  };

  useEffect(() => { cargar(); }, [filtroTipo, filtroRol, filtroLeido]); // eslint-disable-line

  const marcarLeido = async (id) => {
    await fetch(`${BASE_URL_FB}/feedback/${id}/leido`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    setItems(prev => prev.map(i => i.id === id ? { ...i, leido: true } : i));
  };

  const noLeidos = items.filter(i => !i.leido).length;

  return (
    <div>
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
            <MessageSquarePlus size={24} className="text-indigo-600" />
            Feedback de Usuarios
          </h2>
          <p className="text-gray-400 text-sm mt-1">
            {noLeidos > 0 ? `${noLeidos} sin leer` : 'Todo leído'} · {items.length} total
          </p>
        </div>
        <button onClick={cargar} className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-xl text-sm font-semibold hover:bg-indigo-500 transition">
          <RefreshCw size={15} /> Actualizar
        </button>
      </div>

      {/* Filtros */}
      <div className="flex flex-wrap gap-3 mb-6">
        <select value={filtroLeido} onChange={e => setFiltroLeido(e.target.value)} className="border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-600 focus:ring-2 focus:ring-indigo-400 outline-none">
          <option value="false">Sin leer</option>
          <option value="true">Leídos</option>
          <option value="">Todos</option>
        </select>
        <select value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)} className="border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-600 focus:ring-2 focus:ring-indigo-400 outline-none">
          <option value="">Todos los tipos</option>
          <option value="sugerencia">💡 Sugerencia</option>
          <option value="mejora">🔧 Mejora</option>
          <option value="bug">🐛 Error</option>
          <option value="otro">💬 Otro</option>
        </select>
        <select value={filtroRol} onChange={e => setFiltroRol(e.target.value)} className="border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-600 focus:ring-2 focus:ring-indigo-400 outline-none">
          <option value="">Todos los roles</option>
          <option value="cliente">Cliente</option>
          <option value="transportista">Transportista</option>
          <option value="chofer">Chofer</option>
        </select>
      </div>

      {cargando ? (
        <div className="space-y-3">
          {[1,2,3].map(i => <div key={i} className="h-24 bg-gray-100 rounded-xl animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <MessageSquarePlus size={40} className="mx-auto mb-3 opacity-30" />
          <p className="font-medium">No hay feedback con estos filtros</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map(item => (
            <div key={item.id} className={`bg-white rounded-xl border p-5 transition ${item.leido ? 'border-gray-100 opacity-70' : 'border-indigo-200 shadow-sm'}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${TIPO_COLORS[item.tipo] || 'bg-gray-100 text-gray-600'}`}>
                      {TIPO_LABELS[item.tipo] || item.tipo}
                    </span>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${ROL_COLORS[item.rol] || 'bg-gray-100 text-gray-600'}`}>
                      {item.rol}
                    </span>
                    {item.pantalla && (
                      <span className="text-xs text-gray-400 bg-gray-50 px-2 py-0.5 rounded-full">
                        📍 {item.pantalla}
                      </span>
                    )}
                    {!item.leido && <span className="w-2 h-2 bg-indigo-500 rounded-full" />}
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed">{item.mensaje}</p>
                  <div className="mt-2 flex items-center gap-3 text-xs text-gray-400">
                    <span>{item.usuario?.nombre || 'Usuario'}</span>
                    <span>·</span>
                    <span>{item.usuario?.email}</span>
                    <span>·</span>
                    <span>{new Date(item.createdAt).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                  </div>
                </div>
                {!item.leido && (
                  <button
                    onClick={() => marcarLeido(item.id)}
                    className="shrink-0 text-xs text-indigo-600 hover:text-indigo-800 border border-indigo-200 hover:border-indigo-400 px-3 py-1.5 rounded-lg transition font-medium"
                  >
                    Marcar leído
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ========== COMPONENTE: GESTIÓN RED DE MERCADEO ==========
function SeccionRedMercadeo({ store, recargar }) {
  const cfg = store.configPlataforma?.redMercadeo || {};
  const [formCfg, setFormCfg] = useState({ ...cfg });
  const [guardado, setGuardado] = useState(false);
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [filtroEmpresa, setFiltroEmpresa] = useState('');
  const sincronizado = useRef(false);
  const [arbolUsuario, setArbolUsuario] = useState(null); // { uid, nombre, arbol }
  const [cargandoArbol, setCargandoArbol] = useState(false);
  const [pagina, setPagina] = useState(1);
  const POR_PAGINA = 20;

  // Sincronizar formCfg solo la primera vez que llegan datos reales del store (API)
  useEffect(() => {
    if (sincronizado.current) return;
    const cfgActual = store.configPlataforma?.redMercadeo || {};
    if (Object.keys(cfgActual).length > 0) {
      setFormCfg(cfgActual);
      sincronizado.current = true;
    }
  }, [store.configPlataforma]);

  const comisiones = (store.comisionesRed || []).filter(c => {
    if (filtroEstado !== 'todos' && c.status !== filtroEstado) return false;
    if (filtroEmpresa) {
      const emp = store.empresasActivas?.find(e => e.id === c.empresaId)
        || store.empresasPendientes?.find(e => e.id === c.empresaId)
        || store.usuarios?.find(u => u.id === c.empresaId);
      if (!emp?.nombre?.toLowerCase().includes(filtroEmpresa.toLowerCase()) &&
          !emp?.razonSocial?.toLowerCase().includes(filtroEmpresa.toLowerCase())) return false;
    }
    return true;
  }).sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

  const setCfg = (k, v) => setFormCfg(f => ({ ...f, [k]: v }));
  const cambiarFiltroEstado = (v) => { setFiltroEstado(v); setPagina(1); };
  const cambiarFiltroEmpresa = (v) => { setFiltroEmpresa(v); setPagina(1); };

  const guardarConfig = async () => {
    const sumaTrans = (formCfg.pctFleteN1 || 0) + (formCfg.pctFleteN2 || 0) + (formCfg.pctFleteN3 || 0);
    const sumaCliente = (formCfg.pctFleteClienteN1 || 0) + (formCfg.pctFleteClienteN2 || 0) + (formCfg.pctFleteClienteN3 || 0);
    if (sumaTrans > 100) { alert(`La suma de % flete transportista (N1+N2+N3) es ${sumaTrans}% y supera el 100%. Reduce los valores.`); return; }
    if (sumaCliente > 100) { alert(`La suma de % flete cliente (N1+N2+N3) es ${sumaCliente}% y supera el 100%. Reduce los valores.`); return; }
    try {
      await apiGuardarConfig({ redMercadeo: formCfg });
      invalidarCacheConfig(); recargar?.();
      setGuardado(true);
      setTimeout(() => setGuardado(false), 2500);
    } catch (e) {
      console.error('[Config] Error guardando:', e.message);
      alert('Error al guardar la configuración: ' + (e.message || 'intenta de nuevo'));
    }
  };

  const accion = async (id, act) => {
    try {
      await apiAdminGestionarComision(id, act);
      gestionarComisionRed(id, act);
    } catch (e) {
      alert('Error al actualizar la comisión: ' + (e.message || 'intenta de nuevo'));
    }
  };

  const limpiarExpiradas = () => {
    // TODO: agregar endpoint backend para persistir la limpieza de comisiones expiradas
    limpiarComisionesExpiradas();
    alert('Comisiones expiradas marcadas como revertidas (solo en vista local, pendiente sincronizar con servidor).');
  };

  // Estadísticas
  const total = store.comisionesRed || [];
  const stats = {
    pendiente: total.filter(c => c.status === 'pendiente').length,
    disponible: total.filter(c => c.status === 'disponible').length,
    pagada: total.filter(c => c.status === 'pagada').length,
    montoPendiente: total.filter(c => c.status === 'pendiente').reduce((s, c) => s + c.monto, 0),
    montoDisponible: total.filter(c => c.status === 'disponible').reduce((s, c) => s + c.monto, 0),
    montoPagado: total.filter(c => c.status === 'pagada').reduce((s, c) => s + c.monto, 0),
  };

  const colorEstado = (s) => ({ pendiente: 'bg-yellow-100 text-yellow-700', disponible: 'bg-green-100 text-green-700', pagada: 'bg-blue-100 text-blue-700', revertida: 'bg-red-100 text-red-700', congelada: 'bg-gray-100 text-gray-700' }[s] || 'bg-gray-100 text-gray-700');
  const labelEstado = (s) => ({ pendiente: 'Pendiente', disponible: 'Disponible', pagada: 'Pagada', revertida: 'Revertida', congelada: 'Congelada' }[s] || s);

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
            <Users size={24} className="text-green-600" />
            Programa de Referidos
          </h2>
          <p className="text-gray-500 text-sm mt-1">Configura y gestiona el sistema de referidos multinivel</p>
        </div>
        <div className="flex gap-2">
          <button onClick={limpiarExpiradas} className="px-4 py-2 border border-gray-300 text-gray-600 rounded-xl text-sm hover:bg-gray-50 flex items-center gap-2">
            <RefreshCw size={14} /> Limpiar expiradas
          </button>
          <button onClick={async () => {
            try {
              const r = await apiAdminRepararMLM();
              console.log('[MLM Debug]', JSON.stringify(r.debug, null, 2));
              alert(`✅ MLM\nReferidores activados: ${r.referidoresActivados}\nViajes reparados: ${r.viajesReparados}\nComisiones creadas: ${r.comisionesCreadas}\n\nRevisa la consola del navegador para ver el diagnóstico completo.`);
              recargar();
            } catch (e) { alert('Error: ' + e.message); }
          }} className="px-4 py-2 border border-orange-300 text-orange-600 rounded-xl text-sm hover:bg-orange-50 flex items-center gap-2">
            <RefreshCw size={14} /> Reparar MLM
          </button>
        </div>
      </div>

      {/* Estadísticas */}
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-4 text-center">
          <p className="text-xs text-yellow-600 font-semibold">Pendientes</p>
          <p className="text-2xl font-bold text-yellow-700 mt-1">{stats.pendiente}</p>
          <p className="text-sm text-yellow-600 font-semibold">${stats.montoPendiente.toLocaleString()}</p>
        </div>
        <div className="bg-green-50 border border-green-200 rounded-2xl p-4 text-center">
          <p className="text-xs text-green-600 font-semibold">Disponibles</p>
          <p className="text-2xl font-bold text-green-700 mt-1">{stats.disponible}</p>
          <p className="text-sm text-green-600 font-semibold">${stats.montoDisponible.toLocaleString()}</p>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 text-center">
          <p className="text-xs text-blue-600 font-semibold">Pagadas</p>
          <p className="text-2xl font-bold text-blue-700 mt-1">{stats.pagada}</p>
          <p className="text-sm text-blue-600 font-semibold">${stats.montoPagado.toLocaleString()}</p>
        </div>
      </div>

      {/* Toggle habilitada */}
      <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm flex items-center justify-between">
        <div>
          <h3 className="font-bold text-gray-800">Programa activo</h3>
          <p className="text-sm text-gray-500 mt-1">Activa o desactiva la generación de comisiones MLM</p>
        </div>
        <button
          onClick={() => setCfg('habilitada', !formCfg.habilitada)}
          className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors focus:outline-none ${formCfg.habilitada ? 'bg-green-500' : 'bg-gray-300'}`}
        >
          <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${formCfg.habilitada ? 'translate-x-8' : 'translate-x-1'}`} />
        </button>
      </div>

      {/* Configuración de bonos */}
      <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
        <h3 className="font-bold text-gray-800 mb-4">Configuración de comisiones</h3>
        <div className="grid grid-cols-3 gap-6 mb-4">
          {[1, 2, 3].map(n => (
            <div key={n} className="space-y-3">
              <p className="font-semibold text-gray-700 text-sm">Nivel {n}</p>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">Bono transportista ($)</label>
                <input type="number" value={formCfg[`bonoTransN${n}`] || 0}
                  onChange={e => setCfg(`bonoTransN${n}`, Number(e.target.value))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-green-400 focus:outline-none" />
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">Bono cliente ($)</label>
                <input type="number" value={formCfg[`bonoClienteN${n}`] || 0}
                  onChange={e => setCfg(`bonoClienteN${n}`, Number(e.target.value))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-green-400 focus:outline-none" />
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">% sobre comisión Choyero (transportista)</label>
                <input type="number" step="0.1" value={formCfg[`pctFleteN${n}`] || 0}
                  onChange={e => setCfg(`pctFleteN${n}`, Number(e.target.value))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-green-400 focus:outline-none" />
              </div>
              <div>
                <label className="text-xs text-gray-500 mb-1 block">% sobre comisión Choyero (cliente moral)</label>
                <input type="number" step="0.1" value={formCfg[`pctFleteClienteN${n}`] || 0}
                  onChange={e => setCfg(`pctFleteClienteN${n}`, Number(e.target.value))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-green-400 focus:outline-none" />
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-4 mb-4 max-w-xs">
          <div>
            <label className="text-xs text-gray-500 mb-1 block">Días para expirar comisión pendiente</label>
            <input type="number" value={formCfg.diasExpiracion || 60}
              onChange={e => setCfg('diasExpiracion', Number(e.target.value))}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-green-400 focus:outline-none" />
          </div>
        </div>
        <button onClick={guardarConfig} className={`px-6 py-2.5 rounded-xl font-semibold text-sm flex items-center gap-2 ${guardado ? 'bg-green-500 text-white' : 'bg-green-600 hover:bg-green-700 text-white'}`}>
          {guardado ? <><CheckCircle size={16} /> Guardado</> : <><Settings size={16} /> Guardar configuración</>}
        </button>
      </div>


      {/* Resumen por referidor */}
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm">
        <div className="p-5 border-b border-gray-100">
          <h3 className="font-bold text-gray-800">Referidores activos</h3>
          <p className="text-xs text-gray-400 mt-0.5">Personas físicas con al menos un referido en la red</p>
        </div>
        {(() => {
          const todosUsuarios = store.usuarios || [];
          const referidores = todosUsuarios
            .filter(u => u.esReferidor)
            .map(u => {
              const uid = u.id;
              const misReferidos = todosUsuarios.filter(x => x.referidoPor === uid);
              const misComisiones = (store.comisionesRed || []).filter(c => c.userId === uid);
              const ganado = misComisiones.filter(c => c.status === 'disponible' || c.status === 'pagada').reduce((s, c) => s + c.monto, 0);
              const pendiente = misComisiones.filter(c => c.status === 'pendiente').reduce((s, c) => s + c.monto, 0);
              const bloqueado = misComisiones.filter(c => c.status === 'bloqueada').reduce((s, c) => s + c.monto, 0);
              const empresas = [...new Set(misComisiones.map(c => c.empresaId))].length;
              return { uid, u, ganado, pendiente, bloqueado, empresas, totalReferidos: misReferidos.length, totalComisiones: misComisiones.length };
            })
            .filter(r => r.totalReferidos > 0)
            .sort((a, b) => b.totalReferidos - a.totalReferidos || (b.ganado + b.pendiente) - (a.ganado + a.pendiente));

          if (referidores.length === 0) {
            return <div className="text-center py-8 text-gray-400 text-sm">No hay referidores con referidos registrados aún.</div>;
          }
          return (
            <div className="divide-y divide-gray-100">
              {referidores.map(({ uid, u, ganado, pendiente, bloqueado, empresas, totalReferidos, totalComisiones }) => (
                <div key={uid} className="p-4 flex items-center justify-between hover:bg-gray-50">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-blue-700 font-bold text-sm">{(u.nombre || '?')[0]}</span>
                    </div>
                    <div>
                      <p className="font-semibold text-sm text-gray-800">{u.nombre || uid}</p>
                      <p className="text-xs text-gray-400">{u.email} · {totalReferidos} referido{totalReferidos !== 1 ? 's' : ''}{totalComisiones > 0 ? ` · ${totalComisiones} comisión${totalComisiones !== 1 ? 'es' : ''}` : ''}</p>
                      {bloqueado > 0 && <p className="text-xs text-orange-600 font-semibold mt-0.5">🔒 ${bloqueado.toLocaleString()} bloqueado — no califica requisitos</p>}
                    </div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0">
                    <div className="text-right">
                      <p className="text-sm font-bold text-green-700">${ganado.toLocaleString()} <span className="text-xs font-normal text-gray-400">ganado</span></p>
                      {pendiente > 0 && <p className="text-xs text-yellow-600 font-semibold">${pendiente.toLocaleString()} pendiente</p>}
                    </div>
                    <button
                      onClick={() => {
                        if (arbolUsuario?.uid === uid) { setArbolUsuario(null); return; }
                        setCargandoArbol(true);
                        apiGetArbolReferidosAdmin(uid)
                          .then(arbol => setArbolUsuario({ uid, nombre: u.nombre || uid, arbol: arbol || [] }))
                          .catch(() => setArbolUsuario({ uid, nombre: u.nombre || uid, arbol: [] }))
                          .finally(() => setCargandoArbol(false));
                      }}
                      className={`text-xs px-3 py-1.5 rounded-lg font-semibold border transition ${arbolUsuario?.uid === uid ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-600 border-blue-300 hover:bg-blue-50'}`}
                    >
                      {arbolUsuario?.uid === uid ? 'Ocultar árbol' : 'Ver árbol'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          );
        })()}
      </div>

      {/* Árbol visual del referidor seleccionado */}
      {arbolUsuario && (
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-bold text-gray-800">Árbol de red — {arbolUsuario.nombre}</h3>
            <button onClick={() => setArbolUsuario(null)} className="text-gray-400 hover:text-gray-600 text-sm">✕ Cerrar</button>
          </div>
          {cargandoArbol ? (
            <div className="text-center py-10 text-gray-400 text-sm">Cargando árbol...</div>
          ) : arbolUsuario.arbol.length === 0 ? (
            <div className="text-center py-10 text-gray-400 text-sm">Este usuario no tiene referidos aún.</div>
          ) : (
            <div style={{ overflowX: 'auto', overflowY: 'visible', paddingBottom: 16 }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 'max-content', margin: '0 auto' }}>
                {/* Nodo raíz */}
                <div style={{ background: '#1e3a5f', borderRadius: 10, padding: '6px 12px', color: '#fff', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
                  <div style={{ width: 30, height: 30, borderRadius: '50%', background: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, margin: '0 auto 3px' }}>
                    {(arbolUsuario.nombre || 'U')[0].toUpperCase()}
                  </div>
                  <p style={{ fontWeight: 700, fontSize: 11 }}>{arbolUsuario.nombre.split(' ')[0]}</p>
                  <p style={{ fontSize: 9, opacity: 0.7 }}>Referidor</p>
                </div>
                <div style={{ width: 2, height: 20, backgroundColor: '#d1d5db' }} />
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                  {arbolUsuario.arbol.map((nodo, i) => (
                    <NodoArbolAdmin key={nodo.id} nodo={nodo} depth={0} isFirst={i === 0} isLast={i === arbolUsuario.arbol.length - 1} solo={arbolUsuario.arbol.length === 1} />
                  ))}
                </div>
              </div>
            </div>
          )}
          <p className="text-xs text-gray-400 text-center mt-3">Toca un nodo para expandir/contraer sus referidos</p>
        </div>
      )}

      {/* Lista de comisiones */}
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm">
        <div className="p-5 border-b border-gray-100 flex flex-wrap gap-3 items-center justify-between">
          <h3 className="font-bold text-gray-800">Comisiones ({comisiones.length})</h3>
          <div className="flex gap-2 flex-wrap">
            <input
              type="text" placeholder="Buscar empresa..."
              value={filtroEmpresa} onChange={e => cambiarFiltroEmpresa(e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-green-400 w-44"
            />
            <select value={filtroEstado} onChange={e => cambiarFiltroEstado(e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-green-400">
              <option value="todos">Todos</option>
              <option value="pendiente">Pendiente</option>
              <option value="disponible">Disponible</option>
              <option value="pagada">Pagada</option>
              <option value="revertida">Revertida</option>
              <option value="congelada">Congelada</option>
            </select>
          </div>
        </div>
        {comisiones.length === 0 ? (
          <div className="text-center py-12 text-gray-400">No hay comisiones con ese filtro.</div>
        ) : (() => {
          const totalPaginas = Math.ceil(comisiones.length / POR_PAGINA);
          const paginaActual = Math.min(pagina, totalPaginas);
          const slice = comisiones.slice((paginaActual - 1) * POR_PAGINA, paginaActual * POR_PAGINA);
          return (
            <>
              <div className="divide-y divide-gray-100">
                {slice.map(c => {
                  const empReferida = store.empresasActivas?.find(e => e.id === c.empresaId)
                    || store.empresasPendientes?.find(e => e.id === c.empresaId)
                    || store.usuarios?.find(u => u.id === c.empresaId)
                    || {};
                  const beneficiario = store.usuarios?.find(u => u.id === c.userId) || {};
                  const score = c.scoreRiesgo || 0;
                  const tipoLabel = c.tipo?.includes('registro') ? 'Registro' : c.tipo?.includes('flete_cliente') ? 'Flete cliente' : 'Flete trans.';
                  const empNombre = empReferida.nombre || empReferida.razonSocial || c.empresaId;
                  return (
                    <div key={c.id} className="p-4 hover:bg-gray-50">
                      <div className="flex items-start justify-between gap-4">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <p className="font-semibold text-gray-800 text-sm truncate">{empNombre}</p>
                            <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${colorEstado(c.status)}`}>{labelEstado(c.status)}</span>
                            <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">N{c.nivel} · {tipoLabel}</span>
                            {score >= 50 && <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full flex items-center gap-1"><AlertTriangle size={10} />Riesgo {score}</span>}
                          </div>
                          <p className="text-xs text-gray-400 mt-0.5">
                            Beneficiario: {beneficiario.nombre || beneficiario.email || c.userId}
                            {' · '}{new Date(c.creadoEn || c.fecha).toLocaleDateString('es-MX')}
                          </p>
                          {(c.flagsRiesgo?.length > 0) && (
                            <div className="flex flex-wrap gap-1 mt-1">
                              {c.flagsRiesgo.map((f, i) => <span key={i} className="text-xs bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded">{f}</span>)}
                            </div>
                          )}
                        </div>
                        <div className="text-right flex-shrink-0">
                          <p className="font-bold text-gray-800">${c.monto.toLocaleString()}</p>
                          <div className="flex gap-1 mt-1 justify-end flex-wrap">
                            {c.status === 'disponible' && (
                              <button onClick={() => accion(c.id, 'pagar')} className="text-xs px-2 py-1 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Pagar</button>
                            )}
                            {(c.status === 'pendiente' || c.status === 'disponible') && (
                              <button onClick={() => accion(c.id, 'congelar')} className="text-xs px-2 py-1 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">Congelar</button>
                            )}
                            {(c.status === 'pendiente' || c.status === 'congelada') && (
                              <button onClick={() => accion(c.id, 'rechazar')} className="text-xs px-2 py-1 bg-red-100 text-red-600 rounded-lg hover:bg-red-200">Revertir</button>
                            )}
                            {c.status === 'congelada' && (
                              <button onClick={() => accion(c.id, 'aprobar')} className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded-lg hover:bg-green-200">Liberar</button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {totalPaginas > 1 && (
                <div className="flex items-center justify-between px-5 py-3 border-t border-gray-100 bg-gray-50 rounded-b-2xl">
                  <p className="text-xs text-gray-400">
                    Mostrando {(paginaActual - 1) * POR_PAGINA + 1}–{Math.min(paginaActual * POR_PAGINA, comisiones.length)} de {comisiones.length}
                  </p>
                  <div className="flex items-center gap-1">
                    <button onClick={() => setPagina(p => Math.max(1, p - 1))} disabled={paginaActual === 1}
                      className="px-3 py-1.5 text-xs rounded-lg border border-gray-300 disabled:opacity-40 hover:bg-gray-100">← Anterior</button>
                    <span className="px-3 py-1.5 text-xs font-semibold text-gray-700">{paginaActual} / {totalPaginas}</span>
                    <button onClick={() => setPagina(p => Math.min(totalPaginas, p + 1))} disabled={paginaActual === totalPaginas}
                      className="px-3 py-1.5 text-xs rounded-lg border border-gray-300 disabled:opacity-40 hover:bg-gray-100">Siguiente →</button>
                  </div>
                </div>
              )}
            </>
          );
        })()}
      </div>
    </div>
  );
}

// ========== MODAL NUEVO ADMIN (fuera del componente padre para evitar re-mounts) ==========
const ROLES_ADMIN_MODAL = [
  { id: 'superadmin', nombre: 'Super Administrador', descripcion: 'Acceso total al sistema', color: 'red' },
  { id: 'admin', nombre: 'Administrador', descripcion: 'Gestión de empresas y reportes', color: 'orange' },
  { id: 'operador', nombre: 'Operador', descripcion: 'Visualización y soporte básico', color: 'blue' },
  { id: 'soporte', nombre: 'Soporte', descripcion: 'Solo atención a usuarios', color: 'green' }
];
const PERMISOS_ADMIN_MODAL = [
  { id: 'ver_empresas', nombre: 'Ver Transportistas' },
  { id: 'aprobar_empresas', nombre: 'Aprobar Transportistas' },
  { id: 'suspender_empresas', nombre: 'Suspender Transportistas' },
  { id: 'ver_clientes', nombre: 'Ver Clientes' },
  { id: 'ver_reportes', nombre: 'Ver Reportes' },
  { id: 'exportar_datos', nombre: 'Exportar Datos' },
  { id: 'editar_comisiones', nombre: 'Editar Comisiones' },
  { id: 'gestionar_admins', nombre: 'Gestionar Administradores' },
  { id: 'enviar_mensajes', nombre: 'Enviar Mensajes' },
  { id: 'configuracion', nombre: 'Configuración del Sistema' },
  { id: 'insignias', nombre: 'Gestionar Insignias' }
];

const PERMISOS_POR_ROL_DEFAULT = {
  superadmin: ['ver_empresas', 'aprobar_empresas', 'suspender_empresas', 'ver_clientes', 'ver_reportes', 'exportar_datos', 'editar_comisiones', 'gestionar_admins', 'configuracion', 'insignias', 'enviar_mensajes'],
  admin:      ['ver_empresas', 'aprobar_empresas', 'suspender_empresas', 'ver_clientes', 'ver_reportes', 'exportar_datos'],
  operador:   ['ver_empresas', 'ver_clientes'],
  soporte:    ['ver_clientes'],
};

function ModalNuevoAdmin({ onClose, onSubmit }) {
  const [formAdmin, setFormAdmin] = useState({ nombre: '', email: '', password: '', confirmPassword: '', rol: 'operador', permisos: PERMISOS_POR_ROL_DEFAULT['operador'] });
  const [errorForm, setErrorForm] = useState('');
  const [mostrarPassword, setMostrarPassword] = useState(false);

  const generarPassword = () => {
    const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
    const lower = 'abcdefghjkmnpqrstuvwxyz';
    const digits = '23456789';
    const symbols = '!@#$%&*+?';
    const all = upper + lower + digits + symbols;
    let pwd = [
      upper[Math.floor(Math.random() * upper.length)],
      lower[Math.floor(Math.random() * lower.length)],
      digits[Math.floor(Math.random() * digits.length)],
      symbols[Math.floor(Math.random() * symbols.length)],
    ];
    for (let i = 4; i < 12; i++) pwd.push(all[Math.floor(Math.random() * all.length)]);
    pwd = pwd.sort(() => Math.random() - 0.5).join('');
    setFormAdmin(prev => ({ ...prev, password: pwd, confirmPassword: pwd }));
    setMostrarPassword(true);
  };

  const togglePermiso = (permisoId) => {
    setFormAdmin(prev => ({
      ...prev,
      permisos: prev.permisos.includes(permisoId)
        ? prev.permisos.filter(p => p !== permisoId)
        : [...prev.permisos, permisoId]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorForm('');
    if (formAdmin.password.length < 6) { setErrorForm('La contraseña debe tener al menos 6 caracteres'); return; }
    if (formAdmin.password !== formAdmin.confirmPassword) { setErrorForm('Las contraseñas no coinciden'); return; }
    onSubmit(formAdmin);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-800">Agregar Nuevo Administrador</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Nombre Completo *</label>
            <input type="text" required value={formAdmin.nombre}
              onChange={(e) => setFormAdmin({...formAdmin, nombre: e.target.value})}
              placeholder="Nombre del administrador"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Email *</label>
            <input type="email" required value={formAdmin.email}
              onChange={(e) => setFormAdmin({...formAdmin, email: e.target.value})}
              placeholder="email@choyero.app"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Rol *</label>
            <div className="grid grid-cols-2 gap-3">
              {ROLES_ADMIN_MODAL.map(rol => (
                <button key={rol.id} type="button"
                  onClick={() => setFormAdmin(prev => ({ ...prev, rol: rol.id, permisos: PERMISOS_POR_ROL_DEFAULT[rol.id] || [] }))}
                  className={`p-3 rounded-lg border-2 text-left transition ${formAdmin.rol === rol.id ? 'border-yellow-500 bg-yellow-50' : 'border-gray-200 hover:border-gray-300'}`}>
                  <p className="font-semibold">{rol.nombre}</p>
                  <p className="text-xs text-gray-500">{rol.descripcion}</p>
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Permisos Específicos</label>
            <div className="grid grid-cols-2 gap-2 max-h-48 overflow-y-auto p-2 bg-gray-50 rounded-lg">
              {PERMISOS_ADMIN_MODAL.map(permiso => (
                <label key={permiso.id} className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded cursor-pointer">
                  <input type="checkbox" checked={formAdmin.permisos.includes(permiso.id)}
                    onChange={() => togglePermiso(permiso.id)} className="w-4 h-4 text-yellow-600 rounded" />
                  <span className="text-sm">{permiso.nombre}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <div className="flex justify-between items-center mb-1">
              <label className="block text-sm font-semibold text-gray-700">Contraseña *</label>
              <button type="button" onClick={generarPassword}
                className="text-xs px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full hover:bg-yellow-200 font-medium flex items-center gap-1">
                <span>⚡</span> Sugerir contraseña
              </button>
            </div>
            <div className="relative">
              <input type={mostrarPassword ? 'text' : 'password'} required value={formAdmin.password}
                onChange={(e) => setFormAdmin({...formAdmin, password: e.target.value})}
                placeholder="Mínimo 6 caracteres"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 pr-10" />
              <button type="button" onClick={() => setMostrarPassword(v => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs">
                {mostrarPassword ? 'Ocultar' : 'Ver'}
              </button>
            </div>
            {mostrarPassword && formAdmin.password && (
              <div className="mt-1 flex items-center gap-2 bg-yellow-50 border border-yellow-200 rounded px-3 py-1.5">
                <span className="text-xs text-yellow-800 font-mono flex-1 select-all">{formAdmin.password}</span>
                <button type="button" onClick={() => { navigator.clipboard.writeText(formAdmin.password); }}
                  className="text-xs text-yellow-700 hover:text-yellow-900 font-medium shrink-0">Copiar</button>
              </div>
            )}
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Confirmar Contraseña *</label>
            <input type={mostrarPassword ? 'text' : 'password'} required value={formAdmin.confirmPassword}
              onChange={(e) => setFormAdmin({...formAdmin, confirmPassword: e.target.value})}
              placeholder="Repite la contraseña"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500" />
          </div>
          {errorForm && <div className="bg-red-50 border border-red-200 rounded-lg p-3"><p className="text-sm text-red-700">{errorForm}</p></div>}
          <button type="submit" className="w-full px-4 py-3 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 font-semibold flex items-center justify-center space-x-2">
            <UserPlus size={20} /><span>Crear Administrador</span>
          </button>
        </form>
      </div>
    </div>
  );
}

function ModalEditarAdmin({ admin, onClose, onSubmit }) {
  const permisosIniciales = admin.permisos || (admin.rol === 'superadmin' ? ['todo'] : []);
  const [form, setForm] = useState({ nombre: admin.nombre, rol: admin.rol, permisos: permisosIniciales, nuevaPassword: '', confirmarPassword: '' });
  const [errorForm, setErrorForm] = useState('');

  const togglePermiso = (id) => setForm(prev => ({
    ...prev,
    permisos: prev.permisos.includes(id) ? prev.permisos.filter(p => p !== id) : [...prev.permisos, id]
  }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorForm('');
    if (form.nuevaPassword && form.nuevaPassword.length < 6) { setErrorForm('La contraseña debe tener al menos 6 caracteres'); return; }
    if (form.nuevaPassword && form.nuevaPassword !== form.confirmarPassword) { setErrorForm('Las contraseñas no coinciden'); return; }
    const cambios = { nombre: form.nombre, rol: form.rol, permisos: form.permisos };
    if (form.nuevaPassword) cambios.password = form.nuevaPassword;
    onSubmit(admin.id, cambios);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b flex justify-between items-center">
          <div>
            <h3 className="text-xl font-bold text-gray-800">Editar Administrador</h3>
            <p className="text-sm text-gray-500">{admin.email}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Nombre Completo *</label>
            <input type="text" required value={form.nombre}
              onChange={(e) => setForm({ ...form, nombre: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Rol *</label>
            <div className="grid grid-cols-2 gap-3">
              {ROLES_ADMIN_MODAL.map(rol => (
                <button key={rol.id} type="button"
                  onClick={() => setForm({ ...form, rol: rol.id })}
                  className={`p-3 rounded-lg border-2 text-left transition ${form.rol === rol.id ? 'border-yellow-500 bg-yellow-50' : 'border-gray-200 hover:border-gray-300'}`}>
                  <p className="font-semibold text-sm">{rol.nombre}</p>
                  <p className="text-xs text-gray-500">{rol.descripcion}</p>
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Permisos Específicos</label>
            <div className="grid grid-cols-2 gap-2 max-h-48 overflow-y-auto p-2 bg-gray-50 rounded-lg">
              {PERMISOS_ADMIN_MODAL.map(permiso => (
                <label key={permiso.id} className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded cursor-pointer">
                  <input type="checkbox" checked={form.permisos.includes(permiso.id)}
                    onChange={() => togglePermiso(permiso.id)} className="w-4 h-4 text-yellow-600 rounded" />
                  <span className="text-sm">{permiso.nombre}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Nueva Contraseña <span className="text-gray-400 font-normal">(dejar vacío para no cambiar)</span></label>
            <div className="grid grid-cols-2 gap-4">
              <input type="password" value={form.nuevaPassword}
                onChange={(e) => setForm({ ...form, nuevaPassword: e.target.value })}
                placeholder="Nueva contraseña"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500" />
              <input type="password" value={form.confirmarPassword}
                onChange={(e) => setForm({ ...form, confirmarPassword: e.target.value })}
                placeholder="Confirmar contraseña"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500" />
            </div>
          </div>
          {errorForm && <div className="bg-red-50 border border-red-200 rounded-lg p-3"><p className="text-sm text-red-700">{errorForm}</p></div>}
          <div className="flex space-x-3 pt-2">
            <button type="button" onClick={onClose}
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium">Cancelar</button>
            <button type="submit"
              className="flex-1 px-4 py-3 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 font-semibold flex items-center justify-center space-x-2">
              <CheckCircle size={20} /><span>Guardar Cambios</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ModalEditarComision({ empresa, onClose, onGuardar }) {
  const [nuevaComision, setNuevaComision] = useState(empresa?.comisionPersonalizada || 20);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="p-6 border-b flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-800">Modificar Comisión</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <div className="p-6">
          <div className="bg-gray-50 rounded-lg p-4 mb-4">
            <p className="text-sm text-gray-500">Empresa</p>
            <p className="font-bold text-lg">{empresa?.nombre}</p>
          </div>
          <div className="mb-6">
            <label className="block text-sm font-semibold text-gray-700 mb-2">Comisión (%)</label>
            <select value={nuevaComision} onChange={(e) => setNuevaComision(parseInt(e.target.value))}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500">
              <option value={10}>10% - Muy Preferencial</option>
              <option value={12}>12% - Preferencial Plus</option>
              <option value={15}>15% - Preferencial</option>
              <option value={18}>18% - Especial</option>
              <option value={20}>20% - Estándar</option>
              <option value={22}>22% - Mayor</option>
              <option value={25}>25% - Máxima</option>
            </select>
          </div>
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-6">
            <p className="text-sm text-yellow-800">
              <AlertCircle size={14} className="inline mr-1" />
              Este cambio aplicará a todas las transacciones futuras de esta empresa.
            </p>
          </div>
          <button onClick={() => onGuardar(empresa.id, nuevaComision)}
            className="w-full px-4 py-3 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 font-semibold">
            Guardar Cambios
          </button>
        </div>
      </div>
    </div>
  );
}

const COORDS_CIUDADES_ADMIN = {
  // BC — Tijuana / Rosarito
  'Tijuana, BC':                    [32.5149, -117.0382],
  'Rosarito, BC':                   [32.3668, -117.0579],
  'Playas de Rosarito, BC':         [32.3500, -117.0600],
  'La Misión, BC':                  [32.0917, -116.8800],
  'El Descanso, BC':                [32.1700, -116.9400],
  'Primo Tapia, BC':                [32.2700, -117.0100],
  'Popotla, BC':                    [32.2350, -117.0300],
  'Puerto Nuevo, BC':               [32.2600, -117.0200],
  // BC — Ensenada
  'Ensenada, BC':                   [31.8667, -116.5960],
  'Maneadero, BC':                  [31.7100, -116.5900],
  'El Sauzal, BC':                  [31.9300, -116.6700],
  'Punta Banda, BC':                [31.7000, -116.6800],
  'Santo Tomás, BC':                [31.5500, -116.4100],
  'Eréndira, BC':                   [31.3800, -116.4000],
  'San Quintín, BC':                [30.5411, -115.9535],
  'Camalu, BC':                     [30.8500, -116.0800],
  'Colonet, BC':                    [30.9700, -116.1000],
  'San Vicente, BC':                [31.3200, -116.2700],
  'El Rosario, BC':                 [30.0600, -115.7200],
  'Vicente Guerrero, BC':           [30.7200, -116.0500],
  'Valle de Guadalupe, BC':         [32.0333, -116.6000],
  // BC — Tecate
  'Tecate, BC':                     [32.5722, -116.6269],
  'El Hongo, BC':                   [32.4400, -116.3400],
  'La Rumorosa, BC':                [32.5400, -116.0700],
  'Valle de las Palmas, BC':        [32.3900, -116.7100],
  'Ojos Negros, BC':                [31.9000, -116.2600],
  // BC — Mexicali
  'Mexicali, BC':                   [32.6245, -115.4523],
  'Algodones, BC':                  [32.7200, -114.7200],
  'San Felipe, BC':                 [31.0200, -114.8383],
  'Guadalupe Victoria, BC':         [32.1000, -115.2500],
  'Ejido Nuevo León, BC':           [32.3500, -115.6000],
  'Ejido Sonora, BC':               [32.4000, -115.7000],
  'Ciudad Morelos, BC':             [32.7600, -114.9300],
  // BC — Costa del Golfo norte
  'Bahía de los Ángeles, BC':       [28.9500, -113.5600],
  'El Mármol, BC':                  [29.8000, -114.5000],
  'Punta Prieta, BC':               [29.0200, -114.1500],
  // BCS — Norte
  'Guerrero Negro, BCS':            [27.9700, -114.0600],
  'Bahía Asunción, BCS':            [27.1400, -114.2800],
  'Punta Abreojos, BCS':            [26.7100, -113.5500],
  'San Ignacio, BCS':               [27.2900, -112.8800],
  'Vizcaíno, BCS':                  [27.9900, -113.8400],
  'Villa Alberto Andrés Alvarado, BCS': [26.9000, -111.9800],
  // BCS — Santa Rosalía / Mulegé
  'Santa Rosalía, BCS':             [27.3300, -112.2700],
  'Mulegé, BCS':                    [26.8900, -111.9800],
  'San Carlos, BCS':                [24.7900, -112.1000],
  'Bahía Concepción, BCS':          [26.7200, -111.8700],
  'Loreto, BCS':                    [26.0100, -111.3400],
  'Puerto Escondido, BCS':          [25.8200, -111.3100],
  // BCS — La Paz
  'La Paz, BCS':                    [24.1426, -110.3128],
  'El Centenario, BCS':             [24.0600, -110.4100],
  'La Ventana, BCS':                [24.0400, -109.9700],
  'Los Planes, BCS':                [23.9200, -110.0800],
  'Todos Santos, BCS':              [23.4500, -110.2200],
  'El Pescadero, BCS':              [23.2700, -110.1300],
  'Ciudad Constitución, BCS':       [25.0600, -111.6700],
  'Ciudad Insurgentes, BCS':        [25.2700, -111.7700],
  'Comondú, BCS':                   [26.0600, -111.8200],
  // BCS — Los Cabos
  'Cabo San Lucas, BCS':            [22.8897, -109.9167],
  'San José del Cabo, BCS':         [23.0600, -109.6900],
  'Los Barriles, BCS':              [23.6800, -109.7200],
  'Buena Vista, BCS':               [23.6500, -109.7000],
  'La Ribera, BCS':                 [23.6300, -109.7300],
  'Miraflores, BCS':                [23.3600, -109.7500],
  'Santiago, BCS':                  [23.4700, -109.7200],
  'El Triunfo, BCS':                [23.7900, -110.1000],
  'San Antonio, BCS':               [23.7300, -110.0900],
  // Resto del país
  'Ciudad de México':               [19.4326,  -99.1332],
  'Guadalajara':                    [20.6597, -103.3496],
  'Monterrey':                      [25.6866, -100.3161],
};

// ─── Panel Retiros de Referidos (admin) ──────────────────────────────────────
function PanelRetirosAdmin() {
  const [retiros, setRetiros] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [gestionando, setGestionando] = React.useState(null);
  const [notasAdmin, setNotasAdmin] = React.useState('');
  const [msg, setMsg] = React.useState(null);
  const [filtro, setFiltro] = React.useState('pendiente');
  const [cancelando, setCancelando] = React.useState(null);

  const cancelarRetiro = async (retiro) => {
    const motivo = window.prompt(`Motivo de cancelación del retiro de ${retiro.usuario?.nombre} ($${retiro.monto.toLocaleString()} MXN):`);
    if (motivo === null) return;
    setCancelando(retiro.id); setMsg(null);
    try {
      await apiRetiroCancelar(retiro.id, motivo);
      setMsg({ ok: true, text: 'Retiro cancelado correctamente.' });
      cargar();
    } catch (e) {
      setMsg({ ok: false, text: 'Error al cancelar: ' + (e.message || 'intenta más tarde') });
    } finally {
      setCancelando(null);
    }
  };

  const cargar = React.useCallback(() => {
    apiGetRetiros().then(r => setRetiros(r || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  React.useEffect(() => { cargar(); }, [cargar]);

  const gestionar = async (id, accion) => {
    setGestionando(id + accion); setMsg(null);
    try {
      const res = await apiGestionarRetiro(id, accion, notasAdmin);
      if (accion === 'pagar') {
        const via = res.metodo === 'mercadopago' ? `vía MercadoPago (ID: ${res.transferId})` : 'marcado como manual — realiza el SPEI manualmente';
        setMsg({ ok: true, text: `Pago procesado ${via}` });
      } else {
        setMsg({ ok: true, text: `Retiro ${accion === 'aprobar' ? 'aprobado' : 'rechazado'}` });
      }
      try { await cargar(); } catch { /* recargar falló */ }
    } catch (e) { setMsg({ ok: false, text: e.message || 'Error al gestionar' }); }
    setGestionando(null); setNotasAdmin('');
  };

  const retirosFiltrados = filtro === 'todos' ? retiros : retiros.filter(r => r.status === filtro);
  const pendientes = retiros.filter(r => r.status === 'pendiente').length;
  const colorStatus = { pendiente: 'bg-yellow-100 text-yellow-700', aprobado: 'bg-blue-100 text-blue-700', pagado: 'bg-green-100 text-green-700', rechazado: 'bg-red-100 text-red-700', cancelado: 'bg-gray-100 text-gray-600' };

  return (
    <div className="mt-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
          💸 Solicitudes de Retiro
          {pendientes > 0 && <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">{pendientes}</span>}
        </h3>
        <button onClick={cargar} className="text-xs text-gray-500 hover:text-gray-700 border border-gray-300 px-3 py-1.5 rounded-lg">Actualizar</button>
      </div>

      {msg && (
        <div className={`mb-4 px-4 py-3 rounded-lg text-sm font-medium ${msg.ok ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
          {msg.text}
        </div>
      )}

      <div className="flex gap-2 mb-4">
        {[{ id: 'pendiente', label: '⏳ Pendientes' }, { id: 'aprobado', label: '✅ Aprobados' }, { id: 'pagado', label: '💚 Pagados' }, { id: 'rechazado', label: '❌ Rechazados' }, { id: 'cancelado', label: '🚫 Cancelados' }, { id: 'todos', label: 'Todos' }].map(f => (
          <button key={f.id} onClick={() => setFiltro(f.id)}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition ${filtro === f.id ? 'bg-gray-800 text-white' : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50'}`}>
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-8 text-gray-400">Cargando...</div>
      ) : retirosFiltrados.length === 0 ? (
        <div className="text-center py-8 text-gray-400 text-sm">No hay retiros con este filtro</div>
      ) : (
        <div className="space-y-3">
          {retirosFiltrados.map(r => (
            <div key={r.id} className="bg-white border border-gray-200 rounded-xl p-4">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1">
                    <p className="font-bold text-gray-800">{r.usuario?.nombre || '—'}</p>
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${colorStatus[r.status] || 'bg-gray-100 text-gray-600'}`}>{r.status}</span>
                  </div>
                  <p className="text-sm text-gray-500">{r.usuario?.email}</p>
                  <div className="flex items-center gap-4 mt-2 text-sm">
                    <span className="font-bold text-green-700 text-lg">${r.monto.toLocaleString()} MXN</span>
                    {r.montoNeto != null && (
                      <span className="text-xs text-gray-500">
                        Neto: <span className="font-semibold text-green-700">${r.montoNeto.toLocaleString()}</span>
                        {' · '}ISR: <span className="text-red-600">${r.montoIsr?.toLocaleString()}</span>
                      </span>
                    )}
                    <span className="text-gray-400">vía SPEI</span>
                  </div>
                  {r.cuenta?.clabe && (
                    <p className="text-xs text-gray-500 font-mono mt-1">
                      CLABE: {r.cuenta.clabe}
                      {r.cuenta.banco && <span className="font-sans ml-2">· {r.cuenta.banco}</span>}
                    </p>
                  )}
                  {r.rfcReferidor && <p className="text-xs text-gray-500 mt-0.5">RFC: <span className="font-mono">{r.rfcReferidor}</span></p>}
                  <p className="text-xs text-gray-400 mt-1">{new Date(r.creadoEn).toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' })}</p>
                  {r.notasAdmin && <p className="text-xs text-orange-600 mt-1 bg-orange-50 px-2 py-1 rounded">Nota: {r.notasAdmin}</p>}
                  {r.transferId && <p className="text-xs text-green-700 mt-1 font-mono bg-green-50 px-2 py-1 rounded">ID transferencia: {r.transferId}</p>}
                </div>

                {/* Acciones */}
                {r.status === 'pendiente' && (
                  <div className="flex flex-col gap-2 flex-shrink-0">
                    <button
                      onClick={() => gestionar(r.id, 'aprobar')}
                      disabled={!!gestionando}
                      className="px-4 py-2 bg-blue-600 text-white text-xs font-semibold rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                    >
                      ✅ Aprobar
                    </button>
                    <button
                      onClick={() => gestionar(r.id, 'rechazar')}
                      disabled={!!gestionando}
                      className="px-4 py-2 bg-red-100 text-red-700 text-xs font-semibold rounded-lg hover:bg-red-200 transition disabled:opacity-50"
                    >
                      ❌ Rechazar
                    </button>
                  </div>
                )}
                {r.status === 'aprobado' && (
                  <button
                    onClick={() => gestionar(r.id, 'pagar')}
                    disabled={!!gestionando}
                    className="px-4 py-2 bg-green-600 text-white text-xs font-semibold rounded-lg hover:bg-green-700 transition disabled:opacity-50 flex-shrink-0"
                  >
                    {gestionando === r.id + 'pagar' ? '⏳ Pagando...' : '💸 Pagar'}
                  </button>
                )}
                {r.status === 'pagado' && (
                  <button
                    onClick={() => cancelarRetiro(r)}
                    disabled={cancelando === r.id}
                    className="px-3 py-1.5 bg-red-50 text-red-700 text-xs font-semibold rounded-lg hover:bg-red-100 transition disabled:opacity-50 flex-shrink-0 border border-red-200"
                    title="Cancelar retiro"
                  >
                    {cancelando === r.id ? '⏳...' : '🚫 Cancelar'}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Panel Facturación ───────────────────────────────────────────────────────
function SeccionFacturacionAdmin() {
  const [facturas, setFacturas] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [pages, setPages] = React.useState(1);
  const [page, setPage] = React.useState(1);
  const [filtro, setFiltro] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [cancelando, setCancelando] = React.useState(null);
  const [modalCancelar, setModalCancelar] = React.useState(null);
  const [motivoCancelacion, setMotivoCancelacion] = React.useState('03');
  const [health, setHealth] = React.useState(null);
  const [diagnostico, setDiagnostico] = React.useState(null);
  const [diagnosticandoId, setDiagnosticandoId] = React.useState(null);
  const [debugRespuesta, setDebugRespuesta] = React.useState(null);
  const [loadingDebug, setLoadingDebug] = React.useState(false);

  const cargar = React.useCallback(async (p = 1) => {
    setLoading(true);
    try {
      const params = { page: p };
      if (filtro) params.status = filtro;
      const d = await apiGetFacturasAdmin(params);
      setFacturas(d.facturas || []);
      setTotal(d.total || 0);
      setPages(d.pages || 1);
      setPage(p);
    } catch (e) {
      console.error('[Facturación] Error cargando:', e.message);
    } finally {
      setLoading(false);
    }
  }, [filtro]);

  React.useEffect(() => { cargar(1); }, [cargar]);

  const verificarConexion = async () => {
    try {
      const r = await apiFacturamaHealth();
      setHealth(r);
    } catch (e) {
      setHealth({ ok: false, error: e.message });
    }
  };

  const debugFacturama = async () => {
    setLoadingDebug(true);
    try {
      const r = await apiFacturamaDebugRespuesta();
      setDebugRespuesta(r);
    } catch (e) {
      setDebugRespuesta({ error: e.message });
    } finally {
      setLoadingDebug(false);
    }
  };

  const MOTIVOS_CANCELACION = [
    { clave: '01', label: '01 — Comprobante emitido con errores con relación' },
    { clave: '02', label: '02 — Comprobante emitido con errores sin relación' },
    { clave: '03', label: '03 — No se llevó a cabo la operación' },
    { clave: '04', label: '04 — Operación nominativa relacionada en factura global' },
  ];

  const confirmarCancelacion = async () => {
    if (!modalCancelar) return;
    setCancelando(modalCancelar.id);
    setModalCancelar(null);
    try {
      await apiCancelarFactura(modalCancelar.id, motivoCancelacion);
      cargar(page);
    } catch (e) {
      alert(e?.message || 'Error al cancelar');
    } finally {
      setCancelando(null);
      setMotivoCancelacion('03');
    }
  };

  const descargar = (dataUrl, nombre) => {
    if (!dataUrl) return;
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = nombre;
    a.click();
  };

  const diagnosticarFactura = async (factura) => {
    const id = factura.cfdiFacturamaId || 'sin-id';
    setDiagnosticandoId(factura.id);
    try {
      const r = await apiFacturaDiagnostico(id);
      setDiagnostico({
        facturaId: factura.id,
        factura: { folio: `${factura.serie || 'CH'}-${factura.folio}`, cfdiId: factura.cfdiFacturamaId, uuid: factura.uuid, folioNum: factura.folio, serie: factura.serie || 'CH' },
        ...r,
      });
    } catch (e) {
      setDiagnostico({ error: e.message });
    } finally {
      setDiagnosticandoId(null);
    }
  };

  const recuperarCfdiId = async (facturaId, cfdiFacturamaId) => {
    try {
      const r = await apiRecuperarCfdiId(facturaId, cfdiFacturamaId);
      if (r.ok) {
        alert(`Vinculado. PDF: ${r.tienePdf ? 'OK' : 'no disponible'} · XML: ${r.tieneXml ? 'OK' : 'no disponible'}`);
        setDiagnostico(null);
        cargar();
      } else {
        alert(`Error: ${r.error}`);
      }
    } catch (e) {
      alert(`Error: ${e.message}`);
    }
  };

  const [descargando, setDescargando] = React.useState({});
  const descargarFactura = async (facturaId, tipo, folio) => {
    const key = `${facturaId}_${tipo}`;
    setDescargando(prev => ({ ...prev, [key]: true }));
    try {
      const res = await apiGetFacturaArchivos(facturaId, true);
      const url = tipo === 'xml' ? res.xmlUrl : res.pdfUrl;
      if (!url) { alert(`No se pudo obtener el ${tipo.toUpperCase()} de Facturama.`); return; }
      descargar(url, `CH-${folio || facturaId}.${tipo}`);
      // Actualizar la factura en lista local con las nuevas URLs
      setFacturas(prev => prev.map(f => f.id === facturaId ? { ...f, xmlUrl: res.xmlUrl, pdfUrl: res.pdfUrl } : f));
    } catch (e) {
      alert(`Error: ${e.message}`);
    } finally {
      setDescargando(prev => ({ ...prev, [key]: false }));
    }
  };

  const statusColor = (s) => ({
    timbrada:  'bg-green-100 text-green-700',
    pendiente: 'bg-yellow-100 text-yellow-700',
    cancelada: 'bg-red-100 text-red-600',
    error:     'bg-red-50 text-red-400',
  }[s] || 'bg-gray-100 text-gray-600');

  return (
    <div className="p-6">
      {/* Modal debug respuesta raw Facturama */}
      {debugRespuesta && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-3xl w-full max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-gray-800">🧪 Debug Respuesta Facturama</h3>
              <button onClick={() => setDebugRespuesta(null)} className="text-gray-400 hover:text-gray-600 text-xl">✕</button>
            </div>
            {debugRespuesta.error && <p className="text-red-600 text-sm mb-4">{debugRespuesta.error}</p>}
            {debugRespuesta.postResult && (
              <div className="mb-4">
                <p className="text-sm font-bold text-gray-700 mb-2">Intentos POST /api/Cfdi:</p>
                {debugRespuesta.postResult.payloadEnviado && (
                  <details className="mb-2 text-xs">
                    <summary className="cursor-pointer text-blue-600">Ver payload enviado</summary>
                    <pre className="mt-1 bg-blue-50 rounded p-2 whitespace-pre-wrap break-all">{JSON.stringify(debugRespuesta.postResult.payloadEnviado, null, 2)}</pre>
                  </details>
                )}
                {debugRespuesta.postResult.resultados && Object.entries(debugRespuesta.postResult.resultados).map(([label, v]) => (
                  <div key={label} className={`rounded-lg p-3 text-xs font-mono mb-2 ${v.msj || v.error ? 'bg-red-50 border border-red-200' : 'bg-green-50 border border-green-200'}`}>
                    <p className="font-bold text-gray-700 mb-1">{label}</p>
                    {v.status && <p>Status: {v.status}</p>}
                    {v.keys && <p>Keys: [{v.keys.join(', ')}]</p>}
                    {v.msj && <p className="text-red-700 font-bold">msj: {String(v.msj)}</p>}
                    {v.success !== undefined && <p>success: {String(v.success)}</p>}
                    {v.Id !== undefined && <p>Id: <b>{String(v.Id)}</b></p>}
                    {v.uuid_complement && <p>UUID: {v.uuid_complement}</p>}
                    {v.error && <p className="text-red-600">HTTP Error: {v.error} — {v.mensaje}</p>}
                    <details className="mt-1">
                      <summary className="cursor-pointer text-gray-400">Ver JSON completo</summary>
                      <pre className="mt-1 whitespace-pre-wrap break-all">{JSON.stringify(v.rawData ?? v.body, null, 2)}</pre>
                    </details>
                  </div>
                ))}
                {/* Compatibilidad con formato antiguo */}
                {!debugRespuesta.postResult.resultados && (
                  <div className={`rounded-lg p-3 text-xs font-mono ${debugRespuesta.postResult.error ? 'bg-red-50 border border-red-200' : 'bg-green-50 border border-green-200'}`}>
                    <pre className="whitespace-pre-wrap break-all">{JSON.stringify(debugRespuesta.postResult, null, 2)}</pre>
                  </div>
                )}
              </div>
            )}
            {debugRespuesta.postResult?.cuentaInfo && (
              <div className="mb-4">
                <p className="text-sm font-bold text-gray-700 mb-2">Información de cuenta Facturama:</p>
                <div className="space-y-1">
                  {Object.entries(debugRespuesta.postResult.cuentaInfo).map(([path, v]) => (
                    <div key={path} className={`rounded px-3 py-2 text-xs font-mono ${v.error ? 'bg-red-50' : 'bg-green-50'}`}>
                      <span className="font-bold">{path}</span>: <pre className="inline whitespace-pre-wrap">{JSON.stringify(v, null, 2)}</pre>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {debugRespuesta.listaResultados && (
              <div>
                <p className="text-sm font-bold text-gray-700 mb-2">Endpoints de lista probados:</p>
                <div className="space-y-1">
                  {Object.entries(debugRespuesta.listaResultados).map(([path, v]) => (
                    <div key={path} className={`rounded px-3 py-2 text-xs font-mono ${v.error ? 'bg-red-50' : 'bg-green-50'}`}>
                      <span className="font-bold">{path}</span>: {JSON.stringify(v)}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal diagnóstico Facturama */}
      {diagnostico && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-gray-800">🔍 Diagnóstico Facturama</h3>
              <button onClick={() => setDiagnostico(null)} className="text-gray-400 hover:text-gray-600 text-xl">✕</button>
            </div>
            {diagnostico.factura && (
              <div className="bg-gray-50 rounded-lg p-3 mb-4 text-sm">
                <p><b>Folio:</b> {diagnostico.factura.folio}</p>
                <p><b>cfdiFacturamaId en DB:</b> <code className="bg-gray-200 px-1 rounded">{diagnostico.factura.cfdiId || '⚠️ NULL'}</code></p>
                <p><b>UUID fiscal:</b> <code className="text-xs">{diagnostico.factura.uuid || '—'}</code></p>
              </div>
            )}
            {/* Lista de CFDIs en Facturama — mostrar primero si cfdiId es null */}
            {diagnostico.resultados?.lista_cfdis && Array.isArray(diagnostico.resultados.lista_cfdis) && (
              <div className="mb-4">
                <p className="text-sm font-semibold text-gray-700 mb-2">
                  CFDIs en Facturama ({diagnostico.resultados.lista_cfdis.length}):
                </p>
                {diagnostico.resultados.lista_cfdis.length === 0 ? (
                  <p className="text-xs text-gray-500 italic">No hay CFDIs emitidos en Facturama.</p>
                ) : (
                  <div className="space-y-1 max-h-48 overflow-y-auto">
                    {diagnostico.resultados.lista_cfdis.map((c, i) => {
                      const folioMatch = diagnostico.factura && c.Folio === diagnostico.factura.folioNum;
                      return (
                        <div key={i} className={`flex items-center justify-between rounded-lg px-3 py-2 text-xs ${folioMatch ? 'bg-green-50 border border-green-300' : 'bg-gray-50 border border-gray-200'}`}>
                          <span className="font-mono">
                            {folioMatch && <span className="text-green-600 font-bold mr-1">✓</span>}
                            {c.Serie}-{c.Folio} · ID: <b>{c.Id}</b>
                            {c.Uuid && <span className="text-gray-400 ml-2">{c.Uuid.slice(0, 8)}…</span>}
                          </span>
                          {!diagnostico.factura?.cfdiId && (
                            <button
                              onClick={() => recuperarCfdiId(diagnostico.facturaId, c.Id)}
                              className="ml-2 px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700"
                            >
                              Vincular
                            </button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            {diagnostico.resultados && !diagnostico.tieneId && (
              <p className="text-xs text-amber-600 bg-amber-50 rounded-lg p-2 mb-3">
                {diagnostico.resultados.aviso || 'cfdiFacturamaId es NULL — busca el folio correcto arriba y haz clic en Vincular.'}
              </p>
            )}
            {diagnostico.resultados && diagnostico.tieneId && (
              <div className="space-y-2">
                <p className="text-sm font-semibold text-gray-600 mb-2">Respuestas de descarga ({diagnostico.baseUrl}):</p>
                {Object.entries(diagnostico.resultados).filter(([k]) => k !== 'lista_cfdis' && k !== 'aviso' && k !== 'lista_endpoint_usado').map(([k, v]) => (
                  <div key={k} className={`rounded-lg p-3 text-xs font-mono ${v.error ? 'bg-red-50 border border-red-200' : 'bg-green-50 border border-green-200'}`}>
                    <p className="font-bold text-gray-700 mb-1">{k}</p>
                    <pre className="whitespace-pre-wrap break-all">{JSON.stringify(v, null, 2)}</pre>
                  </div>
                ))}
              </div>
            )}
            {diagnostico.error && <p className="text-red-600 text-sm">{diagnostico.error}</p>}
          </div>
        </div>
      )}

      {/* Modal cancelación CFDI */}
      {modalCancelar && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full">
            <h3 className="text-lg font-bold text-gray-800 mb-1">Cancelar factura</h3>
            <p className="text-sm text-gray-500 mb-4">
              {modalCancelar.serie}-{modalCancelar.folio} · UUID: <span className="font-mono text-xs">{modalCancelar.uuid}</span>
            </p>
            <p className="text-sm text-red-600 font-medium mb-4">⚠️ Esta acción es irreversible ante el SAT.</p>
            <label className="block text-sm font-medium text-gray-700 mb-2">Motivo de cancelación (SAT)</label>
            <select
              value={motivoCancelacion}
              onChange={e => setMotivoCancelacion(e.target.value)}
              className="w-full border rounded-lg px-3 py-2 text-sm mb-6"
            >
              {MOTIVOS_CANCELACION.map(m => (
                <option key={m.clave} value={m.clave}>{m.label}</option>
              ))}
            </select>
            <div className="flex gap-3">
              <button onClick={() => setModalCancelar(null)} className="flex-1 px-4 py-2 border rounded-lg text-sm font-medium hover:bg-gray-50">
                Volver
              </button>
              <button onClick={confirmarCancelacion} className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700">
                Confirmar cancelación
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
          <FileText size={26} className="text-blue-600" /> Facturación CFDI
        </h2>
        <div className="flex gap-2">
          <button onClick={verificarConexion} className="flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-600 transition">
            🔌 Estado Facturama
          </button>
          <button onClick={debugFacturama} disabled={loadingDebug} className="flex items-center gap-1.5 px-3 py-1.5 text-sm border border-orange-300 rounded-lg hover:bg-orange-50 text-orange-600 disabled:opacity-50 transition">
            {loadingDebug ? '...' : '🧪 Debug API'}
          </button>
          <button onClick={() => cargar(1)} disabled={loading} className="flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-600 disabled:opacity-50 transition">
            <RotateCcw size={14} className={loading ? 'animate-spin' : ''} /> Actualizar
          </button>
        </div>
      </div>

      {health && (
        <div className={`mb-4 p-3 rounded-lg text-sm ${health.ok ? (health.demo ? 'bg-yellow-50 text-yellow-800 border border-yellow-200' : 'bg-green-50 text-green-700 border border-green-200') : 'bg-red-50 text-red-700 border border-red-200'}`}>
          {health.ok
            ? health.demo
              ? `🟡 ${health.data?.mensaje}`
              : '✅ Conexión con Facturama activa'
            : `❌ Error Facturama: ${health.error}`}
        </div>
      )}

      {/* Resumen */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {[
          { label: 'Total', val: total, color: 'gray' },
          { label: 'Timbradas', val: facturas.filter(f => f.status === 'timbrada').length, color: 'green' },
          { label: 'Pendientes', val: facturas.filter(f => f.status === 'pendiente').length, color: 'yellow' },
          { label: 'Errores', val: facturas.filter(f => f.status === 'error').length, color: 'red' },
        ].map(({ label, val, color }) => (
          <div key={label} className={`bg-${color}-50 border border-${color}-200 rounded-xl p-4`}>
            <p className={`text-xs text-${color}-700 font-semibold uppercase mb-1`}>{label}</p>
            <p className={`text-2xl font-bold text-${color}-800`}>{val}</p>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div className="flex gap-2 mb-4 flex-wrap">
        {[{ id: '', label: 'Todas' }, { id: 'timbrada', label: '✅ Timbradas' }, { id: 'pendiente', label: '⏳ Pendientes' }, { id: 'error', label: '❌ Error' }, { id: 'cancelada', label: 'Canceladas' }].map(f => (
          <button key={f.id} onClick={() => setFiltro(f.id)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition ${filtro === f.id ? 'bg-gray-800 text-white' : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50'}`}>
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-16 text-gray-400">Cargando facturas...</div>
      ) : facturas.length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <FileText size={40} className="mx-auto mb-3 opacity-30" />
          <p>No hay facturas con este filtro</p>
        </div>
      ) : (
        <>
          <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Folio</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Empresa</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Ruta</th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Subtotal</th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">IVA</th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Total</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Status</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Fecha</th>
                  <th className="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {facturas.map(f => (
                  <tr key={f.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <p className="font-mono text-xs font-semibold text-gray-800">{f.serie || 'CH'}-{f.folio || '—'}</p>
                      {f.uuid && <p className="text-xs text-gray-400 font-mono truncate max-w-[120px]">{f.uuid}</p>}
                    </td>
                    <td className="px-4 py-3">
                      <p className="text-xs font-semibold text-gray-800 truncate max-w-[120px]">{f.empresa?.nombre || '—'}</p>
                      <p className="text-xs text-gray-400">{f.rfcReceptor || f.empresa?.rfc || '—'}</p>
                    </td>
                    <td className="px-4 py-3 text-xs text-gray-600 truncate max-w-[140px]">
                      {f.viaje ? `${f.viaje.origen?.split(',')[0]} → ${f.viaje.destino?.split(',')[0]}` : '—'}
                    </td>
                    <td className="px-4 py-3 text-right text-xs text-gray-700">${f.subtotal.toLocaleString('es-MX')}</td>
                    <td className="px-4 py-3 text-right text-xs text-gray-500">${f.iva.toLocaleString('es-MX')}</td>
                    <td className="px-4 py-3 text-right text-sm font-bold text-gray-800">${f.total.toLocaleString('es-MX')}</td>
                    <td className="px-4 py-3 text-center">
                      <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${statusColor(f.status)}`}>{f.status}</span>
                      {f.errorMsg && <p className="text-xs text-red-400 mt-0.5 max-w-[100px] truncate">{f.errorMsg}</p>}
                    </td>
                    <td className="px-4 py-3 text-xs text-gray-500">{new Date(f.creadoEn).toLocaleDateString('es-MX')}</td>
                    <td className="px-4 py-3 text-center">
                      <div className="flex items-center justify-center gap-1.5 flex-wrap">
                        {f.status === 'timbrada' && (
                          <button
                            onClick={() => f.xmlUrl ? descargar(f.xmlUrl, `CH-${f.folio || f.id}.xml`) : descargarFactura(f.id, 'xml', f.folio)}
                            disabled={descargando[`${f.id}_xml`]}
                            className="px-2 py-1 text-xs border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-600 transition disabled:opacity-50"
                          >{descargando[`${f.id}_xml`] ? '...' : 'XML'}</button>
                        )}
                        {f.status === 'timbrada' && (
                          <button
                            onClick={() => f.pdfUrl ? descargar(f.pdfUrl, `CH-${f.folio || f.id}.pdf`) : descargarFactura(f.id, 'pdf', f.folio)}
                            disabled={descargando[`${f.id}_pdf`]}
                            className="px-2 py-1 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                          >{descargando[`${f.id}_pdf`] ? '...' : 'PDF'}</button>
                        )}
                        {f.status === 'timbrada' && (
                          <button onClick={() => diagnosticarFactura(f)} disabled={diagnosticandoId === f.id} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-200 disabled:opacity-50 transition" title="Diagnóstico Facturama">
                            {diagnosticandoId === f.id ? '...' : '🔍'}
                          </button>
                        )}
                        {f.status === 'timbrada' && (
                          <button onClick={() => { setModalCancelar(f); setMotivoCancelacion('03'); }} disabled={cancelando === f.id} className="px-2 py-1 text-xs bg-red-50 text-red-600 border border-red-200 rounded-lg hover:bg-red-100 disabled:opacity-50 transition">
                            {cancelando === f.id ? '...' : 'Cancelar'}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Paginación */}
          {pages > 1 && (
            <div className="flex justify-center gap-2 mt-4">
              {Array.from({ length: pages }, (_, i) => i + 1).map(p => (
                <button key={p} onClick={() => cargar(p)}
                  className={`w-8 h-8 rounded-lg text-sm font-medium transition ${page === p ? 'bg-gray-800 text-white' : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50'}`}>
                  {p}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

// ─── Panel Finanzas / Escrow ─────────────────────────────────────────────────
function SeccionFinanzasAdmin() {
  const [pagos, setPagos] = React.useState([]);
  const [resumen, setResumen] = React.useState({ totalRetenido: 0, totalLiberado: 0, comisionTotal: 0 });
  const [resumenMlm, setResumenMlm] = React.useState({ cantidad: 0, totalBruto: 0, totalNeto: 0, totalIsr: 0 });
  const [loading, setLoading] = React.useState(true);
  const [filtro, setFiltro] = React.useState('todos');
  const [liberando, setLiberando] = React.useState(null);
  const [facturando, setFacturando] = React.useState(null);
  const [facturaMsg, setFacturaMsg] = React.useState({});
  const [modalFactura, setModalFactura] = React.useState(null); // pago activo en modal
  const [facturaForm, setFacturaForm] = React.useState({ serie: 'CH', folio: '', pdfFile: null, xmlFile: null });
  const [pagando, setPagando] = React.useState(null);
  const [pagoMsg, setPagoMsg] = React.useState({});
  const [confirmando, setConfirmando] = React.useState(null);

  const cargar = React.useCallback(() => {
    apiGetFinanzasAdmin().then(d => { if (d.ok) { setPagos(d.pagos); setResumen(d.resumen); if (d.resumenMlm) setResumenMlm(d.resumenMlm); } }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  React.useEffect(() => { cargar(); }, [cargar]);

  const liberar = async (pago) => {
    if (!window.confirm(`¿Liberar $${pago.montoTransportista.toLocaleString()} MXN al transportista?\n\nEsta acción no se puede deshacer.`)) return;
    setLiberando(pago.id);
    try {
      await apiAdminLiberarEscrow(pago.id);
      cargar();
    } catch (e) {
      alert(e?.message || 'Error al liberar el pago');
    } finally {
      setLiberando(null);
    }
  };

  const confirmarPago = async (pago) => {
    if (!window.confirm(`¿Confirmar pago de $${pago.monto.toLocaleString()} MXN como recibido?\n\nEsto activará el viaje sin pasar por MercadoPago.`)) return;
    setConfirmando(pago.id);
    try {
      await apiAdminConfirmarPago(pago.id);
      cargar();
    } catch (e) {
      alert(e?.message || 'Error al confirmar el pago');
    } finally {
      setConfirmando(null);
    }
  };

  const pagarTransportista = async (pago) => {
    if (!pago.viajeId) return alert('Este pago no tiene viaje asociado');
    if (!window.confirm(`¿Enviar $${pago.montoTransportista.toLocaleString()} MXN al transportista?\n\nSe intentará transferencia vía MercadoPago. Si no está disponible, se marcará como pago manual para que realices el SPEI.`)) return;
    setPagando(pago.id);
    setPagoMsg(prev => ({ ...prev, [pago.id]: null }));
    try {
      const res = await apiPagarTransportista(pago.viajeId);
      const metodo = res.metodo === 'mercadopago' ? 'vía MercadoPago'
        : res.metodo === 'ya_procesado' ? '(ya estaba procesado)'
        : 'manual — realiza SPEI';
      setPagoMsg(prev => ({ ...prev, [pago.id]: { ok: true, texto: `✅ Pago registrado ${metodo}` } }));
      cargar();
    } catch (e) {
      setPagoMsg(prev => ({ ...prev, [pago.id]: { ok: false, texto: e?.message || 'Error al procesar pago' } }));
    } finally {
      setPagando(null);
    }
  };

  const abrirModalFactura = (pago) => {
    if (!pago.viajeId) return alert('Este pago no tiene viaje asociado');
    setFacturaForm({ serie: 'CH', folio: '', pdfFile: null, xmlFile: null });
    setModalFactura(pago);
  };

  const leerBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const subirFacturaManual = async () => {
    if (!facturaForm.pdfFile) return alert('Selecciona el archivo PDF');
    if (!facturaForm.xmlFile) return alert('Selecciona el archivo XML');
    setFacturando(modalFactura.id);
    setFacturaMsg(prev => ({ ...prev, [modalFactura.id]: null }));
    try {
      const [pdfUrl, xmlUrl] = await Promise.all([
        leerBase64(facturaForm.pdfFile),
        leerBase64(facturaForm.xmlFile),
      ]);
      const base = modalFactura.montoComision || 0;
      const iva = parseFloat((base * 0.16 / 1.16).toFixed(2));
      const subtotal = parseFloat((base - iva).toFixed(2));
      const res = await apiSubirFacturaManual(modalFactura.viajeId, {
        pdfUrl, xmlUrl,
        serie: facturaForm.serie || 'CH',
        folio: facturaForm.folio || null,
        subtotal,
        iva,
        total: base,
      });
      setFacturaMsg(prev => ({ ...prev, [modalFactura.id]: { ok: true, texto: `✅ Factura ${res.factura?.serie || 'CH'}-${res.factura?.folio || ''} subida` } }));
      setModalFactura(null);
      cargar();
    } catch (e) {
      setFacturaMsg(prev => ({ ...prev, [modalFactura.id]: { ok: false, texto: e?.message || 'Error al subir factura' } }));
    } finally {
      setFacturando(null);
    }
  };

  const pagosFiltrados = filtro === 'todos' ? pagos : pagos.filter(p => p.status === filtro);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        <DollarSign size={26} className="text-green-600" /> Finanzas — Panel Escrow
      </h2>

      {/* Resumen */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
          <p className="text-xs text-yellow-700 font-semibold uppercase mb-1">En garantía (por liberar)</p>
          <p className="text-2xl font-bold text-yellow-800">${resumen.totalRetenido.toLocaleString()} <span className="text-sm font-normal">MXN</span></p>
          <p className="text-xs text-yellow-600 mt-1">{pagos.filter(p => p.status === 'retenido').length} pagos</p>
        </div>
        <div className="bg-green-50 border border-green-200 rounded-xl p-4">
          <p className="text-xs text-green-700 font-semibold uppercase mb-1">Total liberado (escrow)</p>
          <p className="text-2xl font-bold text-green-800">${resumen.totalLiberado.toLocaleString()} <span className="text-sm font-normal">MXN</span></p>
          <p className="text-xs text-green-600 mt-1">{pagos.filter(p => p.status === 'liberado').length} pagos</p>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <p className="text-xs text-blue-700 font-semibold uppercase mb-1">Comisión acumulada</p>
          <p className="text-2xl font-bold text-blue-800">${resumen.comisionTotal.toLocaleString()} <span className="text-sm font-normal">MXN</span></p>
          <p className="text-xs text-blue-600 mt-1">De pagos liberados</p>
        </div>
        <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
          <p className="text-xs text-purple-700 font-semibold uppercase mb-1">Retiros MLM pagados</p>
          <p className="text-2xl font-bold text-purple-800">${resumenMlm.totalBruto.toLocaleString()} <span className="text-sm font-normal">MXN</span></p>
          <div className="flex gap-3 mt-1">
            <p className="text-xs text-purple-600">{resumenMlm.cantidad} retiros</p>
            <p className="text-xs text-green-600">Neto: ${resumenMlm.totalNeto.toLocaleString()}</p>
            <p className="text-xs text-red-500">ISR: ${resumenMlm.totalIsr.toLocaleString()}</p>
          </div>
        </div>
      </div>

      {/* Filtros */}
      <div className="flex gap-2 mb-4">
        {[{ id: 'todos', label: 'Todos' }, { id: 'pendiente', label: '⏳ Pendientes' }, { id: 'retenido', label: '🔒 En garantía' }, { id: 'liberado', label: '✅ Liberados' }, { id: 'pagado', label: '💳 Pagados' }, { id: 'cancelado', label: 'Cancelados' }].map(f => (
          <button key={f.id} onClick={() => setFiltro(f.id)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium transition ${filtro === f.id ? 'bg-gray-800 text-white' : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50'}`}>
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-16 text-gray-400">Cargando movimientos...</div>
      ) : pagosFiltrados.length === 0 ? (
        <div className="text-center py-16 text-gray-400">
          <DollarSign size={40} className="mx-auto mb-3 opacity-30" />
          <p>No hay movimientos con este filtro</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Ruta</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Cliente</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Transportista</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Método</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Total cliente</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Comisión</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase">Al transportista</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Estado</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Fecha</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {pagosFiltrados.map(p => (
                <tr key={p.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="px-4 py-3">
                    <p className="font-medium text-gray-800 text-xs truncate max-w-[150px]">{p.viaje?.origen?.split(',')[0]} → {p.viaje?.destino?.split(',')[0]}</p>
                    {p.viaje?.retornoId && <span className="text-xs bg-teal-100 text-teal-700 px-1.5 py-0.5 rounded font-semibold">Retorno</span>}
                  </td>
                  <td className="px-4 py-3 text-gray-600 text-xs">{p.viaje?.clienteNombre || p.viaje?.clienteId?.slice(0,8) || '—'}</td>
                  <td className="px-4 py-3 text-gray-600 text-xs">{p.viaje?.transportista || '—'}</td>
                  <td className="px-4 py-3 text-gray-500 text-xs capitalize">{p.metodoPago || '—'}</td>
                  <td className="px-4 py-3 text-right font-bold text-gray-800">${p.monto.toLocaleString()}</td>
                  <td className="px-4 py-3 text-right text-blue-700 font-semibold">${p.montoComision.toLocaleString()}</td>
                  <td className="px-4 py-3 text-right text-green-700 font-semibold">${p.montoTransportista.toLocaleString()}</td>
                  <td className="px-4 py-3 text-center">
                    {p.status === 'pagado' && !p.transferId?.startsWith('manual-') ? (
                      <span className="bg-purple-100 text-purple-700 text-xs font-semibold px-2 py-1 rounded-full">💳 Pagado</span>
                    ) : p.status === 'pagado' ? (
                      <span className="bg-orange-100 text-orange-700 text-xs font-semibold px-2 py-1 rounded-full">⏳ SPEI pendiente</span>
                    ) : p.status === 'liberado' ? (
                      <span className="bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded-full">✅ Liberado</span>
                    ) : p.status === 'retenido' ? (
                      <span className="bg-yellow-100 text-yellow-700 text-xs font-semibold px-2 py-1 rounded-full">🔒 Retenido</span>
                    ) : p.status === 'pendiente' ? (
                      <span className="bg-blue-100 text-blue-700 text-xs font-semibold px-2 py-1 rounded-full">⏳ Pendiente</span>
                    ) : (
                      <span className="bg-red-100 text-red-700 text-xs font-semibold px-2 py-1 rounded-full">Cancelado</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-gray-500 text-xs">
                    <p>{new Date(p.creadoEn).toLocaleDateString('es-MX')}</p>
                    {p.fechaLiberacion && <p className="text-green-600">Lib: {new Date(p.fechaLiberacion).toLocaleDateString('es-MX')}</p>}
                    {p.fechaTransferencia && <p className="text-purple-600">Pago: {new Date(p.fechaTransferencia).toLocaleDateString('es-MX')}</p>}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <div className="flex flex-col items-center gap-1.5">
                      {p.status === 'pendiente' && (
                        <>
                          <button
                            onClick={() => confirmarPago(p)}
                            disabled={confirmando === p.id}
                            className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white text-xs font-semibold rounded-lg transition whitespace-nowrap"
                          >
                            {confirmando === p.id ? '...' : '✅ Confirmar pago'}
                          </button>
                          <button
                            onClick={async () => {
                              if (!window.confirm('¿Cancelar este pago pendiente? El viaje asociado también se cancelará si está en pendiente_pago.')) return;
                              try {
                                await apiAdminCancelarPago(p.id);
                                setPagos(prev => prev.map(x => x.id === p.id ? { ...x, status: 'cancelado' } : x));
                              } catch (e) { alert(e.message || 'Error al cancelar'); }
                            }}
                            className="px-3 py-1.5 bg-red-100 hover:bg-red-200 text-red-700 text-xs font-semibold rounded-lg transition whitespace-nowrap"
                          >
                            ✕ Cancelar pago
                          </button>
                        </>
                      )}
                      {p.status === 'retenido' && (
                        <button
                          onClick={() => liberar(p)}
                          disabled={liberando === p.id}
                          className="px-3 py-1.5 bg-green-600 hover:bg-green-700 disabled:bg-green-300 text-white text-xs font-semibold rounded-lg transition whitespace-nowrap"
                        >
                          {liberando === p.id ? '...' : '💸 Liberar'}
                        </button>
                      )}
                      {p.viajeId && ['liberado', 'retenido', 'pagado'].includes(p.status) && (() => {
                        const factura = p.viaje?.facturas?.[0];
                        if (factura?.status === 'timbrada') {
                          return <span className="text-xs text-green-700 font-semibold bg-green-50 border border-green-200 rounded-lg px-2 py-1">🧾 {factura.serie || 'CH'}-{factura.folio}</span>;
                        }
                        if (factura?.status === 'pendiente') {
                          return <span className="text-xs text-yellow-600 font-semibold">⏳ Facturando...</span>;
                        }
                        return (
                          <button
                            onClick={() => abrirModalFactura(p)}
                            disabled={facturando === p.id}
                            className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white text-xs font-semibold rounded-lg transition whitespace-nowrap"
                          >
                            {facturando === p.id ? '...' : '🧾 Facturar'}
                          </button>
                        );
                      })()}
                      {p.viajeId && p.status === 'liberado' && (
                        <button
                          onClick={() => pagarTransportista(p)}
                          disabled={pagando === p.id}
                          className="px-3 py-1.5 bg-purple-600 hover:bg-purple-700 disabled:bg-purple-300 text-white text-xs font-semibold rounded-lg transition whitespace-nowrap"
                        >
                          {pagando === p.id ? '...' : '💳 Pagar'}
                        </button>
                      )}
                      {p.status === 'pagado' && (
                        !p.transferId?.startsWith('manual-')
                          ? <span className="text-xs text-purple-700 font-semibold">✅ Pagado</span>
                          : <span className="text-xs text-orange-600 font-semibold">🏦 Enviar SPEI pendiente</span>
                      )}
                      {facturaMsg[p.id] && (
                        <p className={`text-xs ${facturaMsg[p.id].ok ? 'text-green-600' : 'text-red-500'}`}>{facturaMsg[p.id].texto}</p>
                      )}
                      {pagoMsg[p.id] && (
                        <p className={`text-xs ${pagoMsg[p.id].ok ? 'text-purple-600' : 'text-red-500'}`}>{pagoMsg[p.id].texto}</p>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Panel de retiros de referidos */}
      <PanelRetirosAdmin />

      {/* Modal: subir factura manual */}
      {modalFactura && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
            <h3 className="text-lg font-bold text-gray-800 mb-1">🧾 Subir Factura Manual</h3>
            <p className="text-sm text-gray-500 mb-3">
              {modalFactura.viaje?.origen || ''} → {modalFactura.viaje?.destino || ''}
            </p>

            {/* Datos fiscales del receptor (transportista) */}
            {modalFactura.viaje?.empresa && (
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-3 mb-4">
                <p className="text-xs font-semibold text-gray-500 uppercase mb-2">📋 Datos del receptor — captura en Facturama</p>
                <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
                  <div>
                    <span className="text-xs text-gray-400">Razón Social</span>
                    <p className="font-semibold text-gray-800">{modalFactura.viaje.empresa.razonSocial || modalFactura.viaje.empresa.nombre || '—'}</p>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400">RFC</span>
                    <p className="font-semibold text-gray-800 font-mono">{modalFactura.viaje.empresa.rfc || '—'}</p>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400">Régimen Fiscal</span>
                    <p className="font-semibold text-gray-800">{modalFactura.viaje.empresa.regimenFiscal || '—'}</p>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400">CP Fiscal</span>
                    <p className="font-semibold text-gray-800">{modalFactura.viaje.empresa.cpFiscal || '—'}</p>
                  </div>
                  <div>
                    <span className="text-xs text-gray-400">Uso CFDI</span>
                    <p className="font-semibold text-gray-800">{modalFactura.viaje.empresa.usoCfdi || 'G03'}</p>
                  </div>
                </div>
                {(!modalFactura.viaje.empresa.rfc || !modalFactura.viaje.empresa.razonSocial) && (
                  <p className="text-xs text-orange-600 mt-2">⚠️ Datos fiscales incompletos — pide al transportista que los registre en su perfil.</p>
                )}
              </div>
            )}

            {/* Desglose fiscal automático */}
            {(() => {
              const flete = modalFactura.monto || 0;
              const base = modalFactura.montoComision || 0;
              const subtotal = parseFloat((base / 1.16).toFixed(2));
              const iva = parseFloat((subtotal * 0.16).toFixed(2));
              const retIva = parseFloat((subtotal * 0.04).toFixed(2));
              const retIsr = parseFloat((subtotal * 0.0125).toFixed(2));
              const neto = parseFloat((base - retIva - retIsr).toFixed(2));
              return (
                <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 mb-4 text-sm">
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-xs font-semibold text-blue-700 uppercase">Desglose fiscal — captura en Facturama</p>
                  </div>
                  <div className="bg-blue-100 rounded-lg px-3 py-1.5 mb-3 flex justify-between items-center">
                    <span className="text-xs text-blue-700">Flete ${flete.toLocaleString('es-MX')} × 20% comisión</span>
                    <span className="font-bold text-blue-800">${base.toLocaleString('es-MX')} MXN</span>
                  </div>
                  <div className="space-y-1">
                    <div className="flex justify-between text-gray-700">
                      <span>Subtotal (sin IVA)</span>
                      <span className="font-medium">${subtotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div className="flex justify-between text-gray-700">
                      <span>IVA trasladado 16%</span>
                      <span className="font-medium">${iva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div className="flex justify-between font-bold text-blue-800 border-t border-blue-200 pt-1 mt-1">
                      <span>Total factura</span>
                      <span>${base.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>
                    </div>
                    <div className="border-t border-orange-200 pt-1 mt-1 space-y-1">
                      <p className="text-xs font-semibold text-orange-700 uppercase">Retenciones (las aplica la empresa PM)</p>
                      <div className="flex justify-between text-orange-700">
                        <span>Ret. IVA 4%</span>
                        <span>-${retIva.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>
                      </div>
                      <div className="flex justify-between text-orange-700">
                        <span>Ret. ISR 1.25%</span>
                        <span>-${retIsr.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>
                    <div className="flex justify-between font-bold text-green-800 border-t border-green-200 pt-1 mt-1">
                      <span>Neto que recibes</span>
                      <span>${neto.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 mt-2">Si el transportista es PF, no aplican retenciones — total = neto</p>
                </div>
              );
            })()}

            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Serie</label>
                  <input
                    value={facturaForm.serie}
                    onChange={e => setFacturaForm(f => ({ ...f, serie: e.target.value }))}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    placeholder="CH"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Folio</label>
                  <input
                    value={facturaForm.folio}
                    onChange={e => setFacturaForm(f => ({ ...f, folio: e.target.value }))}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    placeholder="001"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">PDF de la factura <span className="text-red-500">*</span></label>
                <input
                  type="file"
                  accept=".pdf,application/pdf"
                  onChange={e => setFacturaForm(f => ({ ...f, pdfFile: e.target.files[0] || null }))}
                  className="w-full text-sm text-gray-600 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-700 file:font-semibold hover:file:bg-blue-100"
                />
                {facturaForm.pdfFile && <p className="text-xs text-green-600 mt-1">✓ {facturaForm.pdfFile.name}</p>}
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">XML de la factura <span className="text-red-500">*</span></label>
                <input
                  type="file"
                  accept=".xml,text/xml,application/xml"
                  onChange={e => setFacturaForm(f => ({ ...f, xmlFile: e.target.files[0] || null }))}
                  className="w-full text-sm text-gray-600 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:bg-green-50 file:text-green-700 file:font-semibold hover:file:bg-green-100"
                />
                {facturaForm.xmlFile && <p className="text-xs text-green-600 mt-1">✓ {facturaForm.xmlFile.name}</p>}
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => setModalFactura(null)}
                className="flex-1 py-2.5 border border-gray-300 rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                onClick={subirFacturaManual}
                disabled={facturando === modalFactura.id || !facturaForm.pdfFile || !facturaForm.xmlFile}
                className="flex-1 py-2.5 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white rounded-xl text-sm font-semibold"
              >
                {facturando === modalFactura.id ? 'Subiendo...' : 'Subir Factura'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function FormCambiarPassword() {
  const [passForm, setPassForm] = useState({ actual: '', nueva: '', confirmar: '' });
  const [passMsg, setPassMsg] = useState(null);
  const [passGuardando, setPassGuardando] = useState(false);
  const cambiarPass = async () => {
    setPassMsg(null);
    if (!passForm.actual || !passForm.nueva) return setPassMsg({ ok: false, text: 'Completa todos los campos' });
    if (passForm.nueva.length < 6) return setPassMsg({ ok: false, text: 'La nueva contraseña debe tener al menos 6 caracteres' });
    if (passForm.nueva !== passForm.confirmar) return setPassMsg({ ok: false, text: 'Las contraseñas no coinciden' });
    setPassGuardando(true);
    try {
      await apiCambiarPassword({ passwordActual: passForm.actual, passwordNuevo: passForm.nueva });
      setPassMsg({ ok: true, text: 'Contraseña actualizada correctamente' });
      setPassForm({ actual: '', nueva: '', confirmar: '' });
    } catch (e) {
      setPassMsg({ ok: false, text: e?.message || 'Error al cambiar contraseña' });
    } finally {
      setPassGuardando(false);
    }
  };
  return (
    <div className="space-y-3">
      <div>
        <label className="block text-xs font-semibold text-gray-600 mb-1">Contraseña actual</label>
        <input type="password" value={passForm.actual} onChange={e => setPassForm(p => ({ ...p, actual: e.target.value }))}
          placeholder="••••••••" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-400" />
      </div>
      <div>
        <label className="block text-xs font-semibold text-gray-600 mb-1">Nueva contraseña</label>
        <input type="password" value={passForm.nueva} onChange={e => setPassForm(p => ({ ...p, nueva: e.target.value }))}
          placeholder="Mínimo 6 caracteres" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-400" />
      </div>
      <div>
        <label className="block text-xs font-semibold text-gray-600 mb-1">Confirmar nueva contraseña</label>
        <input type="password" value={passForm.confirmar} onChange={e => setPassForm(p => ({ ...p, confirmar: e.target.value }))}
          placeholder="Repite la nueva contraseña" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-400" />
      </div>
      {passMsg && (
        <div className={`rounded-lg px-3 py-2 text-sm ${passMsg.ok ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
          {passMsg.text}
        </div>
      )}
      <button onClick={cambiarPass} disabled={passGuardando}
        className="w-full py-2 bg-red-600 hover:bg-red-700 disabled:bg-red-300 text-white rounded-lg font-semibold text-sm transition">
        {passGuardando ? 'Guardando...' : 'Cambiar contraseña'}
      </button>
    </div>
  );
}

// ── Gráfica de barras SVG pura (sin dependencias) ─────────────────────────────
function BarChart({ datos, campo, color, formatear }) {
  const max = Math.max(...datos.map(d => d[campo]), 1);
  const H = 120; // altura máxima de barra en px
  return (
    <div className="flex items-end gap-2 h-32 pt-2">
      {datos.map((d, i) => {
        const h = Math.round((d[campo] / max) * H);
        return (
          <div key={i} className="flex flex-col items-center flex-1 gap-1">
            <span className="text-xs text-gray-500 font-medium leading-none">
              {d[campo] > 0 ? formatear(d[campo]) : ''}
            </span>
            <div
              className="w-full rounded-t-md transition-all duration-500"
              style={{ height: `${Math.max(h, d[campo] > 0 ? 4 : 0)}px`, backgroundColor: color }}
            />
            <span className="text-xs text-gray-400 whitespace-nowrap">{d.mes}</span>
          </div>
        );
      })}
    </div>
  );
}

function GraficasTendencias() {
  const [tendencias, setTendencias] = useState([]);
  const [cargando, setCargando]     = useState(true);

  useEffect(() => {
    apiGetTendencias()
      .then(t => setTendencias(t || []))
      .catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  if (cargando) return null;
  if (tendencias.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
      {/* Viajes completados por mes */}
      <div className="bg-white rounded-xl shadow-lg p-6">
        <h3 className="text-base font-bold text-gray-800 mb-1">Viajes completados</h3>
        <p className="text-xs text-gray-400 mb-4">Últimos 6 meses</p>
        <BarChart
          datos={tendencias}
          campo="viajes"
          color="#ea580c"
          formatear={v => v}
        />
      </div>

      {/* Ingresos por mes */}
      <div className="bg-white rounded-xl shadow-lg p-6">
        <h3 className="text-base font-bold text-gray-800 mb-1">Ingresos (GMV)</h3>
        <p className="text-xs text-gray-400 mb-4">Últimos 6 meses · MXN</p>
        <BarChart
          datos={tendencias}
          campo="ingresos"
          color="#16a34a"
          formatear={v => `$${(v/1000).toFixed(0)}k`}
        />
      </div>
    </div>
  );
}

// ── Plantillas rápidas para el formulario de Mensajes — precargan título y
// mensaje (siguen siendo editables antes de enviar) para no escribir desde
// cero los avisos más comunes ──────────────────────────────────────────────
const PLANTILLAS_MENSAJE = [
  {
    id: 'mantenimiento',
    emoji: '🔧',
    label: 'Mantenimiento',
    titulo: '🔧 Mantenimiento programado',
    mensaje: 'La plataforma estará en mantenimiento el [fecha] de [hora] a [hora]. Disculpa las molestias.',
  },
  {
    id: 'promocion',
    emoji: '🎉',
    label: 'Nueva promoción',
    titulo: '🎉 ¡Nueva promoción disponible!',
    mensaje: 'Tenemos una promoción especial para ti: [detalle]. Aprovéchala antes de que se acabe.',
  },
  {
    id: 'actualizacion',
    emoji: '📢',
    label: 'Actualización de la app',
    titulo: '📢 Actualizamos Choyero',
    mensaje: 'Hicimos mejoras en la plataforma. Si tienes la app instalada, ábrela para ver las últimas actualizaciones.',
  },
  {
    id: 'aviso',
    emoji: '⚠️',
    label: 'Aviso importante',
    titulo: '⚠️ Aviso importante',
    mensaje: 'Queremos informarte lo siguiente: [detalle].',
  },
  {
    id: 'oferta',
    emoji: '💰',
    label: 'Oferta / descuento',
    titulo: '💰 Oferta especial por tiempo limitado',
    mensaje: 'Por tiempo limitado: [descuento] en [qué]. Usa el código [código] al cotizar.',
  },
  {
    id: 'cobertura',
    emoji: '🚛',
    label: 'Nueva cobertura',
    titulo: '🚛 ¡Ya estamos en tu ciudad!',
    mensaje: 'Choyero ya está disponible en [ciudad]. ¡Empieza a cotizar tu flete hoy mismo!',
  },
];

// ── Etiquetas legibles para cada acción de auditoría ──────────────────────────
const ETIQUETAS_ACCION = {
  empresa_aprobada:       'Empresa aprobada',
  empresa_rechazada:      'Empresa rechazada',
  empresa_suspendida:     'Empresa suspendida',
  plan_cambiado:          'Plan cambiado',
  escrow_liberado_admin:  'Escrow liberado',
  viaje_status_cambiado:  'Cambio de status de viaje',
};

function SeccionMensajes({ usuario, usuarios }) {
  const [destinatario, setDestinatario] = useState('transportistas');
  const [titulo, setTitulo] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [cargandoHistorial, setCargandoHistorial] = useState(true);
  const [busquedaUsuario, setBusquedaUsuario] = useState('');
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [plantillaActiva, setPlantillaActiva] = useState(null);

  const aplicarPlantilla = (plantilla) => {
    setPlantillaActiva(plantilla.id);
    setTitulo(plantilla.titulo);
    setMensaje(plantilla.mensaje);
  };

  useEffect(() => {
    apiGetMensajesAdmin()
      .then(msgs => setHistorial(msgs || []))
      .catch(() => {})
      .finally(() => setCargandoHistorial(false));
  }, []);

  const usuariosFiltrados = busquedaUsuario.trim().length >= 2
    ? usuarios.filter(u =>
        ['transportista', 'cliente'].includes(u.rol) &&
        !u.email?.includes('@chofer.choyero') &&
        (u.nombre?.toLowerCase().includes(busquedaUsuario.toLowerCase()) ||
         u.email?.toLowerCase().includes(busquedaUsuario.toLowerCase()))
      ).slice(0, 8)
    : [];

  const handleEnviar = async (e) => {
    e.preventDefault();
    if (!titulo.trim() || !mensaje.trim()) return;
    if (destinatario === 'usuario' && !usuarioSeleccionado) return;
    setEnviando(true);
    setResultado(null);
    try {
      const payload = { destinatario, titulo, mensaje };
      if (destinatario === 'usuario') payload.usuarioId = usuarioSeleccionado.id;
      const res = await apiEnviarMensajeAdmin(payload);
      setResultado({ ok: true, enviados: res.enviados, nombre: usuarioSeleccionado?.nombre });
      setTitulo('');
      setMensaje('');
      setBusquedaUsuario('');
      setUsuarioSeleccionado(null);
      setPlantillaActiva(null);
      const msgs = await apiGetMensajesAdmin().catch(() => []);
      setHistorial(msgs || []);
    } catch (err) {
      setResultado({ error: err.message || 'Error al enviar' });
    } finally {
      setEnviando(false);
    }
  };

  const labelDestinatario = (d, nombre) => {
    if (d === 'transportistas') return '🚛 Transportistas';
    if (d === 'clientes') return '👤 Clientes';
    return nombre ? `👤 ${nombre}` : '👤 Usuario específico';
  };

  const canEnviar = titulo.trim() && mensaje.trim() && (destinatario !== 'usuario' || usuarioSeleccionado);

  return (
    <div className="max-w-3xl">
      <h2 className="text-3xl font-bold text-gray-800 mb-2">Mensajes</h2>
      <p className="text-gray-500 mb-8">Envía notificaciones in-app a transportistas, clientes o un usuario específico. Aparecen en el campana 🔔 de cada usuario.</p>

      {/* Formulario */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-8">
        <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2"><Send size={18} className="text-orange-500" /> Nuevo mensaje</h3>
        <form onSubmit={handleEnviar} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Destinatarios</label>
            <div className="flex gap-2">
              {['transportistas', 'clientes', 'usuario'].map(d => (
                <button
                  key={d}
                  type="button"
                  onClick={() => { setDestinatario(d); setUsuarioSeleccionado(null); setBusquedaUsuario(''); }}
                  className={`flex-1 py-2.5 px-3 rounded-xl border-2 text-sm font-semibold transition ${destinatario === d ? 'border-orange-500 bg-orange-50 text-orange-700' : 'border-gray-200 text-gray-500 hover:border-gray-300'}`}
                >
                  {d === 'transportistas' ? '🚛 Transportistas' : d === 'clientes' ? '👤 Clientes' : '🎯 Específico'}
                </button>
              ))}
            </div>
          </div>

          {/* Buscador de usuario específico */}
          {destinatario === 'usuario' && (
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Buscar usuario <span className="text-red-400">*</span></label>
              {usuarioSeleccionado ? (
                <div className="flex items-center justify-between px-4 py-3 bg-orange-50 border-2 border-orange-400 rounded-xl">
                  <div>
                    <p className="font-semibold text-orange-800 text-sm">{usuarioSeleccionado.nombre}</p>
                    <p className="text-xs text-orange-600">{usuarioSeleccionado.email} · {usuarioSeleccionado.rol}</p>
                  </div>
                  <button type="button" onClick={() => { setUsuarioSeleccionado(null); setBusquedaUsuario(''); }} className="text-orange-400 hover:text-orange-600"><X size={18} /></button>
                </div>
              ) : (
                <div className="relative">
                  <input
                    type="text"
                    value={busquedaUsuario}
                    onChange={e => setBusquedaUsuario(e.target.value)}
                    placeholder="Escribe nombre o email del usuario..."
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-400 focus:outline-none text-sm"
                    autoComplete="off"
                  />
                  {usuariosFiltrados.length > 0 && (
                    <ul className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
                      {usuariosFiltrados.map(u => (
                        <li
                          key={u.id}
                          onClick={() => { setUsuarioSeleccionado(u); setBusquedaUsuario(''); }}
                          className="px-4 py-3 hover:bg-orange-50 cursor-pointer border-b border-gray-100 last:border-0"
                        >
                          <p className="text-sm font-semibold text-gray-800">{u.nombre}</p>
                          <p className="text-xs text-gray-500">{u.email} · <span className="capitalize">{u.rol}</span></p>
                        </li>
                      ))}
                    </ul>
                  )}
                  {busquedaUsuario.trim().length >= 2 && usuariosFiltrados.length === 0 && (
                    <p className="text-xs text-gray-400 mt-1">Sin resultados para "{busquedaUsuario}"</p>
                  )}
                </div>
              )}
            </div>
          )}

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Plantillas rápidas</label>
            <div className="flex flex-wrap gap-2">
              {PLANTILLAS_MENSAJE.map(p => (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => aplicarPlantilla(p)}
                  className={`px-3 py-1.5 rounded-full border-2 text-xs font-semibold transition ${plantillaActiva === p.id ? 'border-orange-500 bg-orange-50 text-orange-700' : 'border-gray-200 text-gray-500 hover:border-gray-300'}`}
                >
                  {p.emoji} {p.label}
                </button>
              ))}
            </div>
            <p className="text-xs text-gray-400 mt-1.5">Precargan el título y mensaje — puedes editarlos antes de enviar.</p>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Título <span className="text-red-400">*</span></label>
            <input
              type="text"
              value={titulo}
              onChange={e => { setTitulo(e.target.value); setPlantillaActiva(null); }}
              placeholder="Ej. Mantenimiento programado"
              maxLength={100}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-400 focus:outline-none text-sm"
            />
            <p className="text-xs text-gray-400 mt-1 text-right">{titulo.length}/100</p>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Mensaje <span className="text-red-400">*</span></label>
            <textarea
              value={mensaje}
              onChange={e => { setMensaje(e.target.value); setPlantillaActiva(null); }}
              placeholder="Escribe el mensaje completo aquí..."
              rows={4}
              maxLength={500}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-400 focus:outline-none text-sm resize-none"
            />
            <p className="text-xs text-gray-400 mt-1 text-right">{mensaje.length}/500</p>
          </div>
          {resultado && (
            <div className={`p-3 rounded-xl text-sm font-medium ${resultado.ok ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
              {resultado.ok
                ? resultado.nombre
                  ? `✅ Mensaje enviado a ${resultado.nombre}`
                  : `✅ Mensaje enviado a ${resultado.enviados} usuario${resultado.enviados !== 1 ? 's' : ''}`
                : `❌ ${resultado.error}`}
            </div>
          )}
          <button
            type="submit"
            disabled={enviando || !canEnviar}
            className="w-full py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {enviando ? <><RefreshCw size={16} className="animate-spin" /> Enviando...</> : <><Send size={16} /> Enviar mensaje</>}
          </button>
        </form>
      </div>

      {/* Historial */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
        <h3 className="font-bold text-gray-800 mb-4">Historial de mensajes enviados</h3>
        {cargandoHistorial ? (
          <p className="text-gray-400 text-sm">Cargando...</p>
        ) : historial.length === 0 ? (
          <p className="text-gray-400 text-sm">Aún no se han enviado mensajes.</p>
        ) : (
          <div className="space-y-3">
            {historial.map((log) => {
              const d = log.datos || {};
              return (
                <div key={log.id} className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                  <div className="flex items-start justify-between gap-3 mb-1">
                    <p className="font-semibold text-gray-800 text-sm">{d.titulo}</p>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-semibold flex-shrink-0 ${d.destinatario === 'transportistas' ? 'bg-blue-100 text-blue-700' : d.destinatario === 'usuario' ? 'bg-purple-100 text-purple-700' : 'bg-green-100 text-green-700'}`}>
                      {labelDestinatario(d.destinatario)}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mb-2">{d.mensaje}</p>
                  <div className="flex items-center justify-between text-xs text-gray-400">
                    <span>Por {log.adminEmail} · {d.destinatario === 'usuario' && d.usuarioNombre ? d.usuarioNombre : `${d.totalDestinatarios} destinatario${d.totalDestinatarios !== 1 ? 's' : ''}`}</span>
                    <span>{new Date(log.creadoEn).toLocaleString('es-MX', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

function SeccionAuditoria() {
  const [logs, setLogs]       = useState([]);
  const [total, setTotal]     = useState(0);
  const [page, setPage]       = useState(1);
  const [cargando, setCargando] = useState(false);
  const [filtroAccion, setFiltroAccion] = useState('');

  const cargar = async (p = 1, accion = filtroAccion) => {
    setCargando(true);
    try {
      const params = { page: p, take: 50 };
      if (accion) params.accion = accion;
      const res = await apiGetAudit(params);
      setLogs(res.logs || []);
      setTotal(res.total || 0);
      setPage(p);
    } catch { /* silencioso */ }
    finally { setCargando(false); }
  };

  useEffect(() => { cargar(1); }, []); // eslint-disable-line

  const pages = Math.ceil(total / 50);

  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-800 mb-2">Auditoría</h2>
      <p className="text-gray-600 mb-6">Registro de acciones administrativas sensibles</p>

      {/* Filtros */}
      <div className="bg-white rounded-xl shadow p-4 mb-6 flex flex-wrap gap-3 items-end">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Filtrar por acción</label>
          <select
            className="border rounded-lg px-3 py-2 text-sm"
            value={filtroAccion}
            onChange={e => { setFiltroAccion(e.target.value); cargar(1, e.target.value); }}
          >
            <option value="">Todas</option>
            {Object.entries(ETIQUETAS_ACCION).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>
        <button
          onClick={() => cargar(1)}
          className="flex items-center gap-2 px-4 py-2 bg-orange-600 text-white rounded-lg text-sm font-medium hover:bg-orange-700"
        >
          <RefreshCw size={14} /> Actualizar
        </button>
        <span className="text-sm text-gray-500 ml-auto">{total} registros</span>
      </div>

      {/* Tabla */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        {cargando ? (
          <div className="p-12 text-center text-gray-400">Cargando...</div>
        ) : logs.length === 0 ? (
          <div className="p-12 text-center text-gray-400">Sin registros de auditoría aún.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-gray-600 text-xs uppercase">
                <tr>
                  <th className="px-4 py-3 text-left">Fecha</th>
                  <th className="px-4 py-3 text-left">Admin</th>
                  <th className="px-4 py-3 text-left">Acción</th>
                  <th className="px-4 py-3 text-left">Detalles</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {logs.map(log => (
                  <tr key={log.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                      {new Date(log.creadoEn).toLocaleString('es-MX')}
                    </td>
                    <td className="px-4 py-3 text-gray-700">{log.adminEmail}</td>
                    <td className="px-4 py-3">
                      <span className="px-2 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-medium">
                        {ETIQUETAS_ACCION[log.accion] || log.accion}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-gray-500 text-xs max-w-xs truncate">
                      {log.datos ? JSON.stringify(log.datos) : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Paginación */}
        {pages > 1 && (
          <div className="px-4 py-3 border-t flex items-center justify-between text-sm">
            <button
              disabled={page <= 1}
              onClick={() => cargar(page - 1)}
              className="px-3 py-1 rounded border disabled:opacity-40"
            >← Anterior</button>
            <span className="text-gray-500">Página {page} de {pages}</span>
            <button
              disabled={page >= pages}
              onClick={() => cargar(page + 1)}
              className="px-3 py-1 rounded border disabled:opacity-40"
            >Siguiente →</button>
          </div>
        )}
      </div>
    </div>
  );
}

function AppSuperAdmin({ usuario, onLogout }) {
  const { store, dispatch, recargar } = useApiStore(usuario?.rol || 'superadmin');

  // ========== PERMISOS DEL ROL ACTUAL ==========
  const rolActual = usuario?.rol || 'operador';
  const permisosIndividuales = usuario?.permisos || [];
  const seccionesBase = SECCIONES_POR_ROL[rolActual] || [];
  const accionesBase  = ACCIONES_POR_ROL[rolActual]  || [];
  // Sumar secciones y acciones de los permisos individuales asignados
  const seccionesExtra = permisosIndividuales.flatMap(p => PERMISO_A_SECCIONES[p] || []);
  const accionesExtra  = permisosIndividuales.flatMap(p => PERMISO_A_ACCIONES[p]  || []);
  const seccionesPermitidas = [...new Set([...seccionesBase, ...seccionesExtra])];
  const accionesPermitidas  = [...new Set([...accionesBase,  ...accionesExtra])];
  const puedeVer   = (sec) => seccionesPermitidas.includes(sec);
  const puedeHacer = (acc) => accionesPermitidas.includes(acc);

  // ========== ESTADOS ==========
  const [seccion, setSeccion] = useState(seccionesPermitidas[0] || 'clientes');
  const [sidebarAbierto, setSidebarAbierto] = useState(false);
  const [modalDocumentos, setModalDocumentos] = useState(null);
  const procesandoEmpresaRef = useRef(new Set()); // evita doble aprobar/rechazar por doble clic
  const [editandoRfc, setEditandoRfc] = useState(null);
  const [rfcEditado, setRfcEditado] = useState('');
  const [guardandoRfc, setGuardandoRfc] = useState(false);
  const [modalDetalleEmpresa, setModalDetalleEmpresa] = useState(null);
  const [modalSuspender, setModalSuspender] = useState(null); // empresa a suspender/reactivar
  const [promoAsignando, setPromoAsignando] = useState(false);
  const [promoSeleccionada, setPromoSeleccionada] = useState('');
  const [motivoSuspension, setMotivoSuspension] = useState('');
  const [chatEmpresaActivo, setChatEmpresaActivo] = useState(null); // { empresaId, empresaNombre, usuarioId }
  const [modalConfigComision, setMostrarConfigComision] = useState(false);
  const [modalEditarComision, setModalEditarComision] = useState(null);
  const [modalNuevoAdmin, setModalNuevoAdmin] = useState(false);
  const [modalEditarAdmin, setModalEditarAdmin] = useState(null); // admin a editar
  const [modalInsigniasCliente, setModalInsigniasCliente] = useState(null); // cliente al que asignar insignias
  const [clienteExpandido, setClienteExpandido] = useState(null);
  const [filtroTipoCliente, setFiltroTipoCliente] = useState('todos');
  const [empresaExpandida, setEmpresaExpandida] = useState(null);
  const [choferExpandido, setChoferExpandido] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [notificacion, setNotificacion] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState('todas');
  const [exportandoCSV, setExportandoCSV] = useState(null); // key del reporte en progreso
  const [mostrarNotificaciones, setMostrarNotificaciones] = useState(false);
  const [toastNotif, setToastNotif] = useState([]);
  const [toastPausado, setToastPausado] = useState(false);

  // ========== RETENCIONES SAT ==========
  const [retencionesSat, setRetencionesSat] = useState(null);
  const [mesRetenciones, setMesRetenciones] = useState(new Date().toISOString().slice(0, 7));
  useEffect(() => {
    apiGetRetencionesSat(mesRetenciones)
      .then(r => setRetencionesSat(r))
      .catch(() => {});
  }, [mesRetenciones]); // eslint-disable-line

  // ========== MÉTRICAS LIVE ==========
  const [metricasLive, setMetricasLive] = useState(null);
  useEffect(() => {
    const cargar = () => {
      apiGetMetricasLive().then(m => setMetricasLive(m)).catch(() => {});
    };
    cargar();
    const handler = () => cargar();
    window.addEventListener('choyero_admin_metricas', handler);
    return () => window.removeEventListener('choyero_admin_metricas', handler);
  }, []); // eslint-disable-line

  // ========== ACTIVIDAD (login / presencia) ==========
  // Sin evento de socket dedicado — la presencia cambia con cada conexión/desconexión de
  // cualquier usuario, sería demasiado ruido emitir un broadcast por cada una. Se refresca
  // por polling mientras la sección está abierta, igual que el refresh manual del botón.
  const [actividad, setActividad] = useState(null);
  useEffect(() => {
    if (seccion !== 'actividad') return;
    const cargar = () => apiGetActividad().then(a => setActividad(a)).catch(() => {});
    cargar();
    const interval = setInterval(cargar, 15000);
    return () => clearInterval(interval);
  }, [seccion]); // eslint-disable-line

  // ========== ESTADOS: OPERACIONES ==========
  const [opTab, setOpTab] = useState('solicitudes');
  const [chatSoporteActivo, setChatSoporteActivo] = useState(null); // { viajeId, transportistaId, transportistaNombre }
  const [soporteTab, setSoporteTab] = useState('tickets'); // 'tickets' | 'pro'
  const [ticketClienteActivo, setTicketClienteActivo] = useState(null);
  const [configPlanHoras, setConfigPlanHoras] = useState(() => String(getStore().configPlataforma?.horasExclusivaPro ?? 6));
  const [configPlanComPro, setConfigPlanComPro] = useState(() => String(getStore().configPlataforma?.comisionPro ?? 15));
  const [configPlanComBasico, setConfigPlanComBasico] = useState(() => String(getStore().configPlataforma?.comisionBasico ?? 20));
  const [configPrecioProMensual, setConfigPrecioProMensual] = useState(() => String(getStore().configPlataforma?.precioProMensual ?? 599));
  const [configPrecioProAnual, setConfigPrecioProAnual] = useState(() => String(getStore().configPlataforma?.precioProAnual ?? 36000));
  const [configTasaIva, setConfigTasaIva] = useState(() => String((getStore().configPlataforma?.tasaIva ?? 0.16) * 100));
  const [cfgCotizMin, setCfgCotizMin]         = useState(() => String(getStore().configPlataforma?.cotizacionesMinimas ?? 10));
  const [cfgOleada1, setCfgOleada1]           = useState(() => String(parseFloat(((getStore().configPlataforma?.tiempoEsperaLocalMinutos ?? 30) / 60).toFixed(1))));
  const [cfgOleada2, setCfgOleada2]           = useState(() => String(parseFloat(((getStore().configPlataforma?.tiempoEsperaOleada2Minutos ?? 60) / 60).toFixed(1))));
  const [cfgOleada3, setCfgOleada3]           = useState(() => String(parseFloat(((getStore().configPlataforma?.tiempoEsperaOleada3Minutos ?? 120) / 60).toFixed(1))));
  const [cfgAvisoExp, setCfgAvisoExp]         = useState(() => String(getStore().configPlataforma?.horasAvisoExpiracionSolicitud ?? 24));
  const [configMensajePro, setConfigMensajePro] = useState(() => getStore().configPlataforma?.mensajePagoProDeshabilitado ?? 'La suscripción PRO estará disponible próximamente en tu región.');
  const [cfgPrecioFundador, setCfgPrecioFundador] = useState(() => String(getStore().configPlataforma?.precioFundador ?? ''));
  const [cfgLimiteFounders, setCfgLimiteFounders] = useState(() => String(getStore().configPlataforma?.limiteFoundingMembers ?? 50));
  const [cfgFechaLanzamiento, setCfgFechaLanzamiento] = useState(() => { const f = getStore().configPlataforma?.fechaLanzamientoPro; return f ? new Date(f).toISOString().slice(0, 16) : ''; });
  const [guardandoPlanes, setGuardandoPlanes] = useState(false);
  const [planesGuardado, setPlanesGuardado] = useState(false);
  const [opDetalle, setOpDetalle] = useState(null); // { tipo: 'solicitud'|'viaje'|'historial', item }
  const [opFiltro, setOpFiltro] = useState('todos');
  const [opBusqueda, setOpBusqueda] = useState('');
  const [opEmpresaId, setOpEmpresaId] = useState('');
  const [opPrioridad, setOpPrioridad] = useState('');
  const [opNota, setOpNota] = useState('');
  const [opMotivo, setOpMotivo] = useState('');
  const [opConfirmarAccion, setOpConfirmarAccion] = useState(null); // { tipo, id, label, accion }
  const [opUsuarioId, setOpUsuarioId] = useState('');
  const [opLightbox, setOpLightbox] = useState(null); // URL foto en grande
  const [opChatFiltro, setOpChatFiltro] = useState('todos'); // 'todos' | 'cliente_transportista' | 'chofer_transportista'
  const [opVerSolicitudOriginal, setOpVerSolicitudOriginal] = useState(false); // ver solicitud desde modal viaje
  const [opFechaDesde, setOpFechaDesde] = useState('');
  const [opFechaHasta, setOpFechaHasta] = useState('');
  const [opMsgAdmin, setOpMsgAdmin] = useState(''); // texto del mensaje directo admin
  const [opMsgDestinatario, setOpMsgDestinatario] = useState(''); // 'cliente' | 'transportista'
  const [busqChofer, setBusqChofer] = useState('');
  const [filtroEmpresaChofer, setFiltroEmpresaChofer] = useState('');
  const [filtroRetorno, setFiltroRetorno] = useState('todos');
  const [retornosExpandidos, setRetornosExpandidos] = useState(new Set());
  const [busqRetorno, setBusqRetorno] = useState('');
  const [busqCliente, setBusqCliente] = useState('');
  const [comisionSeleccionada, setComisionSeleccionada] = useState(20);

  // ========== BÚSQUEDA GLOBAL ==========
  const [globalSearch, setGlobalSearch] = useState('');
  const [showGlobalSearch, setShowGlobalSearch] = useState(false);
  const globalSearchRef = React.useRef(null);

  // Cerrar búsqueda al hacer click fuera
  React.useEffect(() => {
    const handler = (e) => { if (globalSearchRef.current && !globalSearchRef.current.contains(e.target)) setShowGlobalSearch(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const globalResults = React.useMemo(() => {
    const q = globalSearch.trim().toLowerCase();
    if (q.length < 2) return [];
    const results = [];
    (store.solicitudes || []).forEach(s => {
      if (s.id.toLowerCase().includes(q) || (s.clienteNombre||'').toLowerCase().includes(q) || (s.origen||'').toLowerCase().includes(q) || (s.destino||'').toLowerCase().includes(q) || (s.carga||'').toLowerCase().includes(q)) {
        results.push({ tipo: 'solicitud', label: `${s.id} — ${s.origen} → ${s.destino}`, sub: s.clienteNombre || s.clienteId, status: s.status, item: s });
      }
    });
    (store.viajes || []).forEach(v => {
      if (v.id.toLowerCase().includes(q) || (v.clienteNombre||'').toLowerCase().includes(q) || (v.transportistaNombre||'').toLowerCase().includes(q) || (v.origen||'').toLowerCase().includes(q) || (v.destino||'').toLowerCase().includes(q)) {
        results.push({ tipo: 'viaje', label: `${v.id} — ${v.origen} → ${v.destino}`, sub: `${v.clienteNombre || ''} · ${v.transportistaNombre || ''}`, status: v.status, item: v });
      }
    });
    (store.usuarios || []).filter(u => ['cliente','transportista','chofer'].includes(u.rol)).forEach(u => {
      if (u.nombre.toLowerCase().includes(q) || (u.email||'').toLowerCase().includes(q)) {
        results.push({ tipo: 'usuario', label: u.nombre, sub: `${u.rol} · ${u.email}`, status: u.rol, item: u });
      }
    });
    (store.empresasActivas || []).forEach(e => {
      if (e.nombre.toLowerCase().includes(q) || (e.rfc||'').toLowerCase().includes(q)) {
        results.push({ tipo: 'empresa', label: e.nombre, sub: `RFC: ${e.rfc}`, status: e.status, item: e });
      }
    });
    return results.slice(0, 12);
  }, [globalSearch, store]); // eslint-disable-line

  // ========== ALERTAS AUTOMÁTICAS ==========
  const alertasAdmin = React.useMemo(() => {
    const ahora = Date.now();
    const alertas = [];
    (store.viajes || []).forEach(v => {
      if (v.status === 'incidencia') {
        const ultNotif = (store.notificaciones || []).filter(n => n.datos?.viajeId === v.id && n.tipo === 'incidencia_transportista').sort((a,b) => new Date(b.fecha) - new Date(a.fecha))[0];
        const desde = ultNotif?.fecha || v.fechaCreacion;
        const horas = Math.round((ahora - new Date(desde).getTime()) / 3600000);
        if (horas >= 2) alertas.push({ gravedad: horas > 6 ? 'alta' : 'media', icono: '⚠️', titulo: `Viaje ${v.id} en incidencia por ${horas}h`, detalle: `${v.origen} → ${v.destino}`, accion: () => { setSeccion('operaciones'); setOpDetalle({ tipo: 'viaje', item: v }); } });
      }
      if (v.enDisputa && v.fechaDisputa) {
        const horas = Math.round((ahora - new Date(v.fechaDisputa).getTime()) / 3600000);
        if (horas > 24) alertas.push({ gravedad: 'alta', icono: '🚨', titulo: `Disputa en viaje ${v.id} sin resolver (${horas}h)`, detalle: v.motivoDisputa || '', accion: () => { setSeccion('operaciones'); setOpDetalle({ tipo: 'viaje', item: v }); } });
      }
    });
    (store.solicitudes || []).forEach(s => {
      if (['abierta','en_cotizacion'].includes(s.status) && (s.cotizacionesRecibidas || 0) === 0 && (s.creadoEn || s.fechaCreacion)) {
        const horas = Math.round((ahora - new Date(s.creadoEn || s.fechaCreacion).getTime()) / 3600000);
        if (horas >= 24) alertas.push({ gravedad: 'media', icono: '📭', titulo: `Solicitud ${s.id} sin cotizaciones (${horas}h)`, detalle: `${s.cliente?.nombre || s.clienteNombre || ''} · ${s.origen} → ${s.destino}`, accion: () => { setSeccion('operaciones'); setOpDetalle({ tipo: 'solicitud', item: s }); } });
      }
    });
    return alertas.sort((a,b) => (b.gravedad === 'alta') - (a.gravedad === 'alta'));
  }, [store]); // eslint-disable-line
  // ========== TOAST DE NOTIFICACIONES ==========
  // Toasts: solo desde evento centralizado de useApiStore (nunca desde polling directo)
  useEffect(() => {
    const handle = (e) => {
      const nuevas = (e.detail?.notificaciones || []).filter(
        n => n.destinatarioId === usuario?.id || n.destinatarioRol === 'superadmin'
      );
      if (nuevas.length === 0) return;
      setToastNotif(q => [...q, ...nuevas]);
      // Marcar como leídas al mostrarse en pantalla — evita que reaparezcan en la siguiente sesión
      marcarNotificacionesLeidas(usuario?.id, 'admin');
      apiMarcarLeidas().catch(() => {});
    };
    window.addEventListener('choyero_notif_nueva', handle);
    return () => window.removeEventListener('choyero_notif_nueva', handle);
  }, [usuario?.id]); // eslint-disable-line

  // ========== MENSAJES ENTRANTES DE TRANSPORTISTAS ==========
  const _chatAdminSeenKey = `choyero_admin_chat_seen_${usuario?.id || 'guest'}`;
  const [lastSeenAdminMsgs, setLastSeenAdminMsgs] = useState(() => {
    try { return JSON.parse(localStorage.getItem(_chatAdminSeenKey) || '{}'); } catch { return {}; }
  });
  const _ticketSeenKey = `choyero_admin_tickets_seen_${usuario?.id || 'guest'}`;
  const [lastSeenTickets, setLastSeenTickets] = useState(() => {
    try { return JSON.parse(localStorage.getItem(_ticketSeenKey) || '{}'); } catch { return {}; }
  });
  const _ticketCerradosKey = `choyero_admin_tickets_cerrados_${usuario?.id || 'guest'}`;
  const [ticketsCerrados, setTicketsCerrados] = useState(() => {
    try { return JSON.parse(localStorage.getItem(_ticketCerradosKey) || '[]'); } catch { return []; }
  });
  const [mostrarTicketsCerrados, setMostrarTicketsCerrados] = useState(false);
  const prevMensajesCount = useRef((store.mensajes || []).length);
  const adminMsgLoginShown = useRef(false);

  // Al iniciar sesión, notificar mensajes de transportistas no vistos
  useEffect(() => {
    if (!usuario?.id || adminMsgLoginShown.current) return;
    adminMsgLoginShown.current = true;
    const mensajes = store.mensajes || [];
    const cerrados = store.canalesAdminCerrados || [];
    const canalesAdmin = mensajes
      .filter(m => m.viajeId?.startsWith('admin-empresa-') && m.emisorRol === 'transportista' && !cerrados.includes(m.viajeId))
      .reduce((acc, m) => { if (!acc.includes(m.viajeId)) acc.push(m.viajeId); return acc; }, []);
    canalesAdmin.forEach(canal => {
      const seenTs = lastSeenAdminMsgs[canal] || null;
      const noVistos = mensajes.filter(
        m => m.viajeId === canal && m.emisorRol === 'transportista' &&
             (!seenTs || new Date(m.creadoEn) > new Date(seenTs))
      );
      if (noVistos.length > 0) {
        const ultimo = noVistos[noVistos.length - 1];
        const preview = ultimo.texto.length > 40 ? ultimo.texto.slice(0, 40) + '…' : ultimo.texto;
        setToastNotif(q => [...q, {
          tipo: 'chat_mensaje',
          titulo: `💬 Respuesta de ${ultimo.emisorNombre}`,
          mensaje: `${noVistos.length > 1 ? `${noVistos.length} mensajes: ` : ''}${preview}`,
          datos: { viajeId: canal }
        }]);
        playNotifSound();
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario?.id]);

  // En tiempo real: detectar nuevos mensajes de transportistas
  useEffect(() => {
    const mensajes = store.mensajes || [];
    const cerrados = store.canalesAdminCerrados || [];
    if (mensajes.length > prevMensajesCount.current) {
      const newMsgs = mensajes.slice(prevMensajesCount.current);
      const relevant = newMsgs.filter(
        m => m.viajeId?.startsWith('admin-empresa-') && m.emisorRol === 'transportista' && !cerrados.includes(m.viajeId)
      );
      if (relevant.length > 0) {
        const m = relevant[relevant.length - 1];
        const preview = m.texto.length > 40 ? m.texto.slice(0, 40) + '…' : m.texto;
        setToastNotif(q => [...q, {
          tipo: 'chat_mensaje',
          titulo: `💬 Respuesta de ${m.emisorNombre}`,
          mensaje: preview,
          datos: { viajeId: m.viajeId }
        }]);
        playNotifSound();
      }
    }
    prevMensajesCount.current = mensajes.length;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.mensajes?.length]);

  // ========== ADMINISTRADORES (desde store.usuarios) ==========
  const ROLES_ADMIN = ['superadmin', 'admin', 'operador', 'soporte'];
  const administradores = (store.usuarios || []).filter(u => ROLES_ADMIN.includes(u.rol));

  // ========== DATOS DE PLATAFORMA ==========
  const [configPlataforma, setConfigPlataforma] = useState({
    comisionPorcentaje: store.configPlataforma?.comisionBasico ?? 20,
    zonasActivas: ['Baja California', 'Baja California Sur'],
    versionApp: '1.0.0'
  });

  // ========== EMPRESAS DESDE EL STORE COMPARTIDO ==========
  const _storeEmpresasPendientes = store.empresasPendientes;
  const _storeEmpresasActivas = store.empresasActivas;


  // ========== VIAJES ADMIN (fuente unificada) ==========
  const _todosViajesAdmin = store.reporteViajes || store.viajes || [];

  // ========== CLIENTES REGISTRADOS (store.usuarios rol=cliente + demo) ==========
  const clientesStore = (store.usuarios || [])
    .filter(u => u.rol === 'cliente')
    .map(u => ({
      id: u.id,
      nombre: u.nombre,
      contacto: u.representante || u.nombre,
      email: u.email,
      tipoPersona: u.tipoPersona || null,
      rfc: u.rfc || null,
      telefono: u.telefono || null,
      codigoReferido: u.codigoReferido || null,
      esReferidor: u.esReferidor ?? false,
      referidoPor: u.referidoPor || null,
      activo: u.activo ?? true,
      creadoEn: u.creadoEn || null,
      avatar: u.avatar || null,
      // viajesCompletados real del BD como base — se sobreescribe si hay viajes en el store
      viajesRealizados: u.viajesCompletados ?? 0,
      gastoTotal: 0
    }));
  const clientes = clientesStore.map(c => {
    const viajesCliente = _todosViajesAdmin.filter(v => v.clienteId === c.id);
    const viajesCompletados = viajesCliente.filter(v => ['completada', 'confirmado', 'entrega_confirmada'].includes(v.status));
    const gastado = viajesCompletados.reduce((sum, v) => sum + (v.costoFinal || v.precio || v.costo || 0), 0);
    return {
      ...c,
      // Si el store tiene viajes cargados, usar el conteo real; si no, usar el campo del BD
      viajesRealizados: viajesCliente.length > 0 ? viajesCompletados.length : c.viajesRealizados,
      gastoTotal: gastado > 0 ? gastado : c.gastoTotal
    };
  });

  // Empresas activas desde el store, enriquecidas con datos reales
  const empresasActivasMerged = _storeEmpresasActivas.map(empresa => {
    const flotaReal = (store.flota || []).filter(u => u.empresaId === empresa.id);
    const ownerUser = (store.usuarios || []).find(u => u.empresaId === empresa.id && u.rol === 'transportista');
    const choferesUsuarios = (store.usuarios || []).filter(u => u.empresaId === empresa.id && u.rol === 'chofer');
    const choferesPlantilla = (store.plantillaChoferes || []).filter(c => c.empresaId === empresa.id);
    const choferesReal = choferesUsuarios.length > 0 ? choferesUsuarios : choferesPlantilla;
    const viajesEmpresa = _todosViajesAdmin.filter(v => v.empresaId === empresa.id);
    const retornosEmpresa = (store.retornosVacios || []).filter(r => r.empresaId === empresa.id && r.status === 'completado')
      .map(r => { const o = (r.ofertas||[]).find(of=>of.status==='aceptada'); return { costo: o?.precio||0, comisionPlataforma: undefined, gananciaTransportista: undefined }; });
    const viajesActivos = viajesEmpresa.filter(v =>
      !['completada', 'confirmado', 'entrega_confirmada'].includes(v.status)
    ).length;
    const viajesCompletados = viajesEmpresa.filter(v =>
      ['completada', 'confirmado', 'entrega_confirmada'].includes(v.status)
    ).length + retornosEmpresa.length;
    const pct = Math.max(empresa.comisionPersonalizada ?? configPlataforma.comisionPorcentaje ?? 20, 1);
    const viajesCompletadosEmpresa = [
      ...viajesEmpresa.filter(v => ['completada', 'confirmado', 'entrega_confirmada'].includes(v.status)),
      ...retornosEmpresa
    ];
    const comisionGenerada = viajesCompletadosEmpresa
      .reduce((sum, v) => sum + (v.comisionPlataforma ?? Math.round((v.costoFinal || v.precio || v.costo || 0) * pct / 100)), 0);
    const gananciasTotales = viajesCompletadosEmpresa
      .reduce((sum, v) => sum + (v.gananciaTransportista ?? ((v.costoFinal || v.precio || v.costo || 0) - Math.round((v.costoFinal || v.precio || v.costo || 0) * pct / 100))), 0);
    return {
      ...empresa,
      calificacion: ownerUser?.calificacion ?? null,
      unidades: flotaReal.length > 0 ? flotaReal.length : (empresa.totalUnidades ?? 0),
      choferes: choferesReal.length > 0 ? choferesReal.length : (empresa.totalChoferes || empresa.choferes || 0),
      viajesActivos,
      viajesCompletados,
      comisionGenerada,
      gananciasTotales,
    };
  });

  // Empresas pendientes de aprobación desde el store, más recientes primero
  const empresasPendientesMerged = [..._storeEmpresasPendientes]
    .sort((a, b) => new Date(b.fechaSolicitud || 0) - new Date(a.fechaSolicitud || 0));

  // ========== ESTADÍSTICAS ==========
  const hoy = new Date().toISOString().slice(0, 10);
  const mesActual = new Date().toISOString().slice(0, 7);

  const viajesCompletadosReales = _todosViajesAdmin.filter(v =>
    ['confirmado', 'entrega_confirmada'].includes(v.status)
  );
  // Retornos confirmados normalizados al mismo formato que viajes
  const retornosCompletadosAdmin = (store.retornosVacios || [])
    .filter(r => r.status === 'completado')
    .map(r => {
      const oferta = (r.ofertas || []).find(o => o.status === 'aceptada');
      return {
        id: r.id,
        empresaId: r.empresaId,
        costo: oferta?.precio || 0,
        fechaCompletada: oferta?.fechaPago || r.creadoEn || '',
        fechaCreacion: r.creadoEn || '',
        comisionPlataforma: undefined // se calculará con %
      };
    });
  const todosCompletados = [...viajesCompletadosReales, ...retornosCompletadosAdmin];

  const viajesCompletadosHoy = todosCompletados.filter(v => (v.fechaCompletada || v.creadoEn || '').startsWith(hoy));
  const viajesCompletadosMesActual = todosCompletados.filter(v => (v.fechaCompletada || v.creadoEn || '').startsWith(mesActual));

  const calcComisiones = (lista) => lista.reduce((sum, v) => {
    if (v.comisionPlataforma !== undefined) return sum + v.comisionPlataforma;
    const empresa = empresasActivasMerged.find(e => e.id === v.empresaId);
    const pct = v.empresa?.comisionPersonalizada || empresa?.comisionPersonalizada || configPlataforma.comisionPorcentaje || 20;
    return sum + Math.round((v.costoFinal || v.precio || v.costo || 0) * pct / 100);
  }, 0);

  const gmvReal = todosCompletados.reduce((sum, v) => sum + (v.costoFinal || v.precio || v.costo || 0), 0);
  const gmvHoy = viajesCompletadosHoy.reduce((sum, v) => sum + (v.costoFinal || v.precio || v.costo || 0), 0);
  const gmvMesActual = viajesCompletadosMesActual.reduce((sum, v) => sum + (v.costoFinal || v.precio || v.costo || 0), 0);
  const comisionesReales = calcComisiones(todosCompletados);
  const comisionesHoyReal = calcComisiones(viajesCompletadosHoy);
  const comisionesMesActual = calcComisiones(viajesCompletadosMesActual);

  const stats = {
    empresasActivas: empresasActivasMerged.filter(e => e.status === 'activa').length,
    empresasSuspendidas: empresasActivasMerged.filter(e => e.status === 'suspendida').length,
    totalUnidades: empresasActivasMerged.reduce((sum, e) => sum + (e.unidades || 0), 0),
    totalChoferes: empresasActivasMerged.reduce((sum, e) => sum + (e.choferes || 0), 0),
    viajesActivos: _todosViajesAdmin.filter(v => !['completada', 'confirmado', 'entrega_confirmada'].includes(v.status)).length,
    viajesCompletadosMes: viajesCompletadosMesActual.length > 0 ? viajesCompletadosMesActual.length : (store.historialEntregas || []).length,
    viajesCompletadosHoy: viajesCompletadosHoy.length,
    comisionesTotales: comisionesReales > 0 ? comisionesReales : empresasActivasMerged.reduce((sum, e) => sum + (e.comisionGenerada || 0), 0),
    comisionesHoy: comisionesHoyReal,
    comisionesMes: comisionesMesActual,
    gmvMes: gmvMesActual > 0 ? gmvMesActual : (gmvReal > 0 ? gmvReal : 0),
    gmvHoy,
    clientesActivos: clientes.length,
    clientesRegulares: clientes.filter(c => !c.esReferidor).length,
    clientesMLM: clientes.filter(c => c.esReferidor).length,
  };

  // ========== NOTIFICACIONES DEL STORE ==========
  const notifsPendientes = getNotificacionesPendientes(store, usuario?.id, 'superadmin');
  const cerrarToast = () => {
    setToastNotif(q => {
      if (q[0]?.id) marcarNotificacionesLeidas(usuario?.id, 'superadmin');
      return q.slice(1);
    });
    setToastPausado(true);
    setTimeout(() => setToastPausado(false), 2000);
  };

  // Auto-cerrar toasts: alertas simples en 3.5s, notificaciones del sistema en 8s
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (toastNotif.length === 0 || toastPausado) return;
    const notif = toastNotif[0];
    if (notif?.persistente) return;
    const delay = notif?.tipo?.startsWith('alerta_') ? 3500 : 8000;
    const timer = setTimeout(() => setToastNotif(q => q.slice(1)), delay);
    return () => clearTimeout(timer);
  }, [toastNotif.length, toastPausado]); // eslint-disable-line

  const abrirNotificaciones = () => {
    setMostrarNotificaciones(true);
    marcarNotificacionesLeidas(usuario?.id, 'superadmin');
    const idsNoLeidas = (store.notificaciones || [])
      .filter(n => !n.leida && (n.destinatarioId === usuario?.id || n.destinatarioRol === 'superadmin'))
      .map(n => n.id);
    if (idsNoLeidas.length > 0) apiMarcarLeidas(idsNoLeidas).catch(() => {});
  };

  // ========== FUNCIONES ==========
  const mostrarNotificacion = (mensaje, tipo = 'success', persistente = false, opciones = {}) => {
    setNotificacion({ mensaje, tipo, persistente, ...opciones });
    if (!persistente) setTimeout(() => setNotificacion(n => n?.persistente ? n : null), 4000);
  };

  // Recordatorios automáticos
  useEffect(() => {
    const _ssKey = `choyero_rec_admin_${usuario?.id}`;
    const checkRecordatorios = () => {
      const s = getStore();
      const ahora = Date.now();
      const last = JSON.parse(sessionStorage.getItem(_ssKey) || '{}');
      const pendientes = (s.empresasPendientes || []).filter(e => e.status === 'pendiente');
      if (pendientes.length > 0 && (!last.pendientes || ahora - last.pendientes > 5 * 60 * 1000)) {
        last.pendientes = ahora;
        sessionStorage.setItem(_ssKey, JSON.stringify(last));
        mostrarNotificacion(
          `🏢 Hay ${pendientes.length} empresa(s) esperando aprobación. ¡Revísalas para que puedan operar!`,
          'warning', true, { navegar: 'empresas' }
        );
      }
    };
    let interval;
    const timer = setTimeout(() => {
      checkRecordatorios();
      interval = setInterval(checkRecordatorios, 5 * 60 * 1000);
    }, 3 * 60 * 1000);
    return () => { clearTimeout(timer); if (interval) clearInterval(interval); };
  }, [usuario?.id]); // eslint-disable-line

  const aprobarEmpresa = async (id, comisionPersonalizada = 20) => {
    if (procesandoEmpresaRef.current.has(id)) return; // ya hay una aprobación/rechazo en curso
    const empresa = empresasPendientesMerged.find(e => e.id === id);
    if (!empresa) return;
    procesandoEmpresaRef.current.add(id);
    try {
      await apiAprobarEmpresa(id);
      if (store.empresasPendientes.find(e => e.id === id)) {
        storeAprobarEmpresa(id, comisionPersonalizada);
      }
      mostrarNotificacion(`✅ ${empresa.nombre} ha sido aprobada con comisión del ${comisionPersonalizada}%`);
      setModalDocumentos(null);
      recargar();
    } catch (e) {
      mostrarNotificacion(e.message || 'Error al aprobar la empresa', 'error');
    } finally {
      procesandoEmpresaRef.current.delete(id);
    }
  };

  const actualizarComisionEmpresa = async (empresaId, nuevaComision) => {
    const empresa = empresasActivasMerged.find(e => e.id === empresaId);
    try {
      await apiAdminActualizarComisionEmpresa(empresaId, nuevaComision);
      storeActualizarComision(empresaId, nuevaComision);
      mostrarNotificacion(`✅ Comisión de ${empresa?.nombre || empresaId} actualizada a ${nuevaComision}%`);
      setModalEditarComision(null);
      recargar();
    } catch (e) {
      mostrarNotificacion(e.message || 'Error al actualizar la comisión', 'error');
    }
  };

  // Funciones de administradores
  const agregarAdmin = async (nuevoAdmin) => {
    try {
      const { usuario: adminCreado } = await apiAdminCrearAdmin(nuevoAdmin);
      storeCrearAdmin({ ...adminCreado, password: nuevoAdmin.password });
      mostrarNotificacion(`✅ Administrador ${adminCreado.nombre} agregado. Ya puede iniciar sesión.`);
      setModalNuevoAdmin(false);
      recargar();
    } catch (e) {
      mostrarNotificacion(e.message || '⚠️ Error al crear administrador', 'error');
    }
  };

  const editarAdmin = async (id, cambios) => {
    try {
      await apiAdminActualizarAdmin(id, cambios);
      storeActualizarAdmin(id, cambios);
      mostrarNotificacion('✅ Administrador actualizado correctamente');
      setModalEditarAdmin(null);
      recargar();
    } catch (e) {
      mostrarNotificacion(e.message || '⚠️ Error al actualizar administrador', 'error');
    }
  };

  const toggleStatusAdmin = async (id) => {
    try {
      await apiAdminToggleAdmin(id);
      storeToggleAdmin(id);
      recargar();
    } catch (e) {
      mostrarNotificacion(e.message || '⚠️ Error al cambiar estado', 'error');
    }
  };

  const eliminarAdmin = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este administrador?')) {
      try {
        await apiAdminEliminarAdmin(id);
        storeEliminarAdmin(id);
        mostrarNotificacion('Administrador eliminado', 'error');
        recargar();
      } catch (e) {
        mostrarNotificacion(e.message || '⚠️ Error al eliminar administrador', 'error');
      }
    }
  };

  // Obtener todas las unidades de todos los transportistas
  const obtenerTodasLasUnidades = () => {
    const todasUnidades = [];
    empresasActivasMerged.filter(e => e.status === 'activa').forEach(empresa => {
      const detalle = empresa.unidadesDetalle || [];
      detalle.forEach(unidad => {
        todasUnidades.push({
          ...unidad,
          empresa: empresa.nombre,
          empresaId: empresa.id,
          ciudadEmpresa: empresa.ciudad || null,
        });
      });
    });
    return todasUnidades;
  };

  const rechazarEmpresa = async (id, motivo) => {
    if (procesandoEmpresaRef.current.has(id)) return; // ya hay una aprobación/rechazo en curso
    const empresa = empresasPendientesMerged.find(e => e.id === id);
    if (!empresa) return;
    procesandoEmpresaRef.current.add(id);
    try {
      await apiRechazarEmpresa(id, motivo);
      if (store.empresasPendientes.find(e => e.id === id)) {
        storeRechazarEmpresa(id);
      }
      mostrarNotificacion(`❌ ${empresa.nombre} ha sido rechazada`, 'error');
      setModalDocumentos(null);
      recargar();
    } catch (e) {
      mostrarNotificacion(e.message || 'Error al rechazar la empresa', 'error');
    } finally {
      procesandoEmpresaRef.current.delete(id);
    }
  };

  const confirmarSuspension = async () => {
    if (!modalSuspender) return;
    if (modalSuspender.status === 'activa' && !motivoSuspension.trim()) return;
    const suspendiendo = modalSuspender.status === 'activa';
    const nombre = modalSuspender.nombre;
    const id = modalSuspender.id;
    const motivo = motivoSuspension.trim();
    try {
      if (suspendiendo) {
        await apiSuspenderEmpresa(id, motivo);
      } else {
        await apiAprobarEmpresa(id);
      }
      storeToggleStatusEmpresa(id, motivo);
      mostrarNotificacion(
        suspendiendo ? `⚠️ ${nombre} ha sido suspendida` : `✅ ${nombre} ha sido reactivada`,
        suspendiendo ? 'warning' : 'success'
      );
      setModalSuspender(null);
      setMotivoSuspension('');
      cerrarModalDetalle();
      recargar();
    } catch (e) {
      mostrarNotificacion(e.message || `Error al ${suspendiendo ? 'suspender' : 'reactivar'} la empresa`, 'error');
    }
  };

  // Cierra el modal de detalle y, si el chat fue abierto desde ese modal, lo cierra también
  const cerrarModalDetalle = () => {
    setChatEmpresaActivo(prev => (prev?.origen === 'modal' ? null : prev));
    setModalDetalleEmpresa(null);
  };

  // Cerrar modales con ESC — prioridad: más reciente primero
  useEffect(() => {
    const handle = (e) => {
      if (e.key !== 'Escape') return;
      // Chats: marcar como leído al cerrar con ESC igual que con el botón X
      if (chatEmpresaActivo) {
        const canal = `admin-empresa-${chatEmpresaActivo.empresaId}`;
        const next = { ...lastSeenAdminMsgs, [canal]: new Date().toISOString() };
        setLastSeenAdminMsgs(next);
        try { localStorage.setItem(_chatAdminSeenKey, JSON.stringify(next)); } catch {}
        setChatEmpresaActivo(null);
        return;
      }
      if (chatSoporteActivo) {
        const canal = chatSoporteActivo.viajeId;
        const next = { ...lastSeenAdminMsgs, [canal]: new Date().toISOString() };
        setLastSeenAdminMsgs(next);
        try { localStorage.setItem(_chatAdminSeenKey, JSON.stringify(next)); } catch {}
        setChatSoporteActivo(null);
        return;
      }
      if (ticketClienteActivo) {
        const ts = new Date().toISOString();
        const next = { ...lastSeenTickets, [ticketClienteActivo.viajeId]: ts };
        setLastSeenTickets(next);
        try { localStorage.setItem(_ticketSeenKey, JSON.stringify(next)); } catch {}
        setTicketClienteActivo(null);
        return;
      }
      if (opLightbox)           { setOpLightbox(null); return; }
      if (opConfirmarAccion)    { setOpConfirmarAccion(null); return; }
      if (opDetalle)            { setOpDetalle(null); return; }
      if (modalInsigniasCliente){ setModalInsigniasCliente(null); return; }
      if (modalEditarAdmin)     { setModalEditarAdmin(null); return; }
      if (modalNuevoAdmin)      { setModalNuevoAdmin(false); return; }
      if (modalEditarComision)  { setModalEditarComision(null); return; }
      if (modalConfigComision)  { setMostrarConfigComision(false); return; }
      if (modalSuspender)       { setModalSuspender(null); return; }
      if (modalDocumentos)      { setModalDocumentos(null); return; }
      if (modalDetalleEmpresa)  { cerrarModalDetalle(); return; }
      if (showGlobalSearch)     { setShowGlobalSearch(false); return; }
      // Notificaciones — menor prioridad que modales
      if (toastNotif.length > 0 && !toastPausado) { cerrarToast(); return; }
      if (mostrarNotificaciones) { setMostrarNotificaciones(false); return; }
    };
    document.addEventListener('keydown', handle);
    return () => document.removeEventListener('keydown', handle);
  }, [chatEmpresaActivo, chatSoporteActivo, ticketClienteActivo, opLightbox, opConfirmarAccion, opDetalle, modalInsigniasCliente, modalEditarAdmin, modalNuevoAdmin, modalEditarComision, modalConfigComision, modalSuspender, modalDocumentos, modalDetalleEmpresa, showGlobalSearch, lastSeenAdminMsgs, lastSeenTickets, toastNotif.length, toastPausado, mostrarNotificaciones]); // eslint-disable-line

  const empresasFiltradas = empresasActivasMerged.filter(e => {
    const matchBusqueda = e.nombre.toLowerCase().includes(busqueda.toLowerCase());
    const matchStatus = filtroStatus === 'todas' || e.status === filtroStatus;
    return matchBusqueda && matchStatus;
  });

  // ========== INSIGNIAS ==========
  // Lee las insignias manuales asignadas por el admin desde el store
  const getInsignias = (emp) => {
    const ids = emp.insigniasManuales || [];
    return ids.map(id => CATALOGO_INSIGNIAS.find(b => b.id === id)).filter(Boolean);
  };
  // Alias para compatibilidad con el ranking y tabla
  const calcularInsignias = getInsignias;

  const InsigniaBadge = ({ insignia, small = false }) => {
    const [tooltip, setTooltip] = React.useState(false);
    return (
      <div className="relative inline-block">
        <span
          onMouseEnter={() => setTooltip(true)}
          onMouseLeave={() => setTooltip(false)}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold cursor-default ${insignia.color} ${small ? 'text-xs' : ''}`}
        >
          <span>{insignia.emoji}</span>
          {!small && <span>{insignia.label}</span>}
        </span>
        {tooltip && (
          <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 bg-gray-900 text-white text-xs rounded-lg p-2 shadow-xl pointer-events-none">
            <p className="font-semibold mb-0.5">{insignia.emoji} {insignia.label}</p>
            <p className="text-gray-300 leading-snug">{insignia.desc}</p>
            <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
          </div>
        )}
      </div>
    );
  };

  // ========== HELPERS GLOBALES ==========
  const STATUS_COLOR = {
    cotizando: 'bg-blue-100 text-blue-700', aceptada: 'bg-green-100 text-green-700',
    pagada: 'bg-green-100 text-green-700', en_progreso: 'bg-yellow-100 text-yellow-700',
    en_ruta: 'bg-yellow-100 text-yellow-700', completada: 'bg-green-100 text-green-700',
    cancelada: 'bg-red-100 text-red-700', cancelado_admin: 'bg-red-100 text-red-700',
    en_disputa: 'bg-orange-100 text-orange-700', incidencia: 'bg-orange-100 text-orange-700',
    asignada: 'bg-blue-100 text-blue-700', pendiente: 'bg-gray-100 text-gray-600',
    cliente: 'bg-blue-100 text-blue-700', transportista: 'bg-green-100 text-green-700',
    chofer: 'bg-yellow-100 text-yellow-700', activa: 'bg-green-100 text-green-700',
    suspendida: 'bg-red-100 text-red-700',
  };
  const getBadgeGlobal = (status) => (
    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${STATUS_COLOR[status] || 'bg-gray-100 text-gray-600'}`}>{status}</span>
  );

  // ========== SOPORTE PRO: conversaciones agrupadas ==========
  const conversacionesSoporte = (() => {
    const msgs = (store.mensajes || []).filter(m => m.viajeId?.startsWith('soporte-pro-'));
    const byViaje = {};
    msgs.forEach(m => {
      if (!byViaje[m.viajeId]) byViaje[m.viajeId] = { viajeId: m.viajeId, mensajes: [] };
      byViaje[m.viajeId].mensajes.push(m);
    });
    return Object.values(byViaje).map(conv => {
      const transportistaId = conv.viajeId.replace('soporte-pro-', '');
      const tUser = (store.usuarios || []).find(u => u.id === transportistaId);
      const empresa = (store.empresasActivas || []).find(e => e.id === tUser?.empresaId);
      const ultimo = conv.mensajes[conv.mensajes.length - 1];
      const ultimoAdminMsgTs = [...conv.mensajes].reverse().find(m => m.emisorRol === 'admin')?.creadoEn || null;
      // Combinar: último mensaje enviado por admin O última vez que el admin abrió el chat
      const ultimoAdminTs = ultimoAdminMsgTs && lastSeenAdminMsgs[conv.viajeId]
        ? (ultimoAdminMsgTs > lastSeenAdminMsgs[conv.viajeId] ? ultimoAdminMsgTs : lastSeenAdminMsgs[conv.viajeId])
        : (ultimoAdminMsgTs || lastSeenAdminMsgs[conv.viajeId] || null);
      const noLeidos = conv.mensajes.filter(m =>
        m.emisorRol === 'transportista' && (!ultimoAdminTs || m.creadoEn > ultimoAdminTs)
      ).length;
      return {
        viajeId: conv.viajeId,
        transportistaId,
        transportistaNombre: tUser?.nombre || empresa?.nombre || `Transportista ${transportistaId.slice(-4)}`,
        empresaNombre: empresa?.nombre || '—',
        plan: empresa?.plan || 'basico',
        ultimoMensaje: ultimo,
        noLeidos,
      };
    }).sort((a, b) => {
      if (b.noLeidos !== a.noLeidos) return b.noLeidos - a.noLeidos;
      return new Date(b.ultimoMensaje?.creadoEn || 0) - new Date(a.ultimoMensaje?.creadoEn || 0);
    });
  })();
  const soporteNoLeidosTotal = conversacionesSoporte.reduce((s, c) => s + c.noLeidos, 0);

  // ========== TICKETS DE CLIENTES: mensajes [TICKET -...] a admin ==========
  const _todosTickets = (() => {
    const msgs = (store.mensajes || []).filter(m => m.texto?.startsWith('[TICKET -') && m.destinatarioRol === 'admin');
    const byViaje = {};
    msgs.forEach(m => {
      if (!byViaje[m.viajeId]) byViaje[m.viajeId] = { viajeId: m.viajeId, mensajes: [] };
      byViaje[m.viajeId].mensajes.push(m);
    });
    return Object.values(byViaje).map(conv => {
      const viaje = (_todosViajesAdmin).find(v => v.id === conv.viajeId);
      const cliente = (store.usuarios || []).find(u => u.id === viaje?.clienteId) || (store.usuarios || []).find(u => u.id === conv.mensajes[0]?.emisorId);
      const ultimo = conv.mensajes[conv.mensajes.length - 1];
      const ultimoAdminMsgTs = [...conv.mensajes].reverse().find(m => m.emisorRol === 'admin')?.creadoEn || null;
      const ultimoAdminTs = ultimoAdminMsgTs && lastSeenTickets[conv.viajeId]
        ? (ultimoAdminMsgTs > lastSeenTickets[conv.viajeId] ? ultimoAdminMsgTs : lastSeenTickets[conv.viajeId])
        : (ultimoAdminMsgTs || lastSeenTickets[conv.viajeId] || null);
      const noLeidos = conv.mensajes.filter(m => m.emisorRol !== 'admin' && (!ultimoAdminTs || m.creadoEn > ultimoAdminTs)).length;
      return {
        viajeId: conv.viajeId,
        clienteId: cliente?.id || conv.mensajes[0]?.emisorId,
        clienteNombre: cliente?.nombre || 'Cliente',
        ruta: viaje ? `${viaje.origen} → ${viaje.destino}` : conv.viajeId.slice(-8),
        ultimoMensaje: ultimo,
        noLeidos,
        totalTickets: conv.mensajes.length,
        cerrado: ticketsCerrados.includes(conv.viajeId),
      };
    }).sort((a, b) => {
      if (b.noLeidos !== a.noLeidos) return b.noLeidos - a.noLeidos;
      return new Date(b.ultimoMensaje?.creadoEn || 0) - new Date(a.ultimoMensaje?.creadoEn || 0);
    });
  })();
  const ticketsClientes = _todosTickets.filter(t => !t.cerrado);
  const ticketsClientesCerrados = _todosTickets.filter(t => t.cerrado);
  const ticketsNoLeidosTotal = ticketsClientes.reduce((s, t) => s + t.noLeidos, 0);

  const cerrarTicket = (viajeId) => {
    const next = [...ticketsCerrados, viajeId];
    setTicketsCerrados(next);
    try { localStorage.setItem(_ticketCerradosKey, JSON.stringify(next)); } catch {}
    if (ticketClienteActivo?.viajeId === viajeId) setTicketClienteActivo(null);
  };
  const reabrirTicket = (viajeId) => {
    const next = ticketsCerrados.filter(id => id !== viajeId);
    setTicketsCerrados(next);
    try { localStorage.setItem(_ticketCerradosKey, JSON.stringify(next)); } catch {}
  };

  // ========== MENÚ ==========
  const menu = [
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3 },
    { id: 'pendientes', label: 'Aprobar Empresas', icon: Clock, badge: empresasPendientesMerged.length },
    { id: 'empresas', label: 'Transportistas', icon: Building2 },
    { id: 'mapa', label: 'Mapa de Unidades', icon: Map },
    { id: 'choferes', label: 'Choferes', icon: UserCheck },
    { id: 'clientes', label: 'Clientes', icon: Users },
    { id: 'operaciones', label: 'Operaciones', icon: Briefcase, badge: (store.viajes || []).filter(v => v.enDisputa).length || undefined },
    { id: 'retornos', label: 'Retornos Vacíos', icon: RotateCcw },
    { id: 'admins', label: 'Administradores', icon: Shield },
    { id: 'reportes', label: 'Reportes', icon: TrendingUp },
    { id: 'actividad', label: 'Actividad', icon: Wifi },
    { id: 'finanzas', label: 'Finanzas / Escrow', icon: DollarSign },
    { id: 'facturacion', label: 'Facturación', icon: FileText },
    { id: 'mensajes', label: 'Mensajes', icon: Send },
    { id: 'auditoria', label: 'Auditoría', icon: ClipboardList },
    { id: 'configuracion', label: 'Configuración', icon: Settings },
    { id: 'soporte_chat', label: 'Soporte', icon: MessageSquare, badge: (soporteNoLeidosTotal + ticketsNoLeidosTotal) || undefined },
    { id: 'simulador_red', label: 'Simulador Red', icon: Activity },
    { id: 'red_mercadeo', label: 'Programa de Referidos', icon: Globe },
    { id: 'feedback', label: 'Feedback Usuarios', icon: MessageSquarePlus },
  ].filter(item => puedeVer(item.id));

  // ========== MODALES ==========

  // Modal: Ver Documentos de Empresa Pendiente
  // Modal: Ver Documentos de Empresa Pendiente — JSX inline para evitar desmontaje por referencia cambiante
  const ModalDocumentosJSX = (() => {
    if (!modalDocumentos) return null;
    // Leer del store en vivo — buscar en pendientes y activas (tras aprobación pasa a activas)
    const empresaFresh =
      store.empresasPendientes.find(e => e.id === modalDocumentos?.id) ||
      store.empresasActivas.find(e => e.id === modalDocumentos?.id) ||
      modalDocumentos;
    // Mostrar todos los documentos requeridos, con el status de los subidos
    const usuarioTransportista = store.usuarios.find(u => u.empresaId === modalDocumentos?.id && u.rol === 'transportista');
    const docsRequeridos = getDocumentosRequeridos(usuarioTransportista?.tipoPersona);
    const docsSubidos = empresaFresh?.documentosEmpresa || [];
    const docs = docsRequeridos.map(req => {
      const subido = docsSubidos.find(d => d.id === req.id || d.nombre === req.nombre);
      return subido || { id: req.id, nombre: req.nombre, status: 'pendiente' };
    });
    const docsCompletos = docs.filter(d => d.status === 'verificado').length;
    const totalDocs = docs.length;
    const todosVerificados = docsCompletos === totalDocs && totalDocs > 0;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6 border-b flex justify-between items-center">
            <div>
              <h3 className="text-xl font-bold text-gray-800">Revisión de Solicitud</h3>
              <p className="text-gray-500 text-sm">{empresaFresh?.nombre}</p>
            </div>
            <button onClick={() => setModalDocumentos(null)} className="text-gray-400 hover:text-gray-600">
              <X size={24} />
            </button>
          </div>

          <div className="p-6">
            {/* Info de la empresa */}
            <div className="bg-gray-50 rounded-xl p-4 mb-6">
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-gray-500 mb-1">RFC</p>
                  {editandoRfc === empresaFresh?.id ? (
                    <div className="flex items-center gap-2">
                      <input
                        value={rfcEditado}
                        onChange={e => setRfcEditado(e.target.value.replace(/[^A-Za-z0-9&Ññ]/g, '').toUpperCase().slice(0, 13))}
                        className="border border-blue-400 rounded px-2 py-1 text-sm font-mono w-36 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="RFC"
                        maxLength={13}
                      />
                      <button
                        disabled={guardandoRfc}
                        onClick={async () => {
                          if (!validarDigitoVerificadorRFC(rfcEditado)) { alert('El RFC no es válido (dígito verificador incorrecto).'); return; }
                          setGuardandoRfc(true);
                          try {
                            await apiAdminActualizarRfcEmpresa(empresaFresh.id, rfcEditado);
                            setEditandoRfc(null);
                            recargar();
                          } catch (e) { alert(e.message); }
                          finally { setGuardandoRfc(false); }
                        }}
                        className="text-xs px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
                      >{guardandoRfc ? '...' : 'Guardar'}</button>
                      <button onClick={() => setEditandoRfc(null)} className="text-xs px-2 py-1 border rounded hover:bg-gray-50">✕</button>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      <p className="font-semibold font-mono">{empresaFresh?.rfc || <span className="text-gray-400 italic">Sin RFC</span>}</p>
                      <button onClick={() => { setRfcEditado(empresaFresh?.rfc || ''); setEditandoRfc(empresaFresh?.id); }} className="text-xs text-blue-600 hover:underline">Editar</button>
                    </div>
                  )}
                </div>
                <div>
                  <p className="text-gray-500">{usuarioTransportista?.tipoPersona === 'fisica' ? 'Titular' : 'Representante Legal'}</p>
                  <p className="font-semibold">{empresaFresh?.representante}</p>
                </div>
                <div>
                  <p className="text-gray-500">Email de contacto</p>
                  <p className="font-semibold">{empresaFresh?.email}</p>
                </div>
                <div>
                  <p className="text-gray-500">Teléfono</p>
                  <p className="font-semibold">{empresaFresh?.telefono}</p>
                </div>
                <div className="col-span-2">
                  <p className="text-gray-500">Dirección</p>
                  <p className="font-semibold">{empresaFresh?.direccion}</p>
                </div>
                <div>
                  <p className="text-gray-500">Flotilla Declarada</p>
                  <p className="font-semibold">{empresaFresh?.flota}</p>
                </div>
                <div>
                  <p className="text-gray-500">Fecha de Solicitud</p>
                  <p className="font-semibold">{empresaFresh?.creadoEn ? new Date(empresaFresh.creadoEn).toLocaleDateString('es-MX') : '—'}</p>
                </div>
                {empresaFresh?.codigoPromo && (
                  <div className="col-span-2">
                    <p className="text-gray-500">Código de acceso ingresado</p>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="font-mono font-bold text-green-700 bg-green-50 border border-green-200 px-2 py-0.5 rounded text-sm">🔑 {empresaFresh.codigoPromo}</span>
                      {(() => {
                        const promos = store.configPlataforma?.promos || [];
                        const match = promos.find(p => p.activa && p.codigoAcceso?.toUpperCase() === empresaFresh.codigoPromo?.toUpperCase());
                        return match
                          ? <span className="text-xs text-green-600 font-semibold">✓ Aplica promo "{match.nombre}" — {match.cuposTotal - (match.cuposUsados || 0)} cupos restantes</span>
                          : <span className="text-xs text-gray-400">Sin promo activa que coincida</span>;
                      })()}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Progreso de documentos */}
            <div className="mb-4">
              <div className="flex justify-between text-sm mb-2">
                <span className="text-gray-600">Documentos verificados</span>
                <span className="font-semibold">{docsCompletos}/{totalDocs}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className={`h-2 rounded-full transition-all ${todosVerificados ? 'bg-green-500' : 'bg-yellow-500'}`}
                  style={{ width: `${(docsCompletos/totalDocs)*100}%` }}
                ></div>
              </div>
            </div>

            {/* Cuenta de acceso (si se registró en línea) */}
            {usuarioTransportista && (
              <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-4">
                <p className="text-sm font-semibold text-blue-800 mb-1">Cuenta de acceso al portal</p>
                <p className="text-sm text-blue-700">
                  Email: <span className="font-mono font-semibold">{usuarioTransportista.email}</span>
                </p>
                <p className="text-xs text-blue-500 mt-1">El transportista ya puede iniciar sesión para subir documentos. Al aprobar la empresa, tendrá acceso completo.</p>
              </div>
            )}

            {/* Lista de documentos */}
            <div className="space-y-3 mb-6">
              {docs.map((doc, idx) => {
                const esVerificado = doc.status === 'verificado';
                const esSubido    = doc.status === 'subido';
                const esPendiente = !esVerificado && !esSubido;
                const info = docsRequeridos.find(d => d.id === doc.id || d.nombre === doc.nombre);
                return (
                  <div key={doc.id || idx} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${
                        esVerificado ? 'bg-green-100' : esSubido ? 'bg-blue-100' : 'bg-gray-200'
                      }`}>
                        {esVerificado
                          ? <CheckCircle size={18} className="text-green-600" />
                          : esSubido
                            ? <Clock size={18} className="text-blue-600" />
                            : <FileText size={18} className="text-gray-400" />}
                      </div>
                      <div>
                        <p className="font-medium text-gray-800">{doc.nombre}</p>
                        {info?.descripcion && <p className="text-xs text-gray-400">{info.descripcion}</p>}
                        {esSubido && <p className="text-xs text-blue-600 mt-0.5">Subido por el transportista — pendiente de revisión</p>}
                        {esVerificado && <p className="text-xs text-green-600 mt-0.5">Verificado</p>}
                        {esPendiente && <p className="text-xs text-gray-400 mt-0.5">No adjuntado aún</p>}
                      </div>
                    </div>
                    <div className="flex items-center gap-2 shrink-0">
                      {(esSubido || esVerificado) && (doc.filePath || doc.fileUrl || doc.fileDataUrl) && (
                        <button
                          onClick={async () => {
                            const val = doc.filePath || doc.fileUrl;
                            if (val) {
                              const url = val.startsWith('https://') ? val : await apiGetDownloadUrl(val).catch(() => null);
                              if (url) window.open(url, '_blank');
                            } else {
                              const base64 = doc.fileDataUrl.split(',')[1];
                              const binary = atob(base64);
                              const bytes = new Uint8Array(binary.length);
                              for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                              const blob = new Blob([bytes], { type: 'application/pdf' });
                              window.open(URL.createObjectURL(blob), '_blank');
                            }
                          }}
                          className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 text-white text-xs font-semibold rounded-lg hover:bg-blue-700 transition"
                        >
                          <Eye size={13} />
                          Ver PDF
                        </button>
                      )}
                      {esSubido && puedeHacer('aprobar') && (
                        <button
                          onClick={() => {
                            storeActualizarStatusDocumento(modalDocumentos.id, doc.id, 'verificado');
                            apiAdminVerificarDocumento(modalDocumentos.id, doc.id, 'verificado').catch((e) => {
                              storeActualizarStatusDocumento(modalDocumentos.id, doc.id, doc.status);
                              mostrarNotificacion(e.message || 'Error al verificar el documento en el servidor', 'error');
                            });
                          }}
                          className="flex items-center gap-1 px-3 py-1.5 bg-green-600 text-white text-xs font-semibold rounded-lg hover:bg-green-700 transition"
                        >
                          <CheckCircle size={13} />
                          Verificar
                        </button>
                      )}
                      {esSubido && puedeHacer('rechazar') && (
                        <button
                          onClick={() => {
                            storeActualizarStatusDocumento(modalDocumentos.id, doc.id, 'rechazado');
                            apiAdminVerificarDocumento(modalDocumentos.id, doc.id, 'rechazado').catch((e) => {
                              storeActualizarStatusDocumento(modalDocumentos.id, doc.id, doc.status);
                              mostrarNotificacion(e.message || 'Error al rechazar el documento en el servidor', 'error');
                            });
                          }}
                          className="flex items-center gap-1 px-2 py-1.5 bg-red-100 text-red-700 text-xs font-semibold rounded-lg hover:bg-red-200 transition"
                        >
                          Rechazar
                        </button>
                      )}
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                        esVerificado ? 'bg-green-100 text-green-700'
                        : esSubido    ? 'bg-blue-100 text-blue-700'
                        : doc.status === 'rechazado' ? 'bg-red-100 text-red-700'
                        : 'bg-gray-100 text-gray-500'
                      }`}>
                        {esVerificado ? '✓ Verificado' : esSubido ? '📎 Subido' : doc.status === 'rechazado' ? '✗ Rechazado' : '⏳ Pendiente'}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Advertencia si faltan documentos */}
            {!todosVerificados && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <p className="text-sm text-yellow-800">
                  <AlertCircle size={16} className="inline mr-1" />
                  Hay documentos pendientes de verificación. Puedes aprobar condicionalmente o solicitar los documentos faltantes.
                </p>
              </div>
            )}

            {/* Configuración de comisión */}
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <h4 className="font-semibold text-green-800 mb-3 flex items-center">
                <Percent size={18} className="mr-2" />
                Comisión para este transportista
              </h4>
              <div className="flex items-center space-x-4">
                <select 
                  value={comisionSeleccionada} 
                  onChange={(e) => setComisionSeleccionada(parseInt(e.target.value))}
                  className="px-4 py-2 border border-green-300 rounded-lg focus:ring-2 focus:ring-green-500 bg-white"
                >
                  <option value={15}>15% - Preferencial</option>
                  <option value={18}>18% - Especial</option>
                  <option value={20}>20% - Estándar</option>
                  <option value={22}>22% - Mayor</option>
                  <option value={25}>25% - Máxima</option>
                </select>
                <span className="text-sm text-green-700">
                  Se cobrará el {comisionSeleccionada}% en cada transacción
                </span>
              </div>
            </div>

            {/* Botones de acción */}
            {puedeHacer('aprobar') ? (
              <div className="flex space-x-3">
                <button
                  onClick={() => aprobarEmpresa(modalDocumentos.id, comisionSeleccionada)}
                  className="flex-1 px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold flex items-center justify-center space-x-2"
                >
                  <UserCheck size={20} />
                  <span>Aprobar con {comisionSeleccionada}% comisión</span>
                </button>
                <button
                  onClick={() => {
                    const motivo = prompt('Motivo del rechazo:');
                    if (motivo) rechazarEmpresa(modalDocumentos.id, motivo);
                  }}
                  className="flex-1 px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 font-semibold flex items-center justify-center space-x-2"
                >
                  <UserX size={20} />
                  <span>Rechazar</span>
                </button>
              </div>
            ) : (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-center">
                <p className="text-sm text-yellow-700">Solo puedes consultar los documentos. No tienes permisos para aprobar o rechazar.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  })();

  // Modal: Detalle de Empresa Activa — renderizado como IIFE para evitar desmontaje por referencia cambiante
  const ModalDetalleEmpresaJSX = modalDetalleEmpresa ? (
    <>
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b flex justify-between items-center">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 bg-green-100 flex items-center justify-center shadow">
              {modalDetalleEmpresa?.logo
                ? <img src={modalDetalleEmpresa.logo} alt={modalDetalleEmpresa.nombre} className="w-full h-full object-cover" />
                : <span className="text-green-700 font-black text-2xl">{modalDetalleEmpresa?.nombre?.charAt(0)?.toUpperCase()}</span>}
            </div>
          <div>
            <h3 className="text-xl font-bold text-gray-800">{modalDetalleEmpresa?.nombre}</h3>
            <div className="flex flex-wrap gap-1 mt-1 mb-2">
              {modalDetalleEmpresa && calcularInsignias(
                empresasActivasMerged.find(e => e.id === modalDetalleEmpresa.id) || modalDetalleEmpresa
              ).map(i => (
                <InsigniaBadge key={i.id} insignia={i} />
              ))}
            </div>
            <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
              modalDetalleEmpresa?.status === 'activa' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
            }`}>
              {modalDetalleEmpresa?.status === 'activa' ? '● Activa' : '● Suspendida'}
            </span>
          </div>
          </div>
          <button onClick={cerrarModalDetalle} className="text-gray-400 hover:text-gray-600">
            <X size={24} />
          </button>
        </div>
        
        <div className="p-6">
          {/* Info general */}
          <div className="grid grid-cols-2 gap-6 mb-6">
            <div className="bg-gray-50 rounded-xl p-4">
              <h4 className="font-semibold text-gray-700 mb-3">Información de la Empresa</h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">RFC:</span>
                  <span className="font-mono">{modalDetalleEmpresa?.rfc}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Representante:</span>
                  <span>{modalDetalleEmpresa?.representante}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Email:</span>
                  <span>{modalDetalleEmpresa?.email}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Teléfono:</span>
                  <span>{modalDetalleEmpresa?.telefono}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Fecha Registro:</span>
                  <span>{modalDetalleEmpresa?.creadoEn ? new Date(modalDetalleEmpresa.creadoEn).toLocaleString('es-MX', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' }) : '—'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Fecha Aprobación:</span>
                  <span>{modalDetalleEmpresa?.aprobadoEn ? new Date(modalDetalleEmpresa.aprobadoEn).toLocaleDateString('es-MX') : '—'}</span>
                </div>
                {(() => {
                  const owner = (store.usuarios || []).find(u => u.empresaId === modalDetalleEmpresa?.id && u.rol === 'transportista');
                  if (!owner) return null;
                  return (
                    <div className="flex justify-between">
                      <span className="text-gray-500">Email verificado:</span>
                      {owner.emailVerificado
                        ? <span className="text-xs text-green-600 font-semibold">✓ Verificado</span>
                        : <span className="text-xs text-orange-500 font-semibold">⚠ Sin verificar</span>}
                    </div>
                  );
                })()}
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-4">
              <h4 className="font-semibold text-gray-700 mb-3">Estadísticas</h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">Unidades registradas:</span>
                  <span className="font-semibold">{modalDetalleEmpresa?.unidades}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Flotilla declarada:</span>
                  <span className="font-semibold">{modalDetalleEmpresa?.flota ?? '—'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Choferes:</span>
                  <span className="font-semibold">{modalDetalleEmpresa?.choferes}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Viajes Activos:</span>
                  <span className="font-semibold text-blue-600">{modalDetalleEmpresa?.viajesActivos}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Viajes Completados:</span>
                  <span className="font-semibold">{modalDetalleEmpresa?.viajesCompletados}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Calificación:</span>
                  <span className="font-semibold flex items-center gap-1">
                    {(modalDetalleEmpresa?.viajesCompletados > 0 && modalDetalleEmpresa?.calificacion)
                      ? <><Star size={14} className="text-yellow-400" fill="currentColor" />{Number(modalDetalleEmpresa.calificacion).toFixed(1)}</>
                      : '—'}
                  </span>
                </div>
              </div>
            </div>
          </div>


          {/* Comisiones */}
          <div className="bg-green-50 rounded-xl p-4 mb-6">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-green-600">Comisiones Generadas para Choyero!</p>
                <p className="text-3xl font-bold text-green-700">${(modalDetalleEmpresa?.comisionGenerada || 0).toLocaleString()} MXN</p>
              </div>
              <DollarSign size={48} className="text-green-300" />
            </div>
          </div>

          {/* Comisión personalizada */}
          <div className="bg-yellow-50 rounded-xl p-4 mb-6 border border-yellow-200">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-yellow-700 font-semibold">Comisión Asignada</p>
                <p className="text-2xl font-bold text-yellow-800">{modalDetalleEmpresa?.comisionPersonalizada || 20}%</p>
              </div>
              <button 
                onClick={() => {
                  setModalEditarComision(modalDetalleEmpresa);
                  cerrarModalDetalle();
                }}
                className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 font-semibold flex items-center space-x-2"
              >
                <Edit size={16} />
                <span>Modificar</span>
              </button>
            </div>
          </div>

          {/* Editor de Insignias */}
          {(() => {
            const empId = modalDetalleEmpresa?.id;
            // Leer siempre del store vivo (empresasActivasMerged) para que cada
            // toggle refleje el estado más reciente y no sobreescriba insignias previas
            const empViva = empresasActivasMerged.find(e => e.id === empId);
            const actuales = empViva?.insigniasManuales || [];
            const toggle = (id) => {
              const nuevas = actuales.includes(id)
                ? actuales.filter(x => x !== id)
                : [...actuales, id];
              storeActualizarInsignias(empId, nuevas);
              apiAdminActualizarInsigniasEmpresa(empId, nuevas).catch((e) => {
                storeActualizarInsignias(empId, actuales);
                mostrarNotificacion(e.message || 'Error al guardar las insignias en el servidor', 'error');
              });
            };
            return (
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-6">
                <p className="text-sm font-semibold text-gray-700 mb-3">Insignias asignadas</p>
                <div className="grid grid-cols-2 gap-2">
                  {CATALOGO_INSIGNIAS.map(ins => {
                    const activa = actuales.includes(ins.id);
                    return (
                      <button
                        key={ins.id}
                        onClick={() => toggle(ins.id)}
                        className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm transition-all text-left ${
                          activa
                            ? `${ins.color} font-semibold shadow-sm`
                            : 'bg-white border-gray-200 text-gray-400 hover:border-gray-400'
                        }`}
                      >
                        <span className="text-base">{ins.emoji}</span>
                        <div className="min-w-0">
                          <p className={`font-medium leading-tight truncate ${activa ? '' : 'text-gray-500'}`}>{ins.label}</p>
                          <p className="text-xs text-gray-400 leading-tight truncate">{ins.desc}</p>
                        </div>
                        {activa && <span className="ml-auto text-green-500 shrink-0">✓</span>}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          {/* Documentos */}
          {(() => {
            const empActiva = store.empresasActivas.find(e => e.id === modalDetalleEmpresa?.id);
            const docs = empActiva?.documentosEmpresa;
            if (!docs?.length) return null;
            const tieneArchivos = docs.some(d => d.filePath || d.fileUrl || d.fileDataUrl);
            if (!tieneArchivos) return null;
            return (
              <div className="bg-gray-50 rounded-xl p-4 mb-6">
                <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <FileText size={16} />
                  Documentos de la empresa
                </h4>
                <div className="space-y-2">
                  {docs.map(doc => (
                    <div key={doc.id} className="flex items-center gap-3 text-sm">
                      <span className="text-gray-800 w-48 shrink-0">{doc.nombre}</span>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                        doc.status === 'verificado' ? 'bg-green-100 text-green-700'
                        : doc.status === 'subido'   ? 'bg-blue-100 text-blue-700'
                        : 'bg-gray-100 text-gray-500'
                      }`}>
                        {doc.status === 'verificado' ? '✓ Verificado' : doc.status === 'subido' ? '📎 Subido' : '⏳ Pendiente'}
                      </span>
                      {(doc.filePath || doc.fileUrl || doc.fileDataUrl) && (
                        <button
                          onClick={async () => {
                            const val = doc.filePath || doc.fileUrl;
                            if (val) {
                              const url = val.startsWith('https://') ? val : await apiGetDownloadUrl(val).catch(() => null);
                              if (url) window.open(url, '_blank');
                            } else {
                              const base64 = doc.fileDataUrl.split(',')[1];
                              const binary = atob(base64);
                              const bytes = new Uint8Array(binary.length);
                              for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
                              const blob = new Blob([bytes], { type: 'application/pdf' });
                              window.open(URL.createObjectURL(blob), '_blank');
                            }
                          }}
                          className="flex items-center gap-1 px-3 py-1 bg-blue-600 text-white text-xs font-semibold rounded-lg hover:bg-blue-700 transition"
                        >
                          <Eye size={12} />
                          Ver PDF
                        </button>
                      )}
                      {doc.status === 'subido' && puedeHacer('aprobar') && (
                        <button
                          onClick={() => {
                            apiAdminVerificarDocumento(modalDetalleEmpresa.id, doc.id, 'verificado')
                              .then(() => recargar())
                              .catch(() => {});
                          }}
                          className="flex items-center gap-1 px-3 py-1 bg-green-600 text-white text-xs font-semibold rounded-lg hover:bg-green-700 transition"
                        >
                          <CheckCircle size={12} />
                          Verificar
                        </button>
                      )}
                      {doc.status === 'subido' && puedeHacer('rechazar') && (
                        <button
                          onClick={() => {
                            apiAdminVerificarDocumento(modalDetalleEmpresa.id, doc.id, 'rechazado')
                              .then(() => recargar())
                              .catch(() => {});
                          }}
                          className="flex items-center gap-1 px-3 py-1 bg-red-100 text-red-700 text-xs font-semibold rounded-lg hover:bg-red-200 transition"
                        >
                          Rechazar
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}

          {/* Historial de sanciones */}
          {(() => {
            const emp = empresasActivasMerged.find(e => e.id === modalDetalleEmpresa?.id) || modalDetalleEmpresa;
            const sanciones = (emp?.historialSanciones || []).slice().reverse();
            if (sanciones.length === 0) return null;
            return (
              <div className="mb-6">
                <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <AlertTriangle size={16} className="text-orange-500" />
                  Historial de sanciones
                  <span className="bg-orange-100 text-orange-700 text-xs font-bold px-2 py-0.5 rounded-full">{sanciones.length}</span>
                </h4>
                <div className="space-y-2 max-h-40 overflow-y-auto">
                  {sanciones.map(s => (
                    <div key={s.id} className={`flex items-start gap-3 p-3 rounded-lg border text-sm ${s.tipo === 'suspension' ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}`}>
                      <span className="text-lg">{s.tipo === 'suspension' ? '🔴' : '🟢'}</span>
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-gray-800">{s.tipo === 'suspension' ? 'Suspensión' : 'Reactivación'}</p>
                        <p className="text-gray-600 text-xs">{s.motivo}</p>
                        <p className="text-gray-400 text-xs mt-1">{new Date(s.fecha).toLocaleString('es-MX')} — {s.aplicadoPor}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}

          {/* Promoción */}
          {(() => {
            const emp = empresasActivasMerged.find(e => e.id === modalDetalleEmpresa?.id) || modalDetalleEmpresa;
            const promos = store.configPlataforma?.promos || [];
            const promoConf = emp?.promoActiva && emp?.promoId
              ? promos.find(p => p.id === emp.promoId)
              : null;
            const promosDisponibles = promos.filter(p => p.activa && (p.cuposUsados || 0) < (p.cuposTotal || 0));

            const asignar = async () => {
              if (!promoSeleccionada) return;
              setPromoAsignando(true);
              try {
                await apiAsignarPromo(promoSeleccionada, emp.id);
                setPromoSeleccionada('');
                recargar();
              } catch (e) { alert(e.message || 'Error al asignar'); }
              finally { setPromoAsignando(false); }
            };

            const quitar = async () => {
              if (!emp?.promoId) return;
              if (!window.confirm('¿Quitar la promoción de esta empresa? No se podrá deshacer.')) return;
              setPromoAsignando(true);
              try {
                await apiQuitarPromo(emp.promoId, emp.id);
                recargar();
              } catch (e) { alert(e.message || 'Error al quitar'); }
              finally { setPromoAsignando(false); }
            };

            return (
              <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6">
                <h4 className="font-semibold text-gray-700 mb-3 flex items-center gap-2">🎁 Promoción</h4>
                {emp?.promoActiva && promoConf ? (
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <p className="text-sm font-semibold text-green-800">{promoConf.nombre}</p>
                      <p className="text-xs text-green-600 mt-0.5">
                        {emp.promoFletesUsados || 0} de {promoConf.fletesGratis} fletes usados ·{' '}
                        {promoConf.comisionPromo}% comisión
                      </p>
                      {/* Barra de progreso fletes */}
                      <div className="mt-1.5 h-1.5 bg-green-200 rounded-full w-40">
                        <div
                          className="h-1.5 bg-green-500 rounded-full transition-all"
                          style={{ width: `${Math.min(100, ((emp.promoFletesUsados || 0) / promoConf.fletesGratis) * 100)}%` }}
                        />
                      </div>
                    </div>
                    <button
                      onClick={quitar}
                      disabled={promoAsignando}
                      className="px-3 py-1.5 bg-red-100 text-red-600 hover:bg-red-200 text-xs font-semibold rounded-lg transition disabled:opacity-50 flex-shrink-0"
                    >
                      {promoAsignando ? '...' : '✕ Quitar promo'}
                    </button>
                  </div>
                ) : (
                  <div className="flex items-center gap-2">
                    {promosDisponibles.length > 0 ? (
                      <>
                        <select
                          value={promoSeleccionada}
                          onChange={e => setPromoSeleccionada(e.target.value)}
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white"
                        >
                          <option value="">Seleccionar promoción...</option>
                          {promosDisponibles.map(p => (
                            <option key={p.id} value={p.id}>
                              {p.nombre} — {p.comisionPromo}% · {(p.cuposTotal || 0) - (p.cuposUsados || 0)} cupos restantes
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={asignar}
                          disabled={promoAsignando || !promoSeleccionada}
                          className="px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 disabled:opacity-50 transition flex-shrink-0"
                        >
                          {promoAsignando ? '...' : '🎁 Asignar'}
                        </button>
                      </>
                    ) : (
                      <p className="text-sm text-gray-400 italic">Sin promociones activas con cupos disponibles</p>
                    )}
                  </div>
                )}
              </div>
            );
          })()}

          {/* Acciones */}
          <div className="flex space-x-3">
            {puedeHacer('suspender') && (
              <button
                onClick={() => { setModalSuspender({ ...modalDetalleEmpresa }); setMotivoSuspension(''); }}
                className={`flex-1 px-4 py-3 rounded-lg font-semibold flex items-center justify-center space-x-2 ${
                  modalDetalleEmpresa?.status === 'activa'
                    ? 'bg-red-100 text-red-700 hover:bg-red-200'
                    : 'bg-green-100 text-green-700 hover:bg-green-200'
                }`}
              >
                {modalDetalleEmpresa?.status === 'activa' ? (
                  <><XCircle size={20} /><span>Suspender Empresa</span></>
                ) : (
                  <><CheckCircle size={20} /><span>Reactivar Empresa</span></>
                )}
              </button>
            )}
            <button
              onClick={() => {
                const u = (store.usuarios || []).find(u => u.empresaId === modalDetalleEmpresa?.id && u.rol === 'transportista');
                if (u) {
                  const canal = `admin-empresa-${modalDetalleEmpresa.id}`;
                  reabrirConversacionAdmin(canal);
                  setChatEmpresaActivo({ empresaId: modalDetalleEmpresa.id, empresaNombre: modalDetalleEmpresa.nombre, usuarioId: u.id, usuarioNombre: u.nombre, origen: 'modal' });
                }
              }}
              className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold flex items-center justify-center space-x-2"
            >
              <Mail size={20} />
              <span>Enviar Mensaje</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    {/* Modal confirmación suspensión/reactivación — dentro del mismo árbol para evitar conflictos de stacking */}
    {modalSuspender && (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center p-4 z-[200]">
        <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
          <div className="flex items-center gap-3 mb-4">
            {modalSuspender.status === 'activa' ? (
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <XCircle size={24} className="text-red-600" />
              </div>
            ) : (
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <CheckCircle size={24} className="text-green-600" />
              </div>
            )}
            <div>
              <h3 className="text-lg font-bold text-gray-800">
                {modalSuspender.status === 'activa' ? 'Suspender empresa' : 'Reactivar empresa'}
              </h3>
              <p className="text-sm text-gray-500">{modalSuspender.nombre}</p>
            </div>
          </div>

          {modalSuspender.status === 'activa' ? (
            <>
              <p className="text-sm text-gray-600 mb-4">
                La empresa perderá acceso inmediato a la plataforma. Su transportista recibirá una notificación con el motivo.
              </p>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Motivo de suspensión <span className="text-red-500">*</span>
              </label>
              <textarea
                value={motivoSuspension}
                onChange={e => setMotivoSuspension(e.target.value)}
                placeholder="Ej: Incumplimiento de políticas, quejas reiteradas de clientes, documentación vencida..."
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-400 mb-4 resize-none"
              />
            </>
          ) : (
            <>
              <p className="text-sm text-gray-600 mb-4">
                La empresa recuperará acceso completo a la plataforma. Opcionalmente indica una nota de reactivación.
              </p>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Nota de reactivación <span className="text-gray-400 font-normal">(opcional)</span>
              </label>
              <textarea
                value={motivoSuspension}
                onChange={e => setMotivoSuspension(e.target.value)}
                placeholder="Ej: Situación regularizada, documentación actualizada..."
                rows={2}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-400 mb-4 resize-none"
              />
            </>
          )}

          <div className="flex gap-3">
            <button
              onClick={() => { setModalSuspender(null); setMotivoSuspension(''); }}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-600 rounded-lg hover:bg-gray-50 font-medium text-sm"
            >
              Cancelar
            </button>
            <button
              onClick={confirmarSuspension}
              disabled={modalSuspender.status === 'activa' && !motivoSuspension.trim()}
              className={`flex-1 px-4 py-2 rounded-lg font-semibold text-sm text-white transition ${
                modalSuspender.status === 'activa'
                  ? 'bg-red-600 hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed'
                  : 'bg-green-600 hover:bg-green-700'
              }`}
            >
              {modalSuspender.status === 'activa' ? 'Confirmar suspensión' : 'Reactivar empresa'}
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  ) : null;

  // Modal: Editar Comisión de Empresa


  // Componente: Mapa de todas las unidades (Leaflet real)
  const MapaGeneralUnidades = () => {
    const todasUnidades = obtenerTodasLasUnidades();
    const transportistasActivos = empresasActivasMerged.filter(e => e.status === 'activa');

    // Choferes con GPS real
    const choferesConGps = transportistasActivos.flatMap(e =>
      (e.choferesGps || []).map(c => ({ ...c, empresa: e.nombre, empresaId: e.id }))
    );

    // Agrupar unidades sin GPS por ciudad
    const unidadesPorCiudad = {};
    todasUnidades.forEach(u => {
      const ciudad = u.ubicacion?.ciudad || u.ciudadEmpresa;
      if (ciudad && COORDS_CIUDADES_ADMIN[ciudad]) {
        if (!unidadesPorCiudad[ciudad]) unidadesPorCiudad[ciudad] = [];
        unidadesPorCiudad[ciudad].push(u);
      }
    });

    const iconCluster = (unidades) => {
      const activas = unidades.filter(u => u.status === 'activa' || u.status === 'en_viaje').length;
      const color = activas > 0 ? '#eab308' : '#9ca3af';
      return L.divIcon({
        html: `<div style="position:relative;display:inline-block;">
          <div style="background:white;border:2.5px solid ${color};border-radius:50%;width:44px;height:44px;display:flex;align-items:center;justify-content:center;box-shadow:0 3px 10px rgba(0,0,0,0.22);">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
          </div>
          <div style="position:absolute;top:-5px;right:-5px;background:${color};color:white;font-size:10px;font-weight:bold;border-radius:50%;width:18px;height:18px;display:flex;align-items:center;justify-content:center;border:1.5px solid white;">${unidades.length}</div>
        </div>`,
        iconSize: [44, 44], iconAnchor: [22, 22], popupAnchor: [0, -28], className: '',
      });
    };

    const iconChoferGps = L.divIcon({
      className: '',
      html: `<div style="background:#7c3aed;color:white;border-radius:50%;width:38px;height:38px;display:flex;align-items:center;justify-content:center;font-size:20px;border:3px solid white;box-shadow:0 2px 10px rgba(124,58,237,0.6)">🚛</div>`,
      iconSize: [38, 38], iconAnchor: [19, 19],
    });

    return (
      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <div>
            <h3 className="text-xl font-bold text-gray-800">Mapa de Todas las Unidades</h3>
            <p className="text-gray-500 text-sm">{todasUnidades.length} unidades · {transportistasActivos.length} transportistas activos · {choferesConGps.length} con GPS activo</p>
          </div>
          <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500">
            <span className="flex items-center gap-1.5"><span style={{ background:'#7c3aed',borderRadius:'50%',width:10,height:10,display:'inline-block' }}></span> GPS en tiempo real</span>
            <span className="flex items-center gap-1.5"><span style={{ width:10,height:10,borderRadius:'50%',background:'#eab308',display:'inline-block' }}></span> Activa / En viaje</span>
            <span className="flex items-center gap-1.5"><span style={{ width:10,height:10,borderRadius:'50%',background:'#9ca3af',display:'inline-block' }}></span> Inactiva</span>
          </div>
        </div>
        <div className="rounded-xl overflow-hidden border border-gray-200 mb-6" style={{ height: '500px' }}>
          <MapContainer center={[28.0, -113.5]} zoom={6} style={{ height: '100%', width: '100%' }} scrollWheelZoom={true}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {/* Marcadores GPS reales de choferes */}
            {choferesConGps.map(c => (
              <Marker key={c.id} position={[parseFloat(c.lat), parseFloat(c.lng)]} icon={iconChoferGps}>
                <Popup>
                  <div style={{ minWidth: '180px' }}>
                    <p style={{ fontWeight: '700', fontSize: '13px', color: '#7c3aed', marginBottom: '4px' }}>📡 GPS en tiempo real</p>
                    <p style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937' }}>{c.nombre}</p>
                    <p style={{ fontSize: '11px', color: '#6b7280' }}>{c.empresa}</p>
                    {c.rutaActual && <p style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>🛣 {c.rutaActual}</p>}
                  </div>
                </Popup>
              </Marker>
            ))}
            {/* Marcadores agrupados por ciudad */}
            {Object.entries(unidadesPorCiudad).map(([ciudad, unidades]) => (
              <Marker key={ciudad} position={COORDS_CIUDADES_ADMIN[ciudad]} icon={iconCluster(unidades)}>
                <Popup>
                  <div style={{ minWidth: '190px' }}>
                    <p style={{ fontWeight: '700', fontSize: '13px', marginBottom: '6px', color: '#1f2937' }}>📍 {ciudad}</p>
                    {unidades.map(u => (
                      <div key={u.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 0', borderTop: '1px solid #f3f4f6' }}>
                        <div>
                          <span style={{ fontSize: '12px', fontWeight: '600', color: '#374151', fontFamily: 'monospace' }}>{u.placas}</span>
                          <span style={{ fontSize: '11px', color: '#9ca3af', display: 'block' }}>{u.tipo} · {u.empresa || '—'}</span>
                        </div>
                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', flexShrink: 0, background: u.status === 'activa' || u.status === 'en_viaje' ? '#eab308' : '#9ca3af', display: 'inline-block' }}></span>
                      </div>
                    ))}
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

        {/* Lista de unidades por empresa */}
        <div className="space-y-4">
          <h4 className="font-semibold text-gray-800">Unidades por Transportista</h4>
          {transportistasActivos.filter(e => {
            const flota = (store.flota || []).filter(u => u.empresaId === e.id);
            return flota.length > 0 || e.unidadesDetalle?.length > 0;
          }).map(empresa => {
            const flota = (store.flota || []).filter(u => u.empresaId === empresa.id);
            const unidadesMostrar = flota.length > 0 ? flota : (empresa.unidadesDetalle || []);
            return (
              <div key={empresa.id} className="bg-gray-50 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center space-x-2">
                    <Building2 size={18} className="text-yellow-600" />
                    <span className="font-semibold">{empresa.nombre}</span>
                    <span className="text-xs text-gray-500">({unidadesMostrar.length} unidades)</span>
                  </div>
                  <span className="text-sm bg-yellow-100 text-yellow-800 px-2 py-1 rounded">{empresa.comisionPersonalizada}% comisión</span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                  {unidadesMostrar.map(u => (
                    <div key={u.id} className="flex items-center justify-between bg-white rounded p-2 text-sm">
                      <div>
                        <span className="font-mono font-semibold">{u.placas}</span>
                        <p className="text-xs text-gray-500">{u.tipo || 'N/A'}</p>
                      </div>
                      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: u.status === 'activa' || u.status === 'en_viaje' ? '#eab308' : '#9ca3af', display: 'inline-block', flexShrink: 0 }}></span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
          {transportistasActivos.filter(e => {
            const flota = (store.flota || []).filter(u => u.empresaId === e.id);
            return flota.length === 0 && !e.unidadesDetalle?.length;
          }).length === transportistasActivos.length && (
            <p className="text-center text-gray-400 text-sm py-4">Los transportistas aún no han registrado unidades.</p>
          )}
        </div>
      </div>
    );
  };

  // Componente de Notificación
  const Notificacion = () => {
    if (!notificacion) return null;
    const colores = { success: 'bg-green-500', warning: 'bg-yellow-500', error: 'bg-red-500' };
    if (notificacion.persistente) {
      return (
        <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gray-900 text-white rounded-2xl shadow-2xl z-[99999] max-w-sm w-full mx-4 border border-yellow-400">
          <div className="px-6 pt-5 pb-3 cursor-pointer" onClick={() => { setNotificacion(null); if (notificacion.navegar) setSeccion(notificacion.navegar); }}>
            <div className="flex items-start space-x-3">
              <AlertCircle size={26} className="flex-shrink-0 mt-0.5 text-yellow-400" />
              <p className="font-medium text-sm leading-snug">{notificacion.mensaje}</p>
            </div>
            <p className="text-xs mt-2 opacity-80 underline text-center">Toca aquí para ir a atender →</p>
          </div>
          <div className="border-t border-white/30 px-6 py-2 flex justify-end">
            <button onClick={() => setNotificacion(null)} className="text-xs opacity-80 hover:opacity-100 flex items-center gap-1"><X size={14} /> Cerrar</button>
          </div>
        </div>
      );
    }
    return (
      <div className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${colores[notificacion.tipo]} text-white px-8 py-5 rounded-2xl shadow-2xl z-[99999] flex items-center space-x-3 text-center max-w-sm w-full mx-4`}>
        {notificacion.tipo === 'success' && <CheckCircle size={24} />}
        {notificacion.tipo === 'warning' && <AlertCircle size={24} />}
        {notificacion.tipo === 'error' && <XCircle size={24} />}
        <span className="font-medium">{notificacion.mensaje}</span>
      </div>
    );
  };

  // ========== RENDER PRINCIPAL ==========
  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {Notificacion()}

      {/* Toast flotante de notificaciones */}
      {toastNotif.length > 0 && !toastPausado && (() => {
        const notif = toastNotif[0];
        const seccionDestino = {
          empresa_pendiente: 'empresas',
          empresa_aprobada: 'empresas',
          empresa_rechazada: 'empresas',
          empresa_suspendida: 'empresas',
          empresa_reactivada: 'empresas',
        }[notif.tipo] || null;
        return (
          <div className="fixed inset-0 flex items-center justify-center z-[2000] pointer-events-none">
            <div className="pointer-events-auto animate-slide-in-right w-96 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
              <div className="flex items-center justify-between px-4 py-3 bg-gray-900">
                <div className="flex items-center gap-2">
                  <Bell size={16} className="text-white" />
                  <span className="text-white font-semibold text-sm">
                    Nueva notificación{toastNotif.length > 1 ? ` (1 de ${toastNotif.length})` : ''}
                  </span>
                </div>
                <button onClick={() => cerrarToast()} className="text-gray-300 hover:text-white transition-colors">
                  <X size={18} />
                </button>
              </div>
              <div
                className={`p-4 ${seccionDestino ? 'cursor-pointer hover:bg-gray-50' : ''}`}
                onClick={() => {
                  if (seccionDestino) { setSeccion(seccionDestino); setMostrarNotificaciones(false); }
                  cerrarToast();
                }}
              >
                <p className="font-semibold text-gray-800 text-sm">{notif.titulo}</p>
                <p className="text-gray-600 text-sm mt-1">{notif.mensaje}</p>
                {notif.fecha && (
                  <p className="text-gray-400 text-xs mt-2">
                    {new Date(notif.fecha).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}
                    {' · '}
                    {new Date(notif.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
                  </p>
                )}
                {seccionDestino && <p className="text-gray-500 text-xs font-semibold mt-3">Toca para ver →</p>}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Panel de notificaciones */}
      {mostrarNotificaciones && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-[1000] flex justify-end" onClick={() => setMostrarNotificaciones(false)}>
          <div className="w-full md:w-96 bg-white h-full shadow-2xl flex flex-col" onClick={e => e.stopPropagation()}>
            <div className="p-4 border-b flex justify-between items-center bg-gray-900">
              <div>
                <h3 className="font-bold text-white">Notificaciones</h3>
                <p className="text-xs text-gray-400">{notifsPendientes.length} sin leer</p>
              </div>
              <div className="flex items-center gap-3">
                {(store.notificaciones || []).filter(n => n.destinatarioId === usuario?.id || n.destinatarioRol === 'superadmin').length > 0 && (
                  <button onClick={() => { limpiarNotificaciones(usuario?.id, 'superadmin'); setMostrarNotificaciones(false); }} className="text-xs text-red-400 hover:text-red-300 font-medium">Limpiar todo</button>
                )}
                <button onClick={() => setMostrarNotificaciones(false)} className="text-gray-300 hover:text-white"><X size={20} /></button>
              </div>
            </div>
            <div className="flex-1 overflow-y-auto pb-16 md:pb-0">
              {(store.notificaciones || []).filter(n => n.destinatarioId === usuario?.id || n.destinatarioRol === 'superadmin').length === 0 ? (
                <div className="p-8 text-center text-gray-400">
                  <Bell size={40} className="mx-auto mb-2 opacity-30" />
                  <p className="text-sm">Sin notificaciones</p>
                </div>
              ) : (
                <div className="divide-y">
                  {(store.notificaciones || [])
                    .filter(n => n.destinatarioId === usuario?.id || n.destinatarioRol === 'superadmin')
                    .slice().sort((a, b) => new Date(b.creadoEn) - new Date(a.creadoEn))
                    .map(n => {
                      const _notifNav = {
                        empresa_pendiente:  { seccion: 'pendientes',   label: 'Revisar empresa →' },
                        retiro_solicitado:  { seccion: 'finanzas', label: 'Ver solicitudes de retiro →' },
                        disputa_abierta:    { seccion: 'operaciones',  label: 'Ir a operaciones →' },
                        viaje_disputa:      { seccion: 'operaciones',  label: 'Ir a operaciones →' },
                        empresa_aprobada:   { seccion: 'empresas',     label: 'Ver transportistas →' },
                        empresa_rechazada:  { seccion: 'empresas',     label: 'Ver transportistas →' },
                        comision_red:       { seccion: 'red_mercadeo', label: 'Ver red de mercadeo →' },
                      };
                      const navInfo = _notifNav[n.tipo] || null;
                      const destino = navInfo?.seccion || null;
                      const linkLabel = navInfo?.label || null;
                      return (
                        <div
                          key={n.id}
                          className={`p-4 ${destino ? 'cursor-pointer hover:bg-gray-50' : ''} ${n.leida ? 'bg-white' : 'bg-yellow-50'}`}
                          onClick={() => { if (destino) { setSeccion(destino); setMostrarNotificaciones(false); } }}
                        >
                          <div className="flex items-start space-x-3">
                            <div className={`mt-1 w-2 h-2 rounded-full flex-shrink-0 ${n.leida ? 'bg-gray-300' : 'bg-yellow-500'}`} />
                            <div className="flex-1">
                              <p className="font-semibold text-gray-800 text-sm">{n.titulo}</p>
                              <p className="text-gray-600 text-sm mt-0.5">{n.mensaje}</p>
                              <p className="text-xs text-gray-400 mt-1">{new Date(n.creadoEn || n.fecha).toLocaleString('es-MX')}</p>
                              {linkLabel && <span className="mt-2 inline-block text-xs text-yellow-700 font-semibold">{linkLabel}</span>}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Overlay móvil */}
      {sidebarAbierto && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" onClick={() => setSidebarAbierto(false)} />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-30 w-72 bg-gray-900 text-white p-4 pb-20 md:pb-4 flex flex-col overflow-y-auto
        transform transition-transform duration-300 ease-in-out
        ${sidebarAbierto ? 'translate-x-0' : '-translate-x-full'}
        md:relative md:translate-x-0 md:w-64 md:z-auto
      `}>
        <div className="mb-8 flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-black text-orange-400 leading-none">Choyero!</h1>
            <p className="text-xs font-semibold text-gray-400 tracking-widest uppercase mt-0.5">Marketplace Logístico</p>
            <div className="mt-3 px-2 py-1 bg-yellow-600 rounded text-xs font-semibold inline-block">
              SUPER ADMIN
            </div>
          </div>
          <button onClick={abrirNotificaciones} className="relative mt-1 p-2 rounded-lg hover:bg-gray-800 transition-colors">
            <Bell size={20} className="text-gray-300" />
            {notifsPendientes.length > 0 && (
              <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold">
                {notifsPendientes.length > 9 ? '9+' : notifsPendientes.length}
              </span>
            )}
          </button>
        </div>

        <nav className="space-y-2 flex-1">
          {menu.map(item => (
            <button
              key={item.id}
              onClick={() => { setSeccion(item.id); setSidebarAbierto(false); }}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition ${
                seccion === item.id ? 'bg-yellow-600' : 'hover:bg-gray-800'
              }`}
            >
              <item.icon size={20} />
              <span className="text-sm">{item.label}</span>
              {item.badge > 0 && (
                <span className="ml-auto bg-red-500 text-xs px-2 py-1 rounded-full">
                  {item.badge}
                </span>
              )}
            </button>
          ))}
        </nav>

        {/* Resumen rápido — solo superadmin o admin con ver_reportes */}
        {(rolActual === 'superadmin' || puedeHacer('exportar') || puedeVer('reportes')) && <div className="p-4 bg-gray-800 rounded-xl mb-4">
          <p className="text-xs text-gray-300 mb-2 font-semibold uppercase tracking-wide">Comisiones</p>
          <div className="flex justify-between items-baseline mb-1">
            <p className="text-xs text-gray-300">Hoy</p>
            <p className="text-base font-bold text-green-300">${stats.comisionesHoy.toLocaleString()}</p>
          </div>
          <div className="flex justify-between items-baseline mb-2">
            <p className="text-xs text-gray-300">Este mes</p>
            <p className="text-xl font-bold text-green-400">${stats.comisionesMes.toLocaleString()}</p>
          </div>
          <div className="border-t border-gray-600 pt-2">
            <div className="flex justify-between items-baseline mb-1">
              <p className="text-xs text-gray-300">MLM pendiente</p>
              <p className="text-sm font-bold text-yellow-400">
                ${(store.comisionesRed || []).filter(c => c.status === 'pendiente' || c.status === 'disponible').reduce((s, c) => s + c.monto, 0).toLocaleString()}
              </p>
            </div>
            <div className="flex justify-between items-baseline mb-1">
              <p className="text-xs text-gray-300">MLM bloqueado</p>
              <p className="text-sm font-bold text-orange-400">
                ${(store.comisionesRed || []).filter(c => c.status === 'bloqueada').reduce((s, c) => s + c.monto, 0).toLocaleString()}
              </p>
            </div>
            <div className="flex justify-between items-baseline">
              <p className="text-xs text-gray-300">MLM pagado</p>
              <p className="text-sm font-bold text-blue-400">
                ${(store.comisionesRed || []).filter(c => c.status === 'pagada').reduce((s, c) => s + c.monto, 0).toLocaleString()}
              </p>
            </div>
          </div>
        </div>}

        {/* Admin info */}
        <div className="p-4 bg-gray-800 rounded-xl">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center font-bold">
              <Shield size={20} />
            </div>
            <div>
              <p className="font-semibold text-sm">Administrador</p>
              <p className="text-xs text-gray-400">{usuario?.email}</p>
            </div>
          </div>
        </div>

        <button
          onClick={onLogout}
          className="mt-4 flex items-center space-x-2 px-4 py-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition"
        >
          <LogOut size={18} />
          <span className="text-sm">Cerrar Sesión</span>
        </button>
      </div>

      {/* Contenido Principal */}
      <div className="flex-1 flex flex-col overflow-hidden">

        {/* Header móvil */}
        <div className="md:hidden flex items-center justify-between px-4 py-3 bg-gray-900 text-white flex-shrink-0">
          <button onClick={() => setSidebarAbierto(true)} className="p-2 rounded-lg hover:bg-gray-800">
            <Menu size={22} />
          </button>
          <span className="font-black text-orange-400 text-lg">Choyero!</span>
          <button onClick={abrirNotificaciones} className="relative p-2 rounded-lg hover:bg-gray-800">
            <Bell size={22} className="text-gray-300" />
            {notifsPendientes.length > 0 && (
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold">
                {notifsPendientes.length > 9 ? '9+' : notifsPendientes.length}
              </span>
            )}
          </button>
        </div>

        <div className="flex-1 p-4 pb-24 md:p-8 overflow-auto">

        {/* ========== BÚSQUEDA GLOBAL ========== */}
        <div ref={globalSearchRef} className="relative mb-6">
          <div className="relative">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              value={globalSearch}
              onChange={e => { setGlobalSearch(e.target.value); setShowGlobalSearch(true); }}
              onFocus={() => setShowGlobalSearch(true)}
              placeholder="Buscar solicitudes, viajes, clientes, empresas..."
              className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-400 text-sm"
            />
            {globalSearch && <button onClick={() => { setGlobalSearch(''); setShowGlobalSearch(false); }} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"><X size={16}/></button>}
          </div>
          {showGlobalSearch && globalResults.length > 0 && (
            <div className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-xl shadow-xl z-[500] mt-1 overflow-hidden">
              {['solicitud','viaje','usuario','empresa'].map(tipo => {
                const grupo = globalResults.filter(r => r.tipo === tipo);
                if (!grupo.length) return null;
                const labels = { solicitud: 'Solicitudes', viaje: 'Viajes', usuario: 'Usuarios', empresa: 'Empresas' };
                const colors = { solicitud: 'text-blue-600', viaje: 'text-orange-600', usuario: 'text-green-600', empresa: 'text-purple-600' };
                return (
                  <div key={tipo}>
                    <p className={`px-4 py-1.5 text-xs font-bold uppercase tracking-wide bg-gray-50 border-b ${colors[tipo]}`}>{labels[tipo]}</p>
                    {grupo.map((r, i) => (
                      <button
                        key={i}
                        onClick={() => {
                          setGlobalSearch(''); setShowGlobalSearch(false);
                          if (r.tipo === 'solicitud') { setSeccion('operaciones'); setOpDetalle({ tipo: 'solicitud', item: r.item }); }
                          else if (r.tipo === 'viaje') { setSeccion('operaciones'); setOpDetalle({ tipo: 'viaje', item: r.item }); }
                          else if (r.tipo === 'usuario') { setSeccion('clientes'); }
                          else if (r.tipo === 'empresa') { setSeccion('empresas'); }
                        }}
                        className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-gray-50 text-left border-b border-gray-50 last:border-0"
                      >
                        <div>
                          <p className="text-sm font-medium text-gray-800">{r.label}</p>
                          <p className="text-xs text-gray-400">{r.sub}</p>
                        </div>
                        <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ml-3 flex-shrink-0 ${STATUS_COLOR[r.status] || 'bg-gray-100 text-gray-500'}`}>{r.status}</span>
                      </button>
                    ))}
                  </div>
                );
              })}
            </div>
          )}
          {showGlobalSearch && globalSearch.length >= 2 && globalResults.length === 0 && (
            <div className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-xl shadow-xl z-[500] mt-1 px-4 py-6 text-center text-gray-400 text-sm">
              Sin resultados para "{globalSearch}"
            </div>
          )}
        </div>

        {/* ========== DASHBOARD ========== */}
        {seccion === 'dashboard' && (
          <div>
            <div className="flex flex-wrap justify-between items-center gap-3 mb-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Dashboard General</h2>
                <p className="text-gray-600 text-sm md:text-base">Resumen de la plataforma Choyero!</p>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-500">
                <RefreshCw size={16} />
                <span>{metricasLive ? `Live · ${new Date(metricasLive.actualizadoEn).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}` : 'Cargando...'}</span>
              </div>
            </div>

            {/* Alerta de pendientes */}
            {empresasPendientesMerged.length > 0 && (
              <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-xl shadow-lg p-5 mb-8 text-white">
                <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Clock size={24} />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold">{empresasPendientesMerged.length} empresa(s) esperan aprobación</h3>
                      <p className="text-yellow-100 text-sm">Revisa los documentos y aprueba o rechaza las solicitudes</p>
                    </div>
                  </div>
                  <button
                    onClick={() => setSeccion('pendientes')}
                    className="w-full sm:w-auto px-6 py-3 bg-white text-yellow-600 rounded-xl hover:bg-yellow-50 font-semibold flex items-center justify-center space-x-2"
                  >
                    <span>Revisar Ahora</span>
                    <ChevronRight size={20} />
                  </button>
                </div>
              </div>
            )}

            {/* Estadísticas principales */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-sm text-gray-500">Transportistas Activos</p>
                    <p className="text-3xl font-bold text-green-600">{stats.empresasActivas}</p>
                    {stats.empresasSuspendidas > 0 && (
                      <p className="text-xs text-red-500 mt-1">{stats.empresasSuspendidas} suspendidas</p>
                    )}
                  </div>
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                    <Building2 size={24} className="text-green-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-sm text-gray-500">Clientes Regulares</p>
                    <p className="text-3xl font-bold text-blue-600">{stats.clientesRegulares}</p>
                    <p className="text-xs text-gray-400 mt-1">de {stats.clientesActivos} totales</p>
                  </div>
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                    <Users size={24} className="text-blue-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-sm text-gray-500">Clientes MLM</p>
                    <p className="text-3xl font-bold text-orange-600">{stats.clientesMLM}</p>
                    <p className="text-xs text-gray-400 mt-1">{stats.clientesActivos > 0 ? Math.round(stats.clientesMLM / stats.clientesActivos * 100) : 0}% del total</p>
                  </div>
                  <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                    <Globe size={24} className="text-orange-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-sm text-gray-500">Viajes en Curso</p>
                    <p className="text-3xl font-bold text-orange-600">{stats.viajesActivos}</p>
                    <p className="text-xs text-gray-400 mt-1">{stats.viajesCompletadosHoy} hoy · {stats.viajesCompletadosMes} este mes</p>
                  </div>
                  <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                    <Truck size={24} className="text-orange-600" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-sm text-gray-500 font-semibold">Comisiones</p>
                  <div className="w-10 h-10 bg-purple-100 rounded-xl flex items-center justify-center">
                    <DollarSign size={20} className="text-purple-600" />
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-baseline">
                    <span className="text-xs text-gray-400">Hoy</span>
                    <span className="text-lg font-bold text-purple-600">${stats.comisionesHoy.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-baseline">
                    <span className="text-xs text-gray-400">Este mes</span>
                    <span className="text-2xl font-bold text-purple-700">${stats.comisionesMes >= 1000 ? (stats.comisionesMes / 1000).toFixed(1) + 'K' : stats.comisionesMes.toLocaleString()}</span>
                  </div>
                  <p className="text-xs text-gray-400">{configPlataforma.comisionPorcentaje}% de ${stats.gmvMes >= 1000 ? (stats.gmvMes / 1000).toFixed(1) + 'K' : stats.gmvMes.toLocaleString()} GMV</p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-sm text-gray-500 font-semibold">App Instalada</p>
                  <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
                    <Smartphone size={20} className="text-indigo-600" />
                  </div>
                </div>
                {(() => {
                  const cli = metricasLive?.appInstalada?.cliente;
                  const neg = metricasLive?.appInstalada?.transportista;
                  const pct = (d) => d?.total > 0 ? Math.round(d.instalada / d.total * 100) : 0;
                  return (
                    <div className="space-y-2">
                      <div className="flex justify-between items-baseline">
                        <span className="text-xs text-gray-400">Clientes</span>
                        <span className="text-lg font-bold text-indigo-600">
                          {metricasLive ? `${pct(cli)}%` : '—'}
                          {cli && <span className="text-xs text-gray-400 font-normal ml-1">({cli.instalada}/{cli.total})</span>}
                        </span>
                      </div>
                      <div className="flex justify-between items-baseline">
                        <span className="text-xs text-gray-400">Negocios</span>
                        <span className="text-lg font-bold text-indigo-700">
                          {metricasLive ? `${pct(neg)}%` : '—'}
                          {neg && <span className="text-xs text-gray-400 font-normal ml-1">({neg.instalada}/{neg.total})</span>}
                        </span>
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>

            {/* ── En vivo ahora ── */}
            {metricasLive && (
              <div className="bg-gray-900 rounded-xl p-4 mb-8 border border-gray-700">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-2.5 h-2.5 rounded-full bg-green-400 animate-pulse inline-block" />
                  <span className="text-sm font-semibold text-gray-200">En vivo ahora</span>
                  <span className="ml-auto text-xs text-gray-500">
                    {metricasLive.actualizadoEn ? new Date(metricasLive.actualizadoEn).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : ''}
                  </span>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                  <div className="bg-gray-800 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-orange-400">{metricasLive.viajesActivos}</p>
                    <p className="text-xs text-gray-400 mt-0.5">Viajes activos</p>
                    {metricasLive.viajesPorStatus && Object.keys(metricasLive.viajesPorStatus).length > 0 && (
                      <div className="mt-1 space-y-0.5">
                        {Object.entries(metricasLive.viajesPorStatus).map(([s, c]) => (
                          <p key={s} className="text-xs text-gray-500">{s.replace(/_/g, ' ')}: {c}</p>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="bg-gray-800 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-blue-400">{metricasLive.choferesActivos}</p>
                    <p className="text-xs text-gray-400 mt-0.5">Choferes en ruta</p>
                  </div>
                  <div className="bg-gray-800 rounded-lg p-3 text-center">
                    <p className={`text-2xl font-bold ${metricasLive.solicitudesSinCotizar > 0 ? 'text-yellow-400' : 'text-gray-400'}`}>
                      {metricasLive.solicitudesSinCotizar}
                    </p>
                    <p className="text-xs text-gray-400 mt-0.5">Sin cotizar</p>
                  </div>
                  <div className="bg-gray-800 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-green-400">
                      ${metricasLive.pagosDia >= 1000 ? (metricasLive.pagosDia / 1000).toFixed(1) + 'K' : metricasLive.pagosDia.toLocaleString('es-MX')}
                    </p>
                    <p className="text-xs text-gray-400 mt-0.5">Pagos hoy</p>
                  </div>
                  <div className="bg-gray-800 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-purple-400">{metricasLive.retornosDisponibles}</p>
                    <p className="text-xs text-gray-400 mt-0.5">Retornos disponibles</p>
                  </div>
                </div>
              </div>
            )}

            {/* Segunda fila de stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-bold text-gray-800">Flota Total</h3>
                  <Truck size={20} className="text-gray-400" />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-blue-50 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-blue-600">{stats.totalUnidades}</p>
                    <p className="text-xs text-gray-500">Unidades</p>
                  </div>
                  <div className="bg-green-50 rounded-lg p-3 text-center">
                    <p className="text-2xl font-bold text-green-600">{stats.totalChoferes}</p>
                    <p className="text-xs text-gray-500">Choferes</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-bold text-gray-800">GMV</h3>
                  <Activity size={20} className="text-gray-400" />
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-baseline">
                    <span className="text-xs text-gray-400">Hoy</span>
                    <span className="text-lg font-bold text-gray-700">${stats.gmvHoy.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-baseline">
                    <span className="text-xs text-gray-400">Este mes</span>
                    <span className="text-2xl font-bold text-gray-800">${stats.gmvMes >= 1000 ? (stats.gmvMes / 1000).toFixed(1) + 'K' : stats.gmvMes.toLocaleString()}</span>
                  </div>
                  <p className="text-xs text-gray-400">Valor total de transacciones</p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-bold text-gray-800">Cobertura</h3>
                  <Globe size={20} className="text-gray-400" />
                </div>
                <div className="space-y-2">
                  {configPlataforma.zonasActivas.map((zona, idx) => (
                    <div key={idx} className="flex items-center space-x-2">
                      <MapPin size={16} className="text-green-500" />
                      <span className="text-gray-700">{zona}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Alertas activas */}
            {alertasAdmin.length > 0 && (
              <div className="mb-8">
                <h3 className="font-bold text-gray-800 mb-3 flex items-center gap-2"><AlertTriangle size={18} className="text-orange-500"/> Alertas activas ({alertasAdmin.length})</h3>
                <div className="space-y-2">
                  {alertasAdmin.map((a, i) => (
                    <button key={i} onClick={a.accion} className={`w-full text-left flex items-start justify-between p-4 rounded-xl border cursor-pointer hover:opacity-90 transition-opacity ${a.gravedad === 'alta' ? 'bg-red-50 border-red-200' : 'bg-yellow-50 border-yellow-200'}`}>
                      <div className="flex items-start gap-3">
                        <span className="text-xl">{a.icono}</span>
                        <div>
                          <p className={`font-semibold text-sm ${a.gravedad === 'alta' ? 'text-red-700' : 'text-yellow-700'}`}>{a.titulo}</p>
                          {a.detalle && <p className="text-xs text-gray-500 mt-0.5">{a.detalle}</p>}
                        </div>
                      </div>
                      <span className={`text-xs px-2 py-1 rounded-full font-bold flex-shrink-0 ml-3 ${a.gravedad === 'alta' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'}`}>{a.gravedad.toUpperCase()}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Actividad reciente en tiempo real */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2"><Clock size={16}/> Solicitudes recientes</h3>
                {(store.solicitudes || []).length === 0 ? (
                  <p className="text-gray-400 text-sm">Sin solicitudes</p>
                ) : (
                  <div className="space-y-2">
                    {[...(store.solicitudes || [])].sort((a,b) => new Date(b.creadoEn||b.fechaCreacion||0) - new Date(a.creadoEn||a.fechaCreacion||0)).slice(0,5).map(s => (
                      <button key={s.id} onClick={() => { setSeccion('operaciones'); setOpDetalle({ tipo: 'solicitud', item: s }); }} className="w-full flex items-center justify-between p-2.5 bg-gray-50 rounded-lg hover:bg-gray-100 text-left">
                        <div>
                          <p className="text-xs font-mono text-gray-400">{s.id}</p>
                          <p className="text-sm font-medium text-gray-700">{s.origen} → {s.destino}</p>
                          <p className="text-xs text-gray-400">{s.cliente?.nombre || s.clienteNombre}</p>
                        </div>
                        <span className={`text-xs px-2 py-0.5 rounded-full font-semibold flex-shrink-0 ml-2 ${STATUS_COLOR[s.status] || 'bg-gray-100 text-gray-600'}`}>{s.status}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2"><Truck size={16}/> Viajes activos</h3>
                {(store.viajes || []).length === 0 ? (
                  <p className="text-gray-400 text-sm">Sin viajes activos</p>
                ) : (
                  <div className="space-y-2">
                    {[...(store.viajes || [])].sort((a,b) => new Date(b.creadoEn||b.fechaCreacion||0) - new Date(a.creadoEn||a.fechaCreacion||0)).slice(0,5).map(v => (
                      <button key={v.id} onClick={() => { setSeccion('operaciones'); setOpDetalle({ tipo: 'viaje', item: v }); }} className={`w-full flex items-center justify-between p-2.5 rounded-lg hover:opacity-90 text-left ${v.enDisputa ? 'bg-orange-50' : 'bg-gray-50 hover:bg-gray-100'}`}>
                        <div>
                          <p className="text-xs font-mono text-gray-400">{v.id}</p>
                          <p className="text-sm font-medium text-gray-700">{v.origen} → {v.destino}</p>
                          <p className="text-xs text-gray-400">{v.clienteNombre}</p>
                        </div>
                        <div className="flex flex-col items-end gap-1 flex-shrink-0 ml-2">
                          <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${STATUS_COLOR[v.status] || 'bg-gray-100 text-gray-600'}`}>{v.status}</span>
                          {v.enDisputa && <span className="text-xs text-orange-600 font-bold">⚠️ Disputa</span>}
                        </div>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Top transportistas */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-bold text-gray-800">Top Transportistas por Comisiones</h3>
                <Award size={20} className="text-yellow-500" />
              </div>
              <div className="space-y-3">
                {empresasActivasMerged
                  .filter(e => e.status === 'activa')
                  .sort((a, b) => (b.comisionGenerada || 0) - (a.comisionGenerada || 0))
                  .slice(0, 5)
                  .map((emp, idx) => (
                    <div key={emp.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center space-x-3">
                        <span className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-white ${
                          idx === 0 ? 'bg-yellow-500' : idx === 1 ? 'bg-gray-400' : idx === 2 ? 'bg-orange-400' : 'bg-gray-300'
                        }`}>
                          {idx + 1}
                        </span>
                        <div>
                          <p className="font-semibold">{emp.nombre}</p>
                          <p className="text-xs text-gray-500">{emp.viajesCompletados} viajes completados</p>
                          <div className="flex flex-wrap gap-1 mt-1">
                            {calcularInsignias(emp).map(i => <InsigniaBadge key={i.id} insignia={i} small />)}
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="font-bold text-green-600">${(emp.comisionGenerada || 0).toLocaleString()}</p>
                        <div className="flex items-center text-xs text-gray-500 gap-1">
                          {(emp.viajesCompletados > 0 && emp.calificacion)
                            ? <><Star size={12} className="text-yellow-400" fill="currentColor" />{Number(emp.calificacion).toFixed(1)}</>
                            : <span>Sin calificaciones</span>}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            {/* Panel suscripciones */}
            <div className="bg-white rounded-xl shadow-lg p-6 mt-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-bold text-gray-800 flex items-center gap-2"><CreditCard size={16} className="text-indigo-500" /> Suscripciones</h3>
              </div>
              {(() => {
                const totalE = empresasActivasMerged.length;
                const pro = empresasActivasMerged.filter(e => e.plan === 'pro').length;
                const basico = totalE - pro;
                const precioPro = store.configPlataforma?.precioProMensual ?? store.configPlataforma?.planes?.pro?.precio ?? 1500;
                const mrr = pro * precioPro;
                return (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="flex items-center justify-between p-4 bg-indigo-50 rounded-xl">
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-bold bg-indigo-600 text-white px-2 py-0.5 rounded-full">PRO</span>
                        <span className="text-sm text-gray-700">{pro} empresas</span>
                      </div>
                      <span className="font-bold text-indigo-700">${(pro * precioPro).toLocaleString()}/mes</span>
                    </div>
                    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                      <div className="flex items-center gap-2">
                        <span className="text-xs font-bold bg-gray-400 text-white px-2 py-0.5 rounded-full">BÁSICO</span>
                        <span className="text-sm text-gray-700">{basico} empresas</span>
                      </div>
                      <span className="font-bold text-gray-500">Gratuito</span>
                    </div>
                    <div className="p-4 bg-green-50 rounded-xl">
                      <p className="text-xs text-gray-500 mb-1">MRR estimado</p>
                      <p className="font-bold text-green-700 text-xl">${mrr.toLocaleString()} <span className="text-sm font-normal text-green-600">MXN/mes</span></p>
                      {totalE > 0 && (
                        <div className="mt-2">
                          <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                            <div className="h-full bg-indigo-500 rounded-full transition-all" style={{ width: `${Math.round(pro/totalE*100)}%` }} />
                          </div>
                          <p className="text-xs text-gray-400 mt-1">{Math.round(pro/totalE*100)}% en plan PRO</p>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        )}

        {/* ========== ACTIVIDAD (login / presencia) ========== */}
        {seccion === 'actividad' && (() => {
          const ROL_CFG = {
            cliente:       { label: 'Clientes',     icon: Users,    color: 'text-blue-500',   badge: 'bg-blue-100 text-blue-700' },
            chofer:        { label: 'Conductores',  icon: UserCheck, color: 'text-green-500', badge: 'bg-green-100 text-green-700' },
            transportista: { label: 'Negocios',     icon: Building2, color: 'text-orange-500', badge: 'bg-orange-100 text-orange-700' },
          };
          const tiempoRelativo = (iso) => {
            if (!iso) return '—';
            const diff = Date.now() - new Date(iso).getTime();
            const min = Math.floor(diff / 60000);
            if (min < 1) return 'Ahora';
            if (min < 60) return `Hace ${min} min`;
            const hrs = Math.floor(min / 60);
            if (hrs < 24) return `Hace ${hrs}h`;
            return `Hace ${Math.floor(hrs / 24)}d`;
          };
          return (
            <div>
              <div className="flex flex-wrap justify-between items-center gap-3 mb-6">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Actividad</h2>
                  <p className="text-gray-600 text-sm md:text-base">Inicios de sesión de clientes, conductores y negocios</p>
                </div>
                <button
                  onClick={() => apiGetActividad().then(a => setActividad(a)).catch(() => {})}
                  className="flex items-center space-x-2 text-sm text-gray-500 hover:text-gray-700"
                >
                  <RefreshCw size={16} />
                  <span>{actividad ? `Actualizado ${tiempoRelativo(actividad.actualizadoEn)}` : 'Cargando...'}</span>
                </button>
              </div>

              {!actividad ? (
                <div className="bg-white rounded-xl shadow-lg p-8 text-center text-gray-400">Cargando actividad...</div>
              ) : (
                <>
                  {/* En línea ahora */}
                  <div className="bg-gray-900 rounded-xl p-4 mb-6 border border-gray-700">
                    <div className="flex items-center gap-2">
                      <span className={`w-2.5 h-2.5 rounded-full inline-block ${actividad.enLineaAhora.length > 0 ? 'bg-green-400 animate-pulse' : 'bg-gray-600'}`} />
                      <span className="text-sm font-semibold text-gray-200">En línea ahora</span>
                      <span className="ml-auto text-xs text-gray-500">{tiempoRelativo(actividad.actualizadoEn)}</span>
                    </div>
                    {actividad.enLineaAhora.length === 0 ? (
                      <p className="text-sm text-gray-500 mt-3">Ningún usuario activo en este momento</p>
                    ) : (
                      <div className="flex flex-wrap gap-2 mt-3">
                        {actividad.enLineaAhora.map(u => (
                          <span key={u.id} className="text-xs px-2.5 py-1 bg-gray-800 rounded-full text-gray-200">
                            {u.nombre} · {ROL_CFG[u.rol]?.label}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Cards por rol */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                    {['cliente', 'chofer', 'transportista'].map(rol => {
                      const d = actividad.porRol[rol];
                      const cfg = ROL_CFG[rol];
                      const pct = (n) => d.total > 0 ? Math.round(n / d.total * 100) : 0;
                      const Icono = cfg.icon;
                      return (
                        <div key={rol} className="bg-white rounded-xl shadow-lg p-5">
                          <div className="flex justify-between items-center mb-1">
                            <div className="flex items-center gap-2">
                              <Icono size={18} className={cfg.color} />
                              <h3 className="font-bold text-gray-800">{cfg.label}</h3>
                            </div>
                            <span className="text-sm text-gray-400">{d.total} total</span>
                          </div>
                          <div className="flex items-center gap-1.5 mb-4">
                            <span className={`w-2 h-2 rounded-full ${d.enLinea > 0 ? 'bg-green-500' : 'bg-gray-300'}`} />
                            <span className="text-xs text-gray-500">{d.enLinea} en línea ahora</span>
                          </div>
                          {[
                            ['Última hora', d.ultimaHora],
                            ['Últimas 24h', d.ultimas24h],
                            ['Últimos 7 días', d.ultimos7dias],
                            ['Últimos 30 días', d.ultimos30dias],
                          ].map(([label, n]) => (
                            <div key={label} className="mb-2 last:mb-0">
                              <div className="flex justify-between text-xs text-gray-500 mb-0.5">
                                <span>{label}</span>
                                <span className="font-semibold text-gray-700">{n} ({pct(n)}%)</span>
                              </div>
                              <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                                <div className="h-full bg-orange-400 rounded-full transition-all" style={{ width: `${pct(n)}%` }} />
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    })}
                  </div>

                  {/* Conexiones recientes */}
                  <div className="bg-white rounded-xl shadow-lg p-5">
                    <div className="flex items-center gap-2 mb-4">
                      <Clock size={18} className="text-gray-400" />
                      <h3 className="font-bold text-gray-800">Conexiones recientes</h3>
                    </div>
                    {actividad.recientes.length === 0 ? (
                      <p className="text-sm text-gray-400">Todavía no hay registros de inicio de sesión.</p>
                    ) : (
                      <div className="divide-y">
                        {actividad.recientes.map(u => (
                          <div key={u.id} className="flex items-center justify-between py-3">
                            <div className="flex items-center gap-3">
                              <div className="w-9 h-9 rounded-full bg-gray-200 flex items-center justify-center font-semibold text-gray-600 text-sm overflow-hidden flex-shrink-0">
                                {u.avatar ? <img src={u.avatar} alt="" className="w-full h-full object-cover" /> : (u.nombre?.[0]?.toUpperCase() || '?')}
                              </div>
                              <div>
                                <p className="font-semibold text-sm text-gray-800">{u.nombre}</p>
                                <p className="text-xs text-gray-400">{u.ciudad || '—'}</p>
                              </div>
                            </div>
                            <div className="text-right">
                              <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${ROL_CFG[u.rol]?.badge}`}>{ROL_CFG[u.rol]?.label}</span>
                              <p className="text-xs text-gray-400 mt-1">{tiempoRelativo(u.ultimoLogin)}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          );
        })()}

        {/* ========== EMPRESAS PENDIENTES ========== */}
        {seccion === 'pendientes' && (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Aprobar Empresas</h2>
            <p className="text-gray-600 mb-6">Revisa y aprueba las solicitudes de nuevos transportistas</p>

            {empresasPendientesMerged.length === 0 ? (
              <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                <CheckCircle size={64} className="mx-auto text-green-500 mb-4" />
                <h3 className="text-xl font-bold text-gray-800 mb-2">¡Todo al día!</h3>
                <p className="text-gray-600">No hay empresas pendientes de aprobación</p>
              </div>
            ) : (
              <div className="space-y-4">
                {empresasPendientesMerged.map(empresa => {
                  const _docs = empresa.documentos || [];
                  const docsVerificados = _docs.filter(d => d.status === 'verificado').length;
                  const docsEnviados = _docs.filter(d => d.status === 'enviado' || d.status === 'pendiente_revision').length;
                  const totalDocs = _docs.length;
                  const docsRecibidos = docsVerificados + docsEnviados;
                  // Buscar el usuario transportista asociado (para mostrar credenciales de acceso)
                  const usuarioTransportista = store.usuarios.find(u => u.empresaId === empresa.id && u.rol === 'transportista');

                  return (
                    <div key={empresa.id} className="bg-white rounded-xl shadow-lg p-6">
                      <div className="flex flex-wrap justify-between items-start gap-3 mb-4">
                        <div>
                          <div className="flex items-center space-x-3">
                            <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center">
                              <Building2 size={24} className="text-yellow-600" />
                            </div>
                            <div>
                              <h3 className="text-lg font-bold text-gray-800">{empresa.nombre}</h3>
                              <p className="text-sm text-gray-500">RFC: {empresa.rfc}</p>
                              {usuarioTransportista && (
                                <p className="text-xs text-blue-600 mt-0.5">
                                  <span className="font-semibold">Acceso:</span> {usuarioTransportista.email}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-sm text-gray-500">Solicitud</p>
                          <p className="font-semibold">{empresa.creadoEn ? new Date(empresa.creadoEn).toLocaleDateString('es-MX') : '—'}</p>
                          {empresa.status === 'rechazada' ? (
                            <span className="inline-block mt-1 px-2 py-0.5 bg-red-100 text-red-700 text-xs rounded-full font-semibold">
                              ❌ Rechazada — Re-enviada
                            </span>
                          ) : usuarioTransportista && (
                            <span className="inline-block mt-1 px-2 py-0.5 bg-yellow-100 text-yellow-700 text-xs rounded-full font-semibold">
                              Registro en línea
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                        <div className="bg-gray-50 rounded-lg p-3">
                          <p className="text-xs text-gray-500">Representante</p>
                          <p className="font-semibold text-sm">{empresa.representante}</p>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-3">
                          <p className="text-xs text-gray-500">Contacto</p>
                          <p className="font-semibold text-sm">{empresa.telefono}</p>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-3">
                          <p className="text-xs text-gray-500">Flotilla Declarada</p>
                          <p className="font-semibold text-sm">{empresa.flota}</p>
                        </div>
                      </div>

                      {/* Progreso de documentos */}
                      <div className="mb-4">
                        <div className="flex justify-between text-sm mb-2">
                          <span className="text-gray-600">
                            Docs: {docsVerificados} verificados · {docsEnviados} enviados · {totalDocs - docsRecibidos} faltantes
                          </span>
                          <span className={`font-semibold ${docsVerificados === totalDocs ? 'text-green-600' : docsRecibidos > 0 ? 'text-blue-600' : 'text-yellow-600'}`}>
                            {docsVerificados === totalDocs ? '✓ Verificados' : docsRecibidos > 0 ? '📎 Por revisar' : '⏳ Pendientes'}
                          </span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div
                            className={`h-2 rounded-full ${docsVerificados === totalDocs ? 'bg-green-500' : docsRecibidos > 0 ? 'bg-blue-500' : 'bg-yellow-500'}`}
                            style={{ width: `${(docsRecibidos / totalDocs) * 100}%` }}
                          />
                        </div>
                      </div>

                      <div className="flex space-x-3">
                        {puedeHacer('aprobar') ? (
                          <button
                            onClick={() => setModalDocumentos(empresa)}
                            className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold flex items-center justify-center space-x-2"
                          >
                            <Eye size={20} />
                            <span>Revisar y Aprobar</span>
                          </button>
                        ) : (
                          <button
                            onClick={() => setModalDocumentos(empresa)}
                            className="flex-1 px-4 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 font-semibold flex items-center justify-center space-x-2"
                          >
                            <Eye size={20} />
                            <span>Ver Documentos</span>
                          </button>
                        )}
                        {puedeHacer('rechazar') && (
                          <button
                            onClick={() => {
                              const motivo = prompt('Motivo del rechazo:');
                              if (motivo) rechazarEmpresa(empresa.id, motivo);
                            }}
                            className="px-4 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 font-semibold"
                          >
                            <XCircle size={20} />
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

          </div>
        )}

        {/* ========== EMPRESAS ACTIVAS ========== */}
        {seccion === 'empresas' && (
          <div>
            {/* Lightbox logo — el de Operaciones vive dentro del modal opDetalle, aquí no aplica */}
            {opLightbox && (
              <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[3000]" onClick={() => setOpLightbox(null)}>
                <img src={opLightbox} alt="logo" className="max-w-[90vw] max-h-[90vh] object-contain rounded-xl shadow-2xl" />
                <button className="absolute top-4 right-4 text-white hover:text-gray-300"><X size={32}/></button>
              </div>
            )}
            <div className="flex flex-wrap justify-between items-start gap-3 mb-6">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Transportistas</h2>
                <p className="text-gray-600 text-sm">Empresas registradas en la plataforma</p>
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                {/* Filtro de status */}
                <select 
                  value={filtroStatus}
                  onChange={(e) => setFiltroStatus(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500"
                >
                  <option value="todas">Todas</option>
                  <option value="activa">Activas</option>
                  <option value="suspendida">Suspendidas</option>
                </select>
                {/* Búsqueda */}
                <div className="relative">
                  <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Buscar empresa…"
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                    className="pl-11 pr-4 py-2.5 bg-white border border-gray-200 rounded-xl shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400 w-full sm:w-64"
                  />
                  {busqueda && <button onClick={() => setBusqueda('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"><X size={16}/></button>}
                </div>
              </div>
            </div>

            {/* ── Vista tarjetas (<xl) ── */}
            <div className="xl:hidden bg-white rounded-xl shadow-lg divide-y">
              {empresasFiltradas.length === 0 && (
                <div className="p-10 text-center">
                  <Building2 size={40} className="mx-auto text-gray-300 mb-3" />
                  <p className="text-gray-500 text-sm">No se encontraron empresas</p>
                </div>
              )}
              {empresasFiltradas.map(emp => {
                const expandido = empresaExpandida === emp.id;
                const owner = (store.usuarios || []).find(u => u.empresaId === emp.id && u.rol === 'transportista');
                const canal = `admin-empresa-${emp.id}`;
                const seenTs = lastSeenAdminMsgs[canal] || null;
                const noLeidos = (store.mensajes || []).filter(
                  m => m.viajeId === canal && m.emisorRol === 'transportista' &&
                       (!seenTs || new Date(m.creadoEn) > new Date(seenTs))
                ).length;
                return (
                  <div key={emp.id}>
                    {/* Cabecera de tarjeta */}
                    <div
                      className={`px-4 py-3 cursor-pointer transition-colors ${expandido ? 'bg-green-50' : 'hover:bg-gray-50'}`}
                      onClick={() => setEmpresaExpandida(expandido ? null : emp.id)}
                    >
                      <div className="flex items-center gap-3">
                        {/* Logo */}
                        <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-green-100 flex items-center justify-center">
                          {emp.logo
                            ? <img src={emp.logo} alt={emp.nombre} className="w-full h-full object-cover cursor-pointer hover:opacity-80 transition-opacity" onClick={(e) => { e.stopPropagation(); setOpLightbox(emp.logo); }} />
                            : <span className="text-green-700 font-bold">{emp.nombre?.charAt(0)?.toUpperCase()}</span>}
                        </div>
                        {/* Info principal */}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 flex-wrap">
                            <p className="font-semibold text-sm truncate">{emp.nombre}</p>
                            <span className={`px-1.5 py-0.5 text-xs font-bold rounded-full ${emp.plan === 'pro' ? 'bg-purple-500 text-white' : 'bg-gray-100 text-gray-600'}`}>
                              {emp.plan === 'pro' ? '★ PRO' : 'Básico'}
                            </span>
                            <span className={`px-1.5 py-0.5 text-xs font-semibold rounded-full ${emp.status === 'activa' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                              {emp.status === 'activa' ? '● Activa' : '● Susp.'}
                            </span>
                          </div>
                          {emp.rfc && <p className="text-xs text-gray-400 font-mono">{emp.rfc}</p>}
                        </div>
                        {/* Chevron + badge mensajes */}
                        <div className="flex items-center gap-1 flex-shrink-0">
                          {noLeidos > 0 && <span className="inline-flex items-center justify-center bg-red-500 text-white text-xs w-5 h-5 rounded-full font-bold">{noLeidos}</span>}
                          <span className={`text-gray-400 text-sm transition-transform inline-block ${expandido ? 'rotate-180' : ''}`}>▼</span>
                        </div>
                      </div>
                      {/* Fila stats */}
                      <div className="mt-2 flex items-center gap-3 text-xs text-gray-500 flex-wrap">
                        <span><span className="font-semibold text-blue-600">{emp.viajesActivos}</span> act. · <span className="font-semibold text-gray-700">{emp.viajesCompletados}</span> comp.</span>
                        <span>🚛 {emp.unidades} ud. · 👤 {emp.choferes} ch.</span>
                        {(emp.calificacion && emp.viajesCompletados > 0) && (
                          <span className="flex items-center gap-0.5"><Star size={11} className="text-yellow-400" fill="currentColor" /><span className="font-semibold">{typeof emp.calificacion === 'number' ? emp.calificacion.toFixed(1) : emp.calificacion}</span></span>
                        )}
                        <span className="text-green-600 font-semibold">${(emp.comisionGenerada || 0).toLocaleString()} com.</span>
                      </div>
                    </div>

                    {/* Panel expandible móvil */}
                    {expandido && (
                      <div className="px-4 pb-4 bg-green-50 border-t border-green-200">
                        <div className="bg-white border border-slate-200 rounded-xl p-4 mt-3 shadow-sm space-y-4">
                          {/* Datos */}
                          <div>
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-2">Datos</p>
                            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                              <div>
                                <p className="text-xs text-gray-400">RFC</p>
                                {editandoRfc === emp.id ? (
                                  <div className="flex items-center gap-1 mt-0.5">
                                    <input value={rfcEditado} onChange={e => setRfcEditado(e.target.value.replace(/[^A-Za-z0-9&Ññ]/g,'').toUpperCase().slice(0,13))} className="border border-blue-400 rounded px-1.5 py-0.5 text-xs font-mono w-24 focus:outline-none focus:ring-1 focus:ring-blue-500" maxLength={13} />
                                    <button disabled={guardandoRfc} onClick={async () => { if (!validarDigitoVerificadorRFC(rfcEditado)) { alert('RFC inválido (dígito verificador incorrecto).'); return; } setGuardandoRfc(true); try { await apiAdminActualizarRfcEmpresa(emp.id, rfcEditado); setEditandoRfc(false); recargar(); } catch(e){ alert(e.message); } finally { setGuardandoRfc(false); }}} className="text-xs px-1.5 py-0.5 bg-blue-600 text-white rounded disabled:opacity-50">{guardandoRfc ? '…' : '✓'}</button>
                                    <button onClick={() => setEditandoRfc(false)} className="text-xs px-1.5 py-0.5 border rounded">✕</button>
                                  </div>
                                ) : (
                                  <div className="flex items-center gap-1">
                                    <p className="font-mono font-medium text-gray-800 text-xs">{emp.rfc || '—'}</p>
                                    <button onClick={() => { setRfcEditado(emp.rfc || ''); setEditandoRfc(emp.id); }} className="text-xs text-blue-500 hover:underline">Editar</button>
                                  </div>
                                )}
                              </div>
                              <div><p className="text-xs text-gray-400">Contacto</p><p className="font-medium text-gray-800 text-xs">{owner?.nombre || emp.representante || '—'}</p><p className="text-xs text-gray-500">{owner?.telefono || emp.telefono || '—'}</p></div>
                              <div><p className="text-xs text-gray-400">Ciudad</p><p className="font-medium text-gray-800 text-xs">{[emp.ciudad, emp.estado].filter(Boolean).join(', ') || '—'}</p></div>
                              <div><p className="text-xs text-gray-400">Comisión</p><p className="font-bold text-gray-800 text-xs">{emp.comisionPersonalizada || 20}%</p></div>
                              <div><p className="text-xs text-gray-400">Com. Choyero</p><p className="font-bold text-green-600 text-xs">${(emp.comisionGenerada || 0).toLocaleString()}</p></div>
                              <div><p className="text-xs text-gray-400">Ganancias empresa</p><p className="font-bold text-blue-700 text-xs">${emp.gananciasTotales.toLocaleString()}</p></div>
                            </div>
                          </div>
                          {/* Acciones */}
                          <div className="flex flex-wrap gap-2 pt-2 border-t border-gray-100">
                            <button
                              onClick={e => { e.stopPropagation(); const p = emp.plan === 'pro' ? 'basico' : 'pro'; storeAsignarPlan(emp.id, p); apiAsignarPlanEmpresa(emp.id, p).then(() => recargar()).catch(() => {}); }}
                              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border transition ${emp.plan === 'pro' ? 'bg-gray-50 border-gray-300 text-gray-600' : 'bg-purple-50 border-purple-300 text-purple-700'}`}
                            >
                              {emp.plan === 'pro' ? 'Cambiar a Básico' : '★ Cambiar a PRO'}
                            </button>
                            <button
                              onClick={e => { e.stopPropagation(); setModalDetalleEmpresa(emp); }}
                              className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 border border-blue-300 text-blue-700 rounded-lg text-xs font-medium"
                            >
                              <Eye size={13} /> Ver detalle
                            </button>
                            {owner && (
                              <button
                                onClick={e => { e.stopPropagation(); reabrirConversacionAdmin(canal); setChatEmpresaActivo({ empresaId: emp.id, empresaNombre: emp.nombre, usuarioId: owner.id, usuarioNombre: owner.nombre, origen: 'tabla' }); }}
                                className="relative flex items-center gap-1.5 px-3 py-1.5 bg-green-50 border border-green-300 text-green-700 rounded-lg text-xs font-medium"
                              >
                                <MessageSquare size={13} /> Mensaje
                                {noLeidos > 0 && <span className="bg-red-500 text-white text-xs px-1 rounded-full font-bold">{noLeidos}</span>}
                              </button>
                            )}
                            <button
                              onClick={async e => { e.stopPropagation(); if (!window.confirm(`¿${emp.status === 'activa' ? 'Suspender' : 'Activar'} a ${emp.nombre}?`)) return; await (emp.status === 'activa' ? apiSuspenderEmpresa(emp.id, 'Admin') : apiAprobarEmpresa(emp.id)); recargar(); }}
                              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border transition ${emp.status === 'activa' ? 'bg-red-50 border-red-300 text-red-700' : 'bg-green-50 border-green-300 text-green-700'}`}
                            >
                              {emp.status === 'activa' ? '🚫 Suspender' : '✅ Activar'}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* ── Vista tabla (desktop ≥xl) ── */}
            <div className="hidden xl:block bg-white rounded-xl shadow-lg overflow-x-auto">
              <table className="w-full min-w-0">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 md:px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Empresa</th>
                    <th className="hidden lg:table-cell px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Contacto</th>
                    <th className="hidden md:table-cell px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Flota</th>
                    <th className="hidden sm:table-cell px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Viajes</th>
                    <th className="hidden md:table-cell px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Comisión</th>
                    <th className="hidden md:table-cell px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Ganancias</th>
                    <th className="hidden lg:table-cell px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Calificación</th>
                    <th className="px-3 md:px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Status</th>
                    <th className="hidden sm:table-cell px-3 md:px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Plan</th>
                    <th className="px-3 md:px-4 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Acc.</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {empresasFiltradas.map(emp => {
                    const expandido = empresaExpandida === emp.id;
                    const owner = (store.usuarios || []).find(u => u.empresaId === emp.id && u.rol === 'transportista');
                    const canal = `admin-empresa-${emp.id}`;
                    const seenTs = lastSeenAdminMsgs[canal] || null;
                    const noLeidos = (store.mensajes || []).filter(
                      m => m.viajeId === canal && m.emisorRol === 'transportista' &&
                           (!seenTs || new Date(m.creadoEn) > new Date(seenTs))
                    ).length;
                    return (
                      <React.Fragment key={emp.id}>
                        {/* ── Fila principal ── */}
                        <tr
                          className={`cursor-pointer transition-colors ${expandido ? 'bg-green-200' : 'hover:bg-gray-50'}`}
                          onClick={() => setEmpresaExpandida(expandido ? null : emp.id)}
                        >
                          <td className="px-3 md:px-6 py-4">
                            <div className="flex items-center gap-2">
                              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg overflow-hidden flex-shrink-0 bg-green-100 flex items-center justify-center">
                                {emp.logo ? <img src={emp.logo} alt={emp.nombre} className="w-full h-full object-cover cursor-pointer hover:opacity-80 transition-opacity" onClick={(e) => { e.stopPropagation(); setOpLightbox(emp.logo); }} />
                                  : <span className="text-green-700 font-bold text-sm">{emp.nombre?.charAt(0)?.toUpperCase()}</span>}
                              </div>
                              <div className="min-w-0">
                                <p className="font-semibold text-sm truncate max-w-[120px] sm:max-w-[180px] md:max-w-none">{emp.nombre}</p>
                                {emp.rfc && <p className="text-xs text-gray-400 font-mono hidden sm:block truncate">{emp.rfc}</p>}
                                {(emp.ciudad || emp.estado) && <p className="text-xs text-gray-500 truncate hidden xs:block">{[emp.ciudad, emp.estado].filter(Boolean).join(', ')}</p>}
                                {/* En móvil: mostrar viajes compacto bajo el nombre */}
                                <p className="text-xs text-blue-600 font-semibold sm:hidden">{emp.viajesActivos}✓ · {emp.viajesCompletados}</p>
                              </div>
                            </div>
                          </td>
                          <td className="hidden lg:table-cell px-4 py-4">
                            <div className="text-sm">
                              <p className="font-medium text-gray-800 truncate max-w-[140px]">{owner?.nombre || emp.representante || '—'}</p>
                              <p className="text-xs text-gray-500">{owner?.telefono || emp.telefono || '—'}</p>
                            </div>
                          </td>
                          <td className="hidden md:table-cell px-4 py-4 text-sm">
                            <p><span className="font-semibold">{emp.unidades}</span> ud.</p>
                            <p className="text-gray-500">{emp.choferes} ch.</p>
                          </td>
                          <td className="hidden sm:table-cell px-4 py-4 text-sm">
                            <p className="font-semibold text-blue-600">{emp.viajesActivos} activos</p>
                            <p className="text-gray-500">{emp.viajesCompletados} comp.</p>
                          </td>
                          <td className="hidden md:table-cell px-4 py-4">
                            <span className="font-bold text-green-600">${(emp.comisionGenerada || 0).toLocaleString()}</span>
                            <p className="text-xs text-gray-400">{emp.comisionPersonalizada || 20}% GMV</p>
                          </td>
                          <td className="hidden md:table-cell px-4 py-4">
                            <span className="font-bold text-blue-700">${emp.gananciasTotales.toLocaleString()}</span>
                            <p className="text-xs text-gray-400">{100 - (emp.comisionPersonalizada || 20)}% GMV</p>
                          </td>
                          <td className="hidden lg:table-cell px-4 py-4">
                            {(emp.calificacion && emp.viajesCompletados > 0) ? (
                              <div className="flex items-center gap-1">
                                <Star size={13} className="text-yellow-400 flex-shrink-0" fill="currentColor" />
                                <span className="font-semibold text-gray-800">{typeof emp.calificacion === 'number' ? emp.calificacion.toFixed(1) : emp.calificacion}</span>
                              </div>
                            ) : <span className="text-gray-400 text-sm">—</span>}
                          </td>
                          <td className="px-3 md:px-4 py-4">
                            <span className={`px-2 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${emp.status === 'activa' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                              <span className="hidden sm:inline">{emp.status === 'activa' ? '● Activa' : '● Suspendida'}</span>
                              <span className="sm:hidden">{emp.status === 'activa' ? '●' : '✕'}</span>
                            </span>
                          </td>
                          <td className="hidden sm:table-cell px-3 md:px-4 py-4">
                            <div className="flex flex-col gap-1">
                              <span className={`px-2 py-1 text-xs font-bold rounded-full ${emp.plan === 'pro' ? 'bg-purple-500 text-white' : 'bg-gray-100 text-gray-600'}`}>
                                {emp.plan === 'pro' ? '★ PRO' : 'Básico'}
                              </span>
                              {emp.promoActiva && (
                                <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-green-100 text-green-700 whitespace-nowrap">
                                  🎁 {emp.promoFletesUsados || 0}/{(() => { const cfg = store.configPlataforma?.promos?.find(p => p.id === emp.promoId); return cfg?.fletesGratis || '?'; })()} promo
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="px-3 md:px-4 py-4 text-right">
                            {noLeidos > 0 && <span className="inline-flex items-center justify-center bg-red-500 text-white text-xs w-5 h-5 rounded-full font-bold mr-1">{noLeidos}</span>}
                            <span className={`text-gray-400 transition-transform inline-block ${expandido ? 'rotate-180' : ''}`}>▼</span>
                          </td>
                        </tr>

                        {/* ── Panel expandible ── */}
                        {expandido && (
                          <tr className="bg-green-200">
                            <td colSpan={10} className="px-2 sm:px-6 py-4">
                              <div className="bg-slate-100 border border-slate-300 rounded-xl p-3 sm:p-5 mb-1 shadow-sm">
                                {/* Datos empresa */}
                                <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3">Datos de la empresa</p>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5 text-sm">
                                  <div>
                                    <p className="text-xs text-gray-400 mb-0.5">RFC</p>
                                    {editandoRfc === emp.id ? (
                                      <div className="flex items-center gap-1">
                                        <input value={rfcEditado} onChange={e => setRfcEditado(e.target.value.replace(/[^A-Za-z0-9&Ññ]/g,'').toUpperCase().slice(0,13))} className="border border-blue-400 rounded px-1.5 py-0.5 text-xs font-mono w-32 focus:outline-none focus:ring-1 focus:ring-blue-500" maxLength={13} />
                                        <button disabled={guardandoRfc} onClick={async () => { setGuardandoRfc(true); try { await apiAdminActualizarRfcEmpresa(emp.id, rfcEditado); setEditandoRfc(false); recargar(); } catch(e){ alert(e.message); } finally { setGuardandoRfc(false); }}} className="text-xs px-1.5 py-0.5 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50">{guardandoRfc ? '…' : '✓'}</button>
                                        <button onClick={() => setEditandoRfc(false)} className="text-xs px-1.5 py-0.5 border rounded hover:bg-gray-100">✕</button>
                                      </div>
                                    ) : (
                                      <div className="flex items-center gap-2">
                                        <p className="font-mono font-medium text-gray-800">{emp.rfc || '—'}</p>
                                        <button onClick={() => { setRfcEditado(emp.rfc || ''); setEditandoRfc(emp.id); }} className="text-xs text-blue-500 hover:underline">Editar</button>
                                      </div>
                                    )}
                                  </div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Ciudad / Estado</p><p className="font-medium text-gray-800">{[emp.ciudad, emp.estado].filter(Boolean).join(', ') || '—'}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Email</p><p className="font-medium text-gray-800 break-all">{owner?.email || emp.email || '—'}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Teléfono</p><p className="font-medium text-gray-800">{owner?.telefono || emp.telefono || '—'}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Representante</p><p className="font-medium text-gray-800">{owner?.nombre || emp.representante || '—'}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Estado</p><p className={`font-semibold ${emp.status === 'activa' ? 'text-green-600' : 'text-red-600'}`}>{emp.status === 'activa' ? 'Activa' : 'Suspendida'}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Plan</p><p className={`font-bold ${emp.plan === 'pro' ? 'text-purple-600' : 'text-gray-600'}`}>{emp.plan === 'pro' ? '★ PRO' : 'Básico'}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Comisión aplicada</p><p className="font-bold text-gray-800">{emp.comisionPersonalizada || 20}%</p></div>
                                </div>

                                {/* Flota y operaciones */}
                                <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3 border-t pt-3">Flota y operaciones</p>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5 text-sm">
                                  <div><p className="text-xs text-gray-400 mb-0.5">Unidades registradas</p><p className="font-bold text-gray-800">{emp.unidades}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Choferes</p><p className="font-bold text-gray-800">{emp.choferes}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Viajes activos</p><p className="font-bold text-blue-600">{emp.viajesActivos}</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Viajes completados</p><p className="font-bold text-gray-800">{emp.viajesCompletados}</p></div>
                                </div>

                                {/* Finanzas */}
                                <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3 border-t pt-3">Finanzas</p>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5 text-sm">
                                  <div><p className="text-xs text-gray-400 mb-0.5">Comisión generada para Choyero</p><p className="font-bold text-green-600">${(emp.comisionGenerada || 0).toLocaleString()} MXN</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Ganancias netas empresa</p><p className="font-bold text-blue-700">${emp.gananciasTotales.toLocaleString()} MXN</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">GMV total</p><p className="font-bold text-gray-800">${(emp.comisionGenerada + emp.gananciasTotales).toLocaleString()} MXN</p></div>
                                  <div><p className="text-xs text-gray-400 mb-0.5">Promedio por viaje</p><p className="font-bold text-gray-800">{emp.viajesCompletados > 0 ? `$${Math.round((emp.comisionGenerada + emp.gananciasTotales) / emp.viajesCompletados).toLocaleString()}` : '—'}</p></div>
                                </div>

                                {/* Acciones */}
                                <div className="flex flex-wrap gap-3 pt-4 border-t border-gray-100">
                                  <button
                                    onClick={e => { e.stopPropagation(); const p = emp.plan === 'pro' ? 'basico' : 'pro'; storeAsignarPlan(emp.id, p); apiAsignarPlanEmpresa(emp.id, p).then(() => recargar()).catch(() => {}); }}
                                    className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border transition ${emp.plan === 'pro' ? 'bg-gray-50 border-gray-300 text-gray-600 hover:bg-gray-100' : 'bg-purple-50 border-purple-300 text-purple-700 hover:bg-purple-100'}`}
                                  >
                                    {emp.plan === 'pro' ? 'Cambiar a Básico' : '★ Cambiar a PRO'}
                                  </button>
                                  {puedeHacer('insignias') && (
                                    <button
                                      onClick={e => { e.stopPropagation(); setModalDetalleEmpresa(emp); }}
                                      className="flex items-center gap-2 px-4 py-2 bg-amber-50 border border-amber-300 text-amber-700 rounded-lg text-sm hover:bg-amber-100 font-medium"
                                    >
                                      <Award size={15} /> Insignias
                                    </button>
                                  )}
                                  <button
                                    onClick={e => { e.stopPropagation(); setModalDetalleEmpresa(emp); }}
                                    className="flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-300 text-blue-700 rounded-lg text-sm hover:bg-blue-100 font-medium"
                                  >
                                    <Eye size={15} /> Ver detalle completo
                                  </button>
                                  {owner && (
                                    <button
                                      onClick={e => { e.stopPropagation(); reabrirConversacionAdmin(canal); setChatEmpresaActivo({ empresaId: emp.id, empresaNombre: emp.nombre, usuarioId: owner.id, usuarioNombre: owner.nombre, origen: 'tabla' }); }}
                                      className="relative flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-300 text-green-700 rounded-lg text-sm hover:bg-green-100 font-medium"
                                    >
                                      <MessageSquare size={15} /> Enviar mensaje
                                      {noLeidos > 0 && <span className="bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full font-bold">{noLeidos}</span>}
                                    </button>
                                  )}
                                  <button
                                    onClick={async e => { e.stopPropagation(); if (!window.confirm(`¿${emp.status === 'activa' ? 'Suspender' : 'Activar'} a ${emp.nombre}?`)) return; await (emp.status === 'activa' ? apiSuspenderEmpresa(emp.id, 'Admin') : apiAprobarEmpresa(emp.id)); recargar(); }}
                                    className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border transition ${emp.status === 'activa' ? 'bg-red-50 border-red-300 text-red-700 hover:bg-red-100' : 'bg-green-50 border-green-300 text-green-700 hover:bg-green-100'}`}
                                  >
                                    {emp.status === 'activa' ? '🚫 Suspender empresa' : '✅ Activar empresa'}
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>

              {empresasFiltradas.length === 0 && (
                <div className="p-12 text-center">
                  <Building2 size={48} className="mx-auto text-gray-300 mb-4" />
                  <p className="text-gray-500">No se encontraron empresas</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ========== MAPA DE UNIDADES ========== */}
        {seccion === 'mapa' && (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Mapa de Unidades</h2>
            <p className="text-gray-600 mb-6">Visualiza todas las unidades de todos los transportistas en tiempo real</p>
            {MapaGeneralUnidades()}
          </div>
        )}

        {/* ========== ADMINISTRADORES ========== */}
        {seccion === 'admins' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <div>
                <h2 className="text-3xl font-bold text-gray-800">Administradores</h2>
                <p className="text-gray-600">Gestiona los usuarios con acceso al panel</p>
              </div>
              {puedeHacer('gestionar_admins') && (
                <button
                  onClick={() => setModalNuevoAdmin(true)}
                  className="px-6 py-3 bg-yellow-600 text-white rounded-xl hover:bg-yellow-700 flex items-center space-x-2 font-semibold"
                >
                  <UserPlus size={20} />
                  <span>Agregar Admin</span>
                </button>
              )}
            </div>

            {/* Resumen de roles */}
            <div className="grid grid-cols-4 gap-4 mb-6">
              <div className="bg-red-50 rounded-xl p-4 border border-red-200">
                <p className="text-sm text-red-600">Super Admins</p>
                <p className="text-2xl font-bold text-red-700">{administradores.filter(a => a.rol === 'superadmin').length}</p>
              </div>
              <div className="bg-orange-50 rounded-xl p-4 border border-orange-200">
                <p className="text-sm text-orange-600">Administradores</p>
                <p className="text-2xl font-bold text-orange-700">{administradores.filter(a => a.rol === 'admin').length}</p>
              </div>
              <div className="bg-blue-50 rounded-xl p-4 border border-blue-200">
                <p className="text-sm text-blue-600">Operadores</p>
                <p className="text-2xl font-bold text-blue-700">{administradores.filter(a => a.rol === 'operador').length}</p>
              </div>
              <div className="bg-green-50 rounded-xl p-4 border border-green-200">
                <p className="text-sm text-green-600">Soporte</p>
                <p className="text-2xl font-bold text-green-700">{administradores.filter(a => a.rol === 'soporte').length}</p>
              </div>
            </div>

            {/* Lista de administradores */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Administrador</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Rol</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Permisos</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Estado</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Fecha Alta</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Acciones</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {administradores.map(admin => (
                    <tr key={admin.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-3">
                          <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${
                            admin.rol === 'superadmin' ? 'bg-red-500' :
                            admin.rol === 'admin' ? 'bg-orange-500' :
                            admin.rol === 'operador' ? 'bg-blue-500' : 'bg-green-500'
                          }`}>
                            {admin.nombre.split(' ').map(n => n[0]).slice(0, 2).join('')}
                          </div>
                          <div>
                            <p className="font-semibold">{admin.nombre}</p>
                            <p className="text-xs text-gray-500">{admin.email}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
                          admin.rol === 'superadmin' ? 'bg-red-100 text-red-800' :
                          admin.rol === 'admin' ? 'bg-orange-100 text-orange-800' :
                          admin.rol === 'operador' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
                        }`}>
                          {admin.rol === 'superadmin' ? 'Super Admin' :
                           admin.rol === 'admin' ? 'Administrador' :
                           admin.rol === 'operador' ? 'Operador' : 'Soporte'}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex flex-wrap gap-1 max-w-xs">
                          {(() => {
                            const permisos = admin.permisos || (admin.rol === 'superadmin' ? ['todo'] : []);
                            if (permisos.includes('todo')) {
                              return <span className="px-2 py-0.5 text-xs bg-yellow-100 text-yellow-800 rounded">Todos</span>;
                            }
                            return (
                              <>
                                {permisos.slice(0, 3).map(p => (
                                  <span key={p} className="px-2 py-0.5 text-xs bg-gray-100 text-gray-700 rounded">{p.replace(/_/g, ' ')}</span>
                                ))}
                                {permisos.length > 3 && (
                                  <span className="px-2 py-0.5 text-xs bg-gray-200 text-gray-600 rounded">+{permisos.length - 3}</span>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
                          admin.activo ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                        }`}>
                          {admin.activo ? '● Activo' : '● Inactivo'}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-gray-600">{admin.creadoEn ? new Date(admin.creadoEn).toLocaleDateString('es-MX') : '—'}</td>
                      <td className="px-6 py-4">
                        <div className="flex space-x-2">
                          {puedeHacer('gestionar_admins') && admin.id !== usuario?.id && (
                            <>
                              <button
                                onClick={() => setModalEditarAdmin(admin)}
                                className="p-2 text-yellow-600 hover:bg-yellow-100 rounded-lg"
                                title="Editar"
                              >
                                <Edit size={18} />
                              </button>
                              <button
                                onClick={() => toggleStatusAdmin(admin.id)}
                                className={`p-2 rounded-lg ${admin.activo ? 'text-red-600 hover:bg-red-100' : 'text-green-600 hover:bg-green-100'}`}
                                title={admin.activo ? 'Desactivar' : 'Activar'}
                              >
                                {admin.activo ? <Lock size={18} /> : <Unlock size={18} />}
                              </button>
                              <button
                                onClick={() => eliminarAdmin(admin.id)}
                                className="p-2 text-red-600 hover:bg-red-100 rounded-lg"
                                title="Eliminar"
                              >
                                <Trash2 size={18} />
                              </button>
                            </>
                          )}
                          {admin.email === 'admin@choyero.app' && (
                            <span className="text-xs text-gray-400 italic">Admin principal</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Leyenda de permisos */}
            <div className="mt-6 bg-gray-50 rounded-xl p-6">
              <h4 className="font-semibold text-gray-800 mb-4">Descripción de Roles</h4>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="flex items-start space-x-3">
                  <ShieldCheck className="text-red-500 mt-0.5" size={18} />
                  <div>
                    <p className="font-semibold">Super Administrador</p>
                    <p className="text-gray-500">Acceso total a todas las funciones del sistema</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Shield className="text-orange-500 mt-0.5" size={18} />
                  <div>
                    <p className="font-semibold">Administrador</p>
                    <p className="text-gray-500">Gestión de empresas, reportes y configuraciones básicas</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <ShieldAlert className="text-blue-500 mt-0.5" size={18} />
                  <div>
                    <p className="font-semibold">Operador</p>
                    <p className="text-gray-500">Visualización de información y soporte básico</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Users className="text-green-500 mt-0.5" size={18} />
                  <div>
                    <p className="font-semibold">Soporte</p>
                    <p className="text-gray-500">Solo atención y comunicación con usuarios</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ========== CHOFERES ========== */}
        {seccion === 'choferes' && (() => {
          const todosChoferes = (store.plantillaChoferes || []);
          const choferesFiltrados = todosChoferes.filter(c => {
            const q = globalSearch.trim().toLowerCase();
            const matchQ = !q || (c.nombre||'').toLowerCase().includes(q) || (c.email||'').toLowerCase().includes(q) || (c.licencia||'').toLowerCase().includes(q);
            const matchE = !filtroEmpresaChofer || c.empresaId === filtroEmpresaChofer;
            return matchQ && matchE;
          });
          const estaActivoChofer = (c) => !c.tieneAcceso || c.usuarioActivo !== false;
          const activos = todosChoferes.filter(estaActivoChofer).length;
          const enViaje = (store.ordenesChofer || []).filter(o => o.status === 'en_camino' || o.status === 'recogido').map(o => o.choferEmail);
          const empresasConChofer = [...new Set(todosChoferes.map(c => c.empresaId).filter(Boolean))];

          return (
            <div>
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-800">Choferes</h2>
                  <p className="text-gray-500 text-sm mt-1">{todosChoferes.length} registrados · {activos} activos · {enViaje.length} en viaje ahora</p>
                </div>
              </div>

              {/* KPIs */}
              <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="bg-white rounded-xl shadow p-4 flex items-center gap-4">
                  <div className="w-11 h-11 bg-blue-100 rounded-xl flex items-center justify-center"><UserCheck size={22} className="text-blue-600" /></div>
                  <div><p className="text-2xl font-bold text-gray-800">{activos}</p><p className="text-xs text-gray-500">Activos</p></div>
                </div>
                <div className="bg-white rounded-xl shadow p-4 flex items-center gap-4">
                  <div className="w-11 h-11 bg-orange-100 rounded-xl flex items-center justify-center"><Truck size={22} className="text-orange-600" /></div>
                  <div><p className="text-2xl font-bold text-gray-800">{enViaje.length}</p><p className="text-xs text-gray-500">En viaje ahora</p></div>
                </div>
                <div className="bg-white rounded-xl shadow p-4 flex items-center gap-4">
                  <div className="w-11 h-11 bg-gray-100 rounded-xl flex items-center justify-center"><UserX size={22} className="text-gray-500" /></div>
                  <div><p className="text-2xl font-bold text-gray-800">{todosChoferes.filter(c => !estaActivoChofer(c)).length}</p><p className="text-xs text-gray-500">Inactivos</p></div>
                </div>
              </div>

              {/* Filtros */}
              <div className="flex gap-3 mb-4">
                <select value={filtroEmpresaChofer} onChange={e => setFiltroEmpresaChofer(e.target.value)} className="border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none bg-white shadow-sm">
                  <option value="">Todas las empresas</option>
                  {empresasConChofer.map(eid => {
                    const emp = empresasActivasMerged.find(e => e.id === eid);
                    return <option key={eid} value={eid}>{emp?.nombre || eid}</option>;
                  })}
                </select>
                {globalSearch && <p className="text-xs text-gray-400 self-center">Filtrando por: "{globalSearch}"</p>}
              </div>

              {/* Tabla */}
              <div className="bg-white rounded-xl shadow overflow-hidden">
                {choferesFiltrados.length === 0 ? (
                  <div className="p-16 text-center text-gray-400">
                    <UserCheck size={48} className="mx-auto mb-3 opacity-30" />
                    <p className="font-medium">Sin choferes</p>
                    <p className="text-sm mt-1">No hay choferes que coincidan con el filtro</p>
                  </div>
                ) : (
                  <table className="w-full">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Chofer</th>
                        <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Teléfono</th>
                        <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Empresa</th>
                        <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Licencia / Unidad</th>
                        <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Viajes</th>
                        <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Calificación</th>
                        <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Estado</th>
                        <th className="px-5 py-3"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {choferesFiltrados.map(c => {
                        const empresa = empresasActivasMerged.find(e => e.id === c.empresaId);
                        const estaEnViaje = enViaje.includes(c.email);
                        // Buscar el Usuario real por email para obtener viajesCompletados, avatar y calificación real
                        const usuarioChofer = (store.usuarios || []).find(u => u.email === c.email);
                        const viajesReales = usuarioChofer?.viajesCompletados ?? 0;
                        const avatarChofer = usuarioChofer?.avatar || c.foto || null;
                        // Buscar la unidad asignada a este chofer (por choferAsignado === c.id)
                        const unidadAsig = (empresa?.unidadesDetalle || []).find(u => u.choferAsignado === c.id);
                        const placasChofer = unidadAsig?.placas || null;
                        const unidadStr = unidadAsig
                          ? [unidadAsig.marca, unidadAsig.modelo, unidadAsig.anio].filter(Boolean).join(' ') || unidadAsig.tipo
                          : null;
                        const kmChofer = usuarioChofer?.kmRecorridos ?? 0;
                        const registroEn = usuarioChofer?.creadoEn || c.creadoEn || null;
                        const histChofer = (store.historialEntregas || []).filter(h => h.choferEmail === c.email || h.choferNombre === c.nombre);
                        // Solo mostrar calificación si tiene viajes reales — @default(5.0) no es una calificación real
                        const calProm = viajesReales > 0 || histChofer.filter(h => h.calificacion).length > 0
                          ? (histChofer.filter(h => h.calificacion).length > 0
                            ? (histChofer.reduce((s, h) => s + (h.calificacion || 0), 0) / histChofer.filter(h => h.calificacion).length).toFixed(1)
                            : usuarioChofer?.calificacion?.toFixed(1) || null)
                          : null;
                        const expandido = choferExpandido === (c.id || c.email);
                        const ultimosViajes = [...histChofer].sort((a, b) => new Date(b.fechaCompletada || 0) - new Date(a.fechaCompletada || 0)).slice(0, 5);
                        return (
                          <React.Fragment key={c.id || c.email}>
                            {/* ── Fila principal ── */}
                            <tr
                              className={`cursor-pointer transition-colors ${expandido ? 'bg-blue-50' : 'hover:bg-gray-50'}`}
                              onClick={() => setChoferExpandido(expandido ? null : (c.id || c.email))}
                            >
                              <td className="px-5 py-3">
                                <div className="flex items-center gap-3">
                                  <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-sm flex-shrink-0 overflow-hidden">
                                    {avatarChofer
                                      ? <img src={avatarChofer} alt={c.nombre} className="w-full h-full object-cover" />
                                      : (c.nombre||'?').split(' ').map(n => n[0]).slice(0,2).join('').toUpperCase()
                                    }
                                  </div>
                                  <div>
                                    <div className="flex items-center gap-2">
                                      <p className="font-semibold text-gray-800 text-sm">{c.nombre}</p>
                                      {!estaActivoChofer(c) && <span className="text-xs px-1.5 py-0.5 rounded-full bg-red-100 text-red-600 font-semibold">Inactivo</span>}
                                    </div>
                                    <p className="text-xs text-gray-400">{c.email}</p>
                                  </div>
                                </div>
                              </td>
                              <td className="px-5 py-3 text-sm text-gray-700">{c.telefono || '—'}</td>
                              <td className="px-5 py-3"><p className="text-sm text-gray-700">{empresa?.nombre || '—'}</p></td>
                              <td className="px-5 py-3">
                                <span className="text-xs font-mono bg-gray-100 text-gray-600 px-2 py-0.5 rounded">{c.licencia || '—'}</span>
                                {(unidadStr || placasChofer) && (
                                  <p className="text-xs text-gray-400 mt-0.5">{unidadStr || ''}{placasChofer ? ` · ${placasChofer}` : ''}</p>
                                )}
                              </td>
                              <td className="px-5 py-3"><span className="font-semibold text-gray-800">{viajesReales}</span></td>
                              <td className="px-5 py-3">
                                {calProm
                                  ? <span className="flex items-center gap-1 text-sm font-semibold text-amber-600"><Star size={13} fill="currentColor" /> {calProm}</span>
                                  : <span className="text-gray-300 text-sm">—</span>}
                              </td>
                              <td className="px-5 py-3">
                                {estaEnViaje
                                  ? <span className="text-xs px-2.5 py-1 bg-orange-100 text-orange-700 rounded-full font-semibold">En viaje</span>
                                  : !estaActivoChofer(c)
                                    ? <span className="text-xs px-2.5 py-1 bg-red-100 text-red-600 rounded-full font-semibold">Inactivo</span>
                                    : <span className="text-xs px-2.5 py-1 bg-green-100 text-green-700 rounded-full font-semibold">Disponible</span>}
                              </td>
                              <td className="px-5 py-3 text-right">
                                <span className={`text-gray-400 transition-transform inline-block ${expandido ? 'rotate-180' : ''}`}>▼</span>
                              </td>
                            </tr>

                            {/* ── Panel expandible ── */}
                            {expandido && (
                              <tr className="bg-blue-50">
                                <td colSpan={8} className="px-6 py-4">
                                  <div className="bg-white border border-blue-100 rounded-xl p-5 mb-1 shadow-sm">
                                    {/* Datos personales */}
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3">Datos personales</p>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5 text-sm">
                                      <div><p className="text-xs text-gray-400 mb-0.5">Email</p><p className="font-medium text-gray-800 break-all">{c.email}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Teléfono</p><p className="font-medium text-gray-800">{c.telefono || '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Empresa</p><p className="font-medium text-gray-800">{empresa?.nombre || '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Estado</p><p className={`font-semibold ${estaEnViaje ? 'text-orange-600' : !estaActivoChofer(c) ? 'text-red-600' : 'text-green-600'}`}>{estaEnViaje ? 'En viaje' : !estaActivoChofer(c) ? 'Inactivo' : 'Disponible'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Licencia</p><p className="font-mono font-medium text-gray-800">{c.licencia || '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Unidad asignada</p><p className="font-medium text-gray-800">{unidadStr || '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Placas</p><p className="font-mono font-medium text-gray-800">{placasChofer || '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Km recorridos</p><p className="font-bold text-gray-800">{kmChofer.toLocaleString()} km</p></div>
                                    </div>

                                    {/* Desempeño */}
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3 border-t pt-3">Desempeño</p>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5 text-sm">
                                      <div><p className="text-xs text-gray-400 mb-0.5">Viajes completados</p><p className="font-bold text-gray-800">{viajesReales}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Calificación promedio</p><p className="font-bold text-amber-500">{calProm ? `⭐ ${calProm}` : '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Calificaciones recibidas</p><p className="font-bold text-gray-800">{histChofer.filter(h => h.calificacion).length}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Registro en plataforma</p><p className="font-medium text-gray-800">{registroEn ? new Date(registroEn).toLocaleDateString('es-MX') : '—'}</p></div>
                                    </div>

                                    {/* Últimos viajes */}
                                    {ultimosViajes.length > 0 && (
                                      <div className="mb-5">
                                        <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-2 border-t pt-3">Últimos 5 viajes</p>
                                        <div className="space-y-1">
                                          {ultimosViajes.map((h, i) => (
                                            <div key={i} className="flex justify-between text-xs bg-gray-50 rounded-lg px-3 py-2">
                                              <span className="text-gray-700 font-medium">{h.origen?.split(',')[0]} → {h.destino?.split(',')[0]}</span>
                                              <span className="flex items-center gap-3 text-gray-500">
                                                {h.calificacion && <span className="text-amber-500 font-semibold">⭐ {h.calificacion}</span>}
                                                <span>{h.fechaCompletada ? new Date(h.fechaCompletada).toLocaleDateString('es-MX') : '—'}</span>
                                              </span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}

                                    {/* Acciones */}
                                    <div className="flex flex-wrap gap-3 pt-4 border-t border-gray-100">
                                      {c.usuarioId ? (
                                        <button
                                          onClick={async e => {
                                            e.stopPropagation();
                                            if (!window.confirm(`¿${!estaActivoChofer(c) ? 'Activar' : 'Desactivar'} a ${c.nombre}?`)) return;
                                            try {
                                              await apiAdminToggleAdmin(c.usuarioId);
                                              await recargar();
                                            } catch (err) {
                                              alert(err?.message || 'Error al cambiar el acceso del chofer');
                                            }
                                          }}
                                          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border transition ${!estaActivoChofer(c) ? 'bg-green-50 border-green-300 text-green-700 hover:bg-green-100' : 'bg-red-50 border-red-300 text-red-700 hover:bg-red-100'}`}
                                        >
                                          {!estaActivoChofer(c) ? '✅ Activar chofer' : '🚫 Desactivar chofer'}
                                        </button>
                                      ) : (
                                        <span className="text-xs text-gray-400 italic px-2 py-2">Este chofer no tiene cuenta de acceso — no se puede activar/desactivar.</span>
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          );
        })()}

        {/* ========== CLIENTES ========== */}
        {seccion === 'clientes' && (
          <div>
            <div className="flex items-center justify-between mb-4">
              <div>
                <h2 className="text-3xl font-bold text-gray-800">Clientes Registrados</h2>
                <p className="text-gray-600">{stats.clientesActivos} total · {stats.clientesRegulares} regulares · {stats.clientesMLM} MLM</p>
              </div>
              <div className="flex gap-2">
                {[['todos','Todos'], ['regular','Solo regulares'], ['mlm','Solo MLM']].map(([val, label]) => (
                  <button key={val} onClick={() => setFiltroTipoCliente(val)}
                    className={`px-3 py-1.5 rounded-lg text-sm font-semibold border transition ${filtroTipoCliente === val ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`}>
                    {label}
                  </button>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Cliente</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Teléfono</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Email / RFC</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Registro</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Viajes</th>
                    <th className="hidden md:table-cell px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Calificación</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Gasto Total</th>
                    <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Insignias</th>
                    {puedeHacer('insignias') && <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase">Acciones</th>}
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {clientes.filter(c => {
                    const esRef = c.esReferidor ?? false;
                    if (filtroTipoCliente === 'mlm' && !esRef) return false;
                    if (filtroTipoCliente === 'regular' && esRef) return false;
                    if (!globalSearch) return true;
                    const q = globalSearch.trim().toLowerCase();
                    return (c.nombre||'').toLowerCase().includes(q) || (c.email||'').toLowerCase().includes(q) || (c.rfc||'').toLowerCase().includes(q);
                  }).map(cliente => {
                    const clienteVivo = (store.usuarios || []).find(u => u.id === cliente.id && u.rol === 'cliente') || cliente;
                    const insigniasIds = clienteVivo.insigniasCliente || [];
                    const insignias = insigniasIds.map(id => CATALOGO_INSIGNIAS_CLIENTE.find(b => b.id === id)).filter(Boolean);
                    const expandido = clienteExpandido === cliente.id;
                    const esReferidor = clienteVivo.esReferidor ?? cliente.esReferidor ?? false;
                    const activo = clienteVivo.activo ?? cliente.activo ?? true;
                    return (
                      <React.Fragment key={cliente.id}>
                        {/* ── Fila principal ── */}
                        <tr
                          className={`cursor-pointer transition-colors ${expandido ? 'bg-blue-50' : 'hover:bg-gray-50'}`}
                          onClick={() => setClienteExpandido(expandido ? null : cliente.id)}
                        >
                          <td className="px-6 py-4">
                            <div className="flex items-center space-x-3">
                              <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-blue-100 flex items-center justify-center">
                                {cliente.avatar
                                  ? <img src={cliente.avatar} alt={cliente.nombre} className="w-full h-full object-cover" />
                                  : <span className="text-blue-700 font-bold text-sm">{cliente.nombre?.charAt(0)?.toUpperCase()}</span>}
                              </div>
                              <div>
                                <div className="flex items-center gap-2">
                                  <p className="font-semibold">{cliente.nombre}</p>
                                  {!activo && <span className="text-xs px-1.5 py-0.5 rounded-full bg-red-100 text-red-600 font-semibold">Suspendido</span>}
                                </div>
                                {cliente.tipoPersona && (
                                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${cliente.tipoPersona === 'moral' ? 'bg-purple-100 text-purple-700' : 'bg-blue-100 text-blue-700'}`}>
                                    {cliente.tipoPersona === 'moral' ? 'Persona Moral' : 'Persona Física'}
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-gray-700">{cliente.telefono || '—'}</td>
                          <td className="px-6 py-4">
                            <p className="text-gray-600 text-sm">{cliente.email}</p>
                            {cliente.rfc && <p className="text-xs text-gray-400 font-mono">{cliente.rfc}</p>}
                            {clienteVivo.emailVerificado
                              ? <span className="text-xs text-green-600 font-semibold">✓ Email verificado</span>
                              : <span className="text-xs text-orange-500 font-semibold">⚠ Sin verificar</span>}
                          </td>
                          <td className="px-6 py-4 text-gray-500 text-sm">{cliente.creadoEn ? new Date(cliente.creadoEn).toLocaleDateString('es-MX') : '—'}</td>
                          <td className="px-6 py-4"><span className="font-semibold">{cliente.viajesRealizados}</span></td>
                          <td className="hidden md:table-cell px-6 py-4">
                            {(clienteVivo.calificacion && cliente.viajesRealizados > 0) ? (
                              <div className="flex items-center gap-1">
                                <Star size={13} className="text-yellow-400 flex-shrink-0" fill="currentColor" />
                                <span className="font-semibold text-gray-800">{clienteVivo.calificacion.toFixed(1)}</span>
                              </div>
                            ) : <span className="text-gray-400 text-sm">—</span>}
                          </td>
                          <td className="px-6 py-4"><span className="font-bold text-green-600">${cliente.gastoTotal.toLocaleString()}</span></td>
                          <td className="px-6 py-4">
                            {insignias.length > 0 ? (
                              <div className="flex flex-wrap gap-1">
                                {insignias.map(ins => (
                                  <span key={ins.id} title={ins.desc} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${ins.color}`}>
                                    {ins.emoji} {ins.label}
                                  </span>
                                ))}
                              </div>
                            ) : <span className="text-gray-400 text-sm">Sin insignias</span>}
                          </td>
                          <td className="px-6 py-4 text-right">
                            <span className={`text-gray-400 transition-transform inline-block ${expandido ? 'rotate-180' : ''}`}>▼</span>
                          </td>
                        </tr>

                        {/* ── Panel expandible ── */}
                        {expandido && (
                          <tr className="bg-indigo-50">
                            <td colSpan={9} className="px-6 py-4">
                              {(() => {
                                const solicitudesCliente = (store.solicitudes || []).filter(s => s.clienteId === cliente.id);
                                const solicitudesActivas = solicitudesCliente.filter(s => ['abierta', 'en_cotizacion', 'aceptada'].includes(s.status)).length;
                                const ultimaActividad = [...solicitudesCliente].sort((a, b) => new Date(b.creadoEn || b.fechaCreacion || 0) - new Date(a.creadoEn || a.fechaCreacion || 0))[0];
                                const promedioPorViaje = cliente.viajesRealizados > 0 ? Math.round(cliente.gastoTotal / cliente.viajesRealizados) : 0;
                                const referidorNombre = cliente.referidoPor
                                  ? ((store.usuarios || []).find(u => u.id === cliente.referidoPor)?.nombre || cliente.referidoPor)
                                  : null;
                                const comisionesCliente = (store.comisionesRed || []).filter(c => c.userId === cliente.id);
                                const comisionDisponible = comisionesCliente.filter(c => c.status === 'disponible').reduce((s, c) => s + c.monto, 0);
                                const comisionPagada    = comisionesCliente.filter(c => c.status === 'pagada').reduce((s, c) => s + c.monto, 0);
                                const comisionPendiente = comisionesCliente.filter(c => c.status === 'pendiente').reduce((s, c) => s + c.monto, 0);
                                const comisionTotal     = comisionDisponible + comisionPagada + comisionPendiente;
                                const ultimasComisiones = [...comisionesCliente].sort((a, b) => new Date(b.creadoEn || 0) - new Date(a.creadoEn || 0)).slice(0, 5);
                                return (
                                  <div className="bg-white border border-blue-100 rounded-xl p-5 mb-3 shadow-sm">
                                    {/* ── Datos personales ── */}
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3">Datos personales</p>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5 text-sm">
                                      <div><p className="text-xs text-gray-400 mb-0.5">Email</p><p className="font-medium text-gray-800 break-all">{cliente.email}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Teléfono</p><p className="font-medium text-gray-800">{cliente.telefono || '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">RFC</p><p className="font-medium font-mono text-gray-800">{clienteVivo.rfc || cliente.rfc || '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Tipo persona</p><p className="font-medium text-gray-800">{cliente.tipoPersona === 'moral' ? 'Persona Moral' : 'Persona Física'}</p></div>
                                      {cliente.representante && <div><p className="text-xs text-gray-400 mb-0.5">Representante</p><p className="font-medium text-gray-800">{cliente.representante}</p></div>}
                                      <div><p className="text-xs text-gray-400 mb-0.5">Registro</p><p className="font-medium text-gray-800">{cliente.creadoEn ? new Date(cliente.creadoEn).toLocaleDateString('es-MX') : '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Estado</p><p className={`font-semibold ${activo ? 'text-green-600' : 'text-red-600'}`}>{activo ? 'Activo' : 'Suspendido'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Calificación</p><p className="font-bold text-yellow-500">{(clienteVivo.calificacion && cliente.viajesRealizados > 0) ? `${'⭐'.repeat(Math.round(clienteVivo.calificacion))} ${clienteVivo.calificacion.toFixed(1)}` : '—'}</p></div>
                                    </div>

                                    {/* ── Actividad ── */}
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3 border-t pt-3">Actividad</p>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5 text-sm">
                                      <div><p className="text-xs text-gray-400 mb-0.5">Viajes realizados</p><p className="font-bold text-gray-800">{cliente.viajesRealizados}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Gasto total</p><p className="font-bold text-green-600">${cliente.gastoTotal.toLocaleString()}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Promedio por viaje</p><p className="font-bold text-gray-800">{promedioPorViaje > 0 ? `$${promedioPorViaje.toLocaleString()}` : '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Solicitudes activas</p><p className="font-bold text-blue-600">{solicitudesActivas}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Última actividad</p><p className="font-medium text-gray-800">{ultimaActividad ? new Date(ultimaActividad.creadoEn || ultimaActividad.fechaCreacion || ultimaActividad.fecha).toLocaleDateString('es-MX') : '—'}</p></div>
                                    </div>

                                    {/* ── MLM ── */}
                                    <p className="text-xs font-bold text-gray-400 uppercase tracking-wide mb-3 border-t pt-3">Programa MLM</p>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4 text-sm">
                                      <div><p className="text-xs text-gray-400 mb-0.5">Estado MLM</p><p className={`font-semibold ${esReferidor ? 'text-orange-600' : 'text-gray-400'}`}>{esReferidor ? 'Habilitado' : 'No habilitado'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Código de referido</p><p className="font-mono font-bold text-gray-800">{clienteVivo.codigoReferido || cliente.codigoReferido || '—'}</p></div>
                                      <div><p className="text-xs text-gray-400 mb-0.5">Fue referido por</p><p className="font-medium text-gray-800">{referidorNombre || '—'}</p></div>
                                    </div>

                                    {/* ── Ganancias MLM ── */}
                                    {comisionTotal > 0 && (
                                      <div className="bg-orange-50 border border-orange-100 rounded-xl p-4 mb-4">
                                        <p className="text-xs font-bold text-orange-600 uppercase tracking-wide mb-3">Ganancias por referidos</p>
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm mb-3">
                                          <div><p className="text-xs text-gray-400 mb-0.5">Total acumulado</p><p className="font-bold text-orange-700">${comisionTotal.toLocaleString('es-MX')} MXN</p></div>
                                          <div><p className="text-xs text-gray-400 mb-0.5">Disponible para retiro</p><p className="font-bold text-green-600">${comisionDisponible.toLocaleString('es-MX')} MXN</p></div>
                                          <div><p className="text-xs text-gray-400 mb-0.5">Ya pagado</p><p className="font-bold text-gray-600">${comisionPagada.toLocaleString('es-MX')} MXN</p></div>
                                          <div><p className="text-xs text-gray-400 mb-0.5">Pendiente (en viaje)</p><p className="font-bold text-yellow-600">${comisionPendiente.toLocaleString('es-MX')} MXN</p></div>
                                        </div>
                                        {ultimasComisiones.length > 0 && (
                                          <div className="mt-2">
                                            <p className="text-xs text-gray-400 mb-1">Últimas 5 comisiones</p>
                                            <div className="space-y-1">
                                              {ultimasComisiones.map((c, i) => (
                                                <div key={i} className="flex justify-between text-xs bg-white rounded-lg px-3 py-1.5">
                                                  <span className="text-gray-500">Nivel {c.nivel} · {c.creadoEn ? new Date(c.creadoEn).toLocaleDateString('es-MX') : '—'}</span>
                                                  <span className={`font-semibold ${c.status === 'disponible' ? 'text-green-600' : c.status === 'pagada' ? 'text-gray-500' : 'text-yellow-600'}`}>
                                                    ${c.monto.toLocaleString('es-MX')} · {c.status}
                                                  </span>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}

                                    {/* ── Acciones ── */}
                                    <div className="flex flex-wrap gap-3 pt-4 border-t border-gray-100">
                                      {puedeHacer('insignias') && (
                                        <button onClick={e => { e.stopPropagation(); setModalInsigniasCliente(clienteVivo); }}
                                          className="flex items-center gap-2 px-4 py-2 bg-amber-50 border border-amber-300 text-amber-700 rounded-lg text-sm hover:bg-amber-100 font-medium">
                                          <Award size={15} /> Insignias
                                        </button>
                                      )}
                                      <button
                                        onClick={async e => {
                                          e.stopPropagation();
                                          await apiAdminToggleReferidor(cliente.id, !esReferidor);
                                          dispatch({ type: 'RELOAD_USUARIOS' });
                                        }}
                                        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border transition ${esReferidor ? 'bg-orange-50 border-orange-300 text-orange-700 hover:bg-orange-100' : 'bg-gray-50 border-gray-300 text-gray-600 hover:bg-gray-100'}`}
                                      >
                                        <span className={`w-8 h-4 rounded-full relative inline-block transition-colors ${esReferidor ? 'bg-orange-500' : 'bg-gray-300'}`}>
                                          <span className={`absolute top-0.5 w-3 h-3 bg-white rounded-full shadow transition-all ${esReferidor ? 'left-4' : 'left-0.5'}`} />
                                        </span>
                                        {esReferidor ? 'MLM activo' : 'Habilitar MLM'}
                                      </button>
                                      {puedeHacer('gestionar_admins') && (
                                        <button
                                          onClick={async e => {
                                            e.stopPropagation();
                                            if (!window.confirm(`¿${activo ? 'Suspender' : 'Activar'} a ${cliente.nombre}?`)) return;
                                            await apiAdminToggleAdmin(cliente.id);
                                            dispatch({ type: 'RELOAD_USUARIOS' });
                                          }}
                                          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border transition ${activo ? 'bg-red-50 border-red-300 text-red-700 hover:bg-red-100' : 'bg-green-50 border-green-300 text-green-700 hover:bg-green-100'}`}
                                        >
                                          {activo ? '🚫 Suspender cuenta' : '✅ Activar cuenta'}
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              })()}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ========== OPERACIONES ========== */}
        {seccion === 'operaciones' && (() => {
          const todosUsuarios = store.usuarios || [];
          const todasSolicitudes = store.solicitudes || [];
          const todosViajes = store.viajes || [];
          const todoHistorial = store.historialEntregas || [];
          const todasOrdenesChofer = store.ordenesChofer || [];
          const todosMensajes = store.mensajes || [];
          const todasNotifs = store.notificaciones || [];

          const _fmtFecha = (iso) => {
            if (!iso) return '—';
            const d = new Date(iso);
            return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
          };

          const getBadge = getBadgeGlobal;

          // ── SOLICITUDES TAB ──
          const _getClienteNombre = (s) => s.cliente?.nombre || s.clienteNombre || (store.usuarios||[]).find(u => u.id === s.clienteId)?.nombre || '—';
          const _sortDesc = (a, b) => new Date(b.creadoEn || b.fechaCreacion || b.fecha || 0) - new Date(a.creadoEn || a.fechaCreacion || a.fecha || 0);

          const _matchFecha = (iso) => {
            if (!iso) return true;
            const fecha = iso.slice(0, 10);
            if (opFechaDesde && fecha < opFechaDesde) return false;
            if (opFechaHasta && fecha > opFechaHasta) return false;
            return true;
          };

          const solicitudesFiltradas = todasSolicitudes.filter(s => {
            const matchFiltro = opFiltro === 'todos' || s.status === opFiltro;
            const matchBusqueda = !opBusqueda || s.id.toLowerCase().includes(opBusqueda.toLowerCase()) || _getClienteNombre(s).toLowerCase().includes(opBusqueda.toLowerCase()) || s.origen.toLowerCase().includes(opBusqueda.toLowerCase()) || s.destino.toLowerCase().includes(opBusqueda.toLowerCase());
            const matchPrioridad = !opPrioridad || (s.prioridad || 'normal') === opPrioridad;
            return matchFiltro && matchBusqueda && matchPrioridad && _matchFecha(s.creadoEn || s.fechaCreacion);
          }).sort(_sortDesc);

          // ── VIAJES TAB ──
          const viajesFiltrados = todosViajes.filter(v => {
            const matchFiltro = opFiltro === 'todos' || v.status === opFiltro || (opFiltro === 'en_disputa' && v.enDisputa);
            const matchBusqueda = !opBusqueda || v.id.toLowerCase().includes(opBusqueda.toLowerCase()) || (v.clienteNombre || '').toLowerCase().includes(opBusqueda.toLowerCase()) || (v.transportistaNombre || '').toLowerCase().includes(opBusqueda.toLowerCase()) || (v.origen || '').toLowerCase().includes(opBusqueda.toLowerCase()) || (v.destino || '').toLowerCase().includes(opBusqueda.toLowerCase());
            const matchEmpresa = !opEmpresaId || v.empresaId === opEmpresaId;
            return matchFiltro && matchBusqueda && matchEmpresa && _matchFecha(v.creadoEn || v.fechaCreacion);
          }).sort(_sortDesc);

          // ── HISTORIAL TAB ──
          const historialFiltrado = todoHistorial.filter(h => {
            const matchBusqueda = !opBusqueda || (h.ruta || '').toLowerCase().includes(opBusqueda.toLowerCase()) || (h.cliente || '').toLowerCase().includes(opBusqueda.toLowerCase()) || (h.id || '').toLowerCase().includes(opBusqueda.toLowerCase());
            const matchEmpresa = !opEmpresaId || h.empresaId === opEmpresaId;
            return matchBusqueda && matchEmpresa && _matchFecha(h.fecha);
          }).sort(_sortDesc);

          // ── POR USUARIO TAB ──
          const usuariosOp = todosUsuarios.filter(u => ['cliente','transportista','chofer'].includes(u.rol));
          const usuarioSeleccionado = opUsuarioId ? usuariosOp.find(u => u.id === opUsuarioId) : null;
          const actividadUsuario = usuarioSeleccionado ? {
            solicitudes: todasSolicitudes.filter(s => s.clienteId === usuarioSeleccionado.id),
            cotizaciones: (store.cotizaciones || []).filter(c => c.transportistaId === usuarioSeleccionado.id),
            viajes: todosViajes.filter(v => v.clienteId === usuarioSeleccionado.id || v.transportistaId === usuarioSeleccionado.id),
            ordenes: todasOrdenesChofer.filter(o => o.choferId === usuarioSeleccionado.id),
            historial: todoHistorial.filter(h => h.choferId === usuarioSeleccionado.id),
          } : null;

          return (
            <div>
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-800">Operaciones</h2>
                  <p className="text-gray-600">Monitoreo e intervención en solicitudes y viajes</p>
                </div>
                {(store.viajes || []).filter(v => v.enDisputa).length > 0 && (
                  <div className="flex items-center gap-2 px-4 py-2 bg-orange-50 border border-orange-200 rounded-xl">
                    <AlertTriangle size={18} className="text-orange-600" />
                    <span className="font-semibold text-orange-700">{(store.viajes || []).filter(v => v.enDisputa).length} disputa(s) activa(s)</span>
                  </div>
                )}
              </div>

              {/* Sub-tabs */}
              <div className="flex gap-2 mb-6 border-b border-gray-200">
                {[
                  { id: 'solicitudes', label: 'Solicitudes', count: todasSolicitudes.length },
                  { id: 'viajes', label: 'Viajes Activos', count: todosViajes.length },
                  { id: 'historial', label: 'Historial Entregas', count: todoHistorial.length },
                  { id: 'usuarios', label: 'Por Usuario' },
                ].map(t => (
                  <button
                    key={t.id}
                    onClick={() => { setOpTab(t.id); setOpFiltro('todos'); setOpBusqueda(''); setOpEmpresaId(''); setOpPrioridad(''); }}
                    className={`px-4 py-2 font-semibold text-sm border-b-2 transition-colors flex items-center gap-2 ${opTab === t.id ? 'border-blue-600 text-blue-700' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                  >
                    {t.label}
                    {t.count !== undefined && <span className={`text-xs px-1.5 py-0.5 rounded-full ${opTab === t.id ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'}`}>{t.count}</span>}
                  </button>
                ))}
              </div>

              {/* Barra de búsqueda, filtros y rango de fechas */}
              {opTab !== 'usuarios' && (
                <div className="space-y-3 mb-5">
                  <div className="flex gap-3">
                    <div className="relative flex-1">
                      <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                      <input
                        value={opBusqueda}
                        onChange={e => setOpBusqueda(e.target.value)}
                        placeholder="Buscar por ID, cliente, ruta..."
                        className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                      />
                    </div>
                    <select
                      value={opFiltro}
                      onChange={e => setOpFiltro(e.target.value)}
                      className="px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none"
                    >
                      <option value="todos">Todos los status</option>
                      {opTab === 'solicitudes' && <>
                        <option value="cotizando">Cotizando</option>
                        <option value="aceptada">Aceptada</option>
                        <option value="pagada">Pagada</option>
                        <option value="cancelada">Cancelada</option>
                      </>}
                      {opTab === 'viajes' && <>
                        <option value="en_ruta">En Ruta</option>
                        <option value="en_progreso">En Progreso</option>
                        <option value="incidencia">Con Incidencia</option>
                        <option value="en_disputa">En Disputa</option>
                        <option value="completada">Completada</option>
                        <option value="cancelado_admin">Cancelada por Admin</option>
                      </>}
                      {opTab === 'historial' && <>
                        <option value="completada">Completada</option>
                      </>}
                    </select>
                  </div>
                  <div className="flex flex-wrap items-center gap-3">
                    <div className="flex items-center gap-2">
                      <Calendar size={15} className="text-gray-400" />
                      <span className="text-sm text-gray-500">Desde:</span>
                      <input type="date" value={opFechaDesde} onChange={e => setOpFechaDesde(e.target.value)} className="px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-gray-500">Hasta:</span>
                      <input type="date" value={opFechaHasta} onChange={e => setOpFechaHasta(e.target.value)} className="px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
                    </div>
                    {/* Filtro empresa — solo en viajes e historial */}
                    {(opTab === 'viajes' || opTab === 'historial') && (
                      <select
                        value={opEmpresaId}
                        onChange={e => setOpEmpresaId(e.target.value)}
                        className="px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 max-w-[200px]"
                      >
                        <option value="">Todas las empresas</option>
                        {empresasActivasMerged.map(e => (
                          <option key={e.id} value={e.id}>{e.nombre}</option>
                        ))}
                      </select>
                    )}
                    {/* Filtro prioridad — solo en solicitudes */}
                    {opTab === 'solicitudes' && (
                      <select
                        value={opPrioridad}
                        onChange={e => setOpPrioridad(e.target.value)}
                        className="px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                      >
                        <option value="">Cualquier prioridad</option>
                        <option value="urgente">🔴 Urgente</option>
                        <option value="alta">🟠 Alta</option>
                        <option value="normal">⚪ Normal</option>
                      </select>
                    )}
                    {(opFechaDesde || opFechaHasta || opEmpresaId || opPrioridad) && (
                      <button onClick={() => { setOpFechaDesde(''); setOpFechaHasta(''); setOpEmpresaId(''); setOpPrioridad(''); }} className="text-xs text-gray-400 hover:text-gray-600 underline">Limpiar filtros</button>
                    )}
                  </div>
                </div>
              )}

              {/* ── TAB: SOLICITUDES ── */}
              {opTab === 'solicitudes' && (
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <table className="w-full">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">ID</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Cliente</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Ruta</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Carga</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Cotiz.</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Status</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Fecha</th>
                        <th className="px-4 py-3"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {solicitudesFiltradas.length === 0 ? (
                        <tr><td colSpan={8} className="py-12 text-center text-gray-400">No hay solicitudes</td></tr>
                      ) : solicitudesFiltradas.map(s => (
                        <tr key={s.id} className="hover:bg-gray-50">
                          <td className="px-4 py-3 font-mono text-xs text-gray-500">{s.id}</td>
                          <td className="px-4 py-3 font-medium text-sm">{_getClienteNombre(s)}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{s.origen} → {s.destino}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{s.carga}</td>
                          <td className="px-4 py-3 text-center">
                            <span className="font-semibold text-blue-600">{s.cotizacionesRecibidas || 0}</span>
                          </td>
                          <td className="px-4 py-3">{getBadge(s.status)}</td>
                          <td className="px-4 py-3 text-xs text-gray-400">{_fmtFecha(s.creadoEn || s.fechaCreacion)}</td>
                          <td className="px-4 py-3">
                            <div className="flex items-center gap-2">
                              <button
                                onClick={() => setOpDetalle({ tipo: 'solicitud', item: s })}
                                className="flex items-center gap-1 px-3 py-1 bg-blue-50 border border-blue-200 text-blue-700 rounded-lg text-xs hover:bg-blue-100 font-medium"
                              >
                                <Eye size={13} /> Ver
                              </button>
                              {['abierta', 'en_cotizacion'].includes(s.status) && (
                                <button
                                  onClick={async () => {
                                    if (!window.confirm(`¿Cancelar solicitud ${s.origen} → ${s.destino}?`)) return;
                                    try {
                                      await apiAdminCancelarSolicitud(s.id);
                                      recargar();
                                    } catch (e) { alert(e?.message || 'Error al cancelar'); }
                                  }}
                                  className="flex items-center gap-1 px-3 py-1 bg-red-50 border border-red-200 text-red-600 rounded-lg text-xs hover:bg-red-100 font-medium"
                                >
                                  ✕ Cancelar
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* ── TAB: VIAJES ── */}
              {opTab === 'viajes' && (
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <table className="w-full">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">ID</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Cliente</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Transportista</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Ruta</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Precio</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Status</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Alerta</th>
                        <th className="px-4 py-3"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {viajesFiltrados.length === 0 ? (
                        <tr><td colSpan={8} className="py-12 text-center text-gray-400">No hay viajes activos</td></tr>
                      ) : viajesFiltrados.map(v => (
                        <tr key={v.id} className={`hover:bg-gray-50 ${v.enDisputa ? 'bg-orange-50' : ''}`}>
                          <td className="px-4 py-3 font-mono text-xs text-gray-500">{v.id}</td>
                          <td className="px-4 py-3 text-sm font-medium">{v.clienteNombre || v.clienteId}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{v.transportistaNombre || v.transportistaId}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{v.origen} → {v.destino}</td>
                          <td className="px-4 py-3 text-sm font-semibold text-green-700">${(v.precio || 0).toLocaleString()}</td>
                          <td className="px-4 py-3">{getBadge(v.status)}</td>
                          <td className="px-4 py-3">
                            {v.enDisputa && <span className="flex items-center gap-1 text-xs text-orange-600 font-semibold"><AlertTriangle size={13}/> Disputa</span>}
                            {v.status === 'incidencia' && <span className="flex items-center gap-1 text-xs text-yellow-600 font-semibold"><AlertCircle size={13}/> Incidencia</span>}
                          </td>
                          <td className="px-4 py-3">
                            <button
                              onClick={() => setOpDetalle({ tipo: 'viaje', item: v })}
                              className="flex items-center gap-1 px-3 py-1 bg-blue-50 border border-blue-200 text-blue-700 rounded-lg text-xs hover:bg-blue-100 font-medium"
                            >
                              <Eye size={13} /> Ver
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* ── TAB: HISTORIAL ── */}
              {opTab === 'historial' && (
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <table className="w-full">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">ID</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Fecha</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Ruta</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Cliente</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Chofer</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Empresa</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Calif.</th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">Evidencias</th>
                        <th className="px-4 py-3"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {historialFiltrado.length === 0 ? (
                        <tr><td colSpan={9} className="py-12 text-center text-gray-400">No hay historial con esos filtros</td></tr>
                      ) : historialFiltrado.map(h => (
                        <tr key={h.id} className="hover:bg-gray-50">
                          <td className="px-4 py-3 font-mono text-xs text-gray-500">{h.id}</td>
                          <td className="px-4 py-3 text-xs text-gray-500">{h.fecha}</td>
                          <td className="px-4 py-3 text-sm font-medium">{h.ruta}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{h.cliente}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{h.choferId}</td>
                          <td className="px-4 py-3 text-sm text-gray-600">{h.empresaId}</td>
                          <td className="px-4 py-3">
                            {h.calificacionRecibida ? (
                              <span className="flex items-center gap-1 text-yellow-600 font-bold text-sm">
                                <Star size={13} fill="currentColor" /> {h.calificacionRecibida}
                              </span>
                            ) : <span className="text-gray-400 text-xs">—</span>}
                          </td>
                          <td className="px-4 py-3">
                            {(h.evidencias || []).length > 0 ? (
                              <span className="flex items-center gap-1 text-blue-600 text-xs font-medium">
                                <Image size={13} /> {h.evidencias.length}
                              </span>
                            ) : <span className="text-gray-400 text-xs">—</span>}
                          </td>
                          <td className="px-4 py-3">
                            <button
                              onClick={() => setOpDetalle({ tipo: 'historial', item: h })}
                              className="flex items-center gap-1 px-3 py-1 bg-blue-50 border border-blue-200 text-blue-700 rounded-lg text-xs hover:bg-blue-100 font-medium"
                            >
                              <Eye size={13} /> Ver
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* ── TAB: POR USUARIO ── */}
              {opTab === 'usuarios' && (
                <div>
                  <div className="mb-5">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Seleccionar usuario</label>
                    <select
                      value={opUsuarioId}
                      onChange={e => setOpUsuarioId(e.target.value)}
                      className="w-full max-w-md px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 text-sm"
                    >
                      <option value="">— Elige un usuario —</option>
                      {['cliente','transportista','chofer'].map(rol => {
                        const uss = usuariosOp.filter(u => u.rol === rol);
                        if (!uss.length) return null;
                        return (
                          <optgroup key={rol} label={rol.charAt(0).toUpperCase() + rol.slice(1) + 's'}>
                            {uss.map(u => <option key={u.id} value={u.id}>{u.nombre} ({u.email})</option>)}
                          </optgroup>
                        );
                      })}
                    </select>
                  </div>
                  {usuarioSeleccionado && actividadUsuario && (
                    <div className="space-y-5">
                      {/* Info del usuario */}
                      <div className="bg-white rounded-xl shadow-lg p-5 flex items-center gap-4">
                        <div className="w-14 h-14 bg-blue-100 rounded-full overflow-hidden flex items-center justify-center text-xl font-bold text-blue-700">
                          {usuarioSeleccionado.avatar
                            ? <img src={usuarioSeleccionado.avatar} alt={usuarioSeleccionado.nombre} className="w-full h-full object-cover" />
                            : usuarioSeleccionado.nombre?.charAt(0)?.toUpperCase()}
                        </div>
                        <div>
                          <p className="text-xl font-bold text-gray-800">{usuarioSeleccionado.nombre}</p>
                          <p className="text-sm text-gray-500">{usuarioSeleccionado.email} · {usuarioSeleccionado.telefono || '—'}</p>
                          <span className={`text-xs px-2 py-0.5 rounded-full font-semibold mt-1 inline-block ${usuarioSeleccionado.rol === 'cliente' ? 'bg-blue-100 text-blue-700' : usuarioSeleccionado.rol === 'transportista' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                            {usuarioSeleccionado.rol}
                          </span>
                          {usuarioSeleccionado.rol === 'cliente' && (
                            <div className="mt-2 flex items-center gap-2">
                              <button
                                onClick={async () => {
                                  try {
                                    await apiAdminToggleReferidor(usuarioSeleccionado.id, !usuarioSeleccionado.esReferidor);
                                    recargar();
                                  } catch (e) {
                                    alert(e.message || 'Error al actualizar');
                                  }
                                }}
                                className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${usuarioSeleccionado.esReferidor ? 'bg-orange-500' : 'bg-gray-300'}`}
                              >
                                <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform ${usuarioSeleccionado.esReferidor ? 'translate-x-4.5' : 'translate-x-0.5'}`} />
                              </button>
                              <span className="text-xs font-medium text-gray-600">
                                {usuarioSeleccionado.esReferidor ? '✅ Habilitado como referidor MLM' : 'Habilitar como referidor MLM'}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Solicitudes del cliente */}
                      {usuarioSeleccionado.rol === 'cliente' && (
                        <div className="bg-white rounded-xl shadow-lg p-5">
                          <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><Package size={16}/> Solicitudes ({actividadUsuario.solicitudes.length})</h4>
                          {actividadUsuario.solicitudes.length === 0 ? <p className="text-gray-400 text-sm">Sin solicitudes</p> : (
                            <div className="space-y-2">
                              {actividadUsuario.solicitudes.map(s => (
                                <div key={s.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                  <div>
                                    <p className="font-mono text-xs text-gray-400">{s.id}</p>
                                    <p className="text-sm font-medium">{s.origen} → {s.destino}</p>
                                    <p className="text-xs text-gray-500">{s.carga} · {_fmtFecha(s.creadoEn || s.fechaCreacion)}</p>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    {getBadge(s.status)}
                                    <button onClick={() => setOpDetalle({ tipo: 'solicitud', item: s })} className="text-blue-500 hover:text-blue-700"><Eye size={15}/></button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}

                      {/* Viajes del transportista */}
                      {usuarioSeleccionado.rol === 'transportista' && (
                        <div className="bg-white rounded-xl shadow-lg p-5">
                          <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><Truck size={16}/> Viajes activos ({actividadUsuario.viajes.length})</h4>
                          {actividadUsuario.viajes.length === 0 ? <p className="text-gray-400 text-sm">Sin viajes activos</p> : (
                            <div className="space-y-2">
                              {actividadUsuario.viajes.map(v => (
                                <div key={v.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                  <div>
                                    <p className="font-mono text-xs text-gray-400">{v.id}</p>
                                    <p className="text-sm font-medium">{v.origen} → {v.destino}</p>
                                    <p className="text-xs text-gray-500">{v.clienteNombre} · ${(v.precio || 0).toLocaleString()}</p>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    {getBadge(v.status)}
                                    <button onClick={() => setOpDetalle({ tipo: 'viaje', item: v })} className="text-blue-500 hover:text-blue-700"><Eye size={15}/></button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}

                      {/* Órdenes del chofer */}
                      {usuarioSeleccionado.rol === 'chofer' && (
                        <>
                          <div className="bg-white rounded-xl shadow-lg p-5">
                            <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><Truck size={16}/> Órdenes activas ({actividadUsuario.ordenes.length})</h4>
                            {actividadUsuario.ordenes.length === 0 ? <p className="text-gray-400 text-sm">Sin órdenes activas</p> : (
                              <div className="space-y-2">
                                {actividadUsuario.ordenes.map(o => (
                                  <div key={o.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                    <div>
                                      <p className="font-mono text-xs text-gray-400">{o.id}</p>
                                      <p className="text-sm font-medium">{o.origen} → {o.destino}</p>
                                      <p className="text-xs text-gray-500">{o.cliente} · {_fmtFecha(o.creadoEn)}</p>
                                    </div>
                                    {getBadge(o.status)}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          <div className="bg-white rounded-xl shadow-lg p-5">
                            <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><CheckCircle size={16}/> Historial de entregas ({actividadUsuario.historial.length})</h4>
                            {actividadUsuario.historial.length === 0 ? <p className="text-gray-400 text-sm">Sin entregas</p> : (
                              <div className="space-y-2">
                                {actividadUsuario.historial.map(h => (
                                  <div key={h.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                                    <div>
                                      <p className="font-mono text-xs text-gray-400">{h.id}</p>
                                      <p className="text-sm font-medium">{h.ruta}</p>
                                      <p className="text-xs text-gray-500">{h.fecha} · {h.cliente}</p>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      {getBadge(h.status)}
                                      <button onClick={() => setOpDetalle({ tipo: 'historial', item: h })} className="text-blue-500 hover:text-blue-700"><Eye size={15}/></button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* ── MODAL DETALLE ── */}
              {opDetalle && (() => {
                const { tipo, item } = opDetalle;
                const isViaje = tipo === 'viaje';
                const isSolicitud = tipo === 'solicitud';
                const isHistorial = tipo === 'historial';

                // Datos relacionados
                const msgViaje = todosMensajes.filter(m => m.viajeId === item.id || m.viajeId === item.viajeId);
                const cotizacionesSol = item.cotizaciones || (store.cotizaciones || []).filter(c => c.solicitudId === item.id);
                const notifItem = todasNotifs.filter(n => n.datos?.viajeId === item.id || n.datos?.solicitudId === item.id);
                const incidencias = notifItem.filter(n => ['incidencia_transportista','incidencia_cliente'].includes(n.tipo));
                const ordenChoferViaje = isViaje
                  ? (todasOrdenesChofer.find(o => o.viajeId === item.id) || item.ordenesChofer?.[0])
                  : null;
                const histEntrega = isViaje ? (item.ordenesChofer?.[0]?.historialEntregas?.[0] || null) : null;
                const solicitudOriginal = isViaje && item.solicitudId ? todasSolicitudes.find(s => s.id === item.solicitudId) : null;

                // Usuarios para contacto
                const usuarioCliente = (store.usuarios || []).find(u => u.id === (item.clienteId));
                const usuarioTransportista = (store.usuarios || []).find(u => u.id === item.transportistaId);
                const choferViaje = isViaje
                  ? (store.plantillaChoferes || []).find(c => c.id === item.choferId) || (store.usuarios || []).find(u => u.id === item.choferId)
                  : null;

                // Timeline: construir eventos cronológicos
                const timelineEvents = [];
                if (item.fechaCreacion) timelineEvents.push({ fecha: item.fechaCreacion, label: isSolicitud ? 'Solicitud creada' : 'Viaje iniciado', color: 'bg-blue-400' });
                if (isViaje) {
                  const cotAceptada = (store.cotizaciones || []).find(c => c.solicitudId === item.solicitudId && c.status === 'aceptada');
                  if (cotAceptada?.fechaCreacion) timelineEvents.push({ fecha: cotAceptada.fechaCreacion, label: `Cotización aceptada — $${(cotAceptada.precio || 0).toLocaleString()}`, color: 'bg-green-400' });
                  if (item.fechaPago) timelineEvents.push({ fecha: item.fechaPago, label: 'Pago realizado', color: 'bg-green-500' });
                  if (item.fechaInicio) timelineEvents.push({ fecha: item.fechaInicio, label: 'Viaje en ruta', color: 'bg-yellow-400' });
                }
                incidencias.forEach(n => timelineEvents.push({ fecha: n.fecha, label: `Incidencia: ${n.titulo}`, color: 'bg-orange-400' }));
                if (item.fechaDisputa) timelineEvents.push({ fecha: item.fechaDisputa, label: 'Disputa abierta', color: 'bg-orange-600' });
                if (item.fechaResolucion) timelineEvents.push({ fecha: item.fechaResolucion, label: `Disputa resuelta: ${item.resolucionDisputa || ''}`, color: 'bg-teal-500' });
                if (item.fechaCancelacion) timelineEvents.push({ fecha: item.fechaCancelacion, label: `Cancelado por admin: ${item.motivoCancelacionAdmin || ''}`, color: 'bg-red-500' });
                if (item.fechaCompletadoAdmin) timelineEvents.push({ fecha: item.fechaCompletadoAdmin, label: `Completado por admin: ${item.motivoForzar || ''}`, color: 'bg-purple-500' });
                (item.logAdmin || []).forEach(l => {
                  const labels = { agregar_nota: 'Nota admin', cancelar_solicitud: 'Cancelado por admin', cancelar_viaje: 'Viaje cancelado por admin', abrir_disputa: 'Disputa abierta', resolver_disputa: 'Disputa resuelta', forzar_completar: 'Completado por admin' };
                  if (!timelineEvents.some(e => e.fecha === l.fecha)) timelineEvents.push({ fecha: l.fecha, label: `${labels[l.accion] || l.accion}: ${l.detalle}`, color: 'bg-gray-400', esAdmin: true });
                });
                timelineEvents.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

                // Filtro de chat
                const msgFiltrados = msgViaje.filter(m => {
                  if (opChatFiltro === 'cliente_transportista') return m.emisorRol !== 'chofer' && m.destinatarioRol !== 'chofer';
                  if (opChatFiltro === 'chofer_transportista') return m.emisorRol === 'chofer' || m.destinatarioRol === 'chofer' || m.emisorRol === 'transportista';
                  return true;
                });

                // Helper para refrescar el item
                const _refresh = () => {
                  const src = isSolicitud ? getStore().solicitudes : getStore().viajes;
                  const updated = (src || []).find(x => x.id === item.id);
                  if (updated) setOpDetalle({ tipo, item: updated });
                };

                return (
                  <>
                    {/* Lightbox fotos */}
                    {opLightbox && (
                      <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[3000]" onClick={() => setOpLightbox(null)}>
                        <img src={opLightbox} alt="foto" className="max-w-[90vw] max-h-[90vh] object-contain rounded-xl shadow-2xl" />
                        <button className="absolute top-4 right-4 text-white hover:text-gray-300"><X size={32}/></button>
                      </div>
                    )}

                    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-start justify-center p-4 z-[2000] overflow-y-auto">
                      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl my-6">

                        {/* Header */}
                        <div className="p-6 border-b flex justify-between items-start">
                          <div>
                            <div className="flex items-center gap-3 mb-1 flex-wrap">
                              <span className="font-mono text-sm text-gray-400">{item.id}</span>
                              {getBadge(item.status)}
                              {isViaje && item.enDisputa && <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-orange-100 text-orange-700 flex items-center gap-1"><AlertTriangle size={11}/> EN DISPUTA</span>}
                              {item.completadoPorAdmin && <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-purple-100 text-purple-700">Completado por admin</span>}
                              {item.canceladaPorAdmin && <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-red-100 text-red-700">Cancelado por admin</span>}
                            </div>
                            <h3 className="text-xl font-bold text-gray-800">
                              {isHistorial ? item.ruta : `${item.origen} → ${item.destino}`}
                            </h3>
                            <p className="text-sm text-gray-500">{_fmtFecha(item.creadoEn || item.fechaCreacion || item.fecha)}</p>
                          </div>
                          <div className="flex items-center gap-2">
                            {isViaje && solicitudOriginal && (
                              <button
                                onClick={() => { setOpDetalle({ tipo: 'solicitud', item: solicitudOriginal }); setOpVerSolicitudOriginal(false); setOpChatFiltro('todos'); }}
                                className="flex items-center gap-1 px-3 py-1.5 bg-indigo-50 border border-indigo-200 text-indigo-700 rounded-lg text-xs font-semibold hover:bg-indigo-100"
                              >
                                <FileText size={13}/> Ver solicitud
                              </button>
                            )}
                            {isSolicitud && (() => {
                              const viajeDeEstaSol = todosViajes.find(v => v.solicitudId === item.id);
                              if (!viajeDeEstaSol) return null;
                              return (
                                <button
                                  onClick={() => { setOpDetalle({ tipo: 'viaje', item: viajeDeEstaSol }); setOpChatFiltro('todos'); }}
                                  className="flex items-center gap-1 px-3 py-1.5 bg-green-50 border border-green-200 text-green-700 rounded-lg text-xs font-semibold hover:bg-green-100"
                                >
                                  <Eye size={13}/> Ver viaje y evidencias
                                </button>
                              );
                            })()}
                            <button onClick={() => { setOpDetalle(null); setOpChatFiltro('todos'); setOpLightbox(null); }} className="text-gray-400 hover:text-gray-600"><X size={24}/></button>
                          </div>
                        </div>

                        <div className="p-6 space-y-6 overflow-y-auto max-h-[70vh]">

                          {/* Partes involucradas con contacto */}
                          <div>
                            <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><Users size={15}/> Partes involucradas</h4>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                              {(isSolicitud || isViaje) && (
                                <div className="p-3 bg-blue-50 rounded-xl">
                                  <p className="text-xs text-blue-600 font-semibold mb-1">CLIENTE</p>
                                  <p className="font-medium text-sm">{item.clienteNombre || item.clienteId || '—'}</p>
                                  {usuarioCliente?.telefono && <p className="text-xs text-gray-500 flex items-center gap-1 mt-1"><Phone size={11}/> {usuarioCliente.telefono}</p>}
                                  {usuarioCliente?.email && <p className="text-xs text-gray-500 flex items-center gap-1"><Mail size={11}/> {usuarioCliente.email}</p>}
                                </div>
                              )}
                              {isViaje && (
                                <div className="p-3 bg-green-50 rounded-xl">
                                  <p className="text-xs text-green-600 font-semibold mb-1">TRANSPORTISTA</p>
                                  <p className="font-medium text-sm">{item.transportistaNombre || item.transportistaId || '—'}</p>
                                  {usuarioTransportista?.telefono && <p className="text-xs text-gray-500 flex items-center gap-1 mt-1"><Phone size={11}/> {usuarioTransportista.telefono}</p>}
                                  {usuarioTransportista?.email && <p className="text-xs text-gray-500 flex items-center gap-1"><Mail size={11}/> {usuarioTransportista.email}</p>}
                                </div>
                              )}
                              {isViaje && choferViaje && (
                                <div className="p-3 bg-yellow-50 rounded-xl">
                                  <p className="text-xs text-yellow-600 font-semibold mb-1">CHOFER</p>
                                  <p className="font-medium text-sm">{choferViaje.nombre}</p>
                                  {choferViaje.telefono && <p className="text-xs text-gray-500 flex items-center gap-1 mt-1"><Phone size={11}/> {choferViaje.telefono}</p>}
                                  {choferViaje.email && <p className="text-xs text-gray-500 flex items-center gap-1"><Mail size={11}/> {choferViaje.email}</p>}
                                </div>
                              )}
                              {isHistorial && (
                                <>
                                  <div className="p-3 bg-blue-50 rounded-xl"><p className="text-xs text-blue-600 font-semibold mb-1">CLIENTE</p><p className="font-medium text-sm">{item.cliente || '—'}</p></div>
                                  <div className="p-3 bg-yellow-50 rounded-xl"><p className="text-xs text-yellow-600 font-semibold mb-1">CHOFER ID</p><p className="font-medium text-sm">{item.choferId || '—'}</p></div>
                                  <div className="p-3 bg-green-50 rounded-xl"><p className="text-xs text-green-600 font-semibold mb-1">EMPRESA ID</p><p className="font-medium text-sm">{item.empresaId || '—'}</p></div>
                                </>
                              )}
                            </div>
                          </div>

                          {/* Orden del chofer (solo viajes) */}
                          {isViaje && ordenChoferViaje && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><Truck size={15}/> Orden del chofer</h4>
                              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border">
                                <div>
                                  <p className="font-mono text-xs text-gray-400 mb-0.5">{ordenChoferViaje.id}</p>
                                  <p className="text-sm font-medium">{ordenChoferViaje.origen} → {ordenChoferViaje.destino}</p>
                                  <p className="text-xs text-gray-500 mt-1">Unidad: {ordenChoferViaje.unidad} · {ordenChoferViaje.fechaRecogida} {ordenChoferViaje.horaRecogida}</p>
                                  {ordenChoferViaje.instrucciones && <p className="text-xs text-gray-400 mt-1 italic">{ordenChoferViaje.instrucciones}</p>}
                                </div>
                                <div className="text-right">
                                  {getBadge(ordenChoferViaje.status)}
                                  <p className="text-xs text-gray-400 mt-1">{ordenChoferViaje.distancia}</p>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Timeline */}
                          {timelineEvents.length > 0 && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><Activity size={15}/> Línea de tiempo</h4>
                              <div className="relative pl-5">
                                <div className="absolute left-2 top-0 bottom-0 w-px bg-gray-200" />
                                <div className="space-y-3">
                                  {timelineEvents.map((ev, i) => (
                                    <div key={i} className="flex items-start gap-3">
                                      <div className={`w-3 h-3 rounded-full flex-shrink-0 mt-0.5 -ml-1.5 border-2 border-white shadow ${ev.color}`} />
                                      <div className="flex-1 min-w-0">
                                        <p className={`text-sm font-medium ${ev.esAdmin ? 'text-purple-700' : 'text-gray-700'}`}>{ev.label}</p>
                                        <p className="text-xs text-gray-400">{_fmtFecha(ev.fecha)}</p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Detalles del servicio */}
                          <div>
                            <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><FileText size={15}/> Detalles del servicio</h4>
                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
                              {/* Descripción de la carga */}
                              {(item.descripcion || item.carga) && <div className="p-3 bg-gray-50 rounded-lg col-span-2 sm:col-span-3"><p className="text-xs text-gray-400 mb-0.5">Descripción de la carga</p><p className="font-medium">{item.descripcion || item.carga}</p></div>}
                              {/* Peso y volumen */}
                              {item.peso && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Peso</p><p className="font-medium">{item.peso} tons</p></div>}
                              {item.volumen && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Volumen</p><p className="font-medium">{item.volumen} m³</p></div>}
                              {/* Tipo de vehículo */}
                              {(item.tipoVehiculo || item.tipoUnidad) && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Tipo de vehículo</p><p className="font-medium">{item.tipoVehiculo || item.tipoUnidad}</p></div>}
                              {/* Precio (viajes) */}
                              {item.precio > 0 && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Precio</p><p className="font-bold text-green-700">${item.precio.toLocaleString()}</p></div>}
                              {/* Fecha de recogida */}
                              {(item.fechaRecogida || item.fecha) && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Fecha de recogida</p><p className="font-medium">{item.fechaRecogida || item.fecha}</p></div>}
                              {/* Prioridad */}
                              {isSolicitud && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Prioridad</p><p className={`font-semibold ${item.esUrgente ? 'text-red-600' : 'text-gray-600'}`}>{item.esUrgente ? '🔴 Urgente' : 'Normal'}</p></div>}
                              {/* Cotizaciones */}
                              {isSolicitud && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Cotizaciones</p><p className="font-medium">{item.cotizacionesRecibidas || 0} / {item.maxCotizaciones || 10}</p></div>}
                              {/* Oleada actual */}
                              {isSolicitud && item.oleadaActual && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Oleada actual</p><p className="font-medium">Oleada {item.oleadaActual}</p></div>}
                              {/* Fecha expiración */}
                              {isSolicitud && item.fechaExpiracion && <div className="p-3 bg-gray-50 rounded-lg"><p className="text-xs text-gray-400 mb-0.5">Expira</p><p className={`font-medium text-sm ${new Date(item.fechaExpiracion) < new Date() ? 'text-red-600' : 'text-gray-700'}`}>{_fmtFecha(item.fechaExpiracion)}</p></div>}
                              {/* Notas */}
                              {item.notas && <div className="p-3 bg-gray-50 rounded-lg col-span-2 sm:col-span-3"><p className="text-xs text-gray-400 mb-0.5">Notas del cliente</p><p className="text-sm">{item.notas}</p></div>}
                            </div>
                            {/* Fotos del flete */}
                            {isSolicitud && (item.fotos || []).length > 0 && (
                              <div className="mt-3">
                                <p className="text-xs text-gray-400 mb-2">Fotos del flete</p>
                                <div className="flex flex-wrap gap-2">
                                  {(item.fotos || []).map((foto, i) => (
                                    <img key={i} src={foto} alt={`foto-${i}`} className="w-24 h-20 object-cover rounded-lg border cursor-pointer hover:opacity-80 transition-opacity" onClick={() => setOpLightbox(foto)} />
                                  ))}
                                </div>
                              </div>
                            )}
                            {item.motivoCancelacion && (
                              <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                                <p className="text-xs font-bold text-red-600 mb-1">MOTIVO DE CANCELACIÓN (CLIENTE)</p>
                                <p className="text-sm text-red-700">{item.motivoCancelacion}</p>
                              </div>
                            )}
                            {item.motivoCancelacionAdmin && (
                              <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                                <p className="text-xs font-bold text-red-600 mb-1">CANCELADO POR ADMIN</p>
                                <p className="text-sm text-red-700">{item.motivoCancelacionAdmin}</p>
                              </div>
                            )}
                            {item.enDisputa && item.motivoDisputa && (
                              <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                                <p className="text-xs font-bold text-orange-600 mb-1">MOTIVO DE DISPUTA</p>
                                <p className="text-sm text-orange-700">{item.motivoDisputa}</p>
                                <p className="text-xs text-gray-400 mt-1">{_fmtFecha(item.fechaDisputa)}</p>
                              </div>
                            )}
                            {item.resolucionDisputa && (
                              <div className="mt-3 p-3 bg-teal-50 border border-teal-200 rounded-lg">
                                <p className="text-xs font-bold text-teal-600 mb-1">RESOLUCIÓN DE DISPUTA</p>
                                <p className="text-sm text-teal-700">{item.resolucionDisputa}</p>
                                <p className="text-xs text-gray-400 mt-1">{_fmtFecha(item.fechaResolucion)}</p>
                              </div>
                            )}
                          </div>

                          {/* Cotizaciones (solo solicitudes) */}
                          {isSolicitud && cotizacionesSol.length > 0 && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><DollarSign size={15}/> Cotizaciones recibidas ({cotizacionesSol.length})</h4>
                              <div className="space-y-2">
                                {cotizacionesSol.map(c => (
                                  <div key={c.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border">
                                    <div>
                                      <p className="text-sm font-medium">{c.transportistaNombre}</p>
                                      <p className="text-xs text-gray-500">{c.unidadOfrecida} · {c.tiempoEntrega}</p>
                                      {(c.notas || c.comentario) && <p className="text-xs text-gray-400 mt-1 italic">"{c.notas || c.comentario}"</p>}
                                    </div>
                                    <div className="text-right">
                                      <p className="font-bold text-green-700">${(c.precio || 0).toLocaleString()}</p>
                                      {getBadge(c.status)}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Incidencias */}
                          {isViaje && incidencias.length > 0 && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><AlertCircle size={15}/> Incidencias ({incidencias.length})</h4>
                              <div className="space-y-2">
                                {incidencias.map(n => (
                                  <div key={n.id} className="p-3 bg-orange-50 border border-orange-100 rounded-lg">
                                    <div className="flex items-center justify-between mb-1">
                                      <p className="text-xs font-bold text-orange-600">{n.tipo === 'incidencia_cliente' ? 'Notificado al cliente' : 'Solo transportista'}</p>
                                      <p className="text-xs text-gray-400">{_fmtFecha(n.fecha)}</p>
                                    </div>
                                    <p className="text-sm font-medium">{n.titulo}</p>
                                    <p className="text-sm text-gray-600">{n.mensaje}</p>
                                    {n.datos?.foto && (
                                      <img src={n.datos.foto} alt="incidencia" className="mt-2 w-24 h-20 object-cover rounded-lg cursor-pointer border hover:opacity-80" onClick={() => setOpLightbox(n.datos.foto)} />
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Chat con filtro por canal */}
                          {isViaje && msgViaje.length > 0 && (
                            <div>
                              <div className="flex items-center justify-between mb-3">
                                <h4 className="font-bold text-gray-700 flex items-center gap-2"><MessageSquare size={15}/> Chat ({msgViaje.length} mensajes)</h4>
                                <div className="flex gap-1">
                                  {[
                                    { id: 'todos', label: 'Todos' },
                                    { id: 'cliente_transportista', label: 'Cliente ↔ Transportista' },
                                    { id: 'chofer_transportista', label: 'Chofer ↔ Transportista' },
                                  ].map(f => (
                                    <button
                                      key={f.id}
                                      onClick={() => setOpChatFiltro(f.id)}
                                      className={`px-2 py-1 rounded text-xs font-semibold transition-colors ${opChatFiltro === f.id ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}
                                    >
                                      {f.label}
                                    </button>
                                  ))}
                                </div>
                              </div>
                              <div className="bg-gray-50 rounded-xl p-3 space-y-2 max-h-52 overflow-y-auto">
                                {msgFiltrados.length === 0 ? (
                                  <p className="text-gray-400 text-sm text-center py-4">Sin mensajes en este canal</p>
                                ) : msgFiltrados.map(m => (
                                  <div key={m.id} className="flex gap-2">
                                    <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${m.emisorRol === 'cliente' ? 'bg-blue-400' : m.emisorRol === 'transportista' ? 'bg-green-400' : 'bg-yellow-400'}`} />
                                    <div className="flex-1 min-w-0">
                                      <span className="text-xs font-semibold text-gray-600">{m.emisorNombre}</span>
                                      {m.destinatarioRol && <span className="text-xs text-gray-400 ml-1">→ {m.destinatarioRol}</span>}
                                      <span className="text-xs text-gray-300 ml-2">{_fmtFecha(m.creadoEn)}</span>
                                      <p className="text-sm text-gray-700">{m.texto}</p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Info de entrega completada */}
                          {isViaje && (histEntrega || item.firmaEntrega || (item.evidenciasEntrega || []).length > 0) && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><CheckCircle size={15} className="text-green-500"/> Entrega completada</h4>
                              <div className="space-y-3">
                                {histEntrega?.fecha && (
                                  <div className="p-3 bg-green-50 border border-green-100 rounded-lg">
                                    <p className="text-xs text-green-600 font-semibold mb-0.5">FECHA Y HORA DE ENTREGA</p>
                                    <p className="text-sm font-medium text-gray-800">{_fmtFecha(histEntrega.fecha)}</p>
                                  </div>
                                )}
                                {(item.evidenciasEntrega || histEntrega?.evidencias || []).length > 0 && (
                                  <div>
                                    <p className="text-xs text-gray-500 mb-2 font-semibold">EVIDENCIAS FOTOGRÁFICAS</p>
                                    <div className="flex flex-wrap gap-2">
                                      {(item.evidenciasEntrega || histEntrega?.evidencias || []).map((ev, i) => (
                                        <img key={i} src={ev.base64 || ev} alt={`ev-${i}`}
                                          className="w-24 h-20 object-cover rounded-lg border cursor-pointer hover:opacity-80 transition-opacity"
                                          onClick={() => setOpLightbox(ev.base64 || ev)} />
                                      ))}
                                    </div>
                                  </div>
                                )}
                                {item.firmaEntrega && (
                                  <div>
                                    <p className="text-xs text-gray-500 mb-2 font-semibold">FIRMA DE CONFORMIDAD</p>
                                    <img src={item.firmaEntrega} alt="firma"
                                      className="h-24 border rounded-lg bg-white p-2 cursor-pointer hover:opacity-80"
                                      onClick={() => setOpLightbox(item.firmaEntrega)} />
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          {/* Evidencias de entrega (historial) */}
                          {isHistorial && (item.evidencias || []).length > 0 && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><Image size={15}/> Evidencias de entrega</h4>
                              <div className="flex flex-wrap gap-2">
                                {(item.evidencias || []).map((ev, i) => (
                                  <img key={i} src={ev.base64 || ev} alt={`evidencia-${i}`}
                                    className="w-24 h-20 object-cover rounded-lg border cursor-pointer hover:opacity-80 transition-opacity"
                                    onClick={() => setOpLightbox(ev.base64 || ev)} />
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Log de acciones admin */}
                          {(item.logAdmin || []).length > 0 && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><Shield size={15}/> Historial de acciones admin</h4>
                              <div className="space-y-1.5">
                                {(item.logAdmin || []).map((l, i) => {
                                  const ACCION_LABELS = { cancelar_solicitud: '🚫 Canceló solicitud', cancelar_viaje: '🚫 Canceló viaje', abrir_disputa: '⚠️ Abrió disputa', resolver_disputa: '✅ Resolvió disputa', forzar_completar: '✔️ Forzó completar', agregar_nota: '📝 Agregó nota' };
                                  return (
                                    <div key={i} className="flex items-start justify-between p-2.5 bg-purple-50 border border-purple-100 rounded-lg">
                                      <div className="flex-1">
                                        <p className="text-xs font-bold text-purple-700">{ACCION_LABELS[l.accion] || l.accion} <span className="font-normal text-purple-500">por {l.autor}</span></p>
                                        {l.detalle && <p className="text-xs text-gray-600 mt-0.5">"{l.detalle}"</p>}
                                      </div>
                                      <p className="text-xs text-gray-400 whitespace-nowrap ml-3">{_fmtFecha(l.fecha)}</p>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}

                          {/* Notas admin */}
                          {(item.notasAdmin || []).length > 0 && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><StickyNote size={15}/> Notas internas</h4>
                              <div className="space-y-2">
                                {(item.notasAdmin || []).map((n, i) => (
                                  <div key={i} className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                                    <div className="flex items-center justify-between mb-1">
                                      <p className="text-xs font-semibold text-yellow-700">{n.autor}</p>
                                      <p className="text-xs text-gray-400">{_fmtFecha(n.fecha)}</p>
                                    </div>
                                    <p className="text-sm text-gray-700">{n.texto}</p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Agregar nota */}
                          {(isSolicitud || isViaje) && (
                            <div>
                              <h4 className="font-bold text-gray-700 mb-2 flex items-center gap-2"><StickyNote size={15}/> Agregar nota interna</h4>
                              <div className="flex gap-2">
                                <textarea
                                  value={opNota}
                                  onChange={e => setOpNota(e.target.value)}
                                  placeholder="Escribe una nota interna..."
                                  rows={2}
                                  className="flex-1 px-3 py-2 border border-gray-200 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-300"
                                />
                                <button
                                  onClick={() => {
                                    if (!opNota.trim()) return;
                                    adminAgregarNota(tipo, item.id, opNota.trim(), usuario?.nombre || 'Admin');
                                    setOpNota('');
                                    _refresh();
                                  }}
                                  className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 text-sm font-semibold whitespace-nowrap"
                                >
                                  Guardar nota
                                </button>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Chat directo admin → partes */}
                        {isViaje && (
                          <div>
                            <h4 className="font-bold text-gray-700 mb-3 flex items-center gap-2"><MessageSquare size={15}/> Mensaje directo a parte involucrada</h4>
                            <div className="bg-blue-50 rounded-xl p-4 space-y-3">
                              <div className="flex gap-2">
                                {[
                                  { id: 'cliente', label: 'Cliente', color: 'bg-blue-600' },
                                  { id: 'transportista', label: 'Transportista', color: 'bg-green-600' },
                                ].map(p => (
                                  <button
                                    key={p.id}
                                    onClick={() => setOpMsgDestinatario(opMsgDestinatario === p.id ? '' : p.id)}
                                    className={`px-3 py-1.5 rounded-lg text-sm font-semibold transition-colors ${opMsgDestinatario === p.id ? `${p.color} text-white` : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'}`}
                                  >
                                    {p.label}
                                  </button>
                                ))}
                              </div>
                              {opMsgDestinatario && (
                                <div className="flex gap-2">
                                  <input
                                    value={opMsgAdmin}
                                    onChange={e => setOpMsgAdmin(e.target.value)}
                                    onKeyDown={async e => {
                                      if (e.key === 'Enter' && !e.shiftKey && opMsgAdmin.trim()) {
                                        e.preventDefault();
                                        const texto = opMsgAdmin.trim();
                                        setOpMsgAdmin('');
                                        try {
                                          await apiEnviarMensaje({ viajeId: item.id, texto, destinatarioRol: opMsgDestinatario });
                                          storeEnviarMensaje(item.id, usuario?.id || 'admin', `Admin (${usuario?.nombre || 'Choyero'})`, 'admin', texto, opMsgDestinatario);
                                        } catch { /* fallo silencioso — el mensaje no se enviará */ }
                                      }
                                    }}
                                    placeholder={`Mensaje para el ${opMsgDestinatario}...`}
                                    className="flex-1 px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 bg-white"
                                  />
                                  <button
                                    onClick={async () => {
                                      if (!opMsgAdmin.trim()) return;
                                      const texto = opMsgAdmin.trim();
                                      setOpMsgAdmin('');
                                      try {
                                        await apiEnviarMensaje({ viajeId: item.id, texto, destinatarioRol: opMsgDestinatario });
                                        storeEnviarMensaje(item.id, usuario?.id || 'admin', `Admin (${usuario?.nombre || 'Choyero'})`, 'admin', texto, opMsgDestinatario);
                                      } catch { /* fallo silencioso — el mensaje no se enviará */ }
                                    }}
                                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-semibold"
                                  >
                                    Enviar
                                  </button>
                                </div>
                              )}
                              <p className="text-xs text-blue-500">El mensaje aparecerá en el chat del viaje para la parte seleccionada.</p>
                            </div>
                          </div>
                        )}

                        {/* Footer: acciones de intervención */}
                        {(isSolicitud || isViaje) && (
                          <div className="p-5 border-t bg-gray-50 rounded-b-2xl">
                            <p className="text-xs font-bold text-gray-500 uppercase mb-3">Acciones de intervención</p>
                            {opConfirmarAccion ? (
                              <div className="bg-white border border-red-200 rounded-xl p-4">
                                <p className="text-sm font-bold text-red-700 mb-2">{opConfirmarAccion.label}</p>
                                <textarea
                                  value={opMotivo}
                                  onChange={e => setOpMotivo(e.target.value)}
                                  placeholder="Motivo obligatorio..."
                                  rows={2}
                                  className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-red-300 mb-3"
                                />
                                <div className="flex gap-2">
                                  <button
                                    onClick={() => {
                                      if (!opMotivo.trim()) return;
                                      opConfirmarAccion.accion(opMotivo.trim());
                                      setOpConfirmarAccion(null);
                                      setOpMotivo('');
                                      setTimeout(_refresh, 50);
                                    }}
                                    className="px-5 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 text-sm font-bold"
                                  >
                                    Confirmar
                                  </button>
                                  <button onClick={() => { setOpConfirmarAccion(null); setOpMotivo(''); }} className="px-5 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 text-sm font-semibold">
                                    Cancelar
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="flex flex-wrap gap-2">
                                {isSolicitud && item.status !== 'cancelada' && (
                                  <button
                                    onClick={() => setOpConfirmarAccion({ label: '¿Cancelar esta solicitud?', accion: async (m) => { adminCancelarSolicitud(item.id, m, usuario?.nombre); try { await apiAdminCancelarSolicitud(item.id); recargar(); } catch (e) { alert(e?.message || 'Error al cancelar en servidor'); } } })}
                                    className="flex items-center gap-2 px-4 py-2 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm font-semibold hover:bg-red-100"
                                  >
                                    <Ban size={15}/> Cancelar solicitud
                                  </button>
                                )}
                                {isViaje && !['cancelado','completada'].includes(item.status) && (
                                  <button
                                    onClick={() => setOpConfirmarAccion({ label: '¿Cancelar este viaje?', accion: async (m) => {
                                      adminCancelarViaje(item.id, m, usuario?.nombre);
                                      try { await apiCancelarViaje(item.id, m); recargar(); } catch (e) { alert(e?.message || 'Error al cancelar en servidor'); }
                                    } })}
                                    className="flex items-center gap-2 px-4 py-2 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm font-semibold hover:bg-red-100"
                                  >
                                    <Ban size={15}/> Cancelar viaje
                                  </button>
                                )}
                                {isViaje && !item.enDisputa && !['completada','cancelado'].includes(item.status) && (
                                  <button
                                    onClick={() => setOpConfirmarAccion({ label: '¿Abrir disputa para este viaje?', accion: async (m) => {
                                      adminMarcarDisputa(item.id, m, usuario?.nombre);
                                      try { await apiAdminAbrirDisputa(item.id, m); recargar(); } catch (e) { alert(e?.message || 'Error al abrir disputa en servidor'); }
                                    } })}
                                    className="flex items-center gap-2 px-4 py-2 bg-orange-50 border border-orange-200 text-orange-700 rounded-lg text-sm font-semibold hover:bg-orange-100"
                                  >
                                    <Flag size={15}/> Abrir disputa
                                  </button>
                                )}
                                {isViaje && item.enDisputa && (
                                  <button
                                    onClick={() => setOpConfirmarAccion({ label: '¿Resolver la disputa? Escribe la resolución:', accion: async (m) => {
                                      adminResolverDisputa(item.id, m, usuario?.nombre);
                                      try { await apiAdminResolverDisputa(item.id, m); recargar(); } catch (e) { alert(e?.message || 'Error al resolver disputa en servidor'); }
                                    } })}
                                    className="flex items-center gap-2 px-4 py-2 bg-teal-50 border border-teal-200 text-teal-700 rounded-lg text-sm font-semibold hover:bg-teal-100"
                                  >
                                    <CheckCircle size={15}/> Resolver disputa
                                  </button>
                                )}
                                {isViaje && !['completada','cancelado'].includes(item.status) && (
                                  <button
                                    onClick={() => setOpConfirmarAccion({ label: '¿Forzar completar este viaje?', accion: async (m) => {
                                      adminForzarCompletar(item.id, m, usuario?.nombre);
                                      try { await apiAdminCambiarStatusViaje(item.id, 'completada', m); recargar(); } catch (e) { alert(e?.message || 'Error al forzar completar en servidor'); }
                                    } })}
                                    className="flex items-center gap-2 px-4 py-2 bg-purple-50 border border-purple-200 text-purple-700 rounded-lg text-sm font-semibold hover:bg-purple-100"
                                  >
                                    <CheckCircle size={15}/> Forzar completar
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          );
        })()}

        {/* ========== REPORTES ========== */}
        {seccion === 'reportes' && (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Reportes y Analítica</h2>
            <p className="text-gray-600 mb-6">Métricas de la plataforma</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              {/* Resumen financiero */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-4">Resumen Financiero del Mes</h3>
                <div className="space-y-4">
                  <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">GMV Total (Valor de Transacciones)</span>
                    <span className="font-bold">${stats.gmvMes.toLocaleString()} MXN</span>
                  </div>
                  <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Comisión ({configPlataforma.comisionPorcentaje}%)</span>
                    <span className="font-bold text-green-600">${stats.comisionesTotales.toLocaleString()} MXN</span>
                  </div>
                  <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Viajes Completados</span>
                    <span className="font-bold">{stats.viajesCompletadosMes}</span>
                  </div>
                  <div className="flex justify-between p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                    <span className="text-yellow-900 font-semibold">Ticket Promedio</span>
                    <span className="font-bold text-yellow-900">${stats.viajesCompletadosMes > 0 ? Math.round(stats.gmvMes / stats.viajesCompletadosMes).toLocaleString() : '0'} MXN</span>
                  </div>
                </div>
              </div>

              {/* Métricas de plataforma */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-4">Métricas de Plataforma</h3>
                <div className="space-y-4">
                  <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Transportistas Activos</span>
                    <span className="font-bold">{stats.empresasActivas}</span>
                  </div>
                  <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Clientes Registrados</span>
                    <span className="font-bold">{stats.clientesActivos}</span>
                  </div>
                  <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Unidades en Plataforma</span>
                    <span className="font-bold">{stats.totalUnidades}</span>
                  </div>
                  <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-600">Choferes Registrados</span>
                    <span className="font-bold">{stats.totalChoferes}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Obligaciones fiscales del mes */}
            {(() => {
              const ingresos = stats.comisionesTotales || 0;
              const baseGravable = Math.round(ingresos / 1.16);
              const iva = ingresos - baseGravable;
              // ISR: estimación aproximada para persona física — tasa real depende del régimen activo
              // Usar ~2% sobre base gravable como referencia conservadora (RESICO PF tramos bajos)
              const isr = Math.round(baseGravable * 0.02);
              const totalSat = iva + isr;
              return (
                <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border-l-4 border-red-400">
                  <h3 className="text-lg font-bold text-gray-800 mb-1">Obligaciones Fiscales — {new Date().toLocaleString('es-MX', { month: 'long', year: 'numeric' })}</h3>
                  <p className="text-xs text-gray-400 mb-4">Estimación sobre ingresos de comisiones del mes. Consulta a tu contador para cifras definitivas.</p>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                    <div className="bg-gray-50 rounded-lg p-3 text-center">
                      <p className="text-xs text-gray-500 mb-1">Ingresos totales (IVA inc.)</p>
                      <p className="text-lg font-bold text-gray-800">${ingresos.toLocaleString()}</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3 text-center">
                      <p className="text-xs text-gray-500 mb-1">Base gravable (sin IVA)</p>
                      <p className="text-lg font-bold text-gray-800">${baseGravable.toLocaleString()}</p>
                    </div>
                    <div className="bg-red-50 rounded-lg p-3 text-center border border-red-200">
                      <p className="text-xs text-red-600 mb-1 font-semibold">IVA 16% a pagar</p>
                      <p className="text-lg font-bold text-red-700">${iva.toLocaleString()}</p>
                    </div>
                    <div className="bg-orange-50 rounded-lg p-3 text-center border border-orange-200">
                      <p className="text-xs text-orange-600 mb-1 font-semibold">ISR estimado PF*</p>
                      <p className="text-lg font-bold text-orange-700">${isr.toLocaleString()}</p>
                    </div>
                  </div>
                  <div className="flex justify-between items-center bg-red-100 rounded-lg p-4 border border-red-300">
                    <span className="font-bold text-red-900 text-base">Total estimado a pagar al SAT</span>
                    <span className="font-black text-red-900 text-xl">${totalSat.toLocaleString()} MXN</span>
                  </div>
                  <p className="text-xs text-gray-400 mt-2">* ISR estimado ~2% sobre base gravable (referencia RESICO PF). La tasa real depende de tu régimen y tramo — ajusta con tu contador.</p>
                </div>
              );
            })()}

            {/* Retenciones a transportistas PM — enterar al SAT */}
            <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border-l-4 border-blue-400">
              <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
                <div>
                  <h3 className="text-lg font-bold text-gray-800">Retenciones a Transportistas PM</h3>
                  <p className="text-xs text-gray-400">IVA 4% + ISR 1.25% retenidos a transportistas PM (autotransporte terrestre Art. 1-A LIVA). Enterar al SAT el día 17 de cada mes.</p>
                </div>
                <input
                  type="month"
                  value={mesRetenciones}
                  onChange={e => setMesRetenciones(e.target.value)}
                  className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm"
                />
              </div>
              {retencionesSat ? (
                <>
                  <div className="grid grid-cols-3 gap-4 mb-4">
                    <div className="bg-blue-50 rounded-lg p-3 text-center border border-blue-200">
                      <p className="text-xs text-blue-600 mb-1 font-semibold">IVA retenido (4%)</p>
                      <p className="text-lg font-bold text-blue-700">${(retencionesSat.totalIva || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</p>
                    </div>
                    <div className="bg-purple-50 rounded-lg p-3 text-center border border-purple-200">
                      <p className="text-xs text-purple-600 mb-1 font-semibold">ISR retenido (1.25%)</p>
                      <p className="text-lg font-bold text-purple-700">${(retencionesSat.totalIsr || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</p>
                    </div>
                    <div className="bg-red-50 rounded-lg p-3 text-center border border-red-200">
                      <p className="text-xs text-red-600 mb-1 font-semibold">Total a enterar SAT</p>
                      <p className="text-lg font-bold text-red-700">${(retencionesSat.totalRetenciones || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN</p>
                    </div>
                  </div>
                  {retencionesSat.count === 0 ? (
                    <p className="text-sm text-gray-400 text-center py-2">Sin retenciones en este período (ningún transportista PM con pago liberado)</p>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs text-left border-collapse">
                        <thead>
                          <tr className="bg-gray-50 text-gray-500 uppercase text-xs">
                            <th className="px-3 py-2">Ruta</th>
                            <th className="px-3 py-2 text-right">Monto flete</th>
                            <th className="px-3 py-2 text-right">IVA retenido</th>
                            <th className="px-3 py-2 text-right">ISR retenido</th>
                            <th className="px-3 py-2">Transferido</th>
                          </tr>
                        </thead>
                        <tbody>
                          {retencionesSat.pagos.map(p => (
                            <tr key={p.id} className="border-t border-gray-100 hover:bg-gray-50">
                              <td className="px-3 py-2">{p.viaje?.origen} → {p.viaje?.destino}</td>
                              <td className="px-3 py-2 text-right">${(p.montoTransportista || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
                              <td className="px-3 py-2 text-right text-blue-700">${(p.retencionIva || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
                              <td className="px-3 py-2 text-right text-purple-700">${(p.retencionIsr || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
                              <td className="px-3 py-2 text-gray-400">{p.fechaTransferencia ? new Date(p.fechaTransferencia).toLocaleDateString('es-MX') : '—'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              ) : (
                <p className="text-sm text-gray-400 text-center py-4">Cargando...</p>
              )}
            </div>

            {/* Gráficas de tendencias */}
            <GraficasTendencias />

            {/* Exportar CSV */}
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-lg font-bold text-gray-800">Exportar Reportes</h3>
                  <p className="text-gray-500 text-sm">Descarga los datos en formato CSV (compatible con Excel)</p>
                </div>
              </div>
              {(() => {
                const descargar = (rows, nombre) => {
                  const csv = rows.map(r => r.map(c => `"${String(c ?? '').replace(/"/g, '""')}"`).join(',')).join('\n');
                  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = `choyero_${nombre}_${new Date().toISOString().slice(0, 10)}.csv`;
                  a.click();
                  URL.revokeObjectURL(url);
                };

                const exportsSincronos = [
                  { key: 'solicitudes', label: 'Solicitudes', desc: `${(store.solicitudes||[]).length} registros`, color: 'bg-blue-600 hover:bg-blue-700', getData: () => {
                    const cols = ['ID','Fecha','Cliente','Origen','Destino','Carga','Peso','Tipo Unidad','Status','Cotizaciones'];
                    const rows = (store.solicitudes||[]).map(s => [s.id, s.fechaCreacion?.slice(0,10)||'', s.clienteNombre||'', s.origen, s.destino, s.carga||'', s.peso||'', s.tipoUnidad||'', s.status, s.cotizacionesRecibidas||0]);
                    return [cols, ...rows];
                  }},
                  { key: 'viajes', label: 'Viajes', desc: `${(store.reporteViajes||store.viajes||[]).length} registros`, color: 'bg-orange-600 hover:bg-orange-700', getData: () => {
                    const cols = ['ID','Fecha','Status','Origen','Destino','Precio MXN','Empresa'];
                    const fuente = store.reporteViajes || store.viajes || [];
                    const rows = fuente.map(v => [v.id, (v.creadoEn||v.fechaCreacion||'').slice(0,10), v.status, v.origen||v.solicitud?.origen||'', v.destino||v.solicitud?.destino||'', v.precio||0, v.empresa?.nombre||v.transportista||'']);
                    return [cols, ...rows];
                  }},
                  { key: 'usuarios', label: 'Clientes y Empresas', desc: `${clientes.length} clientes · ${empresasActivasMerged.length} empresas`, color: 'bg-green-600 hover:bg-green-700', getData: () => {
                    const cols = ['Tipo','ID','Nombre','Email','Teléfono','Status','Viajes','Gasto/Comisión MXN'];
                    const rowsC = clientes.map(c => ['Cliente', c.id, c.nombre||c.contacto||'', c.email||'', '', 'activo', c.viajesRealizados||0, c.gastoTotal||0]);
                    const rowsE = empresasActivasMerged.map(e => ['Empresa', e.id, e.nombre, e.email||'', e.telefono||'', e.status, e.viajesCompletados||0, e.comisionGenerada||0]);
                    return [cols, ...rowsC, ...rowsE];
                  }},
                ];

                const exportsAsincronos = [
                  { key: 'pagos', label: 'Pagos y Comisiones', desc: 'Escrow, liberaciones y comisiones', color: 'bg-purple-600 hover:bg-purple-700',
                    fetch: async () => {
                      const d = await apiGetFinanzasAdmin();
                      const cols = ['ID Pago','Fecha','Origen','Destino','Transportista','Método','Monto Total MXN','Comisión MXN','Al Transportista MXN','Status','Fecha Liberación'];
                      const rows = (d.pagos||[]).map(p => [p.id, p.creadoEn?.slice(0,10)||'', p.viaje?.origen||'', p.viaje?.destino||'', p.viaje?.transportista||'', p.metodoPago||'', p.monto||0, p.montoComision||0, p.montoTransportista||0, p.status||'', p.fechaLiberacion?.slice(0,10)||'']);
                      return [cols, ...rows];
                    }},
                  { key: 'retiros', label: 'Retiros MLM', desc: 'Historial CFDI Asimilados a Salarios', color: 'bg-teal-600 hover:bg-teal-700',
                    fetch: async () => {
                      const retiros = await apiGetRetiros();
                      const cols = ['ID','Fecha','Usuario','Email','Monto Bruto MXN','ISR MXN','Monto Neto MXN','Status','UUID CFDI'];
                      const rows = (retiros||[]).map(r => [r.id, r.creadoEn?.slice(0,10)||'', r.usuario?.nombre||'', r.usuario?.email||'', r.monto||0, r.montoIsr||0, r.montoNeto||0, r.status||'', r.cfdiUuid||'']);
                      return [cols, ...rows];
                    }},
                  { key: 'facturas', label: 'Facturas CFDI', desc: 'Todas las facturas timbradas', color: 'bg-rose-600 hover:bg-rose-700',
                    fetch: async () => {
                      let todas = [], page = 1, pages = 1;
                      while (page <= pages) {
                        const d = await apiGetFacturasAdmin({ page });
                        todas = [...todas, ...(d.facturas||[])];
                        pages = d.pages || 1;
                        page++;
                      }
                      const cols = ['ID','Folio','Fecha','UUID','RFC Receptor','Razón Social','Empresa','Subtotal MXN','IVA MXN','Total MXN','Status'];
                      const rows = todas.map(f => [f.id, f.folio||'', f.creadoEn?.slice(0,10)||'', f.uuid||'', f.rfcReceptor||'', f.nombreReceptor||'', f.empresa?.nombre||'', f.subtotal||0, f.iva||0, f.total||0, f.status||'']);
                      return [cols, ...rows];
                    }},
                ];

                return (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                    {exportsSincronos.map(({ key, label, desc, color, getData }) => (
                      <button key={key} onClick={() => descargar(getData(), key)}
                        className={`flex flex-col items-start p-4 ${color} text-white rounded-xl font-semibold`}>
                        <div className="flex items-center gap-2 mb-1"><Download size={18}/> {label}</div>
                        <p className="text-xs font-normal opacity-80">{desc}</p>
                      </button>
                    ))}
                    {exportsAsincronos.map(({ key, label, desc, color, fetch: fetchData }) => (
                      <button key={key} disabled={exportandoCSV === key}
                        onClick={async () => {
                          setExportandoCSV(key);
                          try {
                            const rows = await fetchData();
                            descargar(rows, key);
                          } catch { alert('Error al exportar. Intenta de nuevo.'); }
                          finally { setExportandoCSV(null); }
                        }}
                        className={`flex flex-col items-start p-4 ${color} text-white rounded-xl font-semibold disabled:opacity-60`}>
                        <div className="flex items-center gap-2 mb-1">
                          {exportandoCSV === key ? <RefreshCw size={18} className="animate-spin"/> : <Download size={18}/>}
                          {label}
                        </div>
                        <p className="text-xs font-normal opacity-80">{exportandoCSV === key ? 'Descargando…' : desc}</p>
                      </button>
                    ))}
                  </div>
                );
              })()}
            </div>
          </div>
        )}

        {/* ========== FINANZAS / ESCROW ========== */}
        {seccion === 'finanzas' && <SeccionFinanzasAdmin />}

        {/* ========== FACTURACIÓN ========== */}
        {seccion === 'facturacion' && <SeccionFacturacionAdmin />}

        {/* ========== MENSAJES ========== */}
        {seccion === 'mensajes' && <SeccionMensajes usuario={usuario} usuarios={store.usuarios || []} />}

        {/* ========== AUDITORÍA ========== */}
        {seccion === 'auditoria' && <SeccionAuditoria />}

        {/* ========== CONFIGURACIÓN ========== */}
        {seccion === 'configuracion' && (
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Configuración</h2>
            <p className="text-gray-600 mb-6">Ajustes de la plataforma</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Comisión */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <Percent size={20} className="text-green-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">Comisión de la Plataforma</h3>
                </div>
                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <p className="text-sm text-gray-600 mb-2">Porcentaje actual</p>
                  <p className="text-4xl font-bold text-green-600">{configPlataforma.comisionPorcentaje}%</p>
                </div>
                <p className="text-sm text-gray-500">
                  Esta comisión se cobra sobre cada transacción completada en la plataforma.
                </p>
              </div>

              {/* Zonas activas */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <MapPin size={20} className="text-blue-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">Zonas de Cobertura</h3>
                </div>
                <div className="space-y-2">
                  {configPlataforma.zonasActivas.map((zona, idx) => (
                    <div key={idx} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center space-x-2">
                        <CheckCircle size={16} className="text-green-500" />
                        <span>{zona}</span>
                      </div>
                      <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">Activa</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Difusión global */}
              <div className="bg-white rounded-xl shadow-lg p-6 md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${store.configPlataforma?.difusionGlobal ? 'bg-orange-100' : 'bg-gray-100'}`}>
                    <Globe size={20} className={store.configPlataforma?.difusionGlobal ? 'text-orange-600' : 'text-gray-500'} />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800">Difusión Global de Solicitudes</h3>
                    <p className="text-sm text-gray-500">Envía todas las solicitudes a todos los transportistas afiliados, sin importar su ciudad</p>
                  </div>
                </div>
                <div className={`rounded-xl p-4 mb-4 ${store.configPlataforma?.difusionGlobal ? 'bg-orange-50 border border-orange-200' : 'bg-gray-50 border border-gray-200'}`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className={`font-semibold ${store.configPlataforma?.difusionGlobal ? 'text-orange-700' : 'text-gray-600'}`}>
                        {store.configPlataforma?.difusionGlobal ? '🟠 Difusión global ACTIVA' : '⚫ Difusión geográfica por fases (normal)'}
                      </p>
                      <p className={`text-sm mt-1 ${store.configPlataforma?.difusionGlobal ? 'text-orange-600' : 'text-gray-500'}`}>
                        {store.configPlataforma?.difusionGlobal
                          ? 'Todas las solicitudes son visibles para todos los transportistas de inmediato.'
                          : `Fase 1: transportistas en origen (0-${store.configPlataforma?.tiempoEsperaLocalMinutos || 30} min) · Fase 2: transportistas en destino (${store.configPlataforma?.tiempoEsperaLocalMinutos || 30}-${(store.configPlataforma?.tiempoEsperaLocalMinutos || 30) * 2} min) · Fase 3: todos los demás (${(store.configPlataforma?.tiempoEsperaLocalMinutos || 30) * 2}+ min)`}
                      </p>
                    </div>
                    <button
                      onClick={async () => {
                        const nuevo = !store.configPlataforma?.difusionGlobal;
                        storeToggleDifusion();
                        try { await apiGuardarConfig({ difusionGlobal: nuevo }); invalidarCacheConfig(); recargar(); } catch { storeToggleDifusion(); /* revertir si falla la API */ }
                      }}
                      className={`relative inline-flex h-8 w-14 items-center rounded-full transition-colors focus:outline-none ${store.configPlataforma?.difusionGlobal ? 'bg-orange-500' : 'bg-gray-300'}`}
                    >
                      <span className={`inline-block h-6 w-6 transform rounded-full bg-white shadow-md transition-transform ${store.configPlataforma?.difusionGlobal ? 'translate-x-7' : 'translate-x-1'}`} />
                    </button>
                  </div>
                </div>
                {/* Tiempos y umbral por oleada (solo cuando difusión global está OFF) */}
                {!store.configPlataforma?.difusionGlobal && (
                  <div className="mt-4 pt-4 border-t border-gray-100 space-y-4">
                    <p className="text-xs font-bold text-gray-500 uppercase tracking-wide">Configuración de oleadas</p>

                    {/* Cotizaciones mínimas para avanzar */}
                    <div className="flex items-center justify-between gap-4 bg-orange-50 border border-orange-100 rounded-lg px-4 py-3">
                      <div>
                        <p className="text-sm font-semibold text-gray-700">Cotizaciones mínimas para avanzar de oleada</p>
                        <p className="text-xs text-gray-500 mt-0.5">Si no se alcanza este número, se activa la siguiente oleada</p>
                      </div>
                      <input
                        type="number" min="1" max="50"
                        value={cfgCotizMin}
                        onChange={e => setCfgCotizMin(e.target.value)}
                        onBlur={async e => {
                          const val = parseInt(e.target.value);
                          if (!isNaN(val) && val >= 1) {
                            try { await apiGuardarConfig({ cotizacionesMinimas: val }); invalidarCacheConfig(); recargar(); }
                            catch { setCfgCotizMin(String(store.configPlataforma?.cotizacionesMinimas ?? 10)); }
                          } else { setCfgCotizMin(String(store.configPlataforma?.cotizacionesMinimas ?? 10)); }
                        }}
                        className="w-20 px-3 py-1.5 border border-orange-300 rounded-lg text-sm text-center font-bold focus:outline-none focus:ring-2 focus:ring-orange-400"
                      />
                    </div>

                    {/* Oleada 1 → 2 */}
                    <div className="flex items-center justify-between gap-4 border border-gray-200 rounded-lg px-4 py-3">
                      <div className="flex items-center gap-3">
                        <span className="w-7 h-7 rounded-full bg-blue-100 text-blue-700 text-xs font-bold flex items-center justify-center shrink-0">1</span>
                        <div>
                          <p className="text-sm font-semibold text-gray-700">Oleada 1 → 2</p>
                          <p className="text-xs text-gray-500">Transportistas en <b>origen</b> → Transportistas en <b>destino</b></p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 shrink-0">
                        <input
                          type="number" min="0.1" max="48" step="0.5"
                          value={cfgOleada1}
                          onChange={e => setCfgOleada1(e.target.value)}
                          onBlur={async e => {
                            const hrs = parseFloat(e.target.value);
                            if (!isNaN(hrs) && hrs >= 0.1) {
                              const mins = Math.round(hrs * 60);
                              try { await apiGuardarConfig({ tiempoEsperaLocalMinutos: mins }); invalidarCacheConfig(); recargar(); }
                              catch { setCfgOleada1(String(parseFloat(((store.configPlataforma?.tiempoEsperaLocalMinutos ?? 30) / 60).toFixed(1)))); }
                            } else { setCfgOleada1(String(parseFloat(((store.configPlataforma?.tiempoEsperaLocalMinutos ?? 30) / 60).toFixed(1)))); }
                          }}
                          className="w-20 px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-center font-bold focus:outline-none focus:ring-2 focus:ring-orange-400"
                        />
                        <span className="text-xs text-gray-400 shrink-0">hrs</span>
                      </div>
                    </div>

                    {/* Oleada 2 → 3 */}
                    <div className="flex items-center justify-between gap-4 border border-gray-200 rounded-lg px-4 py-3">
                      <div className="flex items-center gap-3">
                        <span className="w-7 h-7 rounded-full bg-yellow-100 text-yellow-700 text-xs font-bold flex items-center justify-center shrink-0">2</span>
                        <div>
                          <p className="text-sm font-semibold text-gray-700">Oleada 2 → 3</p>
                          <p className="text-xs text-gray-500">Transportistas en <b>destino</b> → Transportistas en <b>ruta intermedia</b></p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 shrink-0">
                        <input
                          type="number" min="0.1" max="48" step="0.5"
                          value={cfgOleada2}
                          onChange={e => setCfgOleada2(e.target.value)}
                          onBlur={async e => {
                            const hrs = parseFloat(e.target.value);
                            if (!isNaN(hrs) && hrs >= 0.1) {
                              const mins = Math.round(hrs * 60);
                              try { await apiGuardarConfig({ tiempoEsperaOleada2Minutos: mins }); invalidarCacheConfig(); recargar(); }
                              catch { setCfgOleada2(String(parseFloat(((store.configPlataforma?.tiempoEsperaOleada2Minutos ?? 60) / 60).toFixed(1)))); }
                            } else { setCfgOleada2(String(parseFloat(((store.configPlataforma?.tiempoEsperaOleada2Minutos ?? 60) / 60).toFixed(1)))); }
                          }}
                          className="w-20 px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-center font-bold focus:outline-none focus:ring-2 focus:ring-orange-400"
                        />
                        <span className="text-xs text-gray-400 shrink-0">hrs</span>
                      </div>
                    </div>

                    {/* Oleada 3 */}
                    <div className="flex items-center justify-between gap-4 border border-gray-200 rounded-lg px-4 py-3">
                      <div className="flex items-center gap-3">
                        <span className="w-7 h-7 rounded-full bg-green-100 text-green-700 text-xs font-bold flex items-center justify-center shrink-0">3</span>
                        <div>
                          <p className="text-sm font-semibold text-gray-700">Oleada 3 — duración máxima</p>
                          <p className="text-xs text-gray-500">Transportistas en <b>ruta intermedia</b> antes de expirar</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 shrink-0">
                        <input
                          type="number" min="0.1" max="48" step="0.5"
                          value={cfgOleada3}
                          onChange={e => setCfgOleada3(e.target.value)}
                          onBlur={async e => {
                            const hrs = parseFloat(e.target.value);
                            if (!isNaN(hrs) && hrs >= 0.1) {
                              const mins = Math.round(hrs * 60);
                              try { await apiGuardarConfig({ tiempoEsperaOleada3Minutos: mins }); invalidarCacheConfig(); recargar(); }
                              catch { setCfgOleada3(String(parseFloat(((store.configPlataforma?.tiempoEsperaOleada3Minutos ?? 120) / 60).toFixed(1)))); }
                            } else { setCfgOleada3(String(parseFloat(((store.configPlataforma?.tiempoEsperaOleada3Minutos ?? 120) / 60).toFixed(1)))); }
                          }}
                          className="w-20 px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-center font-bold focus:outline-none focus:ring-2 focus:ring-orange-400"
                        />
                        <span className="text-xs text-gray-400 shrink-0">hrs</span>
                      </div>
                    </div>
                  </div>
                )}
                {/* Aviso de expiración al cliente */}
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <div className="flex items-center justify-between gap-4">
                    <div>
                      <p className="text-sm font-semibold text-gray-700">Aviso al cliente antes de que expire su solicitud</p>
                      <p className="text-xs text-gray-500 mt-0.5">El cliente recibirá una notificación X horas antes de que venza su fecha de recogida</p>
                    </div>
                    <div className="flex items-center gap-2 shrink-0">
                      <input
                        type="number" min="1" max="72"
                        value={cfgAvisoExp}
                        onChange={e => setCfgAvisoExp(e.target.value)}
                        onBlur={async e => {
                          const val = parseInt(e.target.value);
                          if (!isNaN(val) && val >= 1) {
                            try { await apiGuardarConfig({ horasAvisoExpiracionSolicitud: val }); invalidarCacheConfig(); recargar(); }
                            catch { setCfgAvisoExp(String(store.configPlataforma?.horasAvisoExpiracionSolicitud ?? 24)); }
                          } else { setCfgAvisoExp(String(store.configPlataforma?.horasAvisoExpiracionSolicitud ?? 24)); }
                        }}
                        className="w-20 px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-center font-bold focus:outline-none focus:ring-2 focus:ring-orange-400"
                      />
                      <span className="text-xs text-gray-400 shrink-0">horas</span>
                    </div>
                  </div>
                </div>

                <p className="text-xs text-gray-400 mt-3">
                  Recomendado activar Difusión Global en la fase inicial de operaciones cuando la cobertura aún no es completa en toda la península.
                </p>
              </div>

              {/* Configuración de Planes */}
              <div className="bg-white rounded-xl shadow-lg p-6 md:col-span-2">
                <div className="flex items-center space-x-3 mb-5">
                  <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                    <span className="text-purple-600 font-black text-sm">PRO</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800">Configuración de Planes</h3>
                    <p className="text-sm text-gray-500">Parámetros para cuentas Básico y PRO</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-5">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Ventana exclusiva PRO (horas)</label>
                    <input type="number" min="0" max="72" onWheel={e => e.target.blur()} value={configPlanHoras} onChange={e => setConfigPlanHoras(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400" />
                    <p className="text-xs text-gray-400 mt-1">PRO ve solicitudes {configPlanHoras}h antes que Básico</p>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Comisión Básico (%)</label>
                    <input type="number" min="0" max="100" step="0.5" onWheel={e => e.target.blur()} value={configPlanComBasico} onChange={e => setConfigPlanComBasico(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Comisión PRO (%)</label>
                    <input type="number" min="0" max="100" step="0.5" onWheel={e => e.target.blur()} value={configPlanComPro} onChange={e => setConfigPlanComPro(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400" />
                    <p className="text-xs text-purple-500 mt-1">Ahorro vs Básico: {Math.max(0, parseFloat(configPlanComBasico||0) - parseFloat(configPlanComPro||0)).toFixed(1)}%</p>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Tasa IVA (%)</label>
                    <input type="number" min="0" max="100" step="0.5" onWheel={e => e.target.blur()} value={configTasaIva} onChange={e => setConfigTasaIva(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400" />
                    <p className="text-xs text-gray-400 mt-1">Domicilio fiscal Mulegé BCS — 16% estándar</p>
                  </div>
                </div>
                {/* Pasarela de pago PRO */}
                <div className="border-t border-gray-100 pt-5 mt-1">
                  <p className="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
                    <CreditCard size={15} className="text-orange-500" />
                    Suscripción PRO en autoservicio
                  </p>
                  <div className="grid grid-cols-3 gap-4 mb-4">
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Precio mensual (MXN)</label>
                      <input type="number" min="0" step="1" value={configPrecioProMensual} onChange={e => setConfigPrecioProMensual(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400" />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Precio anual (MXN)</label>
                      <input type="number" min="0" step="1" value={configPrecioProAnual} onChange={e => setConfigPrecioProAnual(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400" />
                    </div>
                    <div className="flex flex-col justify-end">
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Pasarela de pago</label>
                      <div className="flex items-center gap-3">
                        <button
                          onClick={async () => {
                            const nuevo = !store.configPlataforma?.pagoProHabilitado;
                            storeActualizarConfigPlan({ pagoProHabilitado: nuevo });
                            try {
                              await apiGuardarConfig({ pagoProHabilitado: nuevo });
                            } catch (e) {
                              storeActualizarConfigPlan({ pagoProHabilitado: !nuevo });
                              mostrarNotificacion(e.message || 'Error al actualizar pasarela de pago', 'error');
                            }
                          }}
                          className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors focus:outline-none ${store.configPlataforma?.pagoProHabilitado ? 'bg-green-500' : 'bg-gray-300'}`}
                        >
                          <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${store.configPlataforma?.pagoProHabilitado ? 'translate-x-6' : 'translate-x-1'}`} />
                        </button>
                        <span className={`text-sm font-semibold ${store.configPlataforma?.pagoProHabilitado ? 'text-green-600' : 'text-gray-400'}`}>
                          {store.configPlataforma?.pagoProHabilitado ? 'Habilitada' : 'Deshabilitada'}
                        </span>
                      </div>
                    </div>
                  </div>
                  {!store.configPlataforma?.pagoProHabilitado && (
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Mensaje para transportistas (mientras está deshabilitada)</label>
                      <input type="text" value={configMensajePro} onChange={e => setConfigMensajePro(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400" />
                    </div>
                  )}
                </div>

                {/* ── Pre-lanzamiento PRO ── */}
                <div className="border border-orange-200 bg-orange-50 rounded-xl p-4 mb-4">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <p className="text-sm font-bold text-orange-800">Modo Pre-lanzamiento PRO</p>
                      <p className="text-xs text-orange-600 mt-0.5">Muestra teaser + lista de espera a los transportistas antes del lanzamiento</p>
                    </div>
                    <button
                      onClick={async () => {
                        const nuevo = !store.configPlataforma?.modoPreLanzamientoPro;
                        try { await apiGuardarConfig({ modoPreLanzamientoPro: nuevo }); invalidarCacheConfig(); recargar(); }
                        catch (e) { mostrarNotificacion(e.message || 'Error', 'error'); }
                      }}
                      className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors focus:outline-none shrink-0 ${store.configPlataforma?.modoPreLanzamientoPro ? 'bg-orange-500' : 'bg-gray-300'}`}
                    >
                      <span className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${store.configPlataforma?.modoPreLanzamientoPro ? 'translate-x-6' : 'translate-x-1'}`} />
                    </button>
                  </div>
                  {store.configPlataforma?.modoPreLanzamientoPro && (
                    <div className="space-y-3">
                      <div>
                        <label className="block text-xs font-semibold text-gray-600 mb-1">Fecha y hora de lanzamiento (opcional — activa el contador)</label>
                        <input type="datetime-local" value={cfgFechaLanzamiento} onChange={e => setCfgFechaLanzamiento(e.target.value)}
                          onBlur={async e => {
                            try { await apiGuardarConfig({ fechaLanzamientoPro: e.target.value || null }); invalidarCacheConfig(); recargar(); }
                            catch (e) { mostrarNotificacion('Error al guardar fecha', 'error'); }
                          }}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400" />
                      </div>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-xs font-semibold text-gray-600 mb-1">Precio fundador (MXN/mes)</label>
                          <input type="number" min="0" value={cfgPrecioFundador} onChange={e => setCfgPrecioFundador(e.target.value)}
                            onBlur={async e => {
                              const v = parseFloat(e.target.value);
                              if (!isNaN(v) && v > 0) { try { await apiGuardarConfig({ precioFundador: v }); invalidarCacheConfig(); recargar(); } catch { setCfgPrecioFundador(String(store.configPlataforma?.precioFundador ?? '')); } }
                              else { setCfgPrecioFundador(String(store.configPlataforma?.precioFundador ?? '')); }
                            }}
                            placeholder="ej: 299" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400" />
                        </div>
                        <div>
                          <label className="block text-xs font-semibold text-gray-600 mb-1">Límite founding members</label>
                          <input type="number" min="1" value={cfgLimiteFounders} onChange={e => setCfgLimiteFounders(e.target.value)}
                            onBlur={async e => {
                              const v = parseInt(e.target.value);
                              if (!isNaN(v) && v > 0) { try { await apiGuardarConfig({ limiteFoundingMembers: v }); invalidarCacheConfig(); recargar(); } catch { setCfgLimiteFounders(String(store.configPlataforma?.limiteFoundingMembers ?? 50)); } }
                              else { setCfgLimiteFounders(String(store.configPlataforma?.limiteFoundingMembers ?? 50)); }
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400" />
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <button onClick={async () => {
                  const h = parseInt(configPlanHoras); const p = parseFloat(configPlanComPro); const b = parseFloat(configPlanComBasico);
                  const precio = parseFloat(configPrecioProMensual);
                  const precioAnual = parseFloat(configPrecioProAnual);
                  const iva = parseFloat(configTasaIva);
                  if (isNaN(h) || h < 0 || isNaN(p) || p < 0 || p > 100 || isNaN(b) || b < 0 || b > 100) return;
                  if (isNaN(iva) || iva < 0 || iva > 100) return;
                  const datos = { horasExclusivaPro: h, comisionPro: p, comisionBasico: b, precioProMensual: isNaN(precio) ? 599 : precio, precioProAnual: isNaN(precioAnual) ? 36000 : precioAnual, tasaIva: iva / 100, mensajePagoProDeshabilitado: configMensajePro };
                  setGuardandoPlanes(true);
                  try {
                    await apiGuardarConfig(datos);
                    storeActualizarConfigPlan(datos);
                    invalidarCacheConfig(); recargar();
                    setPlanesGuardado(true);
                    setTimeout(() => setPlanesGuardado(false), 2500);
                  } catch (e) {
                    alert('Error al guardar: ' + (e?.message || 'intenta de nuevo'));
                  } finally {
                    setGuardandoPlanes(false);
                  }
                }}
                  disabled={guardandoPlanes}
                  className={`mt-4 px-5 py-2 rounded-lg font-semibold text-sm transition ${planesGuardado ? 'bg-green-600 text-white' : 'bg-purple-600 hover:bg-purple-700 disabled:bg-purple-300 text-white'}`}>
                  {guardandoPlanes ? 'Guardando...' : planesGuardado ? '✅ Guardado' : 'Guardar cambios'}
                </button>
              </div>

              {/* Flete de prueba para transportistas nuevos */}
              <div className="bg-white rounded-xl shadow-lg p-6 md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${store.configPlataforma?.fletesPruebaHabilitado ? 'bg-green-100' : 'bg-gray-100'}`}>
                    <Truck size={20} className={store.configPlataforma?.fletesPruebaHabilitado ? 'text-green-600' : 'text-gray-400'} />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800">Primer Flete de Prueba</h3>
                    <p className="text-sm text-gray-500">Permite a transportistas no aprobados completar 1 flete real antes de bloquear cotizar y mapa</p>
                  </div>
                </div>
                <div className={`rounded-xl p-4 ${store.configPlataforma?.fletesPruebaHabilitado ? 'bg-green-50 border border-green-200' : 'bg-gray-50 border border-gray-200'}`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className={`font-semibold ${store.configPlataforma?.fletesPruebaHabilitado ? 'text-green-700' : 'text-gray-600'}`}>
                        {store.configPlataforma?.fletesPruebaHabilitado ? '🟢 Flete de prueba ACTIVO' : '⚫ Sin flete de prueba — bloqueo inmediato'}
                      </p>
                      <p className={`text-sm mt-1 ${store.configPlataforma?.fletesPruebaHabilitado ? 'text-green-600' : 'text-gray-500'}`}>
                        {store.configPlataforma?.fletesPruebaHabilitado
                          ? 'Los transportistas nuevos pueden cotizar y completar 1 flete real. Después se bloquean cotizar y mapa hasta aprobación.'
                          : 'Los transportistas no aprobados tienen bloqueados cotizar y el mapa desde el momento del registro.'}
                      </p>
                    </div>
                    <button
                      onClick={async () => {
                        const nuevo = !store.configPlataforma?.fletesPruebaHabilitado;
                        try { await apiGuardarConfig({ fletesPruebaHabilitado: nuevo }); invalidarCacheConfig(); recargar(); }
                        catch (e) { mostrarNotificacion(e.message || 'Error al guardar', 'error'); }
                      }}
                      className={`relative inline-flex h-8 w-14 items-center rounded-full transition-colors focus:outline-none shrink-0 ${store.configPlataforma?.fletesPruebaHabilitado ? 'bg-green-500' : 'bg-gray-300'}`}
                    >
                      <span className={`inline-block h-6 w-6 transform rounded-full bg-white shadow-md transition-transform ${store.configPlataforma?.fletesPruebaHabilitado ? 'translate-x-7' : 'translate-x-1'}`} />
                    </button>
                  </div>
                </div>
              </div>

              {/* Cambiar contraseña */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                    <Lock size={20} className="text-red-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">Cambiar Contraseña</h3>
                </div>
                <FormCambiarPassword />
              </div>

              {/* Info del sistema */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                    <Settings size={20} className="text-purple-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800">Sistema</h3>
                </div>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Versión</span>
                    <span className="font-mono">{configPlataforma.versionApp}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Ambiente</span>
                    <span className="text-green-600 font-semibold">Producción</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Última actualización</span>
                    <span>Mayo 2026</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      {/* ========== RETORNOS VACÍOS ========== */}
      {seccion === 'retornos' && (() => {
        const retornos = (store.retornosVacios || []).slice().sort((a, b) => new Date(b.creadoEn||b.fecha||0) - new Date(a.creadoEn||a.fecha||0));
        const colorStatus = s => ({
          disponible:  'bg-green-100 text-green-700',
          negociando:  'bg-yellow-100 text-yellow-700',
          aceptado:    'bg-blue-100 text-blue-700',
          confirmado:  'bg-indigo-100 text-indigo-700',
          en_curso:    'bg-purple-100 text-purple-700',
          completado:  'bg-emerald-100 text-emerald-700',
          cancelado:   'bg-red-100 text-red-600',
          expirado:    'bg-gray-100 text-gray-500',
        }[s] || 'bg-gray-100 text-gray-500');
        const labelStatus = s => ({
          disponible:  'Disponible',
          negociando:  'Negociando',
          aceptado:    'Cupo lleno',
          confirmado:  'Confirmado',
          en_curso:    'En curso',
          completado:  'Completado',
          cancelado:   'Cancelado',
          expirado:    'Expirado',
        }[s] || s);
        const filtrados = retornos.filter(r => {
          if (filtroRetorno !== 'todos' && r.status !== filtroRetorno) return false;
          if (globalSearch) {
            const q = globalSearch.trim().toLowerCase();
            const emp = empresasActivasMerged.find(e => e.id === r.empresaId);
            return (r.origen||'').toLowerCase().includes(q) || (r.destino||'').toLowerCase().includes(q) || (emp?.nombre||'').toLowerCase().includes(q);
          }
          return true;
        });
        const conteo = st => retornos.filter(r => r.status === st).length;

        return (
          <div>
            <div className="mb-6">
              <h2 className="text-3xl font-bold text-gray-800">Retornos Vacíos</h2>
              <p className="text-gray-500 text-sm mt-1">{retornos.length} publicados · {conteo('disponible')} disponibles · {conteo('completado')} completados</p>
            </div>

            {/* KPIs */}
            <div className="grid grid-cols-4 gap-4 mb-6">
              {[
                { label: 'Disponibles', val: conteo('disponible'), color: 'bg-green-100 text-green-700', icon: RotateCcw },
                { label: 'Negociando', val: conteo('negociando'), color: 'bg-yellow-100 text-yellow-700', icon: ArrowRightLeft },
                { label: 'Cupo lleno', val: conteo('aceptado') + conteo('confirmado') + conteo('en_curso'), color: 'bg-blue-100 text-blue-700', icon: Package },
                { label: 'Completados', val: conteo('completado'), color: 'bg-emerald-100 text-emerald-700', icon: CheckCircle },
              ].map(({ label, val, color, icon: Icon }) => (
                <div key={label} className="bg-white rounded-xl shadow p-4 flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${color}`}><Icon size={20} /></div>
                  <div><p className="text-2xl font-bold text-gray-800">{val}</p><p className="text-xs text-gray-500">{label}</p></div>
                </div>
              ))}
            </div>

            {/* Filtro tabs */}
            <div className="flex gap-2 mb-4 flex-wrap">
              {['todos', 'disponible', 'negociando', 'aceptado', 'confirmado', 'en_curso', 'completado', 'cancelado', 'expirado'].map(s => (
                <button key={s} onClick={() => setFiltroRetorno(s)}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition ${filtroRetorno === s ? 'bg-gray-800 text-white' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'}`}>
                  {s === 'todos' ? `Todos (${retornos.length})` : `${labelStatus(s)} (${conteo(s)})`}
                </button>
              ))}
            </div>

            {/* Lista */}
            {filtrados.length === 0 ? (
              <div className="bg-white rounded-xl shadow p-16 text-center text-gray-400">
                <RotateCcw size={48} className="mx-auto mb-3 opacity-30" />
                <p className="font-medium">Sin retornos en esta categoría</p>
              </div>
            ) : (
              <div className="grid gap-3">
                {filtrados.map(r => {
                  const empresa = empresasActivasMerged.find(e => e.id === r.empresaId);
                  const ofertaAceptada = (r.ofertas || []).find(o => o.status === 'aceptada' && o.pagado) || (r.ofertas || []).find(o => o.status === 'aceptada');
                  const ofertasPendientes = (r.ofertas || []).filter(o => o.status === 'pendiente');
                  const totalOfertas = (r.ofertas || []).length;
                  const viaje = (r.viajes || [])[0];
                  const pago = viaje?.pago;
                  const montoFinal = pago?.monto || ofertaAceptada?.contrapropuesta || ofertaAceptada?.precio;
                  const expandido = retornosExpandidos.has(r.id);
                  const toggleExpandido = () => setRetornosExpandidos(prev => { const s = new Set(prev); s.has(r.id) ? s.delete(r.id) : s.add(r.id); return s; });
                  return (
                    <div key={r.id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                      {/* Cabecera */}
                      <div className="p-5">
                        <div className="flex items-start justify-between gap-4">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-2 flex-wrap">
                              <span className={`text-xs px-2.5 py-1 rounded-full font-semibold ${colorStatus(r.status)}`}>{labelStatus(r.status)}</span>
                              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">{r.tipoVehiculo || 'Vehículo no especificado'}</span>
                              {r.precioMinimo && <span className="text-xs bg-orange-50 text-orange-600 px-2 py-0.5 rounded-full">Mín. oculto: ${(r.precioMinimo).toLocaleString()}</span>}
                              {pago && <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${pago.status === 'liberado' ? 'bg-emerald-100 text-emerald-700' : pago.status === 'retenido' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'}`}>Pago: {pago.status}</span>}
                            </div>
                            <p className="font-bold text-gray-800">
                              <MapPin size={13} className="inline mr-1 text-gray-400" />
                              {r.origen} → {r.destino}
                            </p>
                            <div className="flex flex-wrap gap-3 mt-1 text-xs text-gray-500">
                              <span>Empresa: <strong>{empresa?.nombre || r.empresaId}</strong></span>
                              <span>Precio base: <strong>${(r.precioBase||0).toLocaleString()}</strong></span>
                              {r.capacidadDisponible && <span>Capacidad: <strong>{r.capacidadDisponible} ton</strong></span>}
                              {r.expiresAt && <span>Expira: <strong>{new Date(r.expiresAt).toLocaleDateString('es-MX', { day:'2-digit', month:'short' })}</strong></span>}
                            </div>
                            {/* Cliente que pagó */}
                            {ofertaAceptada?.pagado && (
                              <div className="mt-2 flex items-center gap-3 text-xs">
                                <span className="text-gray-500">Cliente: <strong className="text-gray-800">{ofertaAceptada.clienteNombre || ofertaAceptada.clienteId}</strong></span>
                                {montoFinal && <span className="text-emerald-600 font-bold">${montoFinal.toLocaleString()} MXN pagados</span>}
                                {pago?.montoTransportista && <span className="text-gray-400">→ Transportista: ${pago.montoTransportista.toLocaleString()}</span>}
                              </div>
                            )}
                          </div>
                          <div className="text-right flex-shrink-0 space-y-1">
                            <p className="text-xs text-gray-400">{new Date(r.creadoEn||0).toLocaleDateString('es-MX', { day:'2-digit', month:'short', year:'numeric' })}</p>
                            <p className="text-xs text-gray-400">{totalOfertas} oferta{totalOfertas !== 1 ? 's' : ''}{ofertasPendientes.length > 0 && <span className="ml-1 text-yellow-600 font-semibold">· {ofertasPendientes.length} pendiente{ofertasPendientes.length !== 1 ? 's' : ''}</span>}</p>
                            {totalOfertas > 0 && (
                              <button onClick={toggleExpandido} className="text-xs text-blue-600 hover:underline">
                                {expandido ? 'Ocultar ofertas ▲' : 'Ver ofertas ▼'}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* Ofertas expandidas */}
                      {expandido && (r.ofertas || []).length > 0 && (
                        <div className="border-t bg-gray-50 p-4 space-y-2">
                          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Ofertas recibidas</p>
                          {[...(r.ofertas || [])].sort((a, b) => new Date(b.creadoEn) - new Date(a.creadoEn)).map(o => (
                            <div key={o.id} className="bg-white rounded-lg p-3 border text-xs flex items-center justify-between gap-3">
                              <div>
                                <span className="font-semibold text-gray-800">{o.clienteNombre || o.clienteId}</span>
                                {o.origen && <span className="text-gray-400 ml-2">{o.origen} → {o.destino}</span>}
                                {o.peso && <span className="text-gray-400 ml-2">{o.peso} ton</span>}
                              </div>
                              <div className="flex items-center gap-2 flex-shrink-0">
                                <span className="font-bold text-gray-700">${(o.contrapropuesta || o.precio || 0).toLocaleString()}</span>
                                {o.pagado && <span className="text-xs bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full font-semibold">Pagado</span>}
                                <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${o.status === 'pendiente' ? 'bg-yellow-100 text-yellow-700' : o.status === 'aceptada' ? 'bg-green-100 text-green-700' : o.status === 'rechazada' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-700'}`}>
                                  {o.status}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })()}

      {/* ========== PROMOCIONES ========== */}
      {seccion === 'configuracion' && <SeccionPromos recargar={recargar} />}

      {/* ========== SIMULADOR RED MULTINIVEL ========== */}
      {seccion === 'simulador_red' && <SimuladorRedMercadeo configPlataforma={store.configPlataforma} />}

      {/* ========== RED DE MERCADEO (GESTIÓN) ========== */}
      {seccion === 'red_mercadeo' && <SeccionRedMercadeo store={store} recargar={recargar} />}

      {/* ========== FEEDBACK USUARIOS ========== */}
      {seccion === 'feedback' && <SeccionFeedback />}

      {/* ========== SOPORTE PRO ========== */}
      {seccion === 'soporte_chat' && (
        <div>
          <div className="mb-5">
            <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
              <MessageSquare size={24} className="text-purple-600" />
              Soporte
            </h2>
          </div>

          {/* Tabs */}
          <div className="flex gap-1 mb-5 bg-gray-100 p-1 rounded-xl w-fit">
            <button
              onClick={() => setSoporteTab('tickets')}
              className={`px-4 py-2 rounded-lg text-sm font-semibold transition flex items-center gap-2 ${soporteTab === 'tickets' ? 'bg-white shadow text-red-700' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Tickets de Clientes
              {ticketsNoLeidosTotal > 0 && <span className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{ticketsNoLeidosTotal}</span>}
            </button>
            <button
              onClick={() => setSoporteTab('pro')}
              className={`px-4 py-2 rounded-lg text-sm font-semibold transition flex items-center gap-2 ${soporteTab === 'pro' ? 'bg-white shadow text-purple-700' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Soporte PRO
              {soporteNoLeidosTotal > 0 && <span className="bg-purple-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{soporteNoLeidosTotal}</span>}
            </button>
          </div>

          {/* ── TICKETS DE CLIENTES ── */}
          {soporteTab === 'tickets' && (
            ticketsClientes.length === 0 ? (
              <div className="bg-white rounded-xl shadow p-16 text-center">
                <AlertCircle size={48} className="mx-auto text-gray-300 mb-4" />
                <p className="text-gray-500 font-medium">No hay tickets de soporte</p>
                <p className="text-gray-400 text-sm mt-1">Cuando un cliente reporte un problema aparecerá aquí</p>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow overflow-hidden">
                {ticketsClientes.map((t, idx) => {
                  const ultimo = t.ultimoMensaje;
                  const horaUltimo = ultimo ? new Date(ultimo.creadoEn).toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';
                  const tipoTicket = ultimo?.texto?.match(/\[TICKET - ([^\]]+)\]/)?.[1] || 'Reporte';
                  return (
                    <div
                      key={t.viajeId}
                      className={`flex items-center gap-4 px-6 py-4 transition ${idx < ticketsClientes.length - 1 ? 'border-b border-gray-100' : ''} ${t.noLeidos > 0 ? 'bg-red-50' : ''}`}
                    >
                      <div
                        className="flex items-center gap-4 flex-1 min-w-0 cursor-pointer hover:opacity-80"
                        onClick={() => {
                          setTicketClienteActivo(t);
                          const ts = new Date().toISOString();
                          const next = { ...lastSeenTickets, [t.viajeId]: ts };
                          setLastSeenTickets(next);
                          try { localStorage.setItem(_ticketSeenKey, JSON.stringify(next)); } catch {}
                        }}
                      >
                        <div className="w-11 h-11 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 font-bold text-red-600 text-sm">
                          {t.clienteNombre.slice(0, 2).toUpperCase()}
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-0.5">
                            <p className="font-semibold text-gray-800 truncate">{t.clienteNombre}</p>
                            <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full font-medium flex-shrink-0">{tipoTicket}</span>
                          </div>
                          <p className="text-xs text-gray-500 truncate">{t.ruta}</p>
                        </div>
                        <div className="flex flex-col items-end gap-1 flex-shrink-0">
                          <p className="text-xs text-gray-400">{horaUltimo}</p>
                          {t.noLeidos > 0 && (
                            <span className="w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold">
                              {t.noLeidos > 9 ? '9+' : t.noLeidos}
                            </span>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={(e) => { e.stopPropagation(); cerrarTicket(t.viajeId); }}
                        title="Cerrar ticket (marcar como resuelto)"
                        className="ml-2 flex-shrink-0 flex items-center gap-1 px-3 py-1.5 bg-green-50 border border-green-200 text-green-700 rounded-lg text-xs font-semibold hover:bg-green-100 transition"
                      >
                        <CheckCircle size={13} /> Cerrar
                      </button>
                    </div>
                  );
                })}
              </div>
            )
          )}
          {/* Tickets cerrados */}
          {soporteTab === 'tickets' && ticketsClientesCerrados.length > 0 && (
            <div className="mt-4">
              <button
                onClick={() => setMostrarTicketsCerrados(v => !v)}
                className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 font-medium mb-2"
              >
                {mostrarTicketsCerrados ? <ChevronUp size={15} /> : <ChevronDown size={15} />}
                {ticketsClientesCerrados.length} ticket{ticketsClientesCerrados.length !== 1 ? 's' : ''} cerrado{ticketsClientesCerrados.length !== 1 ? 's' : ''}
              </button>
              {mostrarTicketsCerrados && (
                <div className="bg-white rounded-xl shadow overflow-hidden opacity-70">
                  {ticketsClientesCerrados.map((t, idx) => {
                    const ultimo = t.ultimoMensaje;
                    const horaUltimo = ultimo ? new Date(ultimo.creadoEn).toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';
                    const tipoTicket = ultimo?.texto?.match(/\[TICKET - ([^\]]+)\]/)?.[1] || 'Reporte';
                    return (
                      <div
                        key={t.viajeId}
                        className={`flex items-center gap-4 px-6 py-3 ${idx < ticketsClientesCerrados.length - 1 ? 'border-b border-gray-100' : ''}`}
                      >
                        <div
                          className="flex items-center gap-4 flex-1 min-w-0 cursor-pointer hover:opacity-80"
                          onClick={() => setTicketClienteActivo(t)}
                        >
                          <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 font-bold text-gray-500 text-sm">
                            {t.clienteNombre.slice(0, 2).toUpperCase()}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-0.5">
                              <p className="font-semibold text-gray-500 truncate text-sm">{t.clienteNombre}</p>
                              <span className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full font-medium flex-shrink-0">{tipoTicket}</span>
                              <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-medium flex-shrink-0">✓ Cerrado</span>
                            </div>
                            <p className="text-xs text-gray-400 truncate">{t.ruta} · {horaUltimo}</p>
                          </div>
                        </div>
                        <button
                          onClick={() => reabrirTicket(t.viajeId)}
                          className="ml-2 flex-shrink-0 px-3 py-1.5 bg-gray-50 border border-gray-200 text-gray-600 rounded-lg text-xs font-semibold hover:bg-gray-100 transition"
                        >
                          Reabrir
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* ── SOPORTE PRO ── */}
          {soporteTab === 'pro' && (
            conversacionesSoporte.length === 0 ? (
              <div className="bg-white rounded-xl shadow p-16 text-center">
                <MessageSquare size={48} className="mx-auto text-gray-300 mb-4" />
                <p className="text-gray-500 font-medium">No hay conversaciones de soporte aún</p>
                <p className="text-gray-400 text-sm mt-1">Cuando un transportista PRO envíe un mensaje aparecerá aquí</p>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow overflow-hidden">
                {conversacionesSoporte.map((conv, idx) => {
                  const ultimo = conv.ultimoMensaje;
                  const horaUltimo = ultimo ? new Date(ultimo.creadoEn).toLocaleString('es-MX', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';
                  return (
                    <div
                      key={conv.viajeId}
                      onClick={() => setChatSoporteActivo(conv)}
                      className={`flex items-center gap-4 px-6 py-4 cursor-pointer hover:bg-purple-50 transition ${idx < conversacionesSoporte.length - 1 ? 'border-b border-gray-100' : ''} ${conv.noLeidos > 0 ? 'bg-purple-50' : ''}`}
                    >
                      <div className="w-11 h-11 rounded-full bg-purple-200 flex items-center justify-center flex-shrink-0 font-bold text-purple-700 text-sm">
                        {conv.transportistaNombre.slice(0, 2).toUpperCase()}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <p className="font-semibold text-gray-800 truncate">{conv.transportistaNombre}</p>
                          {conv.plan === 'pro' && (
                            <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-xs font-bold bg-gradient-to-r from-yellow-400 to-orange-400 text-white flex-shrink-0">★ PRO</span>
                          )}
                        </div>
                        <p className="text-xs text-gray-500 truncate mt-0.5">
                          {ultimo ? (
                            <><span className={ultimo.emisorRol === 'admin' ? 'text-purple-500' : ''}>{ultimo.emisorRol === 'admin' ? 'Tú: ' : ''}</span>{ultimo.texto}</>
                          ) : 'Sin mensajes'}
                        </p>
                      </div>
                      <div className="flex flex-col items-end gap-1 flex-shrink-0">
                        <p className="text-xs text-gray-400">{horaUltimo}</p>
                        {conv.noLeidos > 0 && (
                          <span className="w-5 h-5 bg-purple-600 text-white text-xs rounded-full flex items-center justify-center font-bold">
                            {conv.noLeidos > 9 ? '9+' : conv.noLeidos}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )
          )}
        </div>
      )}
      </div>
      </div>

      {/* MODALES */}
      {chatSoporteActivo && (
        <ChatModal
          viajeId={chatSoporteActivo.viajeId}
          usuarioId={usuario.id}
          usuarioNombre={usuario.nombre || 'Soporte Choyero'}
          usuarioRol="admin"
          contraparte={{ id: chatSoporteActivo.transportistaId, nombre: chatSoporteActivo.transportistaNombre, rol: 'transportista' }}
          onClose={() => {
            const canal = chatSoporteActivo.viajeId;
            const next = { ...lastSeenAdminMsgs, [canal]: new Date().toISOString() };
            setLastSeenAdminMsgs(next);
            localStorage.setItem(_chatAdminSeenKey, JSON.stringify(next));
            setChatSoporteActivo(null);
          }}
        />
      )}
      {ticketClienteActivo && (
        <ChatModal
          viajeId={ticketClienteActivo.viajeId}
          usuarioId={usuario.id}
          usuarioNombre={usuario.nombre || 'Soporte Choyero'}
          usuarioRol="admin"
          contraparte={{ id: ticketClienteActivo.clienteId, nombre: ticketClienteActivo.clienteNombre, rol: 'cliente' }}
          onClose={() => setTicketClienteActivo(null)}
        />
      )}
      {ModalDocumentosJSX}
      {ModalDetalleEmpresaJSX}

      {/* Chat directo admin → transportista desde detalle empresa */}
      {chatEmpresaActivo && (
        <ChatModal
          viajeId={`admin-empresa-${chatEmpresaActivo.empresaId}`}
          usuarioId={usuario.id}
          usuarioNombre={usuario.nombre || 'Admin Choyero'}
          usuarioRol="admin"
          contraparte={{ id: chatEmpresaActivo.usuarioId, nombre: chatEmpresaActivo.empresaNombre, rol: 'transportista' }}
          onClose={() => {
            const canal = `admin-empresa-${chatEmpresaActivo.empresaId}`;
            const next = { ...lastSeenAdminMsgs, [canal]: new Date().toISOString() };
            setLastSeenAdminMsgs(next);
            localStorage.setItem(_chatAdminSeenKey, JSON.stringify(next));
            setChatEmpresaActivo(null);
          }}
          onCerrarConversacion={() => {
            const canal = `admin-empresa-${chatEmpresaActivo.empresaId}`;
            cerrarConversacionAdmin(canal);
            const next = { ...lastSeenAdminMsgs, [canal]: new Date().toISOString() };
            setLastSeenAdminMsgs(next);
            localStorage.setItem(_chatAdminSeenKey, JSON.stringify(next));
            setChatEmpresaActivo(null);
            cerrarModalDetalle();
          }}
        />
      )}
      {modalEditarComision && (
        <ModalEditarComision
          empresa={modalEditarComision}
          onClose={() => setModalEditarComision(null)}
          onGuardar={(id, comision) => actualizarComisionEmpresa(id, comision)}
        />
      )}
      {modalNuevoAdmin && <ModalNuevoAdmin onClose={() => setModalNuevoAdmin(false)} onSubmit={agregarAdmin} />}
      {modalEditarAdmin && <ModalEditarAdmin admin={modalEditarAdmin} onClose={() => setModalEditarAdmin(null)} onSubmit={editarAdmin} />}
      {modalInsigniasCliente && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]">
          <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full">
            <div className="p-6 border-b flex justify-between items-center">
              <div>
                <h3 className="text-xl font-bold">Insignias del Cliente</h3>
                <p className="text-sm text-gray-500 mt-0.5">{modalInsigniasCliente.nombre}</p>
              </div>
              <button onClick={() => setModalInsigniasCliente(null)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
            </div>
            <div className="p-6">
              <p className="text-sm text-gray-600 mb-4">Selecciona las insignias que deseas asignar o quitar a este cliente.</p>
              <div className="grid grid-cols-2 gap-2">
                {CATALOGO_INSIGNIAS_CLIENTE.map(ins => {
                  const actuales = modalInsigniasCliente.insigniasCliente || [];
                  const activa = actuales.includes(ins.id);
                  const toggle = () => {
                    const nuevas = activa ? actuales.filter(x => x !== ins.id) : [...actuales, ins.id];
                    storeActualizarInsigniasCliente(modalInsigniasCliente.id, nuevas);
                    setModalInsigniasCliente({ ...modalInsigniasCliente, insigniasCliente: nuevas });
                    apiAdminActualizarInsigniasUsuario(modalInsigniasCliente.id, nuevas).catch((e) => {
                      storeActualizarInsigniasCliente(modalInsigniasCliente.id, actuales);
                      setModalInsigniasCliente(prev => prev && { ...prev, insigniasCliente: actuales });
                      mostrarNotificacion(e.message || 'Error al guardar las insignias en el servidor', 'error');
                    });
                  };
                  return (
                    <button
                      key={ins.id}
                      onClick={toggle}
                      className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm transition-all text-left ${
                        activa ? `${ins.color} font-semibold shadow-sm` : 'bg-white border-gray-200 text-gray-400 hover:border-gray-400'
                      }`}
                    >
                      <span className="text-base">{ins.emoji}</span>
                      <div className="min-w-0">
                        <p className={`font-medium leading-tight truncate ${activa ? '' : 'text-gray-500'}`}>{ins.label}</p>
                        <p className="text-xs text-gray-400 leading-tight truncate">{ins.desc}</p>
                      </div>
                      {activa && <span className="ml-auto text-green-500 shrink-0">✓</span>}
                    </button>
                  );
                })}
              </div>
              <button
                onClick={() => setModalInsigniasCliente(null)}
                className="mt-6 w-full px-4 py-2.5 bg-gray-800 text-white rounded-lg hover:bg-gray-900 font-semibold"
              >
                Listo
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bottom nav móvil — admin */}
      <div
        className="fixed bottom-0 left-0 right-0 z-[100] md:hidden bg-gray-900 border-t border-gray-700"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      >
        <div className="flex items-center h-14">
          <button
            onClick={() => setSeccion('dashboard')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors ${seccion === 'dashboard' ? 'text-yellow-400' : 'text-gray-500'}`}
          >
            <BarChart3 size={20} />
            <span>Dashboard</span>
          </button>
          <button
            onClick={() => setSeccion('pendientes')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors relative ${seccion === 'pendientes' ? 'text-yellow-400' : 'text-gray-500'}`}
          >
            <Clock size={20} />
            <span>Pendientes</span>
            {empresasPendientesMerged.length > 0 && (
              <span className="absolute top-2 right-3 w-4 h-4 bg-red-500 text-white text-[9px] rounded-full flex items-center justify-center font-bold">
                {empresasPendientesMerged.length > 9 ? '9+' : empresasPendientesMerged.length}
              </span>
            )}
          </button>
          <button
            onClick={() => setSeccion('operaciones')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors relative ${seccion === 'operaciones' ? 'text-yellow-400' : 'text-gray-500'}`}
          >
            <Briefcase size={20} />
            <span>Operaciones</span>
            {(store.viajes || []).filter(v => v.enDisputa).length > 0 && (
              <span className="absolute top-2 right-3 w-4 h-4 bg-orange-500 text-white text-[9px] rounded-full flex items-center justify-center font-bold">
                {(store.viajes || []).filter(v => v.enDisputa).length > 9 ? '9+' : (store.viajes || []).filter(v => v.enDisputa).length}
              </span>
            )}
          </button>
          <button
            onClick={() => setSeccion('soporte_chat')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors relative ${seccion === 'soporte_chat' ? 'text-yellow-400' : 'text-gray-500'}`}
          >
            <MessageSquare size={20} />
            <span>Soporte</span>
            {(soporteNoLeidosTotal + ticketsNoLeidosTotal) > 0 && (
              <span className="absolute top-2 right-3 w-4 h-4 bg-yellow-500 text-white text-[9px] rounded-full flex items-center justify-center font-bold">
                {(soporteNoLeidosTotal + ticketsNoLeidosTotal) > 9 ? '9+' : soporteNoLeidosTotal + ticketsNoLeidosTotal}
              </span>
            )}
          </button>
          <button
            onClick={() => setSeccion('finanzas')}
            className={`flex-1 flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors ${seccion === 'finanzas' ? 'text-yellow-400' : 'text-gray-500'}`}
          >
            <DollarSign size={20} />
            <span>Finanzas</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppSuperAdmin;